// InstanceSingleOrderManager.js
import React, { useState, useEffect, useRef, useContext, useMemo, useCallback } from "react";
import axios from "axios";
import { Toaster, toast } from 'react-hot-toast';
import InstanceLeftSidebar from "../../../InstanceLeftSidebar";
import PageHeaderWithBreadcrumbs from "../../../../../components/PageHeaderWithBreadcrumbs";
import PurchaseOrderList from '../../../../../components/PurchaseOrder/PurchaseOrderList'
import OutstandingPOsDialog from '../../../../../components/PurchaseOrder/PurchaseOrderList/OutstandingPOsDialog'
import PurchaseOrderProofEnforcementNotice from '../../../../../components/PurchaseOrder/ProofEnforcementNotice';
import InstanceProducts from "../../../connect/products/InstanceProducts";
import { getCustomerReviewGate } from "./purchaseOrderCustomerGate";
import { useHistory } from 'react-router-dom';
import Link from '@mui/material/Link'
import { Avatar, CircularProgress, IconButton, Pagination  } from "@mui/material";
import ViewSidebarIcon from "@mui/icons-material/ViewSidebar"; 
import { Select, MenuItem, FormControl, InputLabel, Stack, ListSubheader, Chip, ListItemIcon, ListItemText } from "@mui/material";
import { alpha } from '@mui/material/styles';
import CheckIcon from "@mui/icons-material/Check";
import { AuthContext } from "../../../../../helpers/AuthContext";
import { filterManualSalesOrderStatusOptions } from '../../../../../utils/manualSalesOrderStatusPolicy';
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import './style.css';
import {
  mergeBookedStampSummary,
  resolveBookedSummaryFinancials,
  resolveFrozenSalesOrderBookedFinancials,
  selectOverviewFinancials,
  unavailableBookedFinancials,
  selectLatestApprovedBookedSalesOrder,
  isApprovedBookedSalesOrder,
  calculateBookedMarginPct,
  getCanonicalPricingRows,
} from './bookedFinancials';
import dayjs from "dayjs";
import InstanceProductManager from "../../../products/ProductPopup";
import OrderFiles from "./order-components/orderFiles/orderFiles";
import OrderUserAssignment from "./order-components/orderUserAssignment/OrderUserAssignment";
import OrderProgressBar from "./order-components/orderProgressBar/OrderProgressBar"; // Updated progress bar
import { Button, Typography, Tooltip, Tabs, Tab, Drawer, Divider, List, ListItemButton } from "@mui/material";
import PresentationScreen from "../../../../../components/PresentationScreen";
import PresentationTabs from "../../../../../components/PresentationTabs";
import CopyProductsToPromoStoreDialog from "./CopyProductsToPromoStoreDialog";
import { resolveLatestPresentation, resolvePromoStoreDocumentProducts } from "./promoStoreConversion";

import { useLocation } from "react-router-dom";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";

import ProductPopup from "../../../products/ProductPopup";
import {
  fetchPresentationDetails as svcFetchPresentationDetails,
  getProductComments as svcGetProductComments
} from "../../../../../services/presentation";
import {
  updateProductsToOrder,
  reorderOrderProducts,
  reorderOrderCartLayout,
  fetchProjectEmailAddressByOrder,
  regeneratePresentationFromCart,
  regenerateEstimateFromCart,
  regenerateSalesOrderFromCart,
  fetchCartHistory,
  fetchDocumentSnapshots,
  fetchCartSnapshots,
  fetchInvoicingCartDiff,
  fetchInvoicingCartDiffByKey,
  listInvoicingCarts,
  fetchInvoicingCartByKey,
  saveInvoicingCartByKey,
  resolveInvoiceInvoicingCart,
  initiateBinatedProofForOrder,
  preflightBinatedProofForOrder,
  initiateProofWorkRequestForOrder,
  getRequestArtStatusesByDocument,
  fetchDesignRepArtworkProofMapping,
  getBinatedCurrentOrderByDocument,
  deleteBinatedCurrentOrderByDocument,
} from "../../../../../services/orders";
import {
  requestProofs,
  requestArtworkForDocument,
  createPurchaseOrderApi,
  fetchPurchaseOrderProofPreflight,
  fetchOutstandingPurchaseOrders,
  fetchAllDesignReps,
} from "../../../../../services/purchaseOrder";
import {
  getClientContacts,
  getCustomerDetailsForOrder,
  requestCustomerConversion,
} from "../../../../../services/customer";
import { uploadFile } from "../../../../../services/customerFiles";
import { cancelCoreNetworkWorkRequest, listCoreNetworkMembers } from "../../../../../services/coreNetwork";
import { Box } from "@mui/system";
import {
  Alert, Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, FormControlLabel, Switch, RadioGroup, Radio, Checkbox,
  TablePagination, TableContainer, InputAdornment
} from "@mui/material";
import ButtonLoader from "../../../../../components/ButtonLoader";
import ApprovalRegenerationDialog from "../../../../../components/GeneratedSalesOrder/ApprovalRegenerationDialog";
import DecorationRoutingErrorDialog, { getDecorationRoutingError } from "../../../../../components/GeneratedSalesOrder/DecorationRoutingErrorDialog";
import RegenerationLoader from "../../../../../components/GeneratedSalesOrder/RegenerationLoader";
import { useParams } from 'react-router-dom';
import { isSupportedProductImageUrl } from '../../../../../utils/productImage';
import { getContactDisplayName } from '../../../../../utils/contactDisplayName';
import SelectedProductsPopup from "../../../../../components/PresentationProductsPopup";
import EmailComposer from "../../../../../components/EmailComposer";
import EmailViewerDialog from "../../../../../components/EmailViewer/EmailViewerDialog";
import DataTable from "../../../../../components/DataTable";
import SettingsIcon from '@mui/icons-material/Settings';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ShippingDetails from "../../../../../components/Shipping";
import Billing from "../../../../../components/Billing";
import { fetchBills as fetchOrderBills } from "../../../../../services/billing";
import {
  PROOF_ENFORCEMENT_MODES,
  normalizeProofEnforcementMode,
} from "../../../../../constants/proofEnforcementModes";
import {
  getProofReadinessCardCopy,
  isProofReadinessBlockingGeneration,
  normalizeProofReadinessStatus,
} from "./purchaseOrderProofReadiness";

import Commissions from "../../../../../components/Commissions"; 
import { EVENT_TYPES } from "../InstanceOrders";
import CustomerSearchSelectAsync from "../../../../../components/CustomerSearchSelectAsync";
import useWorkflowDisplaySettings from "../../../../../hooks/useWorkflowDisplaySettings";
import useBinatedLifecycle from "../../../../../hooks/useBinatedLifecycle";
import {
  confirmSentEstimateRegeneration,
  resolveSentDocumentRegenerationState,
} from "./estimateRegenerationGuard";
import {
  getConvertToPoActionState,
  tryBeginConvertToPo,
} from "./convertToPoActionState";
import { getPaidDepositApprovalIconState } from "./paidDepositApprovalIcon";
import { getBilledMarginView, isBilledMarginStatus } from "./billedMargin";
import {
  CREATE_INVOICE_MODE_OPTIONS,
  DEFAULT_CREATE_INVOICE_MODE,
  DEFAULT_ENABLED_CREATE_INVOICE_MODES,
  normalizeCreateInvoiceModeConfig,
} from "../../../../../constants/createInvoiceModes";
import {
  BinatedLifecycleFilesTable,
  BinatedLifecycleRevisionModal,
  BinatedLifecycleStatusPanel,
  BinatedLifecycleTimeline,
} from "../../../../../components/BinatedLifecycle";
import BinatedArtworkProofMapper from "../../../../../components/BinatedArtworkProofMapper";
import DesignRepArtworkProofMapper from "../../../../../components/DesignRepArtworkProofMapper";
import QuickProofFileSlots from "./QuickProofFileSlots";
import LayersOutlinedIcon from "@mui/icons-material/LayersOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AspectRatioOutlinedIcon from "@mui/icons-material/AspectRatioOutlined";
import TuneOutlinedIcon from "@mui/icons-material/TuneOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import Shipping from '../../../../../components/Shipping'
import Invoices from "../../../../../components/Invoices";
import InvoiceCreationReview from "../../../../../components/Invoices/InvoiceCreationReview";
import SalesOrderInvoiceAddressPrecheck from "./SalesOrderInvoiceAddressPrecheck";
import SalesOrderExistingInvoices, { describeSalesOrderInvoiceHistory, resolveSalesOrderInvoiceActionState } from "./SalesOrderExistingInvoices";
import SalesOrderInvoiceEmailHistory from "./SalesOrderInvoiceEmailHistory";
import DepositCheckRequestDialog from "../../../../../components/DepositCheck/DepositCheckRequestDialog";
import {
  createInvoice,
  fetchInvoicesListByOrder,
  fetchInvoiceEmailHistoryByOrder,
  isInvoicePaidStatus,
  resolveInvoiceCreationPreparation,
  fetchOrderBalanceStatus,
  fetchInvoiceAddressPrecheck,
  notifyInvoiceAddressMissing,
  previewResetInvoiced,
  confirmResetInvoiced,
} from "../../../../../services/invoices";
import { updateEstimation, fetchLatestCompletedSalesOrderForOrder } from "../../../../../services/estimation.js";
import { fetchOperationsManagementSettings } from "../../../../../services/operationsManagement";
import {
  getInvoicePermissionState,
  normalizeInvoiceRoles,
  shouldShowInvoicesTab,
} from "../../../../../utils/invoicePermissions";
import { getInvoiceOwnedCarts, selectInvoiceOwnedCartKey, formatInvoiceCartChoice } from "./invoiceWorkspaceGate";
import { sumActiveInvoiceTotal } from "../../../../../utils/invoiceAvailability";

import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import CloseIcon from "@mui/icons-material/Close";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import UpdateIcon from "@mui/icons-material/Update";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import BuildIcon from "@mui/icons-material/Build"; // or Notes icon if you prefer
import NoteAltIcon from "@mui/icons-material/NoteAlt"; // alternative
import DescriptionIcon from "@mui/icons-material/Description";
import PaymentsIcon from "@mui/icons-material/Payments";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { formatDistance, formatDistanceToNow } from "date-fns";
import { MentionsInput, Mention } from "react-mentions";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ReplyIcon from "@mui/icons-material/Reply";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Backdrop, LinearProgress } from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ForumIcon from "@mui/icons-material/Forum";
import PersonIcon from "@mui/icons-material/Person";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import ImageIcon from "@mui/icons-material/Image";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import ViewInArIcon from "@mui/icons-material/ViewInAr";


 
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
// import ChatIcon from '@mui/icons-material/Chat';
import EventIcon from "@mui/icons-material/Event";
import FormatLineSpacingIcon from "@mui/icons-material/FormatLineSpacing";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { UITableShell, UITableToolbar } from "../../../../../components/ui"; 
import { Table, TableHead, TableBody, TableRow, TableCell, Menu, Paper, Skeleton } from "@mui/material"; 



import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import RefreshIcon from "@mui/icons-material/Refresh";

import TableChartIcon    from "@mui/icons-material/TableChart";
import GridOnIcon        from "@mui/icons-material/GridOn";
import PictureAsPdfIcon  from "@mui/icons-material/PictureAsPdf"
import HistoryIcon from "@mui/icons-material/History";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import VisibilityIcon        from '@mui/icons-material/Visibility';
import EditOutlinedIcon      from '@mui/icons-material/EditOutlined';
import SendIcon              from '@mui/icons-material/Send';
import ArrowDropDownIcon     from '@mui/icons-material/ArrowDropDown';
import TableRowsIcon         from '@mui/icons-material/TableRows';

import io from "socket.io-client";
import useCartWorkspace, { hydrateCartProductTaxDetails } from "./useCartWorkspace";
import { resolveSalesOrderCartUnlocked } from "./cartSourceIsolation";
import { normalizeCartPayload } from "./cartWorkspaceModel";
import { reorderProductsInPayload } from "./cartWorkspaceMutations";
import { reorderCartLayoutInPayload } from "./cartWorkspaceMutations";
import { handleSalesOrderWorkspaceMutationCommitted } from "./salesOrderWorkspaceMutationCommitted";
import { commitSalesOrderWorkspaceProductListMutation } from "./salesOrderWorkspaceProductListMutation";
import { buildEmailNotePreview, buildEmailViewerPropsFromNote } from "../../../../../utils/emailViewerNotes";


const upsertProjectNote = (notes, note) => {
  if (!note) return notes;
  const seq = Number(note.sequence);
  if (!seq) return notes;

  const list = Array.isArray(notes) ? notes : [];
  const exists = list.some((n) => Number(n?.sequence) === seq);
  if (exists) {
    return list.map((n) => {
      if (Number(n?.sequence) !== seq) return n;
      const definedNoteFields = Object.fromEntries(
        Object.entries(note).filter(([, value]) => value !== undefined)
      );
      return { ...n, ...definedNoteFields };
    });
  }

  return [note, ...list];
};

const sanitizeSmartSendCsvDraft = (value = "") =>
  String(value || "")
    .replace(/\s+/g, "")
    .replace(/,{2,}/g, ",");

const getMentionDisplayName = (user = {}) => {
  const first = user.first_name || user.firstName || user.firstname || "";
  const last = user.last_name || user.lastName || user.lastname || "";
  const full = `${first} ${last}`.trim();
  const fallbackId = user.id != null ? `User #${user.id}` : "";
  return String(
    user.display ||
    user.displayName ||
    user.name ||
    full ||
    user.username ||
    user.email ||
    fallbackId
  ).trim();
};

const resolveMentionAvatarUrl = (rawAvatar) => {
  if (!rawAvatar) return null;

  const normalizeUrl = (value) => {
    if (typeof value !== "string") return null;
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (trimmed.startsWith("uploads")) {
      return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${trimmed}`;
    }
    return trimmed;
  };

  if (typeof rawAvatar === "string") {
    const trimmed = rawAvatar.trim();
    if (!trimmed) return null;
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed)) {
        const selected = parsed.find((item) => item?.selected) || parsed[0];
        return normalizeUrl(selected?.url || selected?.src || null);
      }
      if (parsed && typeof parsed === "object") {
        return normalizeUrl(parsed.url || parsed.src || null);
      }
    } catch {
      return normalizeUrl(trimmed);
    }
    return normalizeUrl(trimmed);
  }

  if (Array.isArray(rawAvatar)) {
    const selected = rawAvatar.find((item) => item?.selected) || rawAvatar[0];
    return normalizeUrl(selected?.url || selected?.src || null);
  }

  if (typeof rawAvatar === "object") {
    return normalizeUrl(rawAvatar.url || rawAvatar.src || null);
  }

  return null;
};

const normalizeMentionUser = (user = {}) => {
  const id = user?.id != null ? String(user.id) : "";
  const display = getMentionDisplayName(user) || (id ? `User #${id}` : "");
  return {
    ...user,
    id,
    display,
    mentionName: display,
    avatarUrl: resolveMentionAvatarUrl(
      user.profilePicture ||
      user.profile_picture ||
      user.avatarUrl ||
      user.avatar ||
      user.photoUrl ||
      null
    ),
  };
};

const getProjectNoteAuthorName = (user = {}) => {
  const full = [user.first_name || user.firstName, user.last_name || user.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  return user.name || user.display || user.displayName || full || "";
};

const findProjectNoteAuthorUser = (note, availableUsers = [], assignedUsersDetailed = [], authState = {}) => {
  const userId = String(note?.userId || note?.user?.id || "");
  if (userId) {
    if (String(authState?.id || "") === userId) return authState;
    const byId = (assignedUsersDetailed || []).find((u) => String(u?.id) === userId) ||
      (availableUsers || []).find((u) => String(u?.id) === userId);
    if (byId) return byId;
  }

  // Older inbound project-email notes were stored without userId/avatar even when
  // the sender was an internal user. Resolve those notes by the sender email,
  // preferring users already assigned to this project.
  const noteEmail = String(
    note?.userEmail ||
    note?.fromEmail ||
    note?.email?.fromEmail ||
    note?.meta?.originalSenderEmail ||
    ""
  ).trim().toLowerCase();
  if (!noteEmail) return null;

  const userEmail = (u = {}) => String(
    u?.email || u?.Email || u?.workEmail || u?.userEmail || u?.primaryEmail || ""
  ).trim().toLowerCase();

  if (userEmail(authState) === noteEmail) return authState;
  return (assignedUsersDetailed || []).find((u) => userEmail(u) === noteEmail) ||
    (availableUsers || []).find((u) => userEmail(u) === noteEmail) ||
    null;
};

const enrichProjectNoteAuthor = (note, { availableUsers = [], assignedUsersDetailed = [], authState = {} } = {}) => {
  if (!note) return note;
  const matchingUser = findProjectNoteAuthorUser(note, availableUsers, assignedUsersDetailed, authState);
  const userId = String(note.userId || note.user?.id || matchingUser?.id || "");
  const avatar =
    note.userAvatarUrl ||
    note.userAvatar ||
    note.profilePicture ||
    note.user?.profilePicture ||
    matchingUser?.profilePicture ||
    matchingUser?.profile_picture ||
    matchingUser?.avatarUrl ||
    matchingUser?.avatar ||
    (String(authState?.id || "") === userId ? (authState?.profilePicture || authState?.avatarUrl || authState?.avatar) : null) ||
    null;
  const name =
    note.userName ||
    getProjectNoteAuthorName(note.user || {}) ||
    getProjectNoteAuthorName(matchingUser || {}) ||
    (String(authState?.id || "") === userId ? getProjectNoteAuthorName(authState || {}) : "") ||
    "User";

  return {
    ...note,
    userId: note.userId || userId || null,
    userName: name,
    userAvatarUrl: avatar,
    userAvatar: note.userAvatar || avatar,
  };
};

const resolveProjectNoteAvatarSrc = (note, { availableUsers = [], assignedUsersDetailed = [], authState = {}, defaultAvatarUrl = "/elite-core-placeholder-avatar.png" } = {}) => {
  const enriched = enrichProjectNoteAuthor(note, { availableUsers, assignedUsersDetailed, authState });
  return resolveMentionAvatarUrl(
    enriched?.userAvatarUrl ||
    enriched?.userAvatar ||
    enriched?.profilePicture ||
    enriched?.user?.profilePicture ||
    null
  ) || defaultAvatarUrl;
};

const getInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "?";

const extractMentionIdsFromText = (text = "") =>
  [...new Set(
    Array.from(String(text || "").matchAll(/@\[[^\]]+\]\((\d+)\)/g))
      .map((match) => Number(match[1]))
      .filter(Number.isFinite)
  )];

const buildMentionPreviewHtml = (text = "") =>
  String(text || "").replace(
    /@\[(?<display>[^\]]+)\]\((?<id>\d+)\)/g,
    (_m, _d, _id, _off, _str, groups) => `<b>@${groups?.display || "user"}</b>`
  );

const PROJECT_NOTE_ATTACHMENT_TYPES = new Set([
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "application/pdf",
]);
const PROJECT_NOTE_ATTACHMENT_MAX_BYTES = 15 * 1024 * 1024;

export const formatProjectNoteDateTime = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};
const PROJECT_NOTES_CART_FILTER_KEY = "eliteCore.projectNotes.showCartChanges";
const PROJECT_NOTES_INFINITE_SCROLL_KEY = "eliteCore.projectNotes.infiniteScroll";
const CART_CHANGE_NOTE_ACTIONS = new Set([
  "cart-updated",
  "cart-item-updated",
  "cart-item-removed",
  "cart-other-service-added",
  "cart-other-service-updated",
  "cart-other-service-deleted",
]);

const formatAttachmentSize = (size) => {
  const bytes = Number(size || 0);
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(bytes < 10 * 1024 ? 1 : 0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const validateProjectNoteAttachment = (file) => {
  if (!file) return null;
  if (!PROJECT_NOTE_ATTACHMENT_TYPES.has(file.type)) {
    return "Only image and PDF attachments are supported for project notes.";
  }
  if (file.size > PROJECT_NOTE_ATTACHMENT_MAX_BYTES) {
    return "Attachment must be 15 MB or smaller.";
  }
  return null;
};

function ProjectNoteAttachmentPreview({ file, compact = false, onRemove }) {
  const [previewUrl, setPreviewUrl] = React.useState(null);
  const isPdf = file?.type === "application/pdf";

  React.useEffect(() => {
    if (!file || isPdf) {
      setPreviewUrl(null);
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file, isPdf]);

  if (!file) return null;

  return (
    <div className={`ov2-attachment-preview${compact ? " is-compact" : ""}`}>
      {isPdf ? (
        <div className="ov2-attachment-file-card">
          <PictureAsPdfIcon className="ov2-attachment-file-icon" sx={{ fontSize: compact ? 20 : 24 }} />
          <div className="ov2-attachment-file-copy">
            <div className="ov2-attachment-name" title={file.name}>{file.name}</div>
            <div className="ov2-attachment-meta">{formatAttachmentSize(file.size)}</div>
          </div>
        </div>
      ) : (
        <>
          {previewUrl && <img className="ov2-attachment-thumb" src={previewUrl} alt="Attachment preview" />}
          <div className="ov2-attachment-file-copy">
            <div className="ov2-attachment-name" title={file.name}>{file.name}</div>
            <div className="ov2-attachment-meta">{formatAttachmentSize(file.size)}</div>
          </div>
        </>
      )}
      <button type="button" className="ov2-attachment-remove" onClick={onRemove} aria-label="Remove attachment">×</button>
    </div>
  );
}

function ProjectNoteAttachments({ attachments = [] }) {
  const [lightboxAttachment, setLightboxAttachment] = React.useState(null);
  const list = React.useMemo(() => (Array.isArray(attachments) ? attachments : []).filter((a) => a?.url), [attachments]);
  if (!list.length) return null;

  return (
    <>
      <div className="ov2-note-attachments">
        {list.map((attachment, idx) => {
          const isPdf = attachment.type === "pdf" || attachment.mimeType === "application/pdf";
          const key = `${attachment.url}-${idx}`;
          if (isPdf) {
            return (
              <a key={key} className="ov2-note-file-card" href={attachment.url} target="_blank" rel="noreferrer">
                <PictureAsPdfIcon className="ov2-note-file-icon" sx={{ fontSize: 24 }} />
                <span className="ov2-note-file-copy">
                  <span className="ov2-note-file-name">{attachment.fileName || "PDF attachment"}</span>
                  <span className="ov2-note-file-meta">{formatAttachmentSize(attachment.size)}{attachment.size ? " · " : ""}Open PDF →</span>
                </span>
              </a>
            );
          }
          return (
            <button key={key} type="button" className="ov2-note-image-button" onClick={() => setLightboxAttachment(attachment)}>
              <img className="ov2-note-image-thumb" src={attachment.url} alt={attachment.fileName || "Note attachment"} />
            </button>
          );
        })}
      </div>
      {lightboxAttachment && (
        <div className="ov2-image-lightbox" onClick={() => setLightboxAttachment(null)} role="presentation">
          <button type="button" className="ov2-image-lightbox-close" onClick={() => setLightboxAttachment(null)} aria-label="Close image preview">×</button>
          <img src={lightboxAttachment.url} alt={lightboxAttachment.fileName || "Note attachment preview"} />
        </div>
      )}


    </>
  );
}

const ProjectOverviewNoteComposer = React.memo(function ProjectOverviewNoteComposer({
  initialValue = "",
  mentionUsers = [],
  onSubmit,
}) {
  const [draft, setDraft] = React.useState(initialValue || "");
  const [selectedAttachment, setSelectedAttachment] = React.useState(null);
  const [isPosting, setIsPosting] = React.useState(false);
  const [mentionOpen, setMentionOpen] = React.useState(false);
  const [mentionQuery, setMentionQuery] = React.useState("");
  const [mentionIndex, setMentionIndex] = React.useState(0);
  const inputRef = React.useRef(null);
  const fileInputRef = React.useRef(null);
  const mentionRangeRef = React.useRef({ from: null, to: null });

  React.useEffect(() => {
    setDraft(initialValue || "");
  }, [initialValue]);

  const filteredUsers = React.useMemo(() => {
    const q = mentionQuery.trim().toLowerCase();
    if (!q) return mentionUsers;
    return mentionUsers.filter((u) => `${u.display || ""}`.toLowerCase().includes(q));
  }, [mentionQuery, mentionUsers]);

  const insertMention = React.useCallback((user) => {
    const ta = inputRef.current;
    if (!ta) return;
    const { from, to } = mentionRangeRef.current || {};
    if (from == null || to == null) return;

    const fullName = user.display || user.mentionName || `User #${user.id}` || "User";
    const snippet = `@[${fullName}](${user.id})`;
    const before = draft.slice(0, from);
    const after = draft.slice(to);
    const next = before + snippet + after;
    setDraft(next);

    const caret = (before + snippet).length;
    requestAnimationFrame(() => {
      if (!inputRef.current) return;
      inputRef.current.focus();
      inputRef.current.setSelectionRange(caret, caret);
    });

    setMentionOpen(false);
    setMentionQuery("");
    setMentionIndex(0);
    mentionRangeRef.current = { from: null, to: null };
  }, [draft]);

  const clearAttachment = React.useCallback(() => {
    setSelectedAttachment(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }, []);

  const handleAttachmentChange = React.useCallback((event) => {
    const file = event.target.files?.[0] || null;
    if (!file) {
      setSelectedAttachment(null);
      return;
    }
    const validationError = validateProjectNoteAttachment(file);
    if (validationError) {
      toast.error(validationError);
      clearAttachment();
      return;
    }
    setSelectedAttachment(file);
  }, [clearAttachment]);

  const handleSubmit = React.useCallback(async () => {
    const trimmed = String(draft || "").trim();
    if (!trimmed || isPosting) return;
    setIsPosting(true);
    const ok = await onSubmit?.(trimmed, extractMentionIdsFromText(trimmed), selectedAttachment);
    setIsPosting(false);
    if (ok !== false) {
      setDraft("");
      clearAttachment();
      setMentionOpen(false);
      setMentionQuery("");
      setMentionIndex(0);
      mentionRangeRef.current = { from: null, to: null };
    }
  }, [clearAttachment, draft, isPosting, onSubmit, selectedAttachment]);

  return (
    <div className="ov2-composer">
      <textarea
        ref={inputRef}
        data-ec-notes
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        placeholder="Post a project note... Type @ to tag a teammate"
        rows={3}
        onKeyDown={(e) => {
          if (!mentionOpen) return;
          if (e.key === "Escape") { setMentionOpen(false); return; }
          if (e.key === "ArrowDown" || e.key === "ArrowUp") {
            e.preventDefault();
            const max = filteredUsers.length;
            if (!max) return;
            setMentionIndex((i) =>
              e.key === "ArrowDown" ? (i + 1) % max : (i - 1 + max) % max
            );
          }
          if (e.key === "Enter" && filteredUsers.length) {
            e.preventDefault();
            insertMention(filteredUsers[mentionIndex]);
          }
        }}
        onKeyUp={(e) => {
          const ta = inputRef.current || e.currentTarget;
          const { value, selectionStart } = ta;
          const upto = value.slice(0, selectionStart);
          const match = upto.match(/@([\w .\-]{0,30})$/i);
          if (match) {
            const from = selectionStart - match[0].length;
            const to = selectionStart;
            mentionRangeRef.current = { from, to };
            setMentionQuery(match[1]);
            setMentionOpen(true);
            setMentionIndex(0);
          } else {
            mentionRangeRef.current = { from: null, to: null };
            setMentionOpen(false);
            setMentionQuery("");
            setMentionIndex(0);
          }
        }}
      />

      {mentionOpen && (
        <div className="ov2-mention-menu">
          {filteredUsers.length === 0 ? (
            <div className="ov2-mention-empty">No users found</div>
          ) : (
            filteredUsers.map((u, idx) => (
              <div
                key={u.id}
                className={`ov2-mention-option${idx === mentionIndex ? " is-active" : ""}`}
                onMouseDown={(e) => { e.preventDefault(); insertMention(u); }}
              >
                <div className="ov2-mention-avatar">
                  {u.avatarUrl ? (
                    <img src={u.avatarUrl} alt="" />
                  ) : (
                    <span>{getInitials(u.display || u.mentionName || `User #${u.id}`)}</span>
                  )}
                </div>
                <span className="ov2-mention-name">
                  {u.display || u.mentionName || `User #${u.id}`}
                </span>
              </div>
            ))
          )}
        </div>
      )}

      <div className="ov2-attachment-row">
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*,application/pdf"
          onChange={handleAttachmentChange}
          style={{ display: "none" }}
        />
        <button type="button" className="ov2-attach-btn" onClick={() => fileInputRef.current?.click()} disabled={isPosting}>
          + Attachment
        </button>
        <ProjectNoteAttachmentPreview file={selectedAttachment} onRemove={clearAttachment} />
      </div>

      <div className="ov2-composer-actions">
        <Button
          variant="contained"
          size="small"
          onClick={handleSubmit}
          disabled={!draft.trim() || isPosting}
          sx={{
            fontFamily: '"Nunito", sans-serif',
            fontWeight: 700,
            fontSize: "0.82rem",
            height: 32,
            px: 2,
            bgcolor: "var(--ec-color-primary)",
            "&:hover": { bgcolor: "var(--ec-color-primary-hover, #a90f24)" },
          }}
        >
          {isPosting ? "Posting..." : "Post Note"}
        </Button>
      </div>
    </div>
  );
});

const ProjectNoteReplyEditor = React.memo(function ProjectNoteReplyEditor({
  note,
  initialValue = "",
  projectMentionUsers,
  isAssignedMentionUser,
  onSubmit,
  onCancel,
  onDraftSnapshot,
}) {
  const [draft, setDraft] = React.useState(initialValue || "");
  const [selectedAttachment, setSelectedAttachment] = React.useState(null);
  const [isPosting, setIsPosting] = React.useState(false);
  const fileInputRef = React.useRef(null);

  React.useEffect(() => {
    setDraft(initialValue || "");
  }, [initialValue, note?.sequence]);

  const mentions = React.useMemo(
    () => extractMentionIdsFromText(draft),
    [draft]
  );

  const clearAttachment = React.useCallback(() => {
    setSelectedAttachment(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  }, []);

  const handleAttachmentChange = React.useCallback((event) => {
    const file = event.target.files?.[0] || null;
    if (!file) {
      setSelectedAttachment(null);
      return;
    }
    const validationError = validateProjectNoteAttachment(file);
    if (validationError) {
      toast.error(validationError);
      clearAttachment();
      return;
    }
    setSelectedAttachment(file);
  }, [clearAttachment]);

  const handleSubmit = React.useCallback(async () => {
    const trimmed = String(draft || "").trim();
    if (!trimmed || isPosting) return;
    setIsPosting(true);
    const ok = await onSubmit?.(note, trimmed, mentions, selectedAttachment);
    setIsPosting(false);
    if (ok !== false) {
      setDraft("");
      clearAttachment();
    }
  }, [clearAttachment, draft, isPosting, mentions, note, onSubmit, selectedAttachment]);

  return (
    <div className="ov2-note-reply-area">
      <Stack direction="row" spacing={1}>
        <div className="ov2-reply-mentions-wrap">
          <MentionsInput
            value={draft}
            onChange={(_event, newValue) => setDraft(newValue)}
            onBlur={() => onDraftSnapshot?.(note?.sequence, draft)}
            placeholder="Write a reply... Type @ to tag a teammate"
            className="mentions ov2-reply-mentions"
            singleLine={false}
            allowSuggestionsAboveCursor
          >
            <Mention
              trigger="@"
              data={projectMentionUsers}
              markup="@[__display__](__id__)"
              displayTransform={(id, display) => `@${display}`}
              mentionClassName="mentions__mention"
              renderSuggestion={(suggestion, search, highlighted) => (
                <div
                  className={`mention-suggestion-item ${
                    isAssignedMentionUser(suggestion.id) ? "assigned" : ""
                  }`}
                >
                  {highlighted}
                  {isAssignedMentionUser(suggestion.id) && (
                    <span className="assigned-badge">Assigned</span>
                  )}
                </div>
              )}
            />
          </MentionsInput>
        </div>
        <Button
          variant="contained"
          size="small"
          onClick={handleSubmit}
          disabled={!draft.trim() || isPosting}
          sx={{
            fontWeight: 700, whiteSpace: "nowrap",
            bgcolor: "var(--ec-color-primary)",
            "&:hover": { bgcolor: "var(--ec-color-primary-hover, #a90f24)" },
          }}
        >
          {isPosting ? "Posting..." : "Post"}
        </Button>
        <Button
          variant="text"
          size="small"
          onClick={() => onCancel?.(note?.sequence, draft)}
          disabled={isPosting}
          sx={{ fontWeight: 700, whiteSpace: "nowrap" }}
        >
          Cancel
        </Button>
      </Stack>
      <div className="ov2-attachment-row is-reply">
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*,application/pdf"
          onChange={handleAttachmentChange}
          style={{ display: "none" }}
        />
        <button type="button" className="ov2-attach-btn is-compact" onClick={() => fileInputRef.current?.click()} disabled={isPosting}>
          + Attachment
        </button>
        <ProjectNoteAttachmentPreview file={selectedAttachment} compact onRemove={clearAttachment} />
      </div>
    </div>
  );
});

const parseSmartSendCsvArray = (value = "") =>
  sanitizeSmartSendCsvDraft(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

const formatSmartSendCsvArray = (value = "") =>
  Array.isArray(value) ? value.join(",") : sanitizeSmartSendCsvDraft(value);

const formatSmartSendDraftValue = (value, valueKind) => {
  if (valueKind === "csv") return formatSmartSendCsvArray(value);
  if (value == null) return "";
  return String(value);
};

const parseSmartSendDraftValue = (value, valueKind, emptyNumberValue = null) => {
  if (valueKind === "csv") return parseSmartSendCsvArray(value);
  if (valueKind === "number") {
    const trimmed = String(value ?? "").trim();
    if (trimmed === "") return emptyNumberValue;
    const numericValue = Number(trimmed);
    return Number.isFinite(numericValue) ? numericValue : emptyNumberValue;
  }
  return value;
};

const SmartSendDraftTextField = React.memo(function SmartSendDraftTextField({
  value,
  valueKind = "text",
  emptyNumberValue = null,
  onCommit,
  onDraftValue,
  ...props
}) {
  const [draft, setDraft] = useState(() => formatSmartSendDraftValue(value, valueKind));
  const focusedRef = useRef(false);

  useEffect(() => {
    if (!focusedRef.current) {
      setDraft(formatSmartSendDraftValue(value, valueKind));
    }
  }, [value, valueKind]);

  const commitDraft = useCallback((nextDraft) => {
    const parsedValue = parseSmartSendDraftValue(nextDraft, valueKind, emptyNumberValue);
    onDraftValue?.(parsedValue);
    return parsedValue;
  }, [emptyNumberValue, onDraftValue, valueKind]);

  return (
    <TextField
      {...props}
      value={draft}
      onFocus={(event) => {
        focusedRef.current = true;
        props.onFocus?.(event);
      }}
      onChange={(event) => {
        const nextDraft = valueKind === "csv"
          ? sanitizeSmartSendCsvDraft(event.target.value)
          : event.target.value;
        setDraft(nextDraft);
        commitDraft(nextDraft);
        props.onChange?.(event);
      }}
      onBlur={(event) => {
        focusedRef.current = false;
        const nextDraft = valueKind === "csv"
          ? sanitizeSmartSendCsvDraft(event.target.value)
          : event.target.value;
        setDraft(nextDraft);
        const parsedValue = commitDraft(nextDraft);
        onCommit?.(parsedValue);
        props.onBlur?.(event);
      }}
    />
  );
});
const socket = io(process.env.REACT_APP_NODEJS_SERVER_URL, { withCredentials: true });


 
const ALL_TABS_WITH_ICONS = [
  { key: "Overview",                  label: "Overview",    icon: <DescriptionIcon   sx={{ fontSize: 16 }} /> },
  { key: "Files",                     label: "Files",       icon: <FolderOpenIcon    sx={{ fontSize: 16 }} /> },
  { key: "Presentation",             label: "Presentation",icon: <SlideshowIcon     sx={{ fontSize: 16 }} /> },
  { key: "Estimates",                 label: "Estimates",   icon: <RequestQuoteIcon  sx={{ fontSize: 16 }} /> },
  { key: "Sales Order",              label: "Sales Order", icon: <ReceiptLongIcon   sx={{ fontSize: 16 }} /> },
  { key: "Shipping",                  label: "Shipping",    icon: <LocalShippingIcon sx={{ fontSize: 16 }} /> },
  { key: "Purchase Orders / Proofs", label: "PO / Proofs", icon: <ShoppingCartIcon  sx={{ fontSize: 16 }} /> },
  { key: "Invoice",                   label: "Invoice",     icon: <PaymentsIcon      sx={{ fontSize: 16 }} /> },
  { key: "Bills",                     label: "Bills",       icon: <AccountBalanceIcon sx={{ fontSize: 16 }} /> },
  { key: "Commissions",              label: "Commissions", icon: <AssignmentTurnedInIcon sx={{ fontSize: 16 }} /> },
];




const EST_SO_COLUMNS = [
  { id: "estimationId", label: "Estimation ID",  minWidth: 140, align: "left",   visible: true  },
  { id: "orderDate",    label: "Date",            minWidth: 160, align: "left",   visible: true  },
  { id: "status",       label: "Status",          minWidth: 150, align: "left",   visible: true  },
  { id: "clientEmail",  label: "Client Email",    minWidth: 200, align: "left",   visible: true },
  { id: "action",       label: "Actions",         minWidth: 100, align: "center", visible: true, locked: true },
];


const HISTORY_COLUMNS = [
  { id: "estimationId",  label: "Estimation ID", minWidth: 150, align: "left",   visible: true              },
  { id: "regeneratedBy", label: "User",           minWidth: 200, align: "left",   visible: true              },
  { id: "orderDate",     label: "Updated",        minWidth: 160, align: "left",   visible: true              },
  { id: "revisionNumber",label: "Revision",       minWidth: 100, align: "left",   visible: true              },
  { id: "status",        label: "Status",         minWidth: 180, align: "left",   visible: true              },
  { id: "stripeLinks",   label: "Stripe Links",   minWidth: 200, align: "left",   visible: true              },
  { id: "action",        label: "Action",         minWidth: 100, align: "center", visible: true, locked: true },
];


const PRES_COLUMNS = [
  { id: 'presentationId',     label: 'Presentation ID',   minWidth: 150, align: 'left',   visible: true              },
  { id: 'presentationDate',   label: 'Presentation Date', minWidth: 160, align: 'left',   visible: true              },
  { id: 'clientContactEmail', label: 'Client Email',      minWidth: 220, align: 'left',   visible: true              },
  { id: 'actions',            label: 'Actions',           minWidth: 130, align: 'center', visible: true, locked: true },
];




const POCOLUMNS = [
  { id: 'salesOrderId',   label: 'Sales Order ID',  minWidth: 140, align: 'left',   visible: true },
  { id: 'supplierInfo',   label: 'Supplier',         minWidth: 220, align: 'left',   visible: true },
  { id: 'poNumber',       label: 'PO Number',        minWidth: 160, align: 'left',   visible: true },
  { id: 'projectDetails', label: 'Project Details',  minWidth: 180, align: 'left',   visible: true },
  { id: 'supplierStatus', label: 'Status',           minWidth: 150, align: 'left',   visible: true },
  { id: 'nextActionDate', label: 'Next Action',      minWidth: 160, align: 'left',   visible: true },
  { id: 'proof',          label: 'Proof',            minWidth: 260, align: 'left',   visible: true },
  { id: 'action',         label: 'Actions',          minWidth: 180, align: 'center', visible: true, locked: true },
];



class CartPresentationBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("CartPresentationBoundary caught cart render error:", error);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 2, border: "1px solid #fecaca", background: "#fff1f2", borderRadius: 1.5 }}>
          <Typography sx={{ fontWeight: 700, mb: 0.5 }}>Cart preview failed to render.</Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Please refresh the order data and reopen the cart editor.
          </Typography>
          <Button variant="outlined" size="small" onClick={this.props.onRetry}>
            Reload cart
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}
  
const parseAssignedTo = (v) => {
  if (Array.isArray(v)) return v;
  if (typeof v === "string") {
    try { return JSON.parse(v); } catch { return []; }
  }
  return [];
};

const getAssignedEmail = (rep) => {
  const candidates = [rep?.email, rep?.Email, rep?.userEmail, rep?.id];
  return candidates.find((value) => typeof value === "string" && value.includes("@")) || "";
};

const toContact = (email, rep) => {
  if (!email) return null;
  const name = `${rep?.first_name || ""} ${rep?.last_name || ""}`.trim();
  return {
    id: email,
    name: name || rep?.name || email,
    // Internal users may have a profile photo; customer contacts keep initials.
    avatarUrl: resolveMentionAvatarUrl(
      rep?.profilePicture || rep?.profile_picture || rep?.avatarUrl ||
      rep?.avatar || rep?.photoUrl || null
    ),
  };
};

const isTruthyLike = (value) => (
  value === true ||
  value === 1 ||
  value === '1' ||
  value === 'true'
);
const getTrackingDisplay = (po = {}) => {
  const raw = po?.trackingNumbers;
  const list = Array.isArray(raw)
    ? raw.map((s) => String(s || "").trim()).filter(Boolean)
    : String(raw || "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
  return list.length ? list.join(", ") : "";
};

// ---- Tab gating helpers ----
const TABS = {
  ESTIMATES: "Estimates",
  SALES_ORDER: "Sales Order",
  SHIPPING: "Shipping",
  PO_PROOFS: "Purchase Orders / Proofs",
  PO_PROOFS_ALT: "POs/Proofs",       // route alias you also use
  INVOICE: "Invoice",
  BILLS: "Bills",
  COMMISSIONS: "Commissions",
};

const SO_POST_APPROVAL_STAGES = new Set([
  'sales order ready',
  'client approved',
  'sales order - customer signed',
  'customer signed',
  'in production',
  'shipped',
  'ready to be invoiced',
  'invoiced',
  'paid',
]);
const SALES_ORDER_CART_READY_STATUSES = new Set(['3', '6', '7', '8', '9']);
const isSalesOrderCartReadyStatus = (status) =>
  SALES_ORDER_CART_READY_STATUSES.has(String(status || '').split('_')[0]);
const normalizeSalesOrderStageValue = (value) => String(value || '').trim().toLowerCase();
const isReadySalesOrderStage = (value) =>
  SO_POST_APPROVAL_STAGES.has(normalizeSalesOrderStageValue(value));
const isSalesOrderCartEligible = (salesOrder = {}) => {
  const readinessCandidates = [
    salesOrder?.status,
    salesOrder?.readableStatus,
    salesOrder?.statusLabel,
    salesOrder?.statusName,
    salesOrder?.statusText,
    salesOrder?.stage,
    salesOrder?.stageName,
    salesOrder?.lifecycleStatus,
    salesOrder?.salesOrderStage,
    salesOrder?.lifecycleStage,
    salesOrder?.workflowStage,
  ];

  return readinessCandidates.some((candidate) =>
    isSalesOrderCartReadyStatus(candidate) || isReadySalesOrderStage(candidate)
  );
};
const getLatestSalesOrderRow = (salesOrders = []) =>
  [...salesOrders].sort(
    (a, b) => new Date(b?.updatedAt || 0) - new Date(a?.updatedAt || 0)
  )[0] || null;
const shouldDefaultToSalesOrderCart = ({ tabtype, tabId, order }) => {
  if (normalizeSalesOrderStageValue(tabtype) !== 'sales-order') return false;

  const salesOrders = Array.isArray(order?.SalesOrderData) ? order.SalesOrderData : [];
  if (!salesOrders.length) return false;

  const normalizedTabId = String(tabId || '').trim();
  const matchingSalesOrder = normalizedTabId
    ? salesOrders.find((salesOrder) =>
      String(salesOrder?.estimationId ?? '').trim() === normalizedTabId ||
      String(salesOrder?.id ?? '').trim() === normalizedTabId
    ) || null
    : getLatestSalesOrderRow(salesOrders);

  if (!matchingSalesOrder) return false;

  return isSalesOrderCartEligible(matchingSalesOrder);
};

export const resolveCartViewAfterInvoice = ({ tabtype, tabId, order }) =>
  shouldDefaultToSalesOrderCart({ tabtype, tabId, order })
    ? "sales-order-cart"
    : "order-cart";

// Financials open when SO is "Sales Order Ready" AND PO is Ready For Billing / Closed / Billed
const isFinancialsOpen = ({ so, po }) => {
  const soNorm = String(so || '').trim().toLowerCase();
  const soReady = SO_POST_APPROVAL_STAGES.has(soNorm);
  const poStage = String(po || '').trim().toLowerCase();
  const unlockedPO = ['ready for billing', 'closed', 'billed'].includes(poStage);
  return soReady && unlockedPO;
};

/**
 * Returns { disabled: Set<string>, tips: Record<string,string> }
 * based on the current Sales Order stage.
 */
// add a 3rd param: poUnlockedNow
function getTabGatingBySO(
  soRaw,
  allowShippingNow = false,
  poUnlockedNow = false,
  poStageRaw = '',
  hasInvoiceRows = false,
  hasGeneratedPurchaseOrders = false,
  hasBillRows = false,
  canReviewFinancialTabs = false
) {
  const so = String(soRaw || "").trim().toLowerCase();
  const poHasAnyStage = (() => {
    const raw = poStageRaw;
    if (raw === null || raw === undefined) return false;
    const norm = String(raw).trim().toLowerCase();
    return norm !== '' && norm !== 'null';
  })();
  const poTabsUnlocked = poUnlockedNow || poHasAnyStage;
  const disabled = new Set();
  const tips = {};

  const early = new Set(["quote requested", "lead", "waiting", "presentation draft", "presentation sent", "estimate draft"]);

  if (!so || early.has(so)) {
    [TABS.SHIPPING, TABS.PO_PROOFS, TABS.PO_PROOFS_ALT, TABS.BILLS, TABS.INVOICE, TABS.COMMISSIONS]
      .forEach(tab => { disabled.add(tab); tips[tab] = "Available after estimate created."; });
    tips[TABS.SHIPPING] = "Available after sales order created.";
  }
  else if (so === "estimate sent") {
    [TABS.SHIPPING, TABS.BILLS, TABS.INVOICE, TABS.COMMISSIONS]
      .forEach(tab => { disabled.add(tab); tips[tab] = "Available after sales order created."; });

    // Keep POs locked unless status 3 exists
    if (!poTabsUnlocked) {
      disabled.add(TABS.PO_PROOFS);
      disabled.add(TABS.PO_PROOFS_ALT);
      tips[TABS.PO_PROOFS]     = "Available after client signs the sales order.";
      tips[TABS.PO_PROOFS_ALT] = "Available after client signs the sales order.";
    }
  }
  else if (["agreement pending", "agreement sent", "client change requested"].includes(so)) {
    [TABS.SHIPPING, TABS.PO_PROOFS, TABS.PO_PROOFS_ALT, TABS.BILLS, TABS.INVOICE, TABS.COMMISSIONS]
      .forEach(tab => { disabled.add(tab); tips[tab] = "Available after client approval."; });
    if (poTabsUnlocked) {
      disabled.delete(TABS.PO_PROOFS);
      disabled.delete(TABS.PO_PROOFS_ALT);
      delete tips[TABS.PO_PROOFS];
      delete tips[TABS.PO_PROOFS_ALT];
    }
  }
  else if (SO_POST_APPROVAL_STAGES.has(so)) {
    // Keep POs locked unless status 3 exists
    if (!poTabsUnlocked) {
      disabled.add(TABS.PO_PROOFS);
      disabled.add(TABS.PO_PROOFS_ALT);
      tips[TABS.PO_PROOFS]     = "Available after client signs the sales order.";
      tips[TABS.PO_PROOFS_ALT] = "Available after client signs the sales order.";
    }

    const financialsOpen = isFinancialsOpen({ so: soRaw, po: poStageRaw });
    const billsOpen = hasBillRows || hasGeneratedPurchaseOrders;
    if (!billsOpen) {
      disabled.add(TABS.BILLS);
      tips[TABS.BILLS] = "Bills will appear once Purchase Orders have been generated for this Sales Order.";
    }
    if (!financialsOpen) {
      [TABS.INVOICE, TABS.COMMISSIONS].forEach(tab => {
        disabled.add(tab);
        tips[tab] = "Opens when PO is Ready For Billing, Closed, or Billed.";
      });
    }
  }

  if (allowShippingNow) {
    disabled.delete(TABS.SHIPPING);
    delete tips[TABS.SHIPPING];
  }

  // If at least one invoice record exists for this project, always allow Invoice tab access.
  if (hasInvoiceRows) {
    disabled.delete(TABS.INVOICE);
    delete tips[TABS.INVOICE];
  }

  // Finance can inspect financial workspaces at every sales-order stage.
  // This only unlocks navigation; invoice and bill actions retain their own guards.
  if (canReviewFinancialTabs) {
    [TABS.INVOICE, TABS.BILLS, TABS.COMMISSIONS].forEach((tab) => {
      disabled.delete(tab);
      delete tips[tab];
    });
  }

  return { disabled, tips };
}

// put this near your other helpers

const escapeHtml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const formatMoney = (amount, currency = 'CAD') => {
  const n = Number(amount || 0);
  return `${String(currency || 'CAD').toUpperCase()} ${n.toFixed(2)}`;
};

const APPROVED_OR_LATER_SO_STATUSES = new Set(["3", "6", "7", "8", "9"]);
const ESTIMATE_CREATION_STATUSES = new Set(["1", "1_sent"]);
const SALES_ORDER_CREATION_STATUSES = new Set([
  "2",
  "2_sent",
  ...APPROVED_OR_LATER_SO_STATUSES,
]);

export const resolveDocumentCreationGuards = ({
  records = [],
  globalLocked = false,
  loading = false,
} = {}) => {
  const statuses = (Array.isArray(records) ? records : []).map((record) => String(record?.status));
  const hasEstimate = statuses.some((status) => ESTIMATE_CREATION_STATUSES.has(status));
  const hasSalesOrder = statuses.some((status) => SALES_ORDER_CREATION_STATUSES.has(status));

  return {
    hasEstimate,
    hasSalesOrder,
    blockCreateEstimate: loading || globalLocked || hasEstimate || hasSalesOrder,
    blockCreateSalesOrder: loading || globalLocked || hasSalesOrder,
  };
};

export const isDocumentCreationBlocked = (guards, requestedConversionStatus) => (
  Number(requestedConversionStatus) === 1
    ? Boolean(guards?.blockCreateEstimate)
    : Number(requestedConversionStatus) === 2
      ? Boolean(guards?.blockCreateSalesOrder)
      : true
);

const buildGeneratedInvoiceUrl = (invoiceId) => {
  const base = process.env.REACT_APP_FRONTEND_URL || window.location.origin;
  return invoiceId ? `${base}/generated-invoice/${invoiceId}` : '';
};

const ALL_TABS_BASE = [
  "Overview",
  "Files",
  "Presentation",
  "Estimates",
  "Sales Order",
  "Shipping",
  "Purchase Orders / Proofs",
  "Invoice",
  "Bills",
];

const LEAD_TABS_BASE = [
  "Overview",
  "Files",
  "Presentation",
  "Estimates",
  "Sales Order",
  "Shipping",
  "Purchase Orders / Proofs",
  "Invoice",
  "Bills",
];

export const getTabsToShow = ({
  canSeeCommissions = false,
  canManageInvoices = false,
  canViewInvoices = false,
  invoiceCount = 0,
  customerStatus = "",
} = {}) => {
  const allTabs = canSeeCommissions
    ? [...ALL_TABS_BASE, "Commissions"]
    : ALL_TABS_BASE;
  const leadTabs = canSeeCommissions
    ? [...LEAD_TABS_BASE, "Commissions"]
    : LEAD_TABS_BASE;
  const invoiceTabVisible = shouldShowInvoicesTab({
    canManageInvoices,
    canViewInvoices,
    invoiceCount,
  });
  const visibleTabs =
    customerStatus === "lead" || customerStatus === "in-review"
      ? leadTabs
      : allTabs;

  return invoiceTabVisible
    ? visibleTabs
    : visibleTabs.filter((tab) => tab !== "Invoice");
};

const ORDER_TAB_ROUTE_MAP = {
  overview: 'Overview',
  files: 'Files',
  presentation: 'Presentation',
  estimation: 'Estimates',
  estimates: 'Estimates',
  'sales-order': 'Sales Order',
  shipping: 'Shipping',
  'purchase-orders': 'Purchase Orders / Proofs',
  'purchase-order': 'Purchase Orders / Proofs',
  'purchase-order-home': 'Purchase Orders / Proofs',
  proofs: 'Purchase Orders / Proofs',
  'pos-proofs': 'Purchase Orders / Proofs',
  invoice: 'Invoice',
  bills: 'Bills',
  bill: 'Bills',
  commissions: 'Commissions',
};

const getActiveOrderTabFromPathname = (pathname, tabtype) => {
  const fallbackSegment = String(tabtype || '').trim().toLowerCase();
  const normalizedPath = String(pathname || '').split('?')[0].split('#')[0];
  const pathSegments = normalizedPath
    .split('/')
    .map((segment) => String(segment || '').trim().toLowerCase())
    .filter(Boolean);
  const ordersIndex = pathSegments.findIndex((segment) => segment === 'orders');
  const routeSegment = ordersIndex >= 0 ? pathSegments[ordersIndex + 2] || '' : '';
  const normalizedRouteSegment = routeSegment || fallbackSegment;
  return ORDER_TAB_ROUTE_MAP[normalizedRouteSegment] || 'Overview';
};

const ESTIMATE_DOCUMENT_STATUSES = new Set(['1', '1_sent']);

const isEstimateDocumentStatus = (status) =>
  ESTIMATE_DOCUMENT_STATUSES.has(String(status || '').trim());

const isActiveLifecycleDocument = (row = {}) => {
  const lifecycle = String(row?.lifecycleStatus || '').trim().toLowerCase();
  return !lifecycle || lifecycle === 'active' || lifecycle === 'current';
};

const compareGeneratedDocumentRows = (a = {}, b = {}) => {
  const revisionDiff = Number(b?.revisionNumber || 0) - Number(a?.revisionNumber || 0);
  if (revisionDiff) return revisionDiff;

  const updatedDiff = new Date(b?.updatedAt || b?.orderDate || b?.createdAt || 0)
    - new Date(a?.updatedAt || a?.orderDate || a?.createdAt || 0);
  if (updatedDiff) return updatedDiff;

  return Number(b?.estimationId || b?.id || 0) - Number(a?.estimationId || a?.id || 0);
};

export const resolvePreferredDocumentRowForTab = ({
  tab,
  salesOrderRows = [],
} = {}) => {
  const rows = Array.isArray(salesOrderRows) ? salesOrderRows : [];
  const normalizedTab = String(tab || '').trim().toLowerCase();
  const wantsEstimate = normalizedTab === 'estimates';
  const wantsSalesOrder = normalizedTab === 'sales order';

  if (!wantsEstimate && !wantsSalesOrder) return null;

  const matchingRows = rows.filter((row) => {
    const statusValue = String(row?.status || '').trim();
    if (!statusValue) return false;
    return wantsEstimate
      ? isEstimateDocumentStatus(statusValue)
      : !isEstimateDocumentStatus(statusValue);
  });

  if (!matchingRows.length) return null;

  const activeRows = matchingRows.filter(isActiveLifecycleDocument);
  const preferredPool = activeRows.length ? activeRows : matchingRows;

  return [...preferredPool].sort(compareGeneratedDocumentRows)[0] || null;
};

export const buildSmartOrderTabRoute = ({
  tab,
  instanceUniqueId,
  orderId,
  salesOrderRows = [],
} = {}) => {
  const preferredRow = resolvePreferredDocumentRowForTab({ tab, salesOrderRows });
  if (!preferredRow) return null;

  if (preferredRow.routePath) return preferredRow.routePath;

  const documentId = preferredRow?.estimationId ?? preferredRow?.id;
  if (!documentId || !instanceUniqueId || !orderId) return null;

  const routeType = isEstimateDocumentStatus(preferredRow?.status) ? 'estimation' : 'sales-order';
  return `/instance/${instanceUniqueId}/sales/orders/${orderId}/${routeType}/${documentId}`;
};

export const resolveActiveOrderTab = ({
  pathname,
  tabtype,
  canSeeCommissions = false,
  tabsToShow = [],
} = {}) => {
  const desired = getActiveOrderTabFromPathname(pathname, tabtype);

  if (desired === "Commissions" && !canSeeCommissions) {
    return "Overview";
  }

  if (desired === "Invoice" && !tabsToShow.includes("Invoice")) {
    return "Overview";
  }

  return desired;
};

export const getMissingSalesOrderSendAddresses = (salesOrder = {}) => {
  const hasBillingContact = Boolean(
    String(salesOrder?.billingContactId || "").trim() ||
    String(salesOrder?.billingName || "").trim()
  );
  const hasBillingAddress = Boolean(
    String(salesOrder?.billingAddressId || "").trim() ||
    String(salesOrder?.billingAddress || "").trim()
  );
  const hasShippingContact = Boolean(
    String(salesOrder?.shippingContactId || "").trim() ||
    String(salesOrder?.shippingName || "").trim()
  );
  const hasShippingAddress = Boolean(
    String(salesOrder?.shippingAddressId || "").trim() ||
    String(salesOrder?.shippingAddress || "").trim()
  );

  return [
    !hasBillingContact ? "Billing Contact" : null,
    !hasBillingAddress ? "Billing Address" : null,
    !hasShippingContact ? "Shipping Contact" : null,
    !hasShippingAddress ? "Shipping Address" : null,
  ].filter(Boolean);
};

export const hasRealGeneratedPurchaseOrders = (purchaseOrders = []) =>
  (Array.isArray(purchaseOrders) ? purchaseOrders : []).some((purchaseOrder) => {
    const hasPersistedId = purchaseOrder?.id !== null && purchaseOrder?.id !== undefined;
    const hasPoNumber = String(purchaseOrder?.poNumber || "").trim().length > 0;
    return purchaseOrder?.isDeleted !== true && hasPersistedId && hasPoNumber;
  });

export const resolvePresentationNavigationState = ({
  loading = false,
  orderHydrated = false,
  presentations = [],
} = {}) => {
  const hasResolvedPresentationState = orderHydrated && !loading;
  const hasPresentations = hasResolvedPresentationState && Array.isArray(presentations) && presentations.length > 0;

  return {
    hasResolvedPresentationState,
    hasPresentations,
    showPresentationDetails: hasResolvedPresentationState && !hasPresentations,
    showPresentationHistory: hasResolvedPresentationState && hasPresentations,
  };
};

export const getBinatedProofProviderReadiness = (proofProvider = {}) => {
  const cfg = proofProvider?.binated || {};
  return (
    proofProvider?.enabled === true &&
    cfg?.hasApiKey === true &&
    cfg?.hasApiSecret === true &&
    !!cfg?.baseUrl
  );
};

export const hasIncludedSmartSendSkuPayload = (payload = {}) => (
  payload?.data?.sales_order?.some((salesOrder) =>
    salesOrder?.purchase_order?.some((purchaseOrder) =>
      purchaseOrder?.sku?.some((sku) =>
        sku?.decoration?.some((decoration) =>
          decoration?.placements?.some((placement) =>
            Array.isArray(placement?.url) && placement.url.some((url) => String(url || "").trim())
          )
        )
      )
    )
  )
);

export const getSendToBinatedDisabledReason = ({
  finalSmartSendPayload = null,
  requestArtLoading = false,
  submitting = false,
  lifecycleLoading = false,
  isSubmittedRequestLocked = false,
  settingsReady = false,
  requestArtSmartSend = true,
  selectedRequestPoId = "",
} = {}) => {
  if (requestArtLoading) return "Request artwork payload is loading.";
  if (submitting) return "Binated submission is already in progress.";
  if (requestArtSmartSend && lifecycleLoading) return "Binated request status is still loading.";
  if (requestArtSmartSend && isSubmittedRequestLocked) return "This Binated request has already been submitted.";
  if (!settingsReady) return "Binated proof-provider settings are not ready.";
  if (requestArtSmartSend && !hasIncludedSmartSendSkuPayload(finalSmartSendPayload)) {
    return "Smart Send does not include artwork with a file URL.";
  }
  if (!requestArtSmartSend && !selectedRequestPoId) return "Select a purchase order before sending to Binated.";
  return "";
};

export const resolveAttachedOrderCustomerId = (order = {}) => {
  const attached = Array.isArray(order?.attachedCustomers) ? order.attachedCustomers : [];
  if (!attached.length) return null;
  const first = attached[0];
  return typeof first === "object" ? first?.id || null : first;
};

export const buildProjectHeaderCustomerHref = ({ instanceUniqueId, customerId }) => {
  const normalizedInstance = String(instanceUniqueId || "").trim();
  const normalizedCustomerId = String(customerId ?? "").trim();
  if (!normalizedInstance || !normalizedCustomerId) return "";
  return `/instance/${normalizedInstance}/sales/customers?tab=all&openCustomer=${encodeURIComponent(
    normalizedCustomerId
  )}`;
};

export const resolveCustomerTermsLabel = (customer) => {
  const resolvedName = String(customer?.termsName || "").trim();
  if (resolvedName) return resolvedName;
  return String(customer?.terms ?? "").trim();
};

export const resolveCustomerCreditHold = (customer) => Boolean(
  customer?.isCreditHold ||
  customer?.termsIsCreditHold ||
  customer?.termsName === "Credit Hold" ||
  customer?.terms === "Credit Hold"
);

export const resolveCustomerTermsTooltip = (customer) => {
  const policy = customer?.termsPaymentPolicy;
  const requiresUpfrontPayment = [true, 1, "1", "true"].includes(policy?.requireUpfrontPayment);
  if (!requiresUpfrontPayment) return "";

  if (policy.upfrontMode === "deposit") {
    const rawValue = String(policy.depositValue ?? "").trim();
    const numericValue = Number(rawValue);
    const value = rawValue && Number.isFinite(numericValue) ? String(numericValue) : rawValue;
    if (policy.depositType === "percent" && value) {
      return `Upfront payment required: ${value}% deposit`;
    }
    if (policy.depositType === "fixed" && value) {
      return `Upfront payment required: ${value} fixed deposit`;
    }
    return "Upfront payment required: Deposit";
  }

  return "Upfront payment required: Full payment";
};

const pickInvoiceNumber = (invoice = {}) =>
  invoice?.qboDocNumber || invoice?.docNumber || invoice?.invoiceNumber || invoice?.id || '';

const pickInvoiceAmount = (invoice = {}, fallbackAmount = 0) =>
  invoice?.amount || invoice?.total || invoice?.grandTotal || invoice?.amountDue || fallbackAmount || 0;

const pickPaymentLink = (invoice = {}) =>
  invoice?.checkoutLink || invoice?.checkoutUrl || invoice?.paymentLink || '';

const PROOF_SOURCE_OPTIONS = {
  design_rep: {
    value: "design_rep",
    label: "Binated Files",
    selectedLabel: "Binated Files",
    shortDescription: "Proof files returned from a completed Binated request.",
    tooltip:
      "Use proof files associated with the Design Rep workflow for this Sales Order. Choose this when artwork/proofs were prepared through the design-rep process rather than returned through Core Network. These files can then be mapped to the appropriate product or decoration targets.",
    icon: DesignServicesOutlinedIcon,
  },
  "core-network": {
    value: "core-network",
    label: "Other designer",
    selectedLabel: "Other designer",
    shortDescription: "Proofs provided by your assigned Talent",
    tooltip:
      "Use approved proof files returned from Core Network Request Art work. Approved submission files are synchronized into Sales Order Proofing and can then be mapped to the applicable products or decoration locations.",
    icon: HubOutlinedIcon,
  },
  internal: {
    value: "internal",
    label: "Upload myself",
    selectedLabel: "Upload myself",
    shortDescription: "Proofs handled internally by Elite",
    tooltip:
      "Use proof files being handled internally instead of through an external proof provider. Internal proof files can be mapped to the Sales Order's product or decoration targets before customer approval.",
    icon: FolderOpenOutlinedIcon,
  },
};

const PROOF_SOURCE_DETECTION_ORDER = ["core-network", "internal", "design_rep"];
const REQUEST_PROVIDER_BY_PROOF_SOURCE = {
  design_rep: "binated",
  "core-network": "core-network",
};
const DISABLED_PROOF_SOURCE_MESSAGES = {
  design_rep: "No Binated artwork request exists for this Sales Order.",
  "core-network": "No Core Network artwork request exists for this Sales Order.",
};
const normalizeProofSourceType = (value = "") => String(value || "").trim().toLowerCase();
const normalizeFulfillmentProvider = (value = "") => String(value || "").trim().toLowerCase();
const getRequestProviderForProofSource = (sourceType = "") =>
  REQUEST_PROVIDER_BY_PROOF_SOURCE[normalizeProofSourceType(sourceType)] || "";
const getProofSourceTypeForFulfillmentProvider = (provider = "") => {
  const normalizedProvider = normalizeFulfillmentProvider(provider);
  if (normalizedProvider === "binated") return "design_rep";
  if (normalizedProvider === "core-network") return "core-network";
  if (normalizedProvider === "internal") return "internal";
  return "";
};
const getProofSourcePriorityRank = (sourceType = "") => {
  const normalizedSourceType = normalizeProofSourceType(sourceType);
  if (normalizedSourceType === "core-network") return 0;
  if (normalizedSourceType === "design_rep") return 1;
  if (normalizedSourceType === "internal") return 2;
  return 99;
};

export const formatDesignerRequestElapsed = (createdAt, now = Date.now()) => {
  const start = new Date(createdAt || 0);
  const end = new Date(now);
  if (!createdAt || !Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime())) return null;
  return formatDistance(start, end);
};

export const formatDesignerRequestAgo = (date, now = Date.now()) => {
  const parsed = new Date(date || 0);
  if (!date || !Number.isFinite(parsed.getTime())) return null;
  return formatDistance(parsed, new Date(now), { addSuffix: true });
};

export const getDesignerRequestProgressLabel = (row = {}) => {
  const submissionStatus = String(row.latestSubmission?.status || "").toLowerCase();
  const requestStatus = String(row.lifecycleStatus || "").toLowerCase();
  if (submissionStatus === "revision_requested" || submissionStatus === "rejected" || requestStatus === "revision_requested") return "Changes requested";
  if (submissionStatus === "submitted" || requestStatus === "awaiting_review") return "Awaiting artwork review";
  if (submissionStatus === "approved") return "Artwork reviewed";
  if (requestStatus === "completed" && !row.latestSubmission) return "Completed without an artwork submission";
  if (requestStatus === "completed") return "Design request completed";
  if (!row.assignedTalent && !row.selectedTalent) return "Awaiting designer assignment";
  return "Awaiting artwork submission";
};

const getProofRequestTimestamp = (statusRow = {}) => {
  const candidates = [
    statusRow?.lastActivityAt,
    statusRow?.updatedAt,
    statusRow?.createdAt,
  ];

  for (const candidate of candidates) {
    const parsed = new Date(candidate || 0).getTime();
    if (parsed > 0) return parsed;
  }

  return 0;
};

const FULFILLMENT_METHOD_OPTIONS = [
  {
    value: "binated",
    label: "Send to Binated",
    description: "Use the current Binated designer flow for this request.",
    icon: DesignServicesOutlinedIcon,
  },
  {
    value: "core-network-direct",
    label: "Use other designer",
    description: "Assign this artwork request to another designer.",
    icon: HubOutlinedIcon,
  },
  // Keep these inactive paths available in code for later designer-network expansion.
  // {
  //   value: "core-network-marketplace",
  //   label: "Post to Core Network",
  //   description: "Offer this artwork request to the broader designer network.",
  //   icon: HubOutlinedIcon,
  // },
  // {
  //   value: "internal",
  //   label: "Complete Internally",
  //   description: "Handle this artwork request fully inside Elite Core.",
  //   icon: FolderOpenOutlinedIcon,
  // },
];

const DESIGNER_REQUEST_TAB_OPTIONS = {
  existing: "status",
  create: "form",
};
const CORE_NETWORK_DIRECT_FULFILLMENT = "core-network-direct";

const pluralizeLabel = (count, singular, plural = `${singular}s`) =>
  `${count} ${count === 1 ? singular : plural}`;

const getProofSourceResponseMeta = (sourceType, response = {}) => {
  const normalizedSourceType = String(sourceType || "").trim().toLowerCase();
  const sourceSyncSummary =
    response?.sourceSyncSummary && typeof response.sourceSyncSummary === "object"
      ? response.sourceSyncSummary
      : null;
  const fileGroups = Array.isArray(sourceSyncSummary?.fileGroups) ? sourceSyncSummary.fileGroups : [];
  const mappings = Array.isArray(response?.mappings) ? response.mappings : [];
  const filesMapped = Number(sourceSyncSummary?.filesMapped || 0);
  const filesDiscovered =
    Number(sourceSyncSummary?.filesDiscovered || 0) ||
    fileGroups.reduce((sum, group) => sum + Number(group?.fileCount || 0), 0);

  return {
    sourceType: normalizedSourceType,
    response,
    sourceSyncSummary,
    fileGroups,
    filesMapped,
    filesDiscovered,
    hasUsableData:
      normalizedSourceType === "design_rep"
        ? mappings.length > 0
        : filesDiscovered > 0 || filesMapped > 0 || mappings.length > 0,
  };
};

const buildCoreNetworkLinkageBanner = (sourceMeta = null) => {
  if (!sourceMeta || sourceMeta.sourceType !== "core-network" || !sourceMeta.sourceSyncSummary) return null;

  const workRequestsProcessed = Number(
    sourceMeta.sourceSyncSummary.workRequestsProcessed || sourceMeta.fileGroups.length || 0
  );
  const primaryGroup = sourceMeta.fileGroups[0] || null;
  const primaryRequestLabel = primaryGroup?.workRequestId
    ? `Work Request #${primaryGroup.workRequestId}`
    : "Work Request";
  const primaryWithTalent = primaryGroup?.talentDisplayName
    ? `${primaryRequestLabel} with ${primaryGroup.talentDisplayName}`
    : primaryRequestLabel;

  if (sourceMeta.filesMapped > 0) {
    return {
      heading: "Core Network linked",
      message:
        workRequestsProcessed > 1
          ? `${pluralizeLabel(sourceMeta.filesMapped, "approved proof file")} from ${pluralizeLabel(
              workRequestsProcessed,
              "Core Network work request"
            )} were automatically mapped to this Sales Order.`
          : sourceMeta.filesMapped > 1
            ? `${pluralizeLabel(sourceMeta.filesMapped, "approved proof file")} from ${primaryWithTalent} were automatically mapped to this Sales Order.`
            : `${primaryWithTalent} was automatically mapped to this Sales Order.`,
    };
  }

  if (sourceMeta.filesDiscovered > 0) {
    return {
      heading: "Core Network files found",
      message:
        workRequestsProcessed > 1
          ? `${pluralizeLabel(sourceMeta.filesDiscovered, "approved proof file")} from ${pluralizeLabel(
              workRequestsProcessed,
              "Core Network work request"
            )} were imported automatically. Review their proof assignments below.`
          : `Approved files from ${primaryWithTalent} were imported automatically. Review their proof assignments below.`,
    };
  }

  return null;
};

const buildCoreNetworkProofStatusLine = (sourceMeta = null, fallbackTalentName = "") => {
  if (!sourceMeta || sourceMeta.sourceType !== "core-network") {
    return {
      summary: "Proofs provided by your assigned Talent",
      approvalStatus: "",
    };
  }

  const primaryGroup = sourceMeta.primaryGroup || sourceMeta.fileGroups?.[0] || null;
  const talentName =
    String(primaryGroup?.talentDisplayName || fallbackTalentName || "").trim() || "Your Talent";
  const status = Number(sourceMeta.filesMapped || 0) > 0 ? "completed" : "in progress";
  const approvalStatus = sourceMeta.hasRejectedProofs
    ? "At least one proof has changes requested or is no longer approved."
    : !sourceMeta.proofingComplete && (sourceMeta.hasPendingProofs || sourceMeta.hasRejectedProofs)
      ? "Artwork proofing is still awaiting customer approval."
      : "";
  return {
    summary: `Proofs provided by ${talentName} are ${status}.`,
    approvalStatus,
  };
};

const buildInvoiceEmailSubject = ({ invoice, orderId, order, projectName }) => {
  const invoiceNumber = pickInvoiceNumber(invoice);
  const resolvedProjectName =
    projectName || order?.ProjectName || order?.projectName || invoice?.projectName || `Project ${invoice?.orderId || orderId}`;
  return `Invoice ${invoiceNumber ? `#${invoiceNumber}` : ''} for ${resolvedProjectName}`.replace(/\s+/g, ' ').trim();
};

const buildInvoiceEmailBody = ({ invoice, orderId, order, projectName: projectNameOverride, amountOverride }) => {
  const invoiceId = invoice?.id;
  const invoiceNumber = pickInvoiceNumber(invoice);
  const projectName =
    projectNameOverride || order?.ProjectName || order?.projectName || invoice?.projectName || `Project ${invoice?.orderId || orderId}`;
  const customerName = invoice?.billingName || invoice?.customerName || order?.CustomerName || '';
  const amount = pickInvoiceAmount(invoice, amountOverride);
  const currency = invoice?.currency || order?.currency || 'CAD';
  const status = invoice?.paymentStatus || invoice?.invoiceStatus || 'Open';
  const paymentLink = pickPaymentLink(invoice);
  const invoiceUrl = buildGeneratedInvoiceUrl(invoiceId);
  return `
    <p>Hi${customerName ? ` ${escapeHtml(customerName)}` : ''},</p>
    <p>Your invoice for <strong>${escapeHtml(projectName)}</strong> is ready.</p>
    <table cellpadding="6" cellspacing="0" style="border-collapse:collapse;margin:12px 0;">
      <tr><td><strong>Invoice #</strong></td><td>${escapeHtml(invoiceNumber || invoiceId || '—')}</td></tr>
      <tr><td><strong>Project</strong></td><td>${escapeHtml(projectName)}</td></tr>
      <tr><td><strong>Amount Due</strong></td><td>${escapeHtml(formatMoney(amount, currency))}</td></tr>
      <tr><td><strong>Status</strong></td><td>${escapeHtml(status)}</td></tr>
    </table>
    ${paymentLink ? `<p><a href="${escapeHtml(paymentLink)}">Pay invoice online</a></p>` : ''}
    ${invoiceUrl ? `<p><a href="${escapeHtml(invoiceUrl)}">View invoice</a></p>` : ''}
    <p>Thank you,</p>
  `;
};

const getPreferredInvoiceLayout = (currentLayout) => {
  if (currentLayout && currentLayout !== 'plain') return currentLayout;
  return currentLayout || 'plain';
};

const toDateInput = (raw) => {
  if (!raw) return '';
  if (typeof raw === 'string') {
    // If it's already YYYY-MM-DD or starts with that, just take the first 10 chars
    const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
  }
  // Fallback for Date objects / other shapes: use UTC so no TZ shift
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
};

const DEFAULT_ORDER_CURRENCY_OPTIONS = ["CAD"];
const normalizeCurrencyCode = (value, fallback = "CAD") => {
  const normalized = String(value || "").trim().toUpperCase();
  return normalized || fallback;
};
const normalizeEnabledCurrencyCodes = (settings = {}, fallback = "CAD") => {
  const defaultCode = normalizeCurrencyCode(settings.defaultCurrencyCode, fallback);
  const enabled = Array.isArray(settings.enabledCurrencyCodes)
    ? settings.enabledCurrencyCodes.map((code) => normalizeCurrencyCode(code, null)).filter(Boolean)
    : [];
  return Array.from(new Set([defaultCode, ...enabled]));
};

export function SalesOrderDepositActions({
  isSalesOrderRoute,
  depositCheckDialogOpen,
  setDepositCheckDialogOpen,
  instanceUniqueId,
  orderId,
  currentUser,
  orderInvoices,
  paidDepositIconState,
  onOpenPaidDepositApproval,
}) {
  if (!isSalesOrderRoute) return null;

  return (
    <>
      <Stack direction="row" spacing={0.75} alignItems="center">
        <Tooltip title="Request Deposit Check" arrow>
          <span>
            <IconButton
              size="small"
              aria-label="Request Deposit Check"
              onClick={() => setDepositCheckDialogOpen(true)}
              sx={{ p: 0.25 }}
            >
              <FactCheckOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title={paidDepositIconState.tooltip} arrow>
          <span>
            <IconButton
              size="small"
              aria-label="Approve Sales Order from paid deposit"
              disabled={!paidDepositIconState.enabled}
              onClick={onOpenPaidDepositApproval}
              sx={{
                p: 0.25,
                opacity: paidDepositIconState.enabled ? 1 : 0.4,
                color: paidDepositIconState.enabled ? "success.main" : "text.disabled",
              }}
            >
              <PaymentsIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </span>
        </Tooltip>
      </Stack>

      <DepositCheckRequestDialog
        open={depositCheckDialogOpen}
        onClose={() => setDepositCheckDialogOpen(false)}
        instanceUniqueId={instanceUniqueId}
        orderId={orderId}
        currentUser={currentUser}
        invoices={Array.isArray(orderInvoices) ? orderInvoices : []}
      />
    </>
  );
}




/**
 * Sales Order Create Invoice amount policy.
 *
 * Finance may bill a smaller positive amount as a partial invoice. The
 * approved, immutable Sales Order defines the currently uninvoiced ceiling;
 * exceeding it needs a revised source or reconciliation of existing invoices.
 * Do not silently clamp the entered value (the preview service may cap it).
 */
export const assessSalesOrderInvoiceCreateAmount = ({
  amount,
  remainingInvoiceable,
  hasPriorCoverage = false,
  manualAdditional = false,
  approvedSalesOrderTotal = 0,
} = {}) => {
  const raw = String(amount ?? '').trim();
  if (!raw || !/^\d+(?:\.\d{1,2})?$/.test(raw)) {
    return { valid: false, message: 'Enter a positive invoice amount with up to two decimal places.', role: null };
  }
  const requestedCents = Math.round(Number(raw) * 100);
  const remainingCents = Math.round((Number(remainingInvoiceable) || 0) * 100);
  if (!Number.isSafeInteger(requestedCents) || requestedCents <= 0) {
    return { valid: false, message: 'Enter a positive invoice amount with up to two decimal places.', role: null };
  }
  if (manualAdditional) {
    const approvedCents = Math.round((Number(approvedSalesOrderTotal) || 0) * 100);
    if (approvedCents <= 0 || requestedCents > approvedCents) {
      return { valid: false, message: 'The additional amount cannot exceed the approved Sales Order total. Use an updated Sales Order for a larger charge.', role: null };
    }
    return {
      valid: true, message: '', amount: requestedCents / 100,
      role: 'partial', requestedCents, remainingCents: 0,
      manualAdditional: true,
    };
  }
  if (remainingCents <= 0) {
    return { valid: false, message: 'No uninvoiced balance remains. Review active invoices or update the Sales Order before creating another.', role: null };
  }
  if (requestedCents > remainingCents) {
    return {
      valid: false,
      message: 'This amount exceeds the available invoiceable balance. Review existing invoices or revise the Sales Order; the amount will not be reduced silently.',
      role: null,
      requestedCents,
      remainingCents,
    };
  }
  return {
    valid: true,
    message: '',
    amount: requestedCents / 100,
    role: requestedCents < remainingCents ? 'partial' : (hasPriorCoverage ? 'balance' : 'full'),
    requestedCents,
    remainingCents,
  };
};

function InstanceSingleOrderManager() {
  // Route params are needed by initial hook state (invoice readiness).
  // Resolve them before any useState initializer reads instanceUniqueId.
  const { instanceUniqueId, orderId, tabId, tabtype } = useParams();
  const debugRender =
    typeof window !== "undefined" &&
    (window.__ELITE_DEBUG_RENDER === true || window.localStorage?.getItem("elite_debug_render") === "1");

  // TEMP DEBUG: remove after Project Overview financial KPI source verification is complete.
  const OVERVIEW_FINANCIAL_DEBUG = true;
  const OVERVIEW_FINANCIAL_DEBUG_RAW =
    typeof window !== "undefined" &&
    window.localStorage?.getItem("debugOverviewFinancialsRaw") === "1";

  const { authState } = useContext(AuthContext); 
  const currentUser = authState?.user || authState || {};
  // Preserve both the top-level and nested instance roles. A Super
  // Administrator inherits Administrator access throughout this project page.
  const roleSet = normalizeInvoiceRoles(authState || {});
  const isAdministrator = roleSet.has('administrator');
  const isSuperAdministrator = roleSet.has('super-administrator');
  const isClientRep    = roleSet.has('client-rep');
  const isOrderRep     = roleSet.has('order-rep');
  const isFinanceRep   = roleSet.has('finance-rep') || roleSet.has('finance');
  const {
    canViewInvoices,
    canManageInvoices,
    readOnlyInvoiceAccess,
  } = getInvoicePermissionState(authState || {});
  const canSeeCommissions = isAdministrator || isFinanceRep || isClientRep;
  const currentUserId = Number(currentUser?.id || authState?.id || 0);
  const [currentUserBinatedConnected, setCurrentUserBinatedConnected] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const loadCurrentUserBinatedConnection = async () => {
      if (!currentUserId) {
        setCurrentUserBinatedConnected(false);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/users/${currentUserId}/api-credentials`,
          { headers: { accessToken: localStorage.getItem("accessToken") } }
        );
        const binated = response.data?.binated;
        if (!cancelled) {
          setCurrentUserBinatedConnected(
            binated?.enabledForCurrentInstance === true && binated?.isComplete === true
          );
        }
      } catch (error) {
        if (!cancelled) setCurrentUserBinatedConnected(false);
      }
    };

    loadCurrentUserBinatedConnection();
    return () => {
      cancelled = true;
    };
  }, [currentUserId]);

  const [overviewFinancialDebugOpen, setOverviewFinancialDebugOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [order, setOrder] = useState({});
  const [archiveConfirmOpen, setArchiveConfirmOpen] = useState(false);
  const [archiveProjectNameConfirmation, setArchiveProjectNameConfirmation] = useState("");
  const [archivingProject, setArchivingProject] = useState(false);
  const [orderCurrencyOptions, setOrderCurrencyOptions] = useState(DEFAULT_ORDER_CURRENCY_OPTIONS);
  const [orderCurrencyOptionsLoading, setOrderCurrencyOptionsLoading] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [orderHydrated, setOrderHydrated] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [customerData, setCustomerData] = useState(null);
  const [customerDataLoading, setCustomerDataLoading] = useState(true);
  const [requestingCustomerConversion, setRequestingCustomerConversion] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [popupInitialView, setPopupInitialView] = useState(null);
  const [showProductPopup, setShowProductPopup] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [cartView, setCartView] = useState("order-cart");
  const [salesOrderCartUnlocked, setSalesOrderCartUnlocked] = useState(false);
  // Conservative until instance Sales Settings load so a configured lock never
  // has a brief fail-open editing window during initial render/navigation.
  const [requireSalesOrderCartUnlock, setRequireSalesOrderCartUnlock] = useState(true);
  const effectiveSalesOrderCartUnlocked = resolveSalesOrderCartUnlocked({
    requireUnlock: requireSalesOrderCartUnlock,
    unlocked: salesOrderCartUnlocked,
  });
  const cartViewRef = useRef(cartView);
  const hasAutoSelectedSalesOrderCartRef = useRef(false);
  cartViewRef.current = cartView;
  const [invoicingCarts, setInvoicingCarts] = useState([]);
  const [invoicingCartsLoading, setInvoicingCartsLoading] = useState(false);
  const [invoiceCartsSettledOrderId, setInvoiceCartsSettledOrderId] = useState(null);
  const [invoiceDataSettledOrderId, setInvoiceDataSettledOrderId] = useState(null);
  const [invoicePageRevealedOrderId, setInvoicePageRevealedOrderId] = useState(null);
  const handleInitialInvoiceDataReady = useCallback((readyOrderId) => {
    setInvoiceDataSettledOrderId(String(readyOrderId));
  }, []);
  const [invoicingCartsError, setInvoicingCartsError] = useState('');
  const invoicingCartListRequestRef = useRef(0);
  const [selectedInvoicingCartKey, setSelectedInvoicingCartKey] = useState(null);
  const selectedInvoicingCartKeyRef = useRef(selectedInvoicingCartKey);
  selectedInvoicingCartKeyRef.current = selectedInvoicingCartKey;
  const invoicingCartHydrationRequestRef = useRef(0);
  const [invoicingCartLinesByKey, setInvoicingCartLinesByKey] = useState({});
  const [selectedInvoicingCartRecord, setSelectedInvoicingCartRecord] = useState(null);
  const [invoicingCartHydrationWarning, setInvoicingCartHydrationWarning] = useState('');
  const [presentationData, setPresentationData] = useState([]);
  const [salesOrderData, setSalesOrderData] = useState([]);
  const [purchaseOrderData, setPurchaseOrderData] = useState([]);
  const [orderBills, setOrderBills] = useState([]);
  const {
    showPresentationDetails,
    showPresentationHistory,
  } = resolvePresentationNavigationState({
    loading,
    orderHydrated,
    presentations: presentationData,
  });

  const [regeneratePopup, setRegeneratePopup] = useState(false)
  const [approvalRegeneration, setApprovalRegeneration] = useState({ open: false, mode: "reset", docType: null, targetId: null });
  // Tabs state for the single order view
  const [activeTab, setActiveTab] = useState("Overview");
  const [activePOTab, setActivePOTab] = useState("Purchase Orders");
  const [projectEmailAddress, setProjectEmailAddress] = useState("");
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [showProductManagerPopup, setShowProductManagerPopup] = useState(false);
  const [clientContacts, setClientContacts] = useState([])
  const [contactSourceMode, setContactSourceMode] = useState("customer");
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [emailAttachments, setEmailAttachments] = useState([]);
  const [emailComposerOpen, setEmailComposerOpen] = useState(false);
  const [enforceAddressBeforeSalesOrderSend, setEnforceAddressBeforeSalesOrderSend] = useState(false);
  const [invoiceComposerOpen, setInvoiceComposerOpen] = useState(false);
  const [preparedInvoiceReview, setPreparedInvoiceReview] = useState(null);
  const [enableInvoiceCreationReview, setEnableInvoiceCreationReview] = useState(false);
  const [invoiceCreateMode, setInvoiceCreateMode] = useState(DEFAULT_CREATE_INVOICE_MODE);
  const [enabledCreateInvoiceModes, setEnabledCreateInvoiceModes] = useState(DEFAULT_ENABLED_CREATE_INVOICE_MODES);
  const [salesOrderSnapshotUpdateMode, setSalesOrderSnapshotUpdateMode] = useState('manual');
  const [defaultCreateInvoiceMode, setDefaultCreateInvoiceMode] = useState(DEFAULT_CREATE_INVOICE_MODE);
  const [invoiceCreateAmount, setInvoiceCreateAmount] = useState("");
  const [manualAdditionalInvoice, setManualAdditionalInvoice] = useState(false);
  const [manualAdditionalReason, setManualAdditionalReason] = useState('');
  const [confirmAdditionalInvoice, setConfirmAdditionalInvoice] = useState(false);
  const [invoiceSuggestedAmount, setInvoiceSuggestedAmount] = useState(0);
  const [sendInvoiceEmailNow, setSendInvoiceEmailNow] = useState(false);
  const [defaultQboQueueOnCreate, setDefaultQboQueueOnCreate] = useState(false);
  const [queueInvoiceForQuickBooks, setQueueInvoiceForQuickBooks] = useState(false);
  // The project Sales Order has its own creation route and send-now option.
  // Reuse the Finance address pre-check API, never its invoice creation handler.
  const [invoiceAddressPrecheck, setInvoiceAddressPrecheck] = useState(null);
  const [invoiceAddressPrecheckError, setInvoiceAddressPrecheckError] = useState("");
  const [invoiceAddressPrecheckLoading, setInvoiceAddressPrecheckLoading] = useState(false);
  const [invoiceAddressPrecheckSettled, setInvoiceAddressPrecheckSettled] = useState(false);
  const [invoiceAddressPrecheckRefresh, setInvoiceAddressPrecheckRefresh] = useState(0);
  const [invoiceAddressReminderSending, setInvoiceAddressReminderSending] = useState(false);
  const [invoiceAddressReminderSent, setInvoiceAddressReminderSent] = useState(false);
  const [invoiceComposerPreparing, setInvoiceComposerPreparing] = useState(false);
  const [invoiceInitialReviewSettled, setInvoiceInitialReviewSettled] = useState(false);
  const [invoiceFinancialConfigReady, setInvoiceFinancialConfigReady] = useState(!instanceUniqueId);
  const [invoiceQboDefaultsReady, setInvoiceQboDefaultsReady] = useState(!instanceUniqueId);
  // Prevent duplicate invoices while the async preparation token is obtained.
  const invoiceCreateSubmissionRef = useRef(false);
  const [projectHeaderSettings, setProjectHeaderSettings] = useState({
    showBookedRevenue: true,
    showBookedMargin: true,
    showInHandsDate: true,
  });
  const [emailSending, setEmailSending] = useState(false);
  const [invoiceEmailSending, setInvoiceEmailSending] = useState(false);
  const [invoiceSenderPreview, setInvoiceSenderPreview] = useState({ loading: true, label: '' });
  const [invoiceOpenLoading, setInvoiceOpenLoading] = useState(false);
  const [salesOrderInvoiceHistoryReview, setSalesOrderInvoiceHistoryReview] = useState({
    invoices: [], balanceStatus: null, historyError: false, balanceError: false,
  });
  const [invoiceEmailSendHistory, setInvoiceEmailSendHistory] = useState({
    events: [], loading: false, error: '',
  });
  const [invoiceEmailSendHistoryRefresh, setInvoiceEmailSendHistoryRefresh] = useState(0);
  const [salesOrderResetAccessAllowed, setSalesOrderResetAccessAllowed] = useState(false);
  const [salesOrderResetOpen, setSalesOrderResetOpen] = useState(false);
  const [salesOrderResetPreview, setSalesOrderResetPreview] = useState(null);
  const [salesOrderResetReason, setSalesOrderResetReason] = useState('');
  const [salesOrderResetAcknowledged, setSalesOrderResetAcknowledged] = useState(false);
  const [salesOrderResetLoading, setSalesOrderResetLoading] = useState(false);
  const [salesOrderResetSubmitting, setSalesOrderResetSubmitting] = useState(false);
  const [salesOrderResetError, setSalesOrderResetError] = useState('');
  const invoiceOpenRequestRef = useRef(false);
  const [invoiceDiffState, setInvoiceDiffState] = useState({ loading: false, error: "", data: null });
  const [emailValue, setEmailValue] = useState({
    to: [],
    cc: [],
    bcc: [],
    subject: '',
    body: '',
    templateId: '',
    layout: 'plain',
    quickActions: {
      bccMe: false,
      bccOrderRep: false,
      bccClientRep: false,
      requestReadReceipt: false,
      attachPdf: false,
      attachDashboard: false,
    },
  });
  const [invoiceEmailValue, setInvoiceEmailValue] = useState({
    to: [],
    cc: [],
    bcc: [],
    subject: '',
    body: '',
    templateId: '',
    layout: 'plain',
    quickActions: {
      bccMe: false,
      bccOrderRep: false,
      bccClientRep: false,
      requestReadReceipt: false,
      attachPdf: false,
      attachDashboard: false,
    },
  });

  // Only update the automatic invoice email text when Finance has not
  // customized it. In particular, Amount Due must follow any amount edit.
  const invoiceEmailLastAutofillRef = useRef({ subject: null, body: null });

  const [presentationEmailOpen, setPresentationEmailOpen] = useState(false);
  const [presentationEmailSending, setPresentationEmailSending] = useState(false);
  const [presentationEmailTarget, setPresentationEmailTarget] = useState(null);
  const [presentationEmailValue, setPresentationEmailValue] = useState({
    to: [],
    cc: [],
    bcc: [],
    subject: '',
    body: '',
    templateId: '',
    layout: 'plain',
    quickActions: {
      bccMe: false,
      bccOrderRep: false,
      bccClientRep: false,
      requestReadReceipt: false,
      attachPdf: false,
      attachDashboard: false,
    },
  });
  const [showActions, setShowActions] = useState(false);
  const [estimationPopup, setEstimationPopup] = useState(false)
  const [promoStoreCopyOpen, setPromoStoreCopyOpen] = useState(false);
  const [promoStoreCopySource, setPromoStoreCopySource] = useState({ label: "document", products: [] });
  const history = useHistory();
  const { pathname } = useLocation();
  const normalizedTabType = String(tabtype || '').trim().toLowerCase();
  const hasDocumentId = Boolean(String(tabId || '').trim());
  const isPOProofDetailRoute =
  normalizedTabType === 'pos-proofs' && hasDocumentId;
  const isSalesOrderDocumentTabRoute = normalizedTabType === 'sales-order';
  const isEstimateDocumentTabRoute = normalizedTabType === 'estimation';
  const isSalesOrderDocumentRoute = isSalesOrderDocumentTabRoute && hasDocumentId;
  const isEstimateDocumentRoute = isEstimateDocumentTabRoute && hasDocumentId;
  const isDocumentDetailRoute = isSalesOrderDocumentRoute || isEstimateDocumentRoute;

  useEffect(() => {
    let mounted = true;

    const loadSalesSendSettings = async () => {
      if (mounted && instanceUniqueId) {
        setRequireSalesOrderCartUnlock(true);
      }
      if (!instanceUniqueId) {
        if (mounted) {
          setEnforceAddressBeforeSalesOrderSend(false);
          setRequireSalesOrderCartUnlock(false);
        }
        return;
      }
      try {
        const response = await fetchOperationsManagementSettings(instanceUniqueId);
        if (mounted) {
          setEnforceAddressBeforeSalesOrderSend(
            response?.settings?.sales?.enforceAddressBeforeSalesOrderSend === true
          );
          setRequireSalesOrderCartUnlock(
            response?.settings?.sales?.requireSalesOrderCartUnlock === true
          );
        }
      } catch (error) {
        console.warn("Failed to load Sales settings", error);
        if (mounted) {
          setEnforceAddressBeforeSalesOrderSend(false);
          setRequireSalesOrderCartUnlock(false);
        }
      }
    };

    loadSalesSendSettings();
    return () => {
      mounted = false;
    };
  }, [instanceUniqueId]);

  const visibleCreateInvoiceModeOptions = useMemo(() => (
    CREATE_INVOICE_MODE_OPTIONS.filter((option) => enabledCreateInvoiceModes.includes(option.id))
  ), [enabledCreateInvoiceModes]);

  const resolveDefaultCreateInvoiceMode = useCallback(() => {
    const visibleModes = visibleCreateInvoiceModeOptions.map((option) => option.id);
    if (visibleModes.includes(defaultCreateInvoiceMode)) return defaultCreateInvoiceMode;
    if (visibleModes.includes(DEFAULT_CREATE_INVOICE_MODE)) return DEFAULT_CREATE_INVOICE_MODE;
    return visibleModes[0] || DEFAULT_CREATE_INVOICE_MODE;
  }, [defaultCreateInvoiceMode, visibleCreateInvoiceModeOptions]);

  useEffect(() => {
    let mounted = true;

    const fetchCreateInvoiceModeConfiguration = async () => {
      if (mounted) {
        setInvoiceFinancialConfigReady(false);
        setInvoiceSenderPreview({ loading: true, label: '' });
      }
      if (!instanceUniqueId) {
        const fallback = normalizeCreateInvoiceModeConfig();
        setEnabledCreateInvoiceModes(fallback.enabledModes);
        setDefaultCreateInvoiceMode(fallback.defaultMode);
        setInvoiceCreateMode(fallback.defaultMode);
        if (mounted) {
          setInvoiceSenderPreview({ loading: false, label: '', mode: 'unavailable' });
          setInvoiceFinancialConfigReady(true);
        }
        return;
      }

      try {
        const token = localStorage.getItem("accessToken");
        const instanceRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
          { headers: { accessToken: token } }
        );
        const instanceId = instanceRes?.data?.id;
        if (!instanceId) {
          if (mounted) setInvoiceSenderPreview({ loading: false, label: '', mode: 'unavailable' });
          return;
        }

        const defaultsRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/defaults`,
          { headers: { accessToken: token } }
        );
        const persistedMode = defaultsRes?.data?.defaults?.financialConfiguration?.salesOrderSnapshot?.updateMode;
        const defaults = defaultsRes?.data?.defaults || {};
        // Read the same per-instance sender setting used by server-side
        // invoice send-now and resend. Preview only, never a delivery override.
        // Resolve the same effective From identity enforced by invoice sending.
        // Settings are not authoritative for a preview of a preferred user or
        // custom mailbox; the server must validate the instance policy.
        try {
          const senderResponse = await axios.get(
            `${process.env.REACT_APP_NODEJS_SERVER_URL}/invoices/sender-policy/preview`,
            { headers: { accessToken: token }, params: { instanceUniqueId } }
          );
          const policy = senderResponse?.data || {};
          const mode = String(policy.mode || 'user_selectable');
          const from = policy.from || {};
          const senderEmail = String(from.email || '').trim();
          const senderName = String(from.name || '').trim();
          const senderLabel = senderEmail
            ? (senderName && senderName.toLowerCase() !== senderEmail.toLowerCase()
              ? `${senderName} <${senderEmail}>` : senderEmail)
            : (mode === 'user_selectable' ? String(currentUser?.email || authState?.email || '') : '');
          if (mounted) setInvoiceSenderPreview({ loading: false, label: senderLabel, mode });
        } catch (error) {
          console.warn('Unable to load invoice sender policy preview', error);
          if (mounted) setInvoiceSenderPreview({ loading: false, label: '', mode: 'unavailable' });
        }
        const resolvedMode = persistedMode === 'automatic' ? 'automatic' : 'manual';
        if (!mounted) return;
        setProjectHeaderSettings({
          showBookedRevenue: defaults.projectHeaderSettings?.showBookedRevenue !== false,
          showBookedMargin: defaults.projectHeaderSettings?.showBookedMargin !== false,
          showInHandsDate: defaults.projectHeaderSettings?.showInHandsDate !== false,
        });

        const normalizedConfig = normalizeCreateInvoiceModeConfig(
          defaults?.financialConfiguration?.createInvoice || {}
        );
        setEnabledCreateInvoiceModes(normalizedConfig.enabledModes);
        setDefaultCreateInvoiceMode(normalizedConfig.defaultMode);
        setEnableInvoiceCreationReview(normalizedConfig.enableInvoiceCreationReview);
        setInvoiceCreateMode((prev) => (
          normalizedConfig.enabledModes.includes(prev) ? prev : normalizedConfig.defaultMode
        ));
        setSalesOrderSnapshotUpdateMode(resolvedMode);
      } catch (err) {
        console.warn("Failed to load create invoice mode configuration", err);
        if (mounted) {
          setInvoiceSenderPreview({ loading: false, label: '', mode: 'unavailable' });
          const fallback = normalizeCreateInvoiceModeConfig();
          setEnabledCreateInvoiceModes(fallback.enabledModes);
          setDefaultCreateInvoiceMode(fallback.defaultMode);
          setInvoiceCreateMode((prev) => (fallback.enabledModes.includes(prev) ? prev : fallback.defaultMode));
        }
      } finally {
        // Do not overwrite the successful sender preview: only mark settings ready.
        if (mounted) setInvoiceFinancialConfigReady(true);
      }
    };

    fetchCreateInvoiceModeConfiguration();
    return () => {
      mounted = false;
    };
  }, [instanceUniqueId]);

  useEffect(() => {
    let mounted = true;

    const fetchQboInvoiceSyncDefaults = async () => {
      if (mounted) setInvoiceQboDefaultsReady(false);
      if (!instanceUniqueId) {
        setDefaultQboQueueOnCreate(false);
        setQueueInvoiceForQuickBooks(false);
        if (mounted) setInvoiceQboDefaultsReady(true);
        return;
      }

      try {
        const token = localStorage.getItem("accessToken");
        const res = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/invoices/qbo/settings`,
          { headers: { accessToken: token }, params: { instanceUniqueId } }
        );
        if (!mounted) return;
        const queueOnCreate = res?.data?.qbo_queue_on_create_default === true;
        setDefaultQboQueueOnCreate(queueOnCreate);
        setQueueInvoiceForQuickBooks(queueOnCreate);
      } catch (err) {
        console.warn("Failed to load QBO invoice sync defaults", err);
        if (mounted) {
          setDefaultQboQueueOnCreate(false);
          setQueueInvoiceForQuickBooks(false);
        }
      } finally {
        if (mounted) setInvoiceQboDefaultsReady(true);
      }
    };

    fetchQboInvoiceSyncDefaults();
    return () => {
      mounted = false;
    };
  }, [instanceUniqueId]);

  useEffect(() => {
    let mounted = true;

    const fetchEnabledOrderCurrencies = async () => {
      if (!instanceUniqueId) {
        setOrderCurrencyOptions(DEFAULT_ORDER_CURRENCY_OPTIONS);
        return;
      }

      setOrderCurrencyOptionsLoading(true);
      try {
        const token = localStorage.getItem("accessToken");
        const instanceRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
          { headers: { accessToken: token } }
        );
        const instanceId = instanceRes?.data?.id;
        if (!instanceId) {
          if (mounted) setOrderCurrencyOptions(DEFAULT_ORDER_CURRENCY_OPTIONS);
          return;
        }

        const defaultsRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/defaults`,
          { headers: { accessToken: token } }
        );
        const enabled = normalizeEnabledCurrencyCodes(defaultsRes?.data?.defaults?.currencySettings);
        if (mounted) setOrderCurrencyOptions(enabled.length ? enabled : DEFAULT_ORDER_CURRENCY_OPTIONS);
      } catch (err) {
        console.warn("Failed to load order currency settings", err);
        if (mounted) setOrderCurrencyOptions(DEFAULT_ORDER_CURRENCY_OPTIONS);
      } finally {
        if (mounted) setOrderCurrencyOptionsLoading(false);
      }
    };

    fetchEnabledOrderCurrencies();
    return () => {
      mounted = false;
    };
  }, [instanceUniqueId]);
  const [allNotes, setAllNotes] = useState([]);
  const [noteReplyDrafts, setNoteReplyDrafts] = useState({});
  const [activeReplySequence, setActiveReplySequence] = useState(null);
  const [expandedNoteThreads, setExpandedNoteThreads] = useState({});
  const [chatLastAt, setChatLastAt] = useState(null);
  const [chatLastBy, setChatLastBy] = useState(null);
  const [chatNowTick, setChatNowTick] = useState(Date.now());
  const [documentSnapshotHistory, setDocumentSnapshotHistory] = useState([]);
  const [documentSnapshotHistoryLoading, setDocumentSnapshotHistoryLoading] = useState(false);
  const [showCartChanges, setShowCartChanges] = useState(() => {
    try {
      return window.localStorage.getItem(PROJECT_NOTES_CART_FILTER_KEY) === "true";
    } catch (_error) {
      return false;
    }
  });
  const [projectNotesFilterAnchorEl, setProjectNotesFilterAnchorEl] = useState(null);
  const [infiniteNotesEnabled, setInfiniteNotesEnabled] = useState(() => {
    try {
      const savedPreference = window.localStorage.getItem(PROJECT_NOTES_INFINITE_SCROLL_KEY);
      return savedPreference === null ? true : savedPreference === "true";
    } catch (_error) {
      return false;
    }
  });

   const wasIdleTriggeredRef = React.useRef(false);
   const lastSeenMessageIdRef = React.useRef(null);
  const [lastMessageId, setLastMessageId] = useState(null);
  const [notesPage, setNotesPage] = useState(1);
  const [activeProjectEmailNote, setActiveProjectEmailNote] = useState(null);
  const NOTES_PAGE_SIZE = 20;

   const LIVE_WINDOW_MS = 5 * 60 * 1000;     // green "Live" (last 5m)
   const VISIBLE_WINDOW_MS = 15 * 60 * 1000; // show banner at all (last 15m)

   const [billsSummary, setBillsSummary] = React.useState({
    target: 0,
    actual: 0,
    delta: 0,        // target - actual
    remaining: 0,
    overage: 0,
    rawPct: 0,
    bookedMargin: 0, // passthrough
  });
  const [billedMarginFinancials, setBilledMarginFinancials] = React.useState(null);

  const minutesAgo = (d) => {
    if (!d) return null;
    const ms = Date.now() - new Date(d).getTime();
    return Math.max(0, Math.round(ms / 60000));
  };

 
const getRelativeTime = (date) => {
  const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  if (seconds < 60) return `${seconds}s ago`;
  if (seconds < 3600) { const m = Math.floor(seconds / 60); return `${m} min${m !== 1 ? "s" : ""} ago`; }
  if (seconds < 86400) { const h = Math.floor(seconds / 3600); return `${h} hr${h !== 1 ? "s" : ""} ago`; }
  if (seconds < 2592000) { const d = Math.floor(seconds / 86400); return `${d} day${d !== 1 ? "s" : ""} ago`; }
  if (seconds < 31536000) { const mo = Math.floor(seconds / 2592000); return `${mo} mo ago`; }
  const y = Math.floor(seconds / 31536000); return `${y} yr${y !== 1 ? "s" : ""} ago`;
};

const activeProjectEmailView = React.useMemo(
  () => (activeProjectEmailNote ? buildEmailViewerPropsFromNote(activeProjectEmailNote) : null),
  [activeProjectEmailNote]
);
 
const getEstSoStatusColor = (statusClass) => {
  const s = String(statusClass || "").toLowerCase();
  if (s.includes("approved") || s.includes("signed") || s.includes("paid") || s.includes("completed"))
    return { bg: "var(--ec-status-success-bg)", text: "var(--ec-status-success-text)", border: "var(--ec-status-success-border)" };
  if (s.includes("sent") || s.includes("production") || s.includes("shipped") || s.includes("invoiced"))
    return { bg: "var(--ec-status-info-bg)", text: "var(--ec-status-info-text)", border: "var(--ec-status-info-border)" };
  if (s.includes("pending") || s.includes("draft") || s.includes("ready") || s.includes("requested"))
    return { bg: "var(--ec-status-warning-bg)", text: "var(--ec-status-warning-text)", border: "var(--ec-status-warning-border)" };
  if (s.includes("cancelled") || s.includes("declined") || s.includes("error"))
    return { bg: "var(--ec-status-error-bg)", text: "var(--ec-status-error-text)", border: "var(--ec-status-error-border)" };
  return { bg: "var(--ec-status-neutral-bg)", text: "var(--ec-status-neutral-text)", border: "var(--ec-status-neutral-border)" };
};


const handleEstSoExportCSV = () => {
  if (!filteredSalesRows.length) return;
  const rows = filteredSalesRows.map((r) => ({
    ID: r.estimationId || "",
    Date: r.orderDate ? new Date(r.orderDate).toLocaleDateString() : "",
    Status: r.readableStatus || r.status || "",
    "Client Email": r.clientEmail || "",
  }));
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => `"${String(r[h]).replace(/"/g, '""')}"`).join(",")),
  ].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${activeTab === "Estimates" ? "estimates" : "sales-orders"}.csv`;
  a.click();
  URL.revokeObjectURL(url);
};

 
const handleEstSoExportExcel = () => {
  if (!filteredSalesRows.length) return;
  import("xlsx").then((XLSX) => {
    const rows = filteredSalesRows.map((r) => ({
      "ID":           r.estimationId  || "",
      "Date":         r.orderDate ? new Date(r.orderDate).toLocaleDateString() : "",
      "Status":       r.readableStatus || r.status || "",
      "Client Email": r.clientEmail   || "",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, activeTab === "Estimates" ? "Estimates" : "Sales Orders");
    XLSX.writeFile(wb, `${activeTab === "Estimates" ? "estimates" : "sales-orders"}.xlsx`);
  });
};

 
const handleEstSoExportPDF = () => {
  if (!filteredSalesRows.length) return;
  import("jspdf").then(({ jsPDF }) => {
    import("jspdf-autotable").then(() => {
      const doc = new jsPDF({ orientation: "landscape" });
      doc.setFontSize(14);
      doc.text(activeTab === "Estimates" ? "Estimates" : "Sales Orders", 14, 15);
      doc.setFontSize(9);
      doc.text(`Generated ${new Date().toLocaleString()}`, 14, 22);
      doc.autoTable({
        startY: 28,
        head: [["ID", "Date", "Status", "Client Email"]],
        body: filteredSalesRows.map((r) => [
          r.estimationId  || "—",
          r.orderDate ? new Date(r.orderDate).toLocaleDateString() : "—",
          r.readableStatus || r.status || "—",
          r.clientEmail   || "—",
        ]),
        styles:           { fontSize: 8, cellPadding: 2 },
        headStyles:       { fillColor: [30, 41, 59], textColor: 255, fontStyle: "bold" },
        alternateRowStyles: { fillColor: [248, 250, 252] },
      });
      doc.save(`${activeTab === "Estimates" ? "estimates" : "sales-orders"}.pdf`);
    });
  });
};


const resolveAvatarSrc = (rawAvatar) => {
  let src = defaultAvatarUrl;
  if (typeof rawAvatar === "string" && rawAvatar) {
    try {
      const parsed = JSON.parse(rawAvatar);
      if (Array.isArray(parsed)) {
        const selected = parsed.find((p) => p?.selected) || parsed[0];
        if (selected?.url) src = selected.url;
      } else if (parsed?.url) {
        src = parsed.url;
      } else {
        src = rawAvatar;
      }
    } catch {
      src = rawAvatar;
    }
  }
  if (typeof src === "string" && src.startsWith("uploads")) {
    src = `${process.env.REACT_APP_NODEJS_SERVER_URL}/${src}`;
  }
  return src;
};



const handleHistoryExportCSV = () => {
  if (!mappedSalesOrderData.length) return;
  const rows = mappedSalesOrderData.map((r) => ({
    "Estimation ID": r.estimationId || "",
    "User":          r.regeneratedBy || "",
    "Updated":       r.orderDate ? new Date(r.orderDate).toLocaleDateString() : "",
    "Revision":      r.revisionNumber || "",
    "Status":        r.readableStatus || r.status || "",
  }));
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => `"${String(r[h]).replace(/"/g, '""')}"`).join(",")),
  ].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "revision-history.csv";
  a.click();
};

const handleHistoryExportExcel = () => {
  if (!mappedSalesOrderData.length) return;
  import("xlsx").then((XLSX) => {
    const rows = mappedSalesOrderData.map((r) => ({
      "Estimation ID": r.estimationId || "",
      "User":          r.regeneratedBy || "",
      "Updated":       r.orderDate ? new Date(r.orderDate).toLocaleDateString() : "",
      "Revision":      r.revisionNumber || "",
      "Status":        r.readableStatus || r.status || "",
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Revision History");
    XLSX.writeFile(wb, "revision-history.xlsx");
  });
};

const handleHistoryExportPDF = () => {
  if (!mappedSalesOrderData.length) return;
  import("jspdf").then(({ jsPDF }) => {
    import("jspdf-autotable").then(() => {
      const doc = new jsPDF({ orientation: "landscape" });
      doc.setFontSize(14);
      doc.text("Revision History", 14, 15);
      doc.setFontSize(9);
      doc.text(`Generated ${new Date().toLocaleString()}`, 14, 22);
      doc.autoTable({
        startY: 28,
        head: [["Estimation ID", "User", "Updated", "Revision", "Status"]],
        body: mappedSalesOrderData.map((r) => [
          r.estimationId   || "—",
          r.regeneratedBy  || "—",
          r.orderDate ? new Date(r.orderDate).toLocaleDateString() : "—",
          r.revisionNumber || "—",
          r.readableStatus || r.status || "—",
        ]),
        styles:             { fontSize: 8, cellPadding: 2 },
        headStyles:         { fillColor: [30, 41, 59], textColor: 255, fontStyle: "bold" },
        alternateRowStyles: { fillColor: [248, 250, 252] },
      });
      doc.save("revision-history.pdf");
    });
  });
};

 
const handlePresExportCSV = () => {
  if (!presentationData?.length) return;
  const rows = presentationData.map((r) => ({
    'Presentation ID': r.presentationId || '',
    'Date': r.presentationDate
      ? new Date(r.presentationDate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
      : '',
    'Client Email': r.clientContactEmail || '',
  }));
  const headers = Object.keys(rows[0]);
  const csv = [
    headers.join(','),
    ...rows.map((r) => headers.map((h) => `"${String(r[h]).replace(/"/g, '""')}"`).join(',')),
  ].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a'); a.href = url; a.download = 'presentation-history.csv'; a.click();
  URL.revokeObjectURL(url);
};

 
const handlePresExportExcel = () => {
  if (!presentationData?.length) return;
  const rows = presentationData.map((r) => ({
    'Presentation ID': r.presentationId || '',
    'Date': r.presentationDate
      ? new Date(r.presentationDate).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
      : '',
    'Client Email': r.clientContactEmail || '',
  }));
 
  if (window.XLSX) {
    const ws  = window.XLSX.utils.json_to_sheet(rows);
    const wb  = window.XLSX.utils.book_new();
    window.XLSX.utils.book_append_sheet(wb, ws, 'Presentations');
    window.XLSX.writeFile(wb, 'presentation-history.xlsx');
  } else {
 
    const headers = Object.keys(rows[0]);
    const tsv = [headers.join('\t'), ...rows.map((r) => headers.map((h) => r[h]).join('\t'))].join('\n');
    const blob = new Blob([tsv], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a'); a.href = url; a.download = 'presentation-history.xlsx'; a.click();
    URL.revokeObjectURL(url);
  }
};

 
const handlePresExportPDF = () => {
  if (!presentationData?.length) return;
  const rows = [...presentationData].sort(
    (a, b) => new Date(b.presentationDate || 0) - new Date(a.presentationDate || 0)
  );
  const tableRows = rows.map((r, i) => {
    const d = r.presentationDate ? new Date(r.presentationDate) : null;
    const dateStr = d ? d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—';
    return `<tr style="background:${i % 2 === 0 ? '#fff' : '#f9f9f9'}">
      <td style="padding:8px 12px;border-bottom:1px solid #eee;font-family:monospace;font-size:12px">${r.presentationId || '—'}</td>
      <td style="padding:8px 12px;border-bottom:1px solid #eee;font-size:12px">${dateStr}</td>
      <td style="padding:8px 12px;border-bottom:1px solid #eee;font-size:12px">${r.clientContactEmail || '—'}</td>
    </tr>`;
  }).join('');
  const html = `<!DOCTYPE html><html><head><title>Presentation History</title>
    <style>body{font-family:sans-serif;padding:24px}h2{color:#c3171d;margin-bottom:4px}p{color:#666;font-size:13px;margin-bottom:16px}
    table{width:100%;border-collapse:collapse}thead tr{background:#1a1a1a}thead th{color:#fff;padding:10px 12px;text-align:left;font-size:11px;letter-spacing:.06em;text-transform:uppercase}
    @media print{body{padding:0}}</style></head>
    <body><h2>Presentation History</h2><p>${rows.length} presentation${rows.length !== 1 ? 's' : ''}</p>
    <table><thead><tr><th>Presentation ID</th><th>Presentation Date</th><th>Client Email</th></tr></thead>
    <tbody>${tableRows}</tbody></table></body></html>`;
  const win = window.open('', '_blank');
  win.document.write(html);
  win.document.close();
  win.focus();
  setTimeout(() => { win.print(); win.close(); }, 400);
};
 
 
const [estSoDensityMode, setEstSoDensityMode] = useState("comfortable");
const [estSoDensityAnchor, setEstSoDensityAnchor] = useState(null);
const [estSoColumnMenuAnchor, setEstSoColumnMenuAnchor] = useState(null);
const [estSoPage, setEstSoPage] = useState(0);
const [estSoRowsPerPage, setEstSoRowsPerPage] = useState(25);
const [estSoVisibleCols, setEstSoVisibleCols] = useState(
  () => new Set(EST_SO_COLUMNS.filter((c) => c.visible !== false).map((c) => c.id))
);

const [estSoExportMenuAnchor, setEstSoExportMenuAnchor] = useState(null);


const estSoDensitySettings = {
  compact:     { py: 0.75, fontSize: "0.8125rem" },
  comfortable: { py: 1.5,  fontSize: "0.875rem"  },
  spacious:    { py: 2.25, fontSize: "0.9375rem" },
};
const estSoDensity = estSoDensitySettings[estSoDensityMode];



const [historyDensityMode,     setHistoryDensityMode]     = useState("comfortable");
const [historyDensityAnchor,   setHistoryDensityAnchor]   = useState(null);
const [historyColumnMenuAnchor,setHistoryColumnMenuAnchor]= useState(null);
const [historyExportMenuAnchor,setHistoryExportMenuAnchor]= useState(null);
const [historyPage,            setHistoryPage]            = useState(0);
const [historyRowsPerPage,     setHistoryRowsPerPage]     = useState(25);
const [historyVisibleCols,     setHistoryVisibleCols]     = useState(
  () => new Set(HISTORY_COLUMNS.filter((c) => c.visible !== false).map((c) => c.id))
);
const historyDensity = estSoDensitySettings[historyDensityMode]; 

  
const [presHistoryDensity,       setPresHistoryDensity]       = useState('comfortable');
const [presHistoryDensityAnchor, setPresHistoryDensityAnchor] = useState(null);
const [presExportAnchor,         setPresExportAnchor]         = useState(null);
const [presColMenuAnchor,        setPresColMenuAnchor]        = useState(null);
const [presVisibleCols,          setPresVisibleCols]          = useState(
  new Set(PRES_COLUMNS.filter(c => c.visible !== false).map(c => c.id))
);

const presHistoryDensityMap = {
  compact:     { py: 0.75, fontSize: '0.8125rem' },
  comfortable: { py: 1.5,  fontSize: '0.875rem'  },
  spacious:    { py: 2.25, fontSize: '0.9375rem' },
};
const presDensity = presHistoryDensityMap[presHistoryDensity];

const togglePresCol = (id) => {
  const col = PRES_COLUMNS.find(c => c.id === id);
  if (col?.locked) return;
  setPresVisibleCols(prev => {
    const next = new Set(prev);
    if (next.has(id)) {
      if (next.size > 2) next.delete(id);
    } else {
      next.add(id);
    }
    return next;
  });
};



// const [poDensityMode, setPoDensityMode] = useState('comfortable');
// const [poDensityAnchor, setPoDensityAnchor] = useState(null);
// const [poColumnMenuAnchor, setPoColumnMenuAnchor] = useState(null);
// const [poExportMenuAnchor, setPoExportMenuAnchor] = useState(null);
// const [poPage, setPoPage] = useState(0);
// const [poRowsPerPage, setPoRowsPerPage] = useState(25);

// const [poVisibleCols, setPoVisibleCols] = useState(
//   () => new Set(
//     POCOLUMNS
//       .filter(c => c.visible !== false)
//       .map(c => c.id)
//   )
// );

const [poDensityMode, setPoDensityMode] = useState('comfortable');
const [poDensityAnchor, setPoDensityAnchor] = useState(null);
const [poColumnMenuAnchor, setPoColumnMenuAnchor] = useState(null);
const [poExportMenuAnchor, setPoExportMenuAnchor] = useState(null);
const [poPage, setPoPage] = useState(0);
const [poRowsPerPage, setPoRowsPerPage] = useState(25);
const [poVisibleCols, setPoVisibleCols] = useState(
  () => new Set(POCOLUMNS.filter(c => c.visible !== false).map(c => c.id))
);

const handlePOExportCSV = () => {
  if (!mappedPurchaseOrderData.length) return;
  const rows = mappedPurchaseOrderData.map(r => ({
    'Sales Order ID': r.salesOrderId,
    'PO Number':      r.poNumber,
    'Supplier':       r.supplierInfo?.supplierName || '',
    'Status':         r.supplierStatus || '',
    'Next Action':    r.nextActionDate ? new Date(r.nextActionDate).toLocaleDateString() : '',
    'Proof Status':   r.proofStatus || '',
  }));
  const headers = Object.keys(rows[0]);
  const csv = [headers.join(','), ...rows.map(r => headers.map(h => `"${String(r[h]).replace(/"/g, '""')}"`).join(','))].join('\n');
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
  a.download = 'purchase-orders.csv';
  a.click();
};

const handlePOExportExcel = () => {
  if (!mappedPurchaseOrderData.length) return;
  import('xlsx').then(XLSX => {
    const rows = mappedPurchaseOrderData.map(r => ({
      'Sales Order ID': r.salesOrderId,
      'PO Number':      r.poNumber,
      'Supplier':       r.supplierInfo?.supplierName || '',
      'Status':         r.supplierStatus || '',
      'Next Action':    r.nextActionDate ? new Date(r.nextActionDate).toLocaleDateString() : '',
      'Proof Status':   r.proofStatus || '',
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Purchase Orders');
    XLSX.writeFile(wb, 'purchase-orders.xlsx');
  });
};

const handlePOExportPDF = () => {
  if (!mappedPurchaseOrderData.length) return;
  import('jspdf').then(({ jsPDF }) => {
    import('jspdf-autotable').then(() => {
      const doc = new jsPDF({ orientation: 'landscape' });
      doc.setFontSize(14);
      doc.text('Purchase Orders', 14, 15);
      doc.setFontSize(9);
      doc.text(`Generated ${new Date().toLocaleString()}`, 14, 22);
      doc.autoTable({
        startY: 28,
        head: [['Sales Order ID', 'PO Number', 'Supplier', 'Status', 'Next Action', 'Proof Status']],
        body: mappedPurchaseOrderData.map(r => [
          r.salesOrderId,
          r.poNumber,
          r.supplierInfo?.supplierName || '',
          r.supplierStatus || '',
          r.nextActionDate ? new Date(r.nextActionDate).toLocaleDateString() : '',
          r.proofStatus || '',
        ]),
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [30, 41, 59], textColor: 255, fontStyle: 'bold' },
        alternateRowStyles: { fillColor: [248, 250, 252] },
      });
      doc.save('purchase-orders.pdf');
    });
  });
};

const togglePOCol = (id) => {
  const col = POCOLUMNS.find(c => c.id === id);
  if (col?.locked) return;
  setPoVisibleCols(prev => {
    const next = new Set(prev);
    if (next.has(id)) {
      if (next.size <= 2) return prev; // keep minimum 2 columns
      next.delete(id);
    } else {
      next.add(id);
    }
    return next;
  });
};

  // Proofs state (for POs/Proofs tab)
  const [proofsList, setProofsList] = useState([]);
  const [proofLoading, setProofLoading] = useState(false);
  const [allProofsUploaded, setAllProofsUploaded] = useState(false);
  const [showAddNewProductManager, setShowAddNewProductManager] = useState(false);
  const [cartHistoryOpen, setCartHistoryOpen] = useState(false);
  const [cartHistoryTab, setCartHistoryTab] = useState("activity");
  const [cartActivity, setCartActivity] = useState([]);
  const [cartSnapshots, setCartSnapshots] = useState([]);
  const [cartHistoryLoading, setCartHistoryLoading] = useState(false);
  const [availableUsers, setAvailableUsers] = useState([]); // New state for all users
  const [selectedPOList, setSelectedPOList] = useState([]);
  const [conversionStatus, setConversionStatus] = useState(1);
  const [isSidebar, setIsSidebar] = useState(false);
  const [availableSubStatuses, setAvailableSubStatuses] = useState([]);

  const [poGenStage, setPoGenStage] = useState(0);
  const poGenTimerRef = useRef(null);
  const poConversionInFlightRef = useRef(false);

  // 15s stage messages (cycles up to last while work continues)
  const PO_GEN_STAGES = [
    "Starting PDF engine...",
    "Processing items & shipping... (~15s)",
    "Rendering PDFs... (~30s)",
    "Uploading to Elite Core File Network... (~45s)",
    "Finishing up..."
  ];

  
  // For Purchase Orders / Proofs Home section - Create Purchase Order button loading
  const [creatingPO, setCreatingPO] = useState(false);
  const [createdPO, setCreatedPO] = useState(false);
  const [outstandingReviewOpen, setOutstandingReviewOpen] = useState(false);
  const [outstandingSummary, setOutstandingSummary] = useState(null);
  const [outstandingPoListRefresh, setOutstandingPoListRefresh] = useState(0);
  const [proofEnforcementMode, setProofEnforcementMode] = useState(PROOF_ENFORCEMENT_MODES.NONE);
  const [poProofValidation, setPoProofValidation] = useState(null);
  const [poProofReadiness, setPoProofReadiness] = useState({ status: 'idle', error: null });
  const [poDepositReadiness, setPoDepositReadiness] = useState({ status: 'loading', message: '' });

  const [shippingGate, setShippingGate] = useState({
    loading: true,
    has: false,
    shippingExists: false,
    totalProducts: 0,
    missingProductIds: [],
    allApproved: false,
    shippingComplete: false,
    shippingApproved: false,
    shippingReady: false,
    requireShippingConfirmation: false,
    incompleteProductIds: [],
    unapprovedProductIds: [],
    shippingSource: null,
  });

  const [showEstSoActions, setShowEstSoActions] = useState(false);
  const [instructionDrafts, setInstructionDrafts] = useState({});
  const [docViewTab, setDocViewTab] = useState('details');

  useEffect(() => {
    // Whenever the selected estimate/sales-order document id changes,
    // default the inner doc view back to Details.
    setDocViewTab('details');
  }, [tabId]);
  const toggleEstSoActions = () => setShowEstSoActions((s) => !s);
  const [docRegenerationInProgress, setDocRegenerationInProgress] = useState(false);
  const [activeRegenerationDocType, setActiveRegenerationDocType] = useState(null);
  const [decorationRoutingError, setDecorationRoutingError] = useState({ open: false, issues: [] });
  const [requestArtOpen, setRequestArtOpen] = useState(false);
  const [requestArtClockNow, setRequestArtClockNow] = useState(() => Date.now());
  useEffect(() => {
    if (!requestArtOpen) return undefined;
    setRequestArtClockNow(Date.now());
    const timer = setInterval(() => setRequestArtClockNow(Date.now()), 60000);
    return () => clearInterval(timer);
  }, [requestArtOpen]);
  const [requestArtTab, setRequestArtTab] = useState("designer");
  const [requestArtLoading, setRequestArtLoading] = useState(false);
  const [designRepOptions, setDesignRepOptions] = useState([]);
  const [selectedDesignRepId, setSelectedDesignRepId] = useState("");
  const [binatedSettings, setBinatedSettings] = useState({
    enabled: false,
    ready: false,
    provider: "binated",
    mvpTalentEnabled: false,
  });
  const [selectedRequestPoId, setSelectedRequestPoId] = useState("");
  const [binatedArtView, setBinatedArtView] = useState("form");
  const userSelectedBinatedArtViewRef = useRef(false);
  const [requestArtSmartSend, setRequestArtSmartSend] = useState(true);
  const [smartSendView, setSmartSendView] = useState("preview");
  const [smartSendSkuSelection, setSmartSendSkuSelection] = useState({});
  const [smartSendOverrides, setSmartSendOverrides] = useState({});
  const smartSendDraftOverridesRef = useRef({});
  const [binatedStandardsPreflight, setBinatedStandardsPreflight] = useState(null);
  const [binatedStandardsChecking, setBinatedStandardsChecking] = useState(false);
  const [artForm, setArtForm] = useState(null);
  const [artFormUiVersion, setArtFormUiVersion] = useState(0);
  const [selectedMediaIndex, setSelectedMediaIndex] = useState(0);
  const [selectedPlacementIndex, setSelectedPlacementIndex] = useState(0);
  const [payloadPreviewText, setPayloadPreviewText] = useState("");
  const [selectedCartImportKey, setSelectedCartImportKey] = useState("");
  const [requestArtNote, setRequestArtNote] = useState("");
  const [requestArtFiles, setRequestArtFiles] = useState([]);
  const [proofFulfillmentProvider, setProofFulfillmentProvider] = useState("binated");
  const [proofMappingSourceType, setProofMappingSourceType] = useState("design_rep");
  const [proofSourceLinkageBanner, setProofSourceLinkageBanner] = useState(null);
  const [proofSourceStatusMeta, setProofSourceStatusMeta] = useState(null);
  const [coreNetworkCapabilityFilter, setCoreNetworkCapabilityFilter] = useState("artwork-proof");
  const [coreNetworkTalentOptions, setCoreNetworkTalentOptions] = useState([]);
  const [coreNetworkTalentLoading, setCoreNetworkTalentLoading] = useState(false);
  const [selectedCoreNetworkMemberId, setSelectedCoreNetworkMemberId] = useState("");
  const [selectedMarketplaceMemberIds, setSelectedMarketplaceMemberIds] = useState([]);
  const [marketplaceAudienceMode, setMarketplaceAudienceMode] = useState("top_matches");
  const [marketplaceTopMatchLimit, setMarketplaceTopMatchLimit] = useState("3");
  const [marketplaceBudgetMode, setMarketplaceBudgetMode] = useState("fixed");
  const [marketplaceBudgetRangeMin, setMarketplaceBudgetRangeMin] = useState("");
  const [marketplaceBudgetRangeMax, setMarketplaceBudgetRangeMax] = useState("");
  const [marketplaceOfferExpiryHours, setMarketplaceOfferExpiryHours] = useState("72");
  const [marketplaceMaxOffers, setMarketplaceMaxOffers] = useState("3");
  const [marketplaceCurrency, setMarketplaceCurrency] = useState("");
  const [requestArtDueDate, setRequestArtDueDate] = useState("");
  const proofSourceManualOverrideRef = useRef(false);
  const proofSourceAutoDetectionStartedRef = useRef(false);
  const [requestArtPriorityLevel, setRequestArtPriorityLevel] = useState("normal");
  const [requestArtFeeEstimate, setRequestArtFeeEstimate] = useState("");
  const [requestArtStatuses, setRequestArtStatuses] = useState([]);
  const [requestArtStatusesLoading, setRequestArtStatusesLoading] = useState(false);
  const [requestArtStatusesResolved, setRequestArtStatusesResolved] = useState(false);
  const [currentBinatedOrderOpen, setCurrentBinatedOrderOpen] = useState(false);
  const [currentBinatedOrderLoading, setCurrentBinatedOrderLoading] = useState(false);
  const [currentBinatedOrderDeleting, setCurrentBinatedOrderDeleting] = useState(false);
  const [currentBinatedOrderData, setCurrentBinatedOrderData] = useState(null);
  const bumpArtFormUiVersion = () => setArtFormUiVersion((prev) => prev + 1);
  const isDirectTalentAssignment = proofFulfillmentProvider === "core-network-direct";
  const isCoreNetworkMarketplaceRequest = proofFulfillmentProvider === "core-network-marketplace";
  const resolvedProofWorkProvider = isDirectTalentAssignment || isCoreNetworkMarketplaceRequest
    ? "core-network"
    : proofFulfillmentProvider;
  const isBinatedFulfillment = resolvedProofWorkProvider === "binated";
  const normalizeRequestArtStatusString = (value) => String(value || "").trim().toLowerCase();
  const buildRequestArtScopeKeyFromPayload = (submittedPayload = {}, provider = resolvedProofWorkProvider) => {
    const media = Array.isArray(submittedPayload?.media) ? submittedPayload.media : [];
    const orderItemIds = [];
    const decorationIds = [];
    const artworkIds = [];
    const placementKeys = [];
    const replacementMarkers = [];

    media.forEach((mediaEntry = {}, mediaIndex) => {
      const baseOrderItemId = Number(mediaEntry?.order_item_id || mediaEntry?.orderItemId) || null;
      const baseArtworkId = Number(mediaEntry?.artwork_id || mediaEntry?.artworkId) || null;
      const decorations = Array.isArray(mediaEntry?.decoration_info) ? mediaEntry.decoration_info : [];
      decorations.forEach((decoration = {}, decorationIndex) => {
        const baseDecorationId = Number(decoration?.decoration_id || decoration?.decorationId) || null;
        const placements = Array.isArray(decoration?.placement_info) ? decoration.placement_info : [];
        placements.forEach((placement = {}, placementIndex) => {
          const orderItemId = Number(placement?.order_item_id || placement?.orderItemId || baseOrderItemId) || null;
          const decorationId = Number(placement?.decoration_id || placement?.decorationId || baseDecorationId) || null;
          const artworkId = Number(placement?.artwork_id || placement?.artworkId || baseArtworkId) || null;
          if (orderItemId) orderItemIds.push(orderItemId);
          if (decorationId) decorationIds.push(decorationId);
          if (artworkId) artworkIds.push(artworkId);

          const placementKey =
            String(
              placement?.placement_code ||
              placement?.placement_name ||
              placement?.name ||
              placement?.placement ||
              ""
            ).trim();
          if (placementKey) {
            placementKeys.push(placementKey);
          }

          const referenceDecorationId = String(placement?.reference_decoration_id || "").trim();
          if (mediaEntry?.change_request === true || referenceDecorationId) {
            replacementMarkers.push({
              mediaIndex,
              decorationIndex,
              placementIndex,
              referenceDecorationId: referenceDecorationId || null,
              changeRequest: mediaEntry?.change_request === true,
            });
          }
        });
      });
    });

    const sortedUnique = (values = []) => [...new Set(values.filter(Boolean))].sort((left, right) => Number(left) - Number(right));
    return JSON.stringify({
      scope: orderItemIds.length || decorationIds.length || artworkIds.length ? "products" : "order",
      orderItemIds: sortedUnique(orderItemIds),
      decorationIds: sortedUnique(decorationIds),
      artworkIds: sortedUnique(artworkIds),
      placementKeys: [...new Set(placementKeys.filter(Boolean))].sort(),
      replacementMarkers,
      fulfillmentProvider: provider,
      requestType: "artwork-proof",
      documentType: lifecycleDocumentType,
      documentId: resolvedBinatedDocumentId ? String(resolvedBinatedDocumentId) : null,
    });
  };

  // const [activeSalesOrder,setActiveSalesOrder]=useState(null)
  // Fake Purchase Orders data (for POs/Proofs tab)
  const ACTION_META = {
    'sent-email':            { icon: <MailOutlineIcon fontSize="small"/>,    label: 'Email Sent' },
    'inbound-project-email': { icon: <MailOutlineIcon fontSize="small"/>,    label: 'Email Received' },
    'supplier-email-sent':   { icon: <MailOutlineIcon fontSize="small"/>,    label: 'Supplier PO Sent' },
    'update':                { icon: <UpdateIcon fontSize="small"/>,         label: 'Customer Updated' },
    'approve':               { icon: <CheckCircleIcon fontSize="small"/>,    label: 'Approved' },
    'decline':               { icon: <CancelIcon fontSize="small"/>,         label: 'Declined' },
    'order-create':          { icon: <ShoppingCartIcon fontSize="small"/>,    label: 'New Order' },
    'presentation-generate': { icon: <SlideshowIcon fontSize="small"/>,       label: 'New Presentation' },
    "written-project-note":  { icon: <NoteAltIcon fontSize="small" />,        label: "Project Note" },
    "production-note":       { icon: <NoteAltIcon fontSize="small" />,        label: "Production Note" },
    "purchasing-note":       { icon: <NoteAltIcon fontSize="small" />,        label: "Purchasing Note" },
    "chat-digest":          { icon: <ForumIcon fontSize="small" />,          label: "Live Chat Conversation" },
    'presentation-comment':  { icon: <SlideshowIcon fontSize="small"/>,       label: 'Presentation Comment' },
    'estimate-create':       { icon: <ReceiptLongIcon fontSize="small"/>,     label: 'New Estimate' },
    'new-sales-order':       { icon: <MonetizationOnIcon fontSize="small"/>,  label: 'New Sales Order' },
    'estimate-regenerated':  { icon: <UpdateIcon fontSize="small"/>,          label: 'Estimate Regenerated' },
    'sales-order-regenerated': { icon: <UpdateIcon fontSize="small"/>,        label: 'Sales Order Regenerated' },
    'purchase-order-create': { icon: <LocalOfferIcon fontSize="small"/>,      label: 'New Purchase Order' },
    'new-invoice':           { icon: <DescriptionIcon fontSize="small"/>,    label: 'New Invoice' },
    'new-bill':              { icon: <PaymentsIcon fontSize="small"/>,       label: 'New Bill' },
    'completed-order':       { icon: <DoneAllIcon fontSize="small"/>,        label: 'Order Completed' },
  };
  const defaultAvatarUrl = "/elite-core-placeholder-avatar.png";

  const fakePurchaseOrders = [
    {
      id: 201,
      productImage: "https://placehold.co/50x50?text=Img",
      sku: "SKU-001",
      poNumber: "PO-12345",
      details: "Order details here",
      status: "Pending",
      supplier: "Supplier A",
      productionRep: "John Doe",
    },
    {
      id: 202,
      productImage: "https://placehold.co/50x50?text=Img",
      sku: "SKU-002",
      poNumber: "PO-12346",
      details: "Order details here",
      status: "Shipped",
      supplier: "Supplier B",
      productionRep: "Jane Smith",
    },
  ];
  const [purchaseOrders, setPurchaseOrders] = useState(fakePurchaseOrders);
  const [orderLoading, setOrderLoading] = useState(false);
  const [orderInvoices, setOrderInvoices] = useState([]);
  const [invoiceCreatedActionCheck, setInvoiceCreatedActionCheck] = useState({
    orderId: '', instanceUniqueId: '', salesOrderId: '',
    loading: false, verified: false, error: false,
    invoices: [], approvedSalesOrderTotal: 0,
  });
  // An invoice may have several cart revisions, but /invoice only offers
  // persisted carts that can be matched to a real, active or paid invoice.
  // Never fall back to the project Order Cart or an approved Sales Order Cart.
  const selectableInvoicingCarts = useMemo(
    () => getInvoiceOwnedCarts({ invoices: orderInvoices, carts: invoicingCarts }),
    [orderInvoices, invoicingCarts]
  );

  const routeDocType = String(tabtype || '').toLowerCase();
  const isInvoiceRoute = routeDocType === 'invoice';
  const isInvoiceListRoute = isInvoiceRoute && !tabId;
  const effectiveCartView = isInvoiceRoute
    ? 'invoicing-cart'
    : (cartView === 'invoicing-cart' ? 'order-cart' : cartView);
  const selectedInvoiceCartIsValid = selectableInvoicingCarts.some(
    (cart) => cart.invoicingCartKey === selectedInvoicingCartKey
  );
  const selectedInvoicingCartOrderIdRef = useRef(orderId);
  selectedInvoicingCartOrderIdRef.current = orderId;
  const isInvoiceEditRoute = routeDocType === 'invoice' && !!tabId && tabId !== 'new';
  const activeInvoiceId = isInvoiceEditRoute ? String(tabId) : '';
  const invoiceRouteInvoicingCartKey = isInvoiceEditRoute
    ? new URLSearchParams(window.location.search || '').get('invoicingCartKey') || ''
    : '';
  const [invoiceCartResolution, setInvoiceCartResolution] = useState({ loading: false, error: '', data: null });
  const isEstimateRoute = routeDocType === 'estimation';
  const isSalesOrderRoute = routeDocType === 'sales-order';
  const currentSO = React.useMemo(() => {
    if (!tabId) return null;
    return salesOrderData.find((so) =>
      String(so.estimationId) === String(tabId) || String(so.id) === String(tabId)
    );
  }, [salesOrderData, tabId]);
  // One source of truth for this *existing* Sales Order create path.
  // The address pre-check, optional preview and create request must all refer
  // to the same approved Sales Order (never a different project's document).
  const invoiceCreationSourceSO = useMemo(() => {
    const approved = (salesOrderData || []).filter((so) =>
      ['3', '6', '7', '8', '9'].includes(String(so?.status || ''))
    );
    return approved.find((so) =>
      String(so?.estimationId || '') === String(tabId || '') ||
      String(so?.id || '') === String(tabId || '')
    ) || approved[0] || null;
  }, [salesOrderData, tabId]);
  const invoiceCreationSalesOrderId =
    invoiceCreationSourceSO?.estimationId || invoiceCreationSourceSO?.id || null;

  // Refresh existing invoices when the Sales Order Actions menu opens.
  // Status 9 alone is not enough: an invoice may have been reset, voided or
  // manually removed during testing. Verify a real, linked invoice instead.
  const invoiceActionSalesOrderId = String(currentSO?.estimationId || currentSO?.id || tabId || '');
  useEffect(() => {
    if (!showActions || !isSalesOrderRoute || !canViewInvoices ||
        !orderId || !instanceUniqueId || !invoiceActionSalesOrderId) return undefined;
    let active = true;
    const key = {
      orderId: String(orderId),
      instanceUniqueId: String(instanceUniqueId),
      salesOrderId: invoiceActionSalesOrderId,
    };
    setInvoiceCreatedActionCheck({
      ...key, loading: true, verified: false, error: false,
      invoices: [], approvedSalesOrderTotal: 0,
    });
    // The action needs one fresh invoice lookup, not the heavy balance/
    // snapshot assessment used by the Create Invoice dialog itself.
    fetchInvoicesListByOrder(orderId, { throwOnError: true })
      .then((result) => {
        if (!active) return;
        const invoices = Array.isArray(result) ? result : [];
        setOrderInvoices(invoices);
        const stamp = typeof currentSO?.stampedBookedAmount === 'string'
          ? (() => { try { return JSON.parse(currentSO.stampedBookedAmount); } catch (_) { return null; } })()
          : currentSO?.stampedBookedAmount;
        const savedTotals = [
          currentSO?.Total?.total, currentSO?.Total?.amount,
          currentSO?.Total, currentSO?.total,
          stamp?.totals?.totalInclTax, stamp?.totals?.grandTotal,
          order?.Total?.total, order?.Total?.amount, order?.Total,
        ];
        const approvedTotal = savedTotals
          .map((value) => Number(value))
          .find((value) => Number.isFinite(value) && value > 0) || 0;
        setInvoiceCreatedActionCheck({
          ...key, loading: false, verified: true, error: false,
          invoices, approvedSalesOrderTotal: approvedTotal,
        });
      })
      .catch(() => {
        if (!active) return;
        setInvoiceCreatedActionCheck({
          ...key, loading: false, verified: false, error: true,
          invoices: [], approvedSalesOrderTotal: 0,
        });
      });
    return () => { active = false; };
  }, [showActions, isSalesOrderRoute, canViewInvoices, orderId,
    instanceUniqueId, invoiceActionSalesOrderId]);

  const invoiceCreatedCheckIsCurrent =
    invoiceCreatedActionCheck.orderId === String(orderId || '') &&
    invoiceCreatedActionCheck.instanceUniqueId === String(instanceUniqueId || '') &&
    invoiceCreatedActionCheck.salesOrderId === invoiceActionSalesOrderId;
  const invoiceCreatedActionState = useMemo(() => {
    if (!isSalesOrderRoute || !invoiceCreatedCheckIsCurrent || !invoiceCreatedActionCheck.verified) {
      return { created: false, invoiceId: null };
    }
    return resolveSalesOrderInvoiceActionState({
      invoices: invoiceCreatedActionCheck.invoices,
      instanceUniqueId,
      salesOrderId: invoiceActionSalesOrderId,
      depositInvoiceId: currentSO?.depositInvoiceId || null,
      approvedSalesOrderTotal: invoiceCreatedActionCheck.approvedSalesOrderTotal,
      requireUpfrontPayment: currentSO?.requireUpfrontPayment === true ||
        String(currentSO?.requireUpfrontPayment) === '1',
      upfrontMode: currentSO?.upfrontMode || '',
    });
  }, [isSalesOrderRoute, invoiceCreatedCheckIsCurrent, invoiceCreatedActionCheck, instanceUniqueId,
    invoiceActionSalesOrderId, currentSO?.depositInvoiceId,
    currentSO?.requireUpfrontPayment, currentSO?.upfrontMode]);

  const salesOrderInvoiceHistorySummary = useMemo(() => describeSalesOrderInvoiceHistory({
    invoices: salesOrderInvoiceHistoryReview.invoices,
    instanceUniqueId,
    salesOrderId: invoiceCreationSalesOrderId,
    depositInvoiceId: invoiceCreationSourceSO?.depositInvoiceId || null,
    balanceStatus: salesOrderInvoiceHistoryReview.balanceStatus,
  }), [salesOrderInvoiceHistoryReview, instanceUniqueId, invoiceCreationSalesOrderId,
    invoiceCreationSourceSO?.depositInvoiceId]);

  useEffect(() => {
    let active = true;
    if (!invoiceComposerOpen || !orderId || !instanceUniqueId) return undefined;
    setInvoiceEmailSendHistory({ events: [], loading: true, error: '' });
    fetchInvoiceEmailHistoryByOrder(orderId, { instanceUniqueId })
      .then((result) => {
        if (!active) return;
        setInvoiceEmailSendHistory({
          events: Array.isArray(result?.events) ? result.events : [],
          loading: false,
          error: '',
        });
      })
      .catch((error) => {
        if (!active) return;
        setInvoiceEmailSendHistory({
          events: [], loading: false,
          error: error?.response?.data?.message || 'Could not load invoice email history.',
        });
      });
    return () => { active = false; };
  }, [invoiceComposerOpen, orderId, instanceUniqueId, invoiceEmailSendHistoryRefresh]);

  // Use the same instance-specific access check as the Invoice tab. The
  // backend remains the authority; showing a button is not permission to reset.
  useEffect(() => {
    let active = true;
    setSalesOrderResetAccessAllowed(false);
    if (!invoiceComposerOpen || !isAdministrator || !orderId || !instanceUniqueId ||
        !salesOrderInvoiceHistorySummary.canSeeResetCandidate) return undefined;
    previewResetInvoiced({ orderId, instanceUniqueId })
      .then(() => { if (active) setSalesOrderResetAccessAllowed(true); })
      .catch(() => { if (active) setSalesOrderResetAccessAllowed(false); });
    return () => { active = false; };
  }, [invoiceComposerOpen, isAdministrator, orderId, instanceUniqueId,
      salesOrderInvoiceHistorySummary.canSeeResetCandidate]);

  useEffect(() => {
    if (!invoiceComposerOpen) return undefined;
    let cancelled = false;
    setInvoiceAddressPrecheck(null);
    setInvoiceAddressPrecheckError('');
    setInvoiceAddressPrecheckLoading(true);
    setInvoiceAddressPrecheckSettled(false);

    if (!orderId || !invoiceCreationSalesOrderId) {
      setInvoiceAddressPrecheckError('No approved Sales Order was found to check.');
      setInvoiceAddressPrecheckLoading(false);
      setInvoiceAddressPrecheckSettled(true);
      return undefined;
    }

    fetchInvoiceAddressPrecheck(orderId, {
      instanceUniqueId, salesOrderId: invoiceCreationSalesOrderId,
    }).then((precheck) => {
      if (!cancelled) setInvoiceAddressPrecheck(precheck);
    }).catch((error) => {
      if (!cancelled) {
        setInvoiceAddressPrecheckError(
          error?.response?.data?.message || 'Sales Order address details could not be checked.'
        );
      }
    }).finally(() => {
      if (!cancelled) {
        setInvoiceAddressPrecheckLoading(false);
        setInvoiceAddressPrecheckSettled(true);
      }
    });
    return () => { cancelled = true; };
  }, [invoiceComposerOpen, orderId, instanceUniqueId, invoiceCreationSalesOrderId, invoiceAddressPrecheckRefresh]);

  useEffect(() => {
    if (!invoiceComposerOpen || !invoiceComposerPreparing) return;
    if (!invoiceFinancialConfigReady || !invoiceQboDefaultsReady ||
      !invoiceAddressPrecheckSettled ||
      (enableInvoiceCreationReview && !invoiceInitialReviewSettled)) return;
    setInvoiceComposerPreparing(false);
  }, [
    invoiceComposerOpen, invoiceComposerPreparing, invoiceAddressPrecheckSettled,
    invoiceFinancialConfigReady, invoiceQboDefaultsReady,
    enableInvoiceCreationReview, invoiceInitialReviewSettled,
  ]);

  const handleNotifySalesOrderInvoiceAddressReps = async () => {
    if (!invoiceAddressPrecheck || invoiceAddressPrecheck.ready ||
      invoiceAddressReminderSending || invoiceAddressReminderSent) return;
    setInvoiceAddressReminderSending(true);
    try {
      const result = await notifyInvoiceAddressMissing(orderId, {
        instanceUniqueId,
        salesOrderId: invoiceAddressPrecheck.salesOrderId,
      });
      setInvoiceAddressReminderSent(true);
      toast.success(`Address reminder sent to ${result?.recipientCount || 0} assigned team member(s).`);
      setInvoiceAddressPrecheckRefresh((value) => value + 1);
    } catch (error) {
      if (error?.response?.status === 409) {
        setInvoiceAddressPrecheckRefresh((value) => value + 1);
      }
      toast.error(error?.response?.data?.message || 'Could not send the address reminder.');
    } finally {
      setInvoiceAddressReminderSending(false);
    }
  };

  const activeDocumentPromoStoreProducts = useMemo(
    () => resolvePromoStoreDocumentProducts(currentSO || {}, order?.Products || []),
    [currentSO, order?.Products],
  );
  const latestPresentationForPromoStore = useMemo(
    () => resolveLatestPresentation(presentationData),
    [presentationData],
  );
  const presentationPromoStoreProducts = useMemo(
    () => resolvePromoStoreDocumentProducts(latestPresentationForPromoStore || {}, order?.Products || []),
    [latestPresentationForPromoStore, order?.Products],
  );
  const openPromoStoreCopy = useCallback((label, products) => {
    const sourceProducts = Array.isArray(products) ? products : [];
    if (!sourceProducts.length) {
      toast.error("There are no products available to copy to a PromoStore.");
      return;
    }
    setPromoStoreCopySource({ label, products: sourceProducts });
    setShowActions(false);
    setPromoStoreCopyOpen(true);
  }, []);
  const lifecycleDocumentType = routeDocType || "sales-order";
  const resolvedBinatedDocumentId = React.useMemo(() => {
    const routeDocumentId = String(tabId || "").trim();
    if (routeDocumentId) return routeDocumentId;

    const matchedDocumentId = currentSO?.estimationId ?? currentSO?.id ?? "";
    return String(matchedDocumentId || "").trim();
  }, [currentSO, tabId]);
  const handleBinatedLifecycleError = useCallback((err) => {
    toast.error(err?.response?.data?.message || "Failed to load Binated request status.");
  }, []);

  const binatedLifecycle = useBinatedLifecycle({
    enabled: true,
    isOpen: requestArtOpen,
    isActive: requestArtTab === "binated" && isBinatedFulfillment,
    orderId,
    documentType: lifecycleDocumentType,
    documentId: resolvedBinatedDocumentId,
    requestType: "design_service",
    onError: handleBinatedLifecycleError,
  }) || {};
  const hasBinatedPlacementStatusItems =
    binatedLifecycle.lifecycle?.requestType === "design_service" &&
    Array.isArray(binatedLifecycle.lifecycle?.statusItems) &&
    binatedLifecycle.lifecycle.statusItems.length > 0;
  const binatedCustomerId = useMemo(
    () => resolveAttachedOrderCustomerId(order),
    [order?.attachedCustomers]
  );
  // Binated file/field overrides must never follow the user to another document.
  useEffect(() => {
    smartSendDraftOverridesRef.current = {};
    setSmartSendOverrides({});
  }, [resolvedBinatedDocumentId, lifecycleDocumentType]);
  const projectHeaderCustomerName = String(
    customerData?.businessName || order?.CustomerName || ""
  ).trim();
  const projectHeaderCustomerHref = useMemo(
    () =>
      buildProjectHeaderCustomerHref({
        instanceUniqueId,
        customerId: binatedCustomerId,
      }),
    [binatedCustomerId, instanceUniqueId]
  );
  useEffect(() => {
    userSelectedBinatedArtViewRef.current = false;
  }, [requestArtOpen, resolvedBinatedDocumentId]);
  const { getWorkflowLabel, getWorkflowTooltip } = useWorkflowDisplaySettings(instanceUniqueId);

  useEffect(() => {
    if (!requestArtOpen) return;
    if (!requestArtDueDate && order?.inHandsDate) {
      const formatted = dayjs(order.inHandsDate).isValid() ? dayjs(order.inHandsDate).format("YYYY-MM-DD") : "";
      if (formatted) {
        setRequestArtDueDate(formatted);
      }
    }
  }, [order?.inHandsDate, requestArtDueDate, requestArtOpen]);

  useEffect(() => {
    if (!requestArtOpen) return;
    if (!marketplaceCurrency) {
      const nextCurrency = String(order?.CurrencyCode || order?.currency || "CAD").trim().toUpperCase();
      if (nextCurrency) {
        setMarketplaceCurrency(nextCurrency);
      }
    }
  }, [marketplaceCurrency, order?.CurrencyCode, order?.currency, requestArtOpen]);
  const proofRequestStatusesByProvider = useMemo(() => {
    const next = new Map();
    (Array.isArray(requestArtStatuses) ? requestArtStatuses : []).forEach((statusRow) => {
      const providerKey = normalizeFulfillmentProvider(statusRow?.fulfillmentProvider);
      if (!providerKey) return;
      if (!next.has(providerKey)) {
        next.set(providerKey, []);
      }
      next.get(providerKey).push(statusRow);
    });
    return next;
  }, [requestArtStatuses]);
  const proofSourceAvailability = useMemo(() => {
    return Object.keys(PROOF_SOURCE_OPTIONS).reduce((accumulator, sourceType) => {
      const requestProvider = getRequestProviderForProofSource(sourceType);
      const requestBacked = Boolean(requestProvider);
      const matchingStatuses = requestProvider
        ? proofRequestStatusesByProvider.get(requestProvider) || []
        : [];
      const isApplicable = requestBacked ? matchingStatuses.length > 0 : true;

      accumulator[sourceType] = {
        sourceType,
        requestBacked,
        requestProvider,
        isApplicable,
        matchingStatuses,
        disabledReason: requestBacked && !isApplicable
          ? DISABLED_PROOF_SOURCE_MESSAGES[sourceType] || "No artwork request exists for this Sales Order."
          : "",
      };
      return accumulator;
    }, {});
  }, [proofRequestStatusesByProvider]);
  const preferredRequestBackedProofSourceType = useMemo(() => {
    const candidateStatuses = (Array.isArray(requestArtStatuses) ? requestArtStatuses : [])
      .map((statusRow) => {
        const sourceType = getProofSourceTypeForFulfillmentProvider(statusRow?.fulfillmentProvider);
        if (!sourceType) return null;
        if (!proofSourceAvailability[sourceType]?.isApplicable) return null;
        return {
          statusRow,
          sourceType,
          isActive: Boolean(statusRow?.isActive),
          timestamp: getProofRequestTimestamp(statusRow),
          requestId: Number(statusRow?.requestId || 0),
          priorityRank: getProofSourcePriorityRank(sourceType),
        };
      })
      .filter(Boolean);

    if (!candidateStatuses.length) return "";

    candidateStatuses.sort((left, right) => {
      if (Number(right.isActive) !== Number(left.isActive)) {
        return Number(right.isActive) - Number(left.isActive);
      }
      if (left.priorityRank !== right.priorityRank) {
        return left.priorityRank - right.priorityRank;
      }
      if (right.timestamp !== left.timestamp) {
        return right.timestamp - left.timestamp;
      }
      return right.requestId - left.requestId;
    });

    return candidateStatuses[0]?.sourceType || "";
  }, [proofSourceAvailability, requestArtStatuses]);
  const applicableProofSourceTypes = useMemo(
    () =>
      Object.values(proofSourceAvailability)
        .filter((entry) => entry?.isApplicable)
        .map((entry) => entry.sourceType),
    [proofSourceAvailability]
  );
  const firstApplicableProofSourceType =
    preferredRequestBackedProofSourceType || applicableProofSourceTypes[0] || "";

  useEffect(() => {
    if (!requestArtOpen || requestArtTab !== "proofing") return;
    if (!orderId || !lifecycleDocumentType || !resolvedBinatedDocumentId) return;
    if (!requestArtStatusesResolved || requestArtStatusesLoading) return;
    if (proofSourceAutoDetectionStartedRef.current || proofSourceManualOverrideRef.current) return;

    let cancelled = false;
    proofSourceAutoDetectionStartedRef.current = true;

    (async () => {
      try {
        if (preferredRequestBackedProofSourceType) {
          if (cancelled || proofSourceManualOverrideRef.current) return;
          setProofMappingSourceType(preferredRequestBackedProofSourceType);
          setProofSourceLinkageBanner(null);
          setProofSourceStatusMeta(null);
          return;
        }

        for (const sourceType of PROOF_SOURCE_DETECTION_ORDER) {
          if (!proofSourceAvailability[sourceType]?.isApplicable) continue;
          const response = await fetchDesignRepArtworkProofMapping(lifecycleDocumentType, resolvedBinatedDocumentId, {
            orderId,
            sourceType,
          });
          const sourceMeta = getProofSourceResponseMeta(sourceType, response || {});
          if (!sourceMeta.hasUsableData) continue;
          if (cancelled || proofSourceManualOverrideRef.current) return;
          setProofMappingSourceType(sourceType);
          setProofSourceLinkageBanner(
            sourceType === "core-network" ? buildCoreNetworkLinkageBanner(sourceMeta) : null
          );
          setProofSourceStatusMeta(sourceType === "core-network" ? sourceMeta : null);
          return;
        }

        if (!cancelled && !proofSourceManualOverrideRef.current) {
          setProofMappingSourceType(firstApplicableProofSourceType || "");
          setProofSourceLinkageBanner(null);
          setProofSourceStatusMeta(null);
        }
      } catch (error) {
        if (!cancelled) {
          setProofSourceLinkageBanner(null);
          setProofSourceStatusMeta(null);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [
    firstApplicableProofSourceType,
    lifecycleDocumentType,
    orderId,
    preferredRequestBackedProofSourceType,
    proofSourceAvailability,
    requestArtStatusesLoading,
    requestArtStatusesResolved,
    requestArtOpen,
    requestArtTab,
    resolvedBinatedDocumentId,
  ]);

  useEffect(() => {
    if (!requestArtOpen || requestArtTab !== "proofing") return;
    if (!requestArtStatusesResolved || requestArtStatusesLoading) return;

    if (proofMappingSourceType && proofSourceAvailability[proofMappingSourceType]?.isApplicable) {
      return;
    }

    setProofMappingSourceType(firstApplicableProofSourceType || "");
    setProofSourceLinkageBanner(null);
    setProofSourceStatusMeta(null);
  }, [
    firstApplicableProofSourceType,
    proofMappingSourceType,
    proofSourceAvailability,
    requestArtStatusesLoading,
    requestArtStatusesResolved,
    requestArtOpen,
    requestArtTab,
  ]);

  useEffect(() => {
    if (
      !requestArtOpen ||
      requestArtTab !== "binated" ||
      !instanceUniqueId
    ) {
      return;
    }

    let cancelled = false;
    (async () => {
      try {
        setCoreNetworkTalentLoading(true);
        const response = await listCoreNetworkMembers({
          instanceUniqueId,
          status: "active",
          networkType: "design",
          capabilityType: coreNetworkCapabilityFilter || undefined,
          portalEnabled: true,
          directAssignmentEligible: true,
        });
        const members = Array.isArray(response?.members) ? response.members : Array.isArray(response) ? response : [];
        if (cancelled) return;
        setCoreNetworkTalentOptions(members);
        if (members.length === 0) {
          setSelectedCoreNetworkMemberId("");
          setSelectedMarketplaceMemberIds([]);
          return;
        }
        setSelectedCoreNetworkMemberId((current) => {
          const stillExists = members.some((member) => String(member?.id) === String(current));
          return stillExists ? current : "";
        });
        setSelectedMarketplaceMemberIds((current) => current.filter((memberId) => members.some((member) => String(member?.id) === String(memberId))));
      } catch (error) {
        if (!cancelled) {
          setCoreNetworkTalentOptions([]);
          setSelectedCoreNetworkMemberId("");
          setSelectedMarketplaceMemberIds([]);
          toast.error(error?.response?.data?.message || "Failed to load eligible Core Network members.");
        }
      } finally {
        if (!cancelled) {
          setCoreNetworkTalentLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [coreNetworkCapabilityFilter, instanceUniqueId, requestArtOpen, requestArtTab]);

  const loadRequestArtStatuses = useCallback(async () => {
    const shouldLoadStatusesForTab =
      requestArtTab === "binated" || requestArtTab === "proofing";
    if (
      !requestArtOpen ||
      !shouldLoadStatusesForTab ||
      !orderId ||
      !resolvedBinatedDocumentId ||
      !lifecycleDocumentType
    ) {
      return;
    }

    try {
      setRequestArtStatusesResolved(false);
      setRequestArtStatusesLoading(true);
      const response = await getRequestArtStatusesByDocument(orderId, {
        documentType: routeDocType || "sales-order",
        documentId: resolvedBinatedDocumentId,
        requestType: "artwork-proof",
      });
      const nextStatuses = Array.isArray(response?.requestStatuses) ? response.requestStatuses : [];
      setRequestArtStatuses(nextStatuses);
    } catch (_error) {
      setRequestArtStatuses([]);
    } finally {
      setRequestArtStatusesResolved(true);
      setRequestArtStatusesLoading(false);
    }
  }, [lifecycleDocumentType, orderId, requestArtOpen, requestArtTab, resolvedBinatedDocumentId, routeDocType]);

  useEffect(() => {
    if (
      !requestArtOpen ||
      !["binated", "proofing"].includes(requestArtTab)
    ) return;
    loadRequestArtStatuses();
  }, [loadRequestArtStatuses, requestArtOpen, requestArtTab]);
  const docRelatedPurchaseOrders = useMemo(
    () => (purchaseOrderData || []).filter((po) => String(po?.salesOrderId) === String(tabId)),
    [purchaseOrderData, tabId]
  );
  const selectedCoreNetworkMember = useMemo(
    () => coreNetworkTalentOptions.find((member) => String(member?.id) === String(selectedCoreNetworkMemberId)) || null,
    [coreNetworkTalentOptions, selectedCoreNetworkMemberId]
  );
  const selectedCoreNetworkMembership = useMemo(() => {
    const memberships = Array.isArray(selectedCoreNetworkMember?.memberships) ? selectedCoreNetworkMember.memberships : [];
    return memberships.find((membership) => String(membership?.status || "").toLowerCase() === "active") || null;
  }, [selectedCoreNetworkMember]);
  const selectedCoreNetworkCapability = useMemo(() => {
    const capabilities = Array.isArray(selectedCoreNetworkMember?.capabilities) ? selectedCoreNetworkMember.capabilities : [];
    return capabilities.find((capability) => {
      if (!capability || capability.isActive === false) return false;
      if (coreNetworkCapabilityFilter && String(capability.capabilityType || "").toLowerCase() !== String(coreNetworkCapabilityFilter || "").toLowerCase()) {
        return false;
      }
      if (selectedCoreNetworkMembership?.id && capability.membershipId && Number(capability.membershipId) !== Number(selectedCoreNetworkMembership.id)) {
        return false;
      }
      return true;
    }) || null;
  }, [coreNetworkCapabilityFilter, selectedCoreNetworkMember, selectedCoreNetworkMembership]);
  const selectedCoreNetworkCapacitySummary = useMemo(() => {
    const slots = Array.isArray(selectedCoreNetworkMember?.capacitySlots) ? selectedCoreNetworkMember.capacitySlots : [];
    const today = dayjs().startOf("day");
    return slots
      .filter((slot) => {
        if (!slot?.slotDate) return false;
        if (selectedCoreNetworkMembership?.id && slot.membershipId && Number(slot.membershipId) !== Number(selectedCoreNetworkMembership.id)) {
          return false;
        }
        if (coreNetworkCapabilityFilter && slot.capabilityType && String(slot.capabilityType).toLowerCase() !== String(coreNetworkCapabilityFilter).toLowerCase()) {
          return false;
        }
        return dayjs(slot.slotDate).isSame(today, "day") || dayjs(slot.slotDate).isAfter(today, "day");
      })
      .sort((left, right) => new Date(left.slotDate) - new Date(right.slotDate))[0] || null;
  }, [coreNetworkCapabilityFilter, selectedCoreNetworkMember, selectedCoreNetworkMembership]);
  const activeRequestArtStatusProvider = useMemo(
    () =>
      requestArtTab === "proofing" && proofMappingSourceType
        ? getRequestProviderForProofSource(proofMappingSourceType) || proofMappingSourceType
        : resolvedProofWorkProvider,
    [proofMappingSourceType, requestArtTab, resolvedProofWorkProvider]
  );
  const requestArtStatusesForProvider = useMemo(
    () =>
      (Array.isArray(requestArtStatuses) ? requestArtStatuses : []).filter(
        (statusRow) => String(statusRow?.fulfillmentProvider || "").toLowerCase() === String(activeRequestArtStatusProvider || "").toLowerCase()
      ).sort((left, right) => getProofRequestTimestamp(right) - getProofRequestTimestamp(left)),
    [activeRequestArtStatusProvider, requestArtStatuses]
  );
  const proofingResetBlockedReason = useMemo(() => {
    const clientApproved =
      String(currentSO?.status || "").split("_")[0] === "3" &&
      String(currentSO?.customerAgreed ?? "0") === "1";
    if (clientApproved) {
      return "This Sales Order has been client approved. Reset the Sales Order approval before changing Artwork & Proofing.";
    }

    const hasActiveExternalProofRequest = requestArtStatusesForProvider.some(
      (statusRow) => Boolean(statusRow?.isActive)
    );
    if (hasActiveExternalProofRequest) {
      return "This proof request has already been submitted externally and can no longer be reset from the Sales Order action.";
    }

    return "";
  }, [currentSO?.customerAgreed, currentSO?.status, requestArtStatusesForProvider]);
  const latestProofWorkRequestStatus = requestArtStatusesForProvider[0] || null;
  const latestProofWorkRequestId = latestProofWorkRequestStatus?.requestId || null;
  const hasExistingDesignerRequest =
    resolvedProofWorkProvider !== "binated" && requestArtStatusesForProvider.length > 0;

  const ART_TYPE_OPTIONS = ["Vector Art", "Virtuals", "Creative Art", "Digitizing", "Image Editing", "Typeset"];
  const PRIORITY_TO_HOURS = { "Same Day": 8, "Next Day": 24, "5 Days": 120 };
  const ART_TYPE_TO_PROCESS = {
    "Vector Art": "VECTOR",
    Virtuals: "VIRTUAL",
    "Creative Art": "CREATIVE",
    Digitizing: "DIGITIZING",
    "Image Editing": "IMAGE_EDITING",
    Typeset: "TYPESET",
  };
  const ART_TYPE_ICONS = {
    "Vector Art": <ArchitectureIcon fontSize="small" />,
    Virtuals: <ViewInArIcon fontSize="small" />,
    "Creative Art": <AutoAwesomeIcon fontSize="small" />,
    Digitizing: <AutoFixHighIcon fontSize="small" />,
    "Image Editing": <ImageIcon fontSize="small" />,
    Typeset: <TextFieldsIcon fontSize="small" />,
  };
  const PLACEMENT_OPTIONS = [
    { code: "LC", name: "Left Chest" },
    { code: "RC", name: "Right Chest" },
    { code: "FC", name: "Front Center" },
    { code: "BK", name: "Back" },
    { code: "ART", name: "Artwork" },
  ];

  const splitCsv = (value = "") =>
    String(value)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  const placementCodeFromName = (value = "") =>
    String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  const pickFirst = (...vals) => vals.find((v) => {
    if (v == null) return false;
    if (Array.isArray(v)) return v.length > 0;
    return String(v).trim() !== "";
  });
  const findNestedByKeys = (root, keys = []) => {
    if (!root || typeof root !== "object") return undefined;
    const wanted = keys.map((k) => String(k).toLowerCase().replace(/[^a-z0-9]/g, ""));
    const queue = [root];
    const seen = new Set();
    while (queue.length) {
      const node = queue.shift();
      if (!node || typeof node !== "object") continue;
      if (seen.has(node)) continue;
      seen.add(node);
      if (Array.isArray(node)) {
        node.forEach((v) => queue.push(v));
        continue;
      }
      for (const [rawKey, val] of Object.entries(node)) {
        const normalized = String(rawKey).toLowerCase().replace(/[^a-z0-9]/g, "");
        if (wanted.includes(normalized)) return val;
        if (val && typeof val === "object") queue.push(val);
      }
    }
    return undefined;
  };
  const normalizeStringList = (value) => {
    if (value == null) return [];
    if (Array.isArray(value)) {
      return value
        .flatMap((entry) => normalizeStringList(entry))
        .filter(Boolean);
    }
    if (typeof value === "object") {
      const candidates = [
        value.color,
        value.colors,
        value.colour,
        value.name,
        value.label,
        value.value,
      ];
      const nested = candidates
        .flatMap((entry) => normalizeStringList(entry))
        .filter(Boolean);
      if (nested.length) return nested;
      return Object.values(value)
        .flatMap((entry) => normalizeStringList(entry))
        .filter(Boolean);
    }
    return String(value)
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  };
  const parseLogoSize = (value) => {
    if (value == null || value === "") return { width: null, height: null, measurementUnit: "", label: "" };
    if (typeof value === "object") {
      const width = Number(value.width ?? value.w ?? value.logoWidth);
      const height = Number(value.height ?? value.h ?? value.logoHeight);
      const measurementUnit = String(value.measurementUnit || value.unit || value.units || "").trim();
      if (Number.isFinite(width) || Number.isFinite(height)) {
        const safeWidth = Number.isFinite(width) ? width : null;
        const safeHeight = Number.isFinite(height) ? height : null;
        const numericLabel =
          safeWidth != null && safeHeight != null
            ? `${safeWidth} x ${safeHeight}${measurementUnit ? ` ${measurementUnit}` : ""}`
            : `${safeWidth ?? safeHeight}${measurementUnit ? ` ${measurementUnit}` : ""}`;
        return { width: safeWidth, height: safeHeight, measurementUnit, label: numericLabel };
      }
      return { width: null, height: null, measurementUnit: "", label: String(value?.label || value?.name || "") };
    }
    const text = String(value).trim();
    if (!text) return { width: null, height: null, measurementUnit: "", label: "" };
    const match = text.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)(?:\s*([a-zA-Z]+))?/);
    if (match) {
      return {
        width: Number(match[1]),
        height: Number(match[2]),
        measurementUnit: String(match[3] || "").trim(),
        label: text,
      };
    }
    return { width: null, height: null, measurementUnit: "", label: text };
  };

  const buildCartImportSeed = ({ item = {}, po = {} } = {}) => {
    const artwork =
      item?.artwork ||
      item?.ArtWork ||
      item?.decoration?.artwork ||
      item?.Decoration?.ArtWork ||
      item?.DecoratorDetails?.ArtWork ||
      {};
    const sku = pickFirst(
      item.sku,
      item.SKU,
      item?.product?.sku,
      item?.product?.SKU,
      item.supplierSku,
      item.productCode,
      item?.ProductItem?.sku,
      item?.ProductItem?.SKU,
      findNestedByKeys(item, ["sku", "supplierSku", "productCode"]),
      po?.poNumber ? `PO-${po.poNumber}` : ""
    ) || "";
    const productName = pickFirst(
      item.productName,
      item.name,
      item.ProductName,
      item.title,
      item?.product?.name,
      item?.product?.productName,
      item?.product?.title,
      findNestedByKeys(item, ["productName", "name", "title"]),
      po?.purchaseOrderType,
      po?.productName
    ) || "";
    const category = pickFirst(
      item.category,
      item.productCategory,
      item?.product?.category,
      findNestedByKeys(item, ["category", "productCategory"]),
      "Apparel"
    );
    const garment = pickFirst(
      item.variantName,
      item.style,
      item.garment,
      item?.product?.style,
      item?.product?.variantName,
      findNestedByKeys(item, ["variantName", "style", "garment"]),
      ""
    );
    const productUrl = pickFirst(
      item.productUrl,
      item.url,
      item?.product?.url,
      findNestedByKeys(item, ["productUrl", "url", "productLink"]),
      ""
    );
    const logoColorRaw = pickFirst(
      artwork?.logoColor,
      artwork?.LogoColor,
      item?.logoColor,
      item?.LogoColor,
      item?.colors,
      item?.colours,
      item?.colour,
      findNestedByKeys(item, ["logoColor", "LogoColor", "colors", "colour", "colours"]),
      ""
    );
    const importedColors = normalizeStringList(logoColorRaw);
    const textRaw = pickFirst(
      artwork?.text,
      artwork?.Text,
      item?.text,
      item?.Text,
      findNestedByKeys(item, ["text", "texts", "wording", "copy"]),
      ""
    );
    const textList = normalizeStringList(textRaw);
    const logoSizeRaw = pickFirst(
      artwork?.logoSize,
      artwork?.LogoSize,
      artwork?.size,
      artwork?.Size,
      item?.logoSize,
      item?.LogoSize,
      findNestedByKeys(item, ["logoSize", "LogoSize", "size", "dimensions"]),
      ""
    );
    const logoSize = parseLogoSize(logoSizeRaw);
    const previewImage = pickFirst(
      item?.image,
      item?.imageUrl,
      item?.previewImage,
      item?.selectedImage,
      item?.filePath,
      item?.product?.image,
      item?.product?.imageUrl,
      artwork?.selectedImage,
      artwork?.SelectedImage,
      findNestedByKeys(item, ["image", "imageUrl", "selectedImage", "previewImage", "filePath", "file"]),
      Array.isArray(artwork?.files) ? artwork.files[0] : null
    ) || "";
    return {
      sku: String(sku || ""),
      productName: String(productName || ""),
      category: String(category || ""),
      garment: String(garment || ""),
      productUrl: String(productUrl || ""),
      importedColors,
      textList,
      previewImage: String(previewImage || ""),
      logoSizeLabel: String(logoSize?.label || ""),
      logoWidth: logoSize.width,
      logoHeight: logoSize.height,
      logoMeasurementUnit: String(logoSize.measurementUnit || ""),
    };
  };

  const normalizeOutputFormat = (value = "png") => String(value || "png").trim().toLowerCase() || "png";
  const uniqueNonEmpty = (items = []) => Array.from(new Set((items || []).map((v) => String(v || "").trim()).filter(Boolean)));
  const extractCartPlacements = (item = {}) => {
    const decorationPools = [
      ...(Array.isArray(item?.decoration) ? item.decoration : []),
      ...(Array.isArray(item?.decorations) ? item.decorations : []),
      ...(Array.isArray(item?.Decoration) ? item.Decoration : []),
      ...(Array.isArray(item?.DecoratorDetails) ? item.DecoratorDetails : []),
      ...(Array.isArray(item?.Imprinting?.Decorations) ? item.Imprinting.Decorations : []),
      ...(Array.isArray(item?.rows) ? item.rows : []),
    ];
    const fallbackLocation = pickFirst(
      item?.Location,
      item?.location,
      item?.Imprinting?.Locations?.Values?.[0]?.Name,
      "Artwork"
    );
    const grouped = new Map();
    const normalizeAndPush = (locationRaw, urlsRaw = []) => {
      const locationName = String(locationRaw || fallbackLocation || "Artwork").trim();
      const key = locationName.toLowerCase();
      const existing = grouped.get(key) || { placement_name: locationName, urls: [] };
      existing.urls = uniqueNonEmpty([...(existing.urls || []), ...(urlsRaw || [])]);
      grouped.set(key, existing);
    };
    decorationPools.forEach((dec) => {
      const locationName = pickFirst(dec?.Location, dec?.location, dec?.placement_name, fallbackLocation);
      const directUrls = uniqueNonEmpty([
        dec?.artwork?.selectedImage,
        dec?.ArtWork?.Image,
        dec?.image,
        dec?.filePath,
        dec?.url,
      ]);
      normalizeAndPush(locationName, directUrls);
      const rows = Array.isArray(dec?.rows) ? dec.rows : [];
      rows.forEach((row) => {
        normalizeAndPush(locationName, uniqueNonEmpty([
          row?.artwork?.selectedImage,
          row?.ArtWork?.Image,
          row?.image,
          row?.filePath,
          row?.url,
        ]));
      });
    });
    return Array.from(grouped.values()).map((entry) => ({
      placement_name: entry.placement_name,
      placement_code: placementCodeFromName(entry.placement_name),
      urls: uniqueNonEmpty(entry.urls),
    }));
  };
  const buildBinatedReference = (instanceSlug, projectId, salesDocId) => {
    const slug = String(instanceSlug || "").trim();
    const project = String(projectId || "").trim();
    const sales = String(salesDocId || "").trim();
    return [slug, project].filter(Boolean).join("-") + (sales ? `=${sales}` : "");
  };
  const displayBinatedReference = [String(orderId || "").trim(), String(tabId || "").trim()]
    .filter(Boolean)
    .join("-");

  const cartItemOptions = useMemo(() => {
    const pools = [
      Array.isArray(selectedProducts) ? selectedProducts : [],
      Array.isArray(order?.cart?.items) ? order.cart.items : [],
      Array.isArray(order?.cart?.products) ? order.cart.products : [],
      Array.isArray(order?.Products) ? order.Products : [],
    ];
    const merged = pools.flat().filter((x) => x && typeof x === "object");
    const dedup = [];
    const seen = new Set();
    merged.forEach((item, idx) => {
      const key = String(item.id || item.productId || item.ItemId || item.sku || item.SKU || idx);
      if (seen.has(key)) return;
      seen.add(key);
      dedup.push({
        key,
        raw: item,
        label: item.productName || item.name || item.ProductName || item.sku || item.SKU || `Item ${idx + 1}`,
      });
    });
    return dedup;
  }, [selectedProducts, order]);

  const buildMediaItem = ({ po = {}, source = null } = {}) => {
    const item = source || {};
    const seed = buildCartImportSeed({ item, po });
    const isImportedFromCart = !!source;
    const importedPlacements = isImportedFromCart ? extractCartPlacements(item) : [];
    const placementInfo = importedPlacements.length
      ? importedPlacements.map((place) => ({
          placement_code: place.placement_code || placementCodeFromName(place.placement_name || ""),
          placement_name: place.placement_name || "Artwork",
          process_type: ART_TYPE_TO_PROCESS["Vector Art"] || "VECTOR",
          art_type: "Vector Art",
          height: Number.isFinite(seed.logoHeight) ? seed.logoHeight : 100,
          width: Number.isFinite(seed.logoWidth) ? seed.logoWidth : 100,
          measurement_unit: seed.logoMeasurementUnit || "px",
          product_color: "",
          colors: seed.importedColors,
          background_color: "",
          text: seed.textList,
          url: place.urls || [],
          sewout_logo_recreation: "No",
          output_file_format: "png",
          is_proofing: false,
          email_users: [],
        }))
      : [
          {
            placement_code: PLACEMENT_OPTIONS[0].code,
            placement_name: PLACEMENT_OPTIONS[0].name,
            process_type: ART_TYPE_TO_PROCESS["Vector Art"] || "VECTOR",
            art_type: "Vector Art",
            height: Number.isFinite(seed.logoHeight) ? seed.logoHeight : 100,
            width: Number.isFinite(seed.logoWidth) ? seed.logoWidth : 100,
            measurement_unit: seed.logoMeasurementUnit || "px",
            product_color: "",
            colors: seed.importedColors,
            background_color: "",
            text: seed.textList,
            url: [],
            sewout_logo_recreation: "No",
            output_file_format: "png",
            is_proofing: false,
            email_users: [],
          },
        ];
    return {
      product_sku: isImportedFromCart ? seed.sku : "",
      priority: "5 Days",
      due_hours: PRIORITY_TO_HOURS["5 Days"],
      description: "Art request",
      reference: buildBinatedReference(instanceUniqueId, orderId, tabId),
      instructions: "Please create artwork files for this order.",
      product_category: seed.category,
      product_name: isImportedFromCart ? seed.productName : "",
      product: seed.garment || "",
      product_url: seed.productUrl,
      garment: seed.garment,
      change_request: false,
      decoration_info: [
        {
          decoration: "Vector Art",
          decoration_instructions: "Artwork request from Elite Core",
          placement_info: placementInfo,
        },
      ],
    };
  };

  const buildInitialArtForm = (po = {}) => {
    const mediaItem = buildMediaItem({ po });
    const proofUrls = Array.isArray(po?.proofs)
      ? po.proofs.map((p) => p?.proofFilePath || p?.filePath).filter(Boolean)
      : [];
    if (mediaItem?.decoration_info?.[0]?.placement_info?.[0]) {
      mediaItem.decoration_info[0].placement_info[0].url = proofUrls;
    }
    return {
      request_type: "art",
      meta: {
        decorationType: "New",
        isPrivate: false,
      },
      media: [mediaItem],
    };
  };

  const toDateOnlyOrNull = (value) => {
    if (!value) return null;
    if (typeof value === "string") {
      const match = value.match(/^(\d{4}-\d{2}-\d{2})/);
      if (match) return match[1];
    }
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date.toISOString().slice(0, 10);
  };

  const firstNonEmpty = (...values) => pickFirst(...values) ?? null;

  const asList = (value) => {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    return [value];
  };

  const splitColors = (value) => {
    if (Array.isArray(value)) return value.flatMap(splitColors).filter(Boolean);
    if (value == null) return [];
    if (typeof value === "object") {
      return splitColors(firstNonEmpty(value.name, value.label, value.value, value.color, value.colour, value.colors));
    }
    return String(value)
      .split(/[,/|]+|\s+and\s+/i)
      .map((entry) => entry.trim())
      .filter(Boolean);
  };

  const isValidDirectUrl = (value) => {
    const raw = String(value || "").trim();
    if (!raw || /\/generated-(sales-order|estimate)\//i.test(raw)) return false;
    try {
      const parsed = new URL(raw);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (_err) {
      return false;
    }
  };

  const isImageUrl = isSupportedProductImageUrl;

  const inferOutputFileFormat = (url) => {
    const raw = String(Array.isArray(url) ? url[0] : url || "").split("?")[0].split("#")[0];
    const ext = raw.includes(".") ? raw.split(".").pop() : "";
    return normalizeOutputFormat(ext || "png");
  };

  const parseLogoSizeForBinated = (value) => {
    const raw = String(value || "").toLowerCase();
    const unit = raw.includes("cm") ? "cm" : raw.includes("mm") ? "mm" : raw.includes("px") ? "px" : "inch";
    const byMatch = raw.match(/(\d+(?:\.\d+)?)\s*(?:"|in|inch|inches)?\s*(?:x|×|by)\s*(\d+(?:\.\d+)?)/i);
    if (byMatch) {
      return { width: Number(byMatch[1]), height: Number(byMatch[2]), measurement_unit: unit };
    }

    const parsed = parseLogoSize(value);
    return {
      width: Number.isFinite(Number(parsed?.width)) ? Number(parsed.width) : null,
      height: Number.isFinite(Number(parsed?.height)) ? Number(parsed.height) : null,
      measurement_unit: parsed?.measurementUnit ? String(parsed.measurementUnit).toLowerCase() : unit,
    };
  };

  const normalizePlacementCode = (location = "") => {
    const value = String(location || "").trim().toLowerCase();
    if (value === "left chest" || value === "left-chest") return "LC";
    if (value === "right chest" || value === "right-chest") return "RC";
    if (value === "middle" || value === "center" || value === "centre") return "MIDDLE";
    if (value === "front") return "FRONT";
    if (value === "back") return "BACK";
    if (value === "left sleeve") return "LS";
    if (value === "right sleeve") return "RS";
    return String(location || "PLACEMENT")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "") || "PLACEMENT";
  };

  const mapBinatedDecorationType = (imprintType, chargeName) => {
    const text = `${imprintType || ""} ${chargeName || ""}`.toLowerCase();
    if (/embroider|digitiz/.test(text)) return "Digitizing";
    if (/image|photo|raster/.test(text)) return "Image Editing";
    if (/marketing|collateral|flyer|brochure/.test(text)) return "Creative Art";
    if (/virtual|mockup/.test(text)) return "Virtuals";
    if (/creative/.test(text)) return "Creative Art";
    if (/screen|print|vector|dtf|heat|transfer|pad/.test(text)) return "Vector Art";
    return "Vector Art";
  };

  const getChargeName = (decoration = {}) => {
    const charges = [
      ...(Array.isArray(decoration?.Charge) ? decoration.Charge : []),
      ...(Array.isArray(decoration?.charges) ? decoration.charges : []),
      ...(Array.isArray(decoration?.rows) ? decoration.rows : []),
    ];
    const found = charges.find((charge) => firstNonEmpty(charge?.Name, charge?.ChargeName, charge?.chargeName, charge?.Type, charge?.type));
    return firstNonEmpty(found?.Name, found?.ChargeName, found?.chargeName, found?.Type, found?.type, decoration?.chargeName, decoration?.ChargeName, "");
  };

  const getArtworkUrl = (artwork = {}) => firstNonEmpty(
    artwork?.FileUrl,
    artwork?.fileUrl,
    artwork?.Image,
    artwork?.image,
    artwork?.url,
    artwork?.URL,
    artwork?.selectedImage,
    artwork?.previewUrl,
  );

  const findArtworkForDecoration = (product = {}, decoration = {}) => {
    const decorationId = firstNonEmpty(decoration?.id, decoration?.DecorationId, decoration?.decorationId);
    const artworkPools = [
      decoration?.ArtWork,
      decoration?.artwork,
      ...(Array.isArray(decoration?.artworks) ? decoration.artworks : []),
      ...(Array.isArray(decoration?.ArtWorks) ? decoration.ArtWorks : []),
      ...(Array.isArray(product?.artworks) ? product.artworks : []),
      ...(Array.isArray(product?.ArtWorks) ? product.ArtWorks : []),
      ...(Array.isArray(product?.ArtWork) ? product.ArtWork : []),
      product?.ArtWork,
      product?.artwork,
    ].filter(Boolean);
    const matched = artworkPools.find((artwork) => {
      if (!decorationId) return false;
      const artworkDecorationId = firstNonEmpty(artwork?.DecorationId, artwork?.decorationId, artwork?.Decoration?.id);
      return String(artworkDecorationId || "") === String(decorationId);
    });
    return matched || artworkPools.find((artwork) => isValidDirectUrl(getArtworkUrl(artwork))) || null;
  };

  const buildGarmentLabel = (product = {}) => {
    const pricing = asList(product?.Pricing || product?.pricings)[0] || {};
    const cartDetail = asList(product?.cartDetails)[0] || {};
    const normalize = (value) => {
      const text = String(value || "").trim();
      return !text || text.toLowerCase() === "n/a" ? "" : text;
    };
    const size = firstNonEmpty(
      normalize(pricing?.Size),
      normalize(pricing?.size),
      normalize(cartDetail?.size),
      normalize(product?.Size),
      normalize(product?.size),
      normalize(product?.VariantSize),
      normalize(product?.variantSize),
      normalize(product?.selectedSize),
    );
    const color = firstNonEmpty(
      normalize(pricing?.Color),
      normalize(pricing?.color),
      normalize(cartDetail?.color),
      normalize(product?.Color),
      normalize(product?.color),
      normalize(product?.VariantColor),
      normalize(product?.variantColor),
      normalize(product?.selectedColor),
    );
    return [size, color].filter(Boolean).join(" - ");
  };

  const parseMaybeJson = (value) => {
    if (typeof value !== "string") return value;
    try {
      return JSON.parse(value);
    } catch (_err) {
      return value;
    }
  };

  const toMoneyNumber = (value, fallback = 0) => {
    if (typeof value === "number") return Number.isFinite(value) ? value : fallback;
    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) return fallback;
      const numeric = Number(trimmed.replace(/[$,%]/g, ""));
      return Number.isFinite(numeric) ? numeric : fallback;
    }
    if (value && typeof value === "object") {
      const parsed = parseMaybeJson(value);
      if (parsed !== value) return toMoneyNumber(parsed, fallback);
      const moneyKeys = [
        "targetRevenue",
        "revenue",
        "subtotal",
        "invoiceableTotal",
        "salesOrderTotal",
        "totalIncl",
        "totalInclTax",
        "bookedMargin",
        "amount",
      ];
      for (const key of moneyKeys) {
        if (value[key] == null) continue;
        const resolved = toMoneyNumber(value[key], Number.NaN);
        if (Number.isFinite(resolved)) return resolved;
      }
    }
    return fallback;
  };

  const FINANCIAL_SIGNAL_KEYS = [
    "subtotal",
    "totalInclTax",
    "bookedMarginAmount",
    "bookedMargin",
    "targetRevenue",
    "revenue",
    "invoiceableTotal",
    "salesOrderTotal",
    "targetCosts",
    "costs",
  ];

  const getFinancialSignalNumber = (value) => {
    const numeric = toMoneyNumber(value, Number.NaN);
    return Number.isFinite(numeric) ? numeric : null;
  };

  const hasUsableCostRows = (rows = []) => asList(rows).some((row) => {
    if (!row || typeof row !== "object") return false;
    return [
      row?.NetCost,
      row?.netCost,
      row?.Cost,
      row?.cost,
      row?.UnitCost,
      row?.unitCost,
      row?.TotalCost,
      row?.totalCost,
      row?.amount,
    ].some((value) => {
      const numeric = getFinancialSignalNumber(value);
      return numeric != null && numeric !== 0;
    });
  });

  const getLineCostRowPools = (line = {}) => [
    getCanonicalPricingRows(line),
    line?.Charge,
    line?.Charges,
    line?.charges,
    line?.DecorationCharges,
    line?.decorationCharges,
    line?.SetupCharge,
    line?.SetupCharges,
    line?.setupCharge,
    line?.setupCharges,
    line?.RunCharge,
    line?.RunCharges,
    line?.runCharge,
    line?.runCharges,
    ...asList(line?.Decorations).flatMap((decoration) => [
      decoration?.Charge,
      decoration?.Charges,
      decoration?.charges,
      getCanonicalPricingRows(decoration),
      decoration?.SetupCharge,
      decoration?.SetupCharges,
      decoration?.setupCharge,
      decoration?.setupCharges,
      decoration?.RunCharge,
      decoration?.RunCharges,
      decoration?.runCharge,
      decoration?.runCharges,
    ]),
    ...asList(line?.decorations).flatMap((decoration) => [
      decoration?.Charge,
      decoration?.Charges,
      decoration?.charges,
      getCanonicalPricingRows(decoration),
      decoration?.SetupCharge,
      decoration?.SetupCharges,
      decoration?.setupCharge,
      decoration?.setupCharges,
      decoration?.RunCharge,
      decoration?.RunCharges,
      decoration?.runCharge,
      decoration?.runCharges,
    ]),
  ];

  const getPayloadSummaryEntry = (rawPayload = {}) => {
    const payload = parseMaybeJson(rawPayload) || {};
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return { summary: {}, source: null };

    const nestedPayload = parseMaybeJson(payload?.payload) || payload?.payload || {};
    const cartPayload = parseMaybeJson(payload?.cartPayload) || payload?.cartPayload || {};
    const cartSnapshot = parseMaybeJson(payload?.cartSnapshot) || payload?.cartSnapshot || {};
    const approvedSnapshot = parseMaybeJson(payload?.approvedSnapshot) || payload?.approvedSnapshot || {};
    const meta = parseMaybeJson(payload?.meta) || payload?.meta || {};
    const data = parseMaybeJson(payload?.data) || payload?.data || {};
    const dataCartPayload = parseMaybeJson(data?.cartPayload) || data?.cartPayload || {};
    const cartWorkspace = parseMaybeJson(payload?.cartWorkspace) || payload?.cartWorkspace || {};
    const cartWorkspacePayload = parseMaybeJson(cartWorkspace?.cartPayload) || cartWorkspace?.cartPayload || {};

    const candidates = [
      ["orderSummary", payload?.orderSummary],
      ["OrderSummary", payload?.OrderSummary],
      ["summary", payload?.summary],
      ["Summary", payload?.Summary],
      ["cartPayload.orderSummary", cartPayload?.orderSummary],
      ["cartPayload.OrderSummary", cartPayload?.OrderSummary],
      ["cartPayload.summary", cartPayload?.summary],
      ["payload.orderSummary", nestedPayload?.orderSummary],
      ["payload.OrderSummary", nestedPayload?.OrderSummary],
      ["payload.summary", nestedPayload?.summary],
      ["meta.orderSummary", meta?.orderSummary],
      ["meta.summary", meta?.summary],
      ["cartWorkspace.orderSummary", cartWorkspace?.orderSummary],
      ["cartWorkspace.cartPayload.orderSummary", cartWorkspacePayload?.orderSummary],
      ["cartWorkspace.cartPayload.OrderSummary", cartWorkspacePayload?.OrderSummary],
      ["cartWorkspace.cartPayload.summary", cartWorkspacePayload?.summary],
      ["cartSnapshot.orderSummary", cartSnapshot?.orderSummary],
      ["approvedSnapshot.orderSummary", approvedSnapshot?.orderSummary],
      ["data.orderSummary", data?.orderSummary],
      ["data.cartPayload.orderSummary", dataCartPayload?.orderSummary],
    ];

    for (const [source, candidate] of candidates) {
      const summary = parseMaybeJson(candidate);
      if (summary && typeof summary === "object" && !Array.isArray(summary) && Object.keys(summary).length > 0) return { summary, source };
    }

    return { summary: {}, source: null };
  };

  const getPayloadSummary = (rawPayload = {}) => getPayloadSummaryEntry(rawPayload).summary || {};

  const getCartLines = (orderData = {}, cartPayload = {}) => [
    ...asList(cartPayload?.Products),
    ...asList(cartPayload?.products),
    ...asList(cartPayload?.Items),
    ...asList(cartPayload?.items),
    ...asList(orderData?.Products),
    ...asList(orderData?.products),
    ...asList(orderData?.Items),
    ...asList(orderData?.items),
  ].filter((line) => line && typeof line === "object");

  const getCartOtherServices = (orderData = {}, cartPayload = {}) => [
    ...asList(cartPayload?.OtherService),
    ...asList(cartPayload?.OtherServices),
    ...asList(cartPayload?.otherServices),
    ...asList(orderData?.OtherService),
    ...asList(orderData?.OtherServices),
    ...asList(orderData?.otherServices),
  ].filter((line) => line && typeof line === "object");

  const isSalesOrderIdentityValue = (value) => {
    const text = String(value || "").trim().toLowerCase();
    return ["sales-order", "sales_order", "salesorder", "sales-order-cart", "sales_order_cart", "salesordercart"].includes(text);
  };

  const isApprovedSalesOrderRow = (row = {}) => isApprovedBookedSalesOrder(row);

  const withSalesOrderCartIdentity = (payload, row = {}) => {
    const parsed = parseMaybeJson(payload);
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return parsed;
    if (!isApprovedSalesOrderRow(row)) return parsed;
    return { ...parsed, __salesOrderCartIdentity: true };
  };

  const hasSalesOrderCartIdentity = (rawPayload = {}) => {
    const payload = parseMaybeJson(rawPayload);
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return false;
    const nestedPayload = parseMaybeJson(payload?.payload) || payload?.payload || {};
    const relationships = payload?.relationships || {};
    const invoiceRelationships = payload?.invoiceRelationships || {};
    const meta = payload?.meta || {};
    const nestedMeta = nestedPayload?.meta || {};
    return Boolean(
      payload.__salesOrderCartIdentity ||
      isSalesOrderIdentityValue(payload?.source) ||
      isSalesOrderIdentityValue(payload?.Source) ||
      isSalesOrderIdentityValue(payload?.sourceCartType) ||
      isSalesOrderIdentityValue(payload?.cartType) ||
      isSalesOrderIdentityValue(payload?.type) ||
      isSalesOrderIdentityValue(payload?.documentType) ||
      isSalesOrderIdentityValue(payload?.snapshotReason) ||
      isSalesOrderIdentityValue(meta?.source) ||
      isSalesOrderIdentityValue(meta?.sourceCartType) ||
      isSalesOrderIdentityValue(relationships?.sourceCartType) ||
      isSalesOrderIdentityValue(invoiceRelationships?.sourceCartType) ||
      isSalesOrderIdentityValue(nestedPayload?.source) ||
      isSalesOrderIdentityValue(nestedPayload?.Source) ||
      isSalesOrderIdentityValue(nestedPayload?.sourceCartType) ||
      isSalesOrderIdentityValue(nestedPayload?.cartType) ||
      isSalesOrderIdentityValue(nestedPayload?.type) ||
      isSalesOrderIdentityValue(nestedPayload?.documentType) ||
      isSalesOrderIdentityValue(nestedMeta?.source) ||
      isSalesOrderIdentityValue(nestedMeta?.sourceCartType) ||
      payload?.salesOrderCartSnapshotId ||
      nestedPayload?.salesOrderCartSnapshotId
    );
  };

  const getCostRowPoolCountForPayload = (rawPayload = {}) => {
    const payload = parseMaybeJson(rawPayload);
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return 0;
    const lines = [...getCartLines({}, payload), ...getCartOtherServices({}, payload)];
    return lines.reduce((sum, line) => sum + getLineCostRowPools(line).filter((pool) => asList(pool).length > 0).length, 0);
  };

  const isFalseHundredPercentSalesOrderCartCandidate = (rawPayload = {}) => {
    const summary = getSnapshotSummaryFromPayload(rawPayload) || getPayloadSummary(parseMaybeJson(rawPayload) || {});
    const hasSummaryFields = summary && typeof summary === "object" && Object.keys(summary).length > 0 && hasRealFinancialSignal({ orderSummary: summary });
    // A subtotal alone does not prove booked margin. Accept usable margin/cost
    // summaries or actual cost rows, not a fabricated 100% margin.
    const hasTrustedFinancialSummary = hasSummaryFields && Boolean(resolveBookedSummaryFinancials(summary));
    if (hasTrustedFinancialSummary || getCostRowPoolCountForPayload(rawPayload) > 0) return false;
    const derived = deriveCartFinancialSummary({}, rawPayload, "sales-order-cart");
    if (!derived) return false;
    return (
      toMoneyNumber(derived.bookedRevenue, 0) > 0 &&
      toMoneyNumber(derived.costs, 0) === 0 &&
      Math.abs(toMoneyNumber(derived.bookedMargin, 0) - toMoneyNumber(derived.bookedRevenue, 0)) < 0.01
    );
  };

  const isUsableSalesOrderCartCandidate = (rawPayload = {}) =>
    hasSalesOrderCartIdentity(rawPayload) && !isFalseHundredPercentSalesOrderCartCandidate(rawPayload);

  const hasRealFinancialSignal = (summaryOrPayload = {}) => {
    const payload = parseMaybeJson(summaryOrPayload);
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return false;

    const summary = getPayloadSummary(payload);
    const hasNonZeroFinancialValue = [payload, summary].some((source) =>
      FINANCIAL_SIGNAL_KEYS.some((key) => {
        const numeric = getFinancialSignalNumber(source?.[key]);
        return numeric != null && numeric !== 0;
      })
    );
    if (hasNonZeroFinancialValue) return true;

    const lines = [
      ...getCartLines({}, payload),
      ...getCartOtherServices({}, payload),
    ];

    return lines.some((line) => {
      const lineRevenue = getFinancialSignalNumber(firstNonEmpty(
        line?.lineTotal,
        line?.LineTotal,
        line?.extendedPrice,
        line?.ExtendedPrice,
        line?.subtotal,
        line?.SubTotal,
        line?.total,
        line?.Total,
        line?.amount,
      ));
      return (lineRevenue != null && lineRevenue !== 0) || getLineCostRowPools(line).some(hasUsableCostRows);
    });
  };

  const hasFinancialFields = (value) => hasRealFinancialSignal(value);

  const getLatestBookedStamp = (approvedSalesOrder = null) => {
    // Only the same approved revision used for commissions may supply booked
    // financials. Never select an unrelated draft or the project-wide cart.
    const stamp = parseMaybeJson(approvedSalesOrder?.stampedBookedAmount);
    return hasFinancialFields(stamp) ? stamp : null;
  };

  const getLineQuantity = (line = {}) => {
    const qty = toMoneyNumber(firstNonEmpty(line?.Quantity, line?.quantity, line?.qty, 1), 1);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  };

  const getLineRevenue = (line = {}) => {
    const direct = toMoneyNumber(firstNonEmpty(
      line?.lineTotal,
      line?.LineTotal,
      line?.extendedPrice,
      line?.ExtendedPrice,
      line?.subtotal,
      line?.SubTotal,
      line?.total,
      line?.Total,
      line?.amount,
    ), Number.NaN);
    if (Number.isFinite(direct)) return direct;

    const unitPrice = toMoneyNumber(firstNonEmpty(
      line?.UnitPrice,
      line?.unitPrice,
      line?.Price,
      line?.price,
      line?.SellPrice,
      line?.sellPrice,
    ), 0);
    return unitPrice * getLineQuantity(line);
  };

  const sumNetCostRows = (rows = [], fallbackQuantity = 1) => asList(rows).reduce((sum, row) => {
    if (!row || typeof row !== "object") return sum;
    const netCost = toMoneyNumber(firstNonEmpty(
      row?.NetCost,
      row?.netCost,
      row?.Cost,
      row?.cost,
      row?.UnitCost,
      row?.unitCost,
      row?.TotalCost,
      row?.totalCost,
      row?.amount,
    ), Number.NaN);
    if (!Number.isFinite(netCost)) return sum;
    const directTotalCost = toMoneyNumber(firstNonEmpty(row?.TotalCost, row?.totalCost), Number.NaN);
    if (Number.isFinite(directTotalCost)) return sum + directTotalCost;
    const qty = toMoneyNumber(firstNonEmpty(row?.Quantity, row?.quantity, row?.qty, fallbackQuantity), fallbackQuantity);
    return sum + (netCost * (Number.isFinite(qty) && qty > 0 ? qty : fallbackQuantity));
  }, 0);

  const getLineCosts = (line = {}) => {
    const quantity = getLineQuantity(line);
    const directCost = toMoneyNumber(firstNonEmpty(line?.targetCosts, line?.costs, line?.totalCost, line?.TotalCost), Number.NaN);
    if (Number.isFinite(directCost) && directCost !== 0) return directCost;

    return getLineCostRowPools(line).reduce((sum, rows) => sum + sumNetCostRows(rows, quantity), 0);
  };

  const deriveCartFinancialSummary = (orderData = {}, rawCartPayload = {}, source = "order-cart") => {
    const cartPayload = parseMaybeJson(rawCartPayload) || {};
    const combinedPayload = {
      ...cartPayload,
      Products: getCartLines(orderData, cartPayload),
      OtherService: getCartOtherServices(orderData, cartPayload),
      orderSummary: firstNonEmpty(getPayloadSummary(cartPayload), orderData?.orderSummary, orderData?.summary, {}),
    };

    // Empty async payloads are not authoritative; return null so a higher/later valid source is preserved.
    if (!hasRealFinancialSignal(combinedPayload)) return null;

    const cartSummary = getPayloadSummary(cartPayload);
    const orderSummary = getPayloadSummary(orderData);
    const products = getCartLines(orderData, cartPayload);
    const otherServices = getCartOtherServices(orderData, cartPayload);
    const allLines = [...products, ...otherServices];

    const derivedRevenue = allLines.reduce((sum, line) => sum + getLineRevenue(line), 0);
    const derivedCosts = allLines.reduce((sum, line) => sum + getLineCosts(line), 0);
    const summaryRevenue = toMoneyNumber(firstNonEmpty(
      cartSummary?.subtotal,
      orderSummary?.subtotal,
      cartPayload?.subtotal,
      orderData?.cart?.bookedRevenue,
      orderData?.Total,
    ), Number.NaN);
    const revenue = Number.isFinite(summaryRevenue) ? summaryRevenue : derivedRevenue;

    const explicitTotalInclTax = toMoneyNumber(firstNonEmpty(
      cartSummary?.totalInclTax,
      orderSummary?.totalInclTax,
      cartSummary?.totalIncl,
      orderSummary?.totalIncl,
    ), Number.NaN);
    const tax = toMoneyNumber(firstNonEmpty(cartSummary?.tax, orderSummary?.tax, cartSummary?.taxTotal, orderSummary?.taxTotal), 0);
    const totalInclTax = Number.isFinite(explicitTotalInclTax) ? explicitTotalInclTax : revenue + tax;

    const summaryMargin = toMoneyNumber(firstNonEmpty(
      cartSummary?.bookedMarginAmount,
      orderSummary?.bookedMarginAmount,
      cartSummary?.bookedMargin,
      orderSummary?.bookedMargin,
      orderData?.cart?.bookedMargin,
    ), Number.NaN);

    const explicitCosts = toMoneyNumber(firstNonEmpty(
      cartSummary?.targetCosts,
      cartSummary?.costs,
      orderSummary?.targetCosts,
      orderSummary?.costs,
    ), Number.NaN);
    const costsFromMargin = Number.isFinite(summaryRevenue) && Number.isFinite(summaryMargin)
      ? summaryRevenue - summaryMargin
      : Number.NaN;
    const costs = Number.isFinite(explicitCosts) && explicitCosts !== 0
      ? explicitCosts
      : Number.isFinite(costsFromMargin)
        ? costsFromMargin
        : derivedCosts;
    const bookedMargin = Number.isFinite(explicitCosts) && explicitCosts !== 0
      ? revenue - costs
      : Number.isFinite(summaryMargin) ? summaryMargin : revenue - costs;

    return {
      source,
      bookedRevenue: toMoneyNumber(revenue),
      costs: toMoneyNumber(costs),
      bookedMargin: toMoneyNumber(bookedMargin),
      bookedMarginPct: calculateBookedMarginPct(revenue, bookedMargin),
      totalInclTax: toMoneyNumber(totalInclTax),
    };
  };

  const getSalesOrderCartPayloadCandidates = (approvedSalesOrder = null) => {
    if (!approvedSalesOrder) return [];
    const row = approvedSalesOrder;
    const stamp = parseMaybeJson(row.stampedBookedAmount) || {};
    const rawProducts = parseMaybeJson(row.products);
    return [
      withSalesOrderCartIdentity(stamp?.cartSnapshot, row),
      withSalesOrderCartIdentity(stamp?.cartPayload, row),
      withSalesOrderCartIdentity(row?.cartSnapshot, row),
      withSalesOrderCartIdentity(row?.salesOrderCartSnapshot, row),
      withSalesOrderCartIdentity(row?.cartPayload, row),
      withSalesOrderCartIdentity(row?.payload, row),
      withSalesOrderCartIdentity(row?.cart, row),
      ...(Array.isArray(rawProducts) && rawProducts.length
        ? [withSalesOrderCartIdentity({ Products: rawProducts }, row)] : []),
    ].map(parseMaybeJson).filter(Boolean);
  };

  const firstValidFinancialSummary = (candidates = [], source) => {
    for (const candidate of candidates) {
      const summary = deriveCartFinancialSummary({}, candidate, source);
      if (summary) return summary;
    }
    return null;
  };

  const getSnapshotSummaryFromPayload = (rawPayload = {}) => {
    const payload = parseMaybeJson(rawPayload);
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return null;
    const directSummary = getPayloadSummary(payload);
    if (directSummary && typeof directSummary === "object" && !Array.isArray(directSummary) && hasRealFinancialSignal({ orderSummary: directSummary })) {
      return mergeBookedStampSummary(payload, directSummary);
    }
    const nestedPayload = parseMaybeJson(payload?.payload) || payload?.payload;
    const cartSnapshot = parseMaybeJson(payload?.cartSnapshot) || payload?.cartSnapshot;
    const cartPayload = parseMaybeJson(payload?.cartPayload) || payload?.cartPayload;
    const approvedSnapshot = parseMaybeJson(payload?.approvedSnapshot) || payload?.approvedSnapshot;
    const candidates = [
      payload?.orderSummary,
      payload?.OrderSummary,
      payload?.summary,
      nestedPayload?.orderSummary,
      cartSnapshot?.orderSummary,
      cartPayload?.orderSummary,
      approvedSnapshot?.orderSummary,
    ];

    const nestedSummary = candidates
      .map(parseMaybeJson)
      .find((summary) => summary && typeof summary === "object" && !Array.isArray(summary) && hasRealFinancialSignal({ orderSummary: summary })) || null;
    if (nestedSummary) return mergeBookedStampSummary(payload, nestedSummary);
    return hasRealFinancialSignal(payload) ? mergeBookedStampSummary(payload) : null;
  };

  const financialsFromSnapshotSummary = resolveBookedSummaryFinancials;

  const firstValidSnapshotSummaryFinancials = (candidates = [], source) => {
    for (const candidate of candidates) {
      const summary = getSnapshotSummaryFromPayload(candidate);
      const financials = financialsFromSnapshotSummary(summary, source);
      if (financials) return financials;
    }
    return null;
  };

  const getOverviewFinancialDebugSummaryValues = (rawPayload = {}) => {
    const payload = parseMaybeJson(rawPayload) || {};
    const summary = getPayloadSummary(payload);
    return {
      subtotal: getFinancialSignalNumber(summary?.subtotal ?? payload?.subtotal),
      totalInclTax: getFinancialSignalNumber(
        summary?.totalInclTax ??
        summary?.totalIncl ??
        payload?.totalInclTax ??
        payload?.totalIncl ??
        payload?.invoiceableTotal ??
        payload?.salesOrderTotal
      ),
      bookedMarginAmount: getFinancialSignalNumber(summary?.bookedMarginAmount ?? payload?.bookedMarginAmount),
      bookedMarginPct: getFinancialSignalNumber(summary?.bookedMarginPct ?? payload?.bookedMarginPct),
      bookedMargin: getFinancialSignalNumber(summary?.bookedMargin ?? payload?.bookedMargin),
      targetRevenue: getFinancialSignalNumber(summary?.targetRevenue ?? payload?.targetRevenue),
      revenue: getFinancialSignalNumber(summary?.revenue ?? payload?.revenue),
      targetCosts: getFinancialSignalNumber(summary?.targetCosts ?? payload?.targetCosts),
      costs: getFinancialSignalNumber(summary?.costs ?? payload?.costs),
    };
  };

  const getOverviewFinancialDebugReason = (rawPayload, derivedSummary, acceptedReason) => {
    if (acceptedReason) return acceptedReason;
    if (derivedSummary) return "accepted";
    const payload = parseMaybeJson(rawPayload);
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return "rejected-empty";
    const lines = [...getCartLines({}, payload), ...getCartOtherServices({}, payload)];
    const summary = getPayloadSummary(payload);
    const hasSummaryKeys = summary && typeof summary === "object" && Object.keys(summary).length > 0;
    if (!hasSummaryKeys && lines.length === 0) return "rejected-no-summary-no-lines";
    const values = getOverviewFinancialDebugSummaryValues(payload);
    const hasAnyFinancialKey = Object.values(values).some((value) => value != null);
    const allKnownValuesZero = hasAnyFinancialKey && Object.values(values).every((value) => value == null || value === 0);
    if (allKnownValuesZero) return "rejected-all-zero";
    return "rejected-no-financial-signal";
  };

  const buildOverviewFinancialDebugCandidate = (label, rawPayload, derivedSummary, acceptedReason, extra = {}) => {
    const payload = parseMaybeJson(rawPayload);
    const summaryEntry = payload && typeof payload === "object" ? getPayloadSummaryEntry(payload) : { summary: {}, source: null };
    const summary = summaryEntry.summary;
    const products = payload && typeof payload === "object" ? asList(payload?.Products || payload?.products) : [];
    const items = payload && typeof payload === "object" ? asList(payload?.Items || payload?.items) : [];
    const otherServices = payload && typeof payload === "object"
      ? [...asList(payload?.OtherService), ...asList(payload?.OtherServices), ...asList(payload?.otherServices)]
      : [];
    const allLines = [...products, ...items, ...otherServices];
    const costRowPoolCount = allLines.reduce((sum, line) => sum + getLineCostRowPools(line).filter((pool) => asList(pool).length > 0).length, 0);

    return {
      label,
      exists: Boolean(payload && typeof payload === "object"),
      topLevelKeys: payload && typeof payload === "object" ? Object.keys(payload).slice(0, 24) : [],
      summaryKeys: summary && typeof summary === "object" ? Object.keys(summary) : [],
      summarySource: summaryEntry.source,
      summaryValues: getOverviewFinancialDebugSummaryValues(payload || {}),
      hasRealFinancialSignal: hasRealFinancialSignal(payload || {}),
      derived: derivedSummary ? {
        source: derivedSummary.source,
        bookedRevenue: derivedSummary.bookedRevenue,
        totalInclTax: derivedSummary.totalInclTax,
        bookedMargin: derivedSummary.bookedMargin,
        bookedMarginPct: derivedSummary.bookedMarginPct,
        costs: derivedSummary.costs,
        costsDerivedFromBookedMargin: derivedSummary.costsDerivedFromBookedMargin === true,
      } : null,
      reason: getOverviewFinancialDebugReason(payload, derivedSummary, acceptedReason),
      counts: {
        products: products.length,
        items: items.length,
        otherServices: otherServices.length,
        salesOrderDataCandidates: extra.salesOrderDataCandidateCount || 0,
        costRowPools: costRowPoolCount,
      },
      ...(OVERVIEW_FINANCIAL_DEBUG_RAW ? { rawPayload: payload } : {}),
    };
  };

  const getExpectedOverviewFinancialsFromCandidates = (candidates = []) => {
    for (const candidate of candidates) {
      const values = getOverviewFinancialDebugSummaryValues(candidate);
      const revenue = values.subtotal ?? values.targetRevenue ?? values.revenue;
      const bookedMargin = values.bookedMarginAmount ?? values.bookedMargin;
      if (revenue != null || bookedMargin != null || values.totalInclTax != null) {
        return {
          subtotal: revenue,
          revenue,
          totalInclTax: values.totalInclTax,
          bookedMarginAmount: bookedMargin,
          bookedMarginPct: values.bookedMarginPct,
          bookedMargin,
          costsFromMargin: revenue != null && bookedMargin != null
            ? revenue - bookedMargin
            : null,
        };
      }
    }
    return null;
  };

  const numbersDiffer = (a, b, tolerance = 0.01) =>
    a != null && b != null && Math.abs(toMoneyNumber(a) - toMoneyNumber(b)) > tolerance;

  const formatOverviewCurrency = (value) =>
    value == null || value === ""
      ? "—"
      : `${toMoneyNumber(value).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  const getSalesOrderProductsForBinated = (salesOrder = {}, orderData = {}) => {
    const payload = parseMaybeJson(salesOrder?.payload) || {};
    const stampedBookedAmount = parseMaybeJson(salesOrder?.stampedBookedAmount) || {};
    const cartSnapshot = parseMaybeJson(salesOrder?.cartSnapshot) || {};
    const cart = parseMaybeJson(salesOrder?.cart) || {};
    const orderSalesOrderCartSnapshot = parseMaybeJson(orderData?.salesOrderCartSnapshot) || {};
    const pools = [
      salesOrder?.products,
      salesOrder?.Products,
      payload?.items,
      payload?.products,
      payload?.Products,
      stampedBookedAmount?.cartSnapshot?.items,
      orderSalesOrderCartSnapshot?.items,
      cartSnapshot?.items,
      cart?.items,
      orderData?.Products,
      orderData?.Items,
    ];

    // Different cart/snapshot representations can use id, OrderItemId, or
    // ProductId for the same product. ProductId is a catalogue ID (e.g. ASI),
    // NOT an order-line ID; never use it as the primary de-duplication key.
    const getOrderLineId = (product = {}) => firstNonEmpty(
      product?.persistedOrderItemId, product?.PersistedOrderItemId,
      product?.orderItemId, product?.OrderItemId, product?.OrderItemID,
      product?.dbItemId, product?.DBItemId,
      ...asList(product?.artworks).map((artwork) => artwork?.OrderItemId || artwork?.orderItemId),
      ...asList(product?.ArtWorks).map((artwork) => artwork?.OrderItemId || artwork?.orderItemId),
      ...asList(product?.decorations).map((decoration) => decoration?.OrderItemId || decoration?.orderItemId),
      ...asList(product?.Decorations).map((decoration) => decoration?.OrderItemId || decoration?.orderItemId),
      product?.id, product?.Id, product?.orderProductId,
    );

    const seen = new Set();
    return pools.flatMap((pool) => (Array.isArray(pool) ? pool : []))
      .filter((product) => product && typeof product === "object")
      .filter((product, index) => {
        const lineId = getOrderLineId(product);
        // The fallback is source-position scoped: two independent lines of
        // the same catalogue product must never collapse on ProductId/SKU.
        const key = lineId != null && String(lineId).trim()
          ? `order-line:${lineId}`
          : `unidentified:${index}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  };

  const getUniqueDecorationsForProduct = (product = {}) => {
    const decorations = [
      ...asList(product?.decorations),
      ...asList(product?.Decorations),
      ...asList(product?.Decoration),
      ...asList(product?.Imprinting?.Decorations),
    ].filter((decoration) => decoration && typeof decoration === "object");
    const seen = new Set();
    return decorations.filter((decoration, index) => {
      const fallbackParts = [
        decoration?.OrderItemId || decoration?.orderItemId || decoration?.OrderItemID || "",
        decoration?.Location || decoration?.location || decoration?.placement_name || "",
      ].map((part) => String(part || "").trim()).filter(Boolean);
      const key = String(firstNonEmpty(
        decoration?.id,
        decoration?.DecorationId,
        decoration?.decorationId,
        fallbackParts.length ? fallbackParts.join(":") : `decoration-${index}`,
      ));
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  };

  const buildBinatedSalesOrderSmartSendPayloadFromSalesOrder = (form = {}) => {
    const salesOrder = form?.salesOrder || currentSO || (salesOrderData || []).find((so) => String(so?.estimationId || so?.id) === String(tabId)) || {};
    const salesOrderId = String(firstNonEmpty(salesOrder?.estimationId, tabId, salesOrder?.id, salesOrder?.salesOrderId) || "");
    const projectNumber = String(firstNonEmpty(salesOrder?.orderId, salesOrder?.OrderId, order?.OrderId, orderId) || "") || null;
    const inHandsDate = toDateOnlyOrNull(firstNonEmpty(salesOrder?.inHandsDate, salesOrder?.inhandsDate, order?.inHandsDate, order?.inhandsDate));
    const emailUsers = Array.isArray(form?.email_users)
      ? form.email_users
      : (Array.isArray(form?.emailUsers) ? form.emailUsers : []);
    const products = getSalesOrderProductsForBinated(salesOrder, order);
    const sku = products.map((product, productIndex) => {
      const decorations = getUniqueDecorationsForProduct(product);
      const decoration = decorations.map((decorationItem) => {
        const artwork = findArtworkForDecoration(product, decorationItem);
        const artworkUrl = getArtworkUrl(artwork);
        if (!isValidDirectUrl(artworkUrl)) return null;
        const location = firstNonEmpty(decorationItem?.Location, decorationItem?.location, decorationItem?.placement_name, "Artwork");
        const chargeName = getChargeName(decorationItem);
        const imprintType = firstNonEmpty(decorationItem?.ArtWork?.ImprintType, decorationItem?.artwork?.imprintType, artwork?.ImprintType, artwork?.imprintType, chargeName);
        const logoSize = parseLogoSizeForBinated(firstNonEmpty(decorationItem?.ArtWork?.LogoSize, decorationItem?.artwork?.logoSize, artwork?.LogoSize, artwork?.logoSize));
        const colors = splitColors(firstNonEmpty(decorationItem?.ArtWork?.LogoColor, decorationItem?.artwork?.logoColor, artwork?.LogoColor, artwork?.logoColor));
        const instructions = String(firstNonEmpty(decorationItem?.ArtWork?.SupplierNotes, decorationItem?.artwork?.supplierNotes, artwork?.SupplierNotes, artwork?.supplierNotes, form?.notes, "Please create artwork files for this order.") || "");
        const placement = {
          placement_code: normalizePlacementCode(location),
          placement_name: String(location || "Artwork"),
          description: String(firstNonEmpty(decorationItem?.ArtWork?.LogoName, decorationItem?.artwork?.logoName, artwork?.LogoName, artwork?.logoName, product?.Name, product?.name, product?.ProductName, "Artwork") || ""),
          reference: salesOrderId,
          instructions,
          process_type: String(firstNonEmpty(imprintType, chargeName, "Vector Art") || ""),
          height: logoSize.height,
          width: logoSize.width,
          measurement_unit: logoSize.measurement_unit,
          background_color: "",
          colors,
          text: [],
          url: [artworkUrl],
          sewout_logo_recreation: false,
          output_file_format: inferOutputFileFormat(artworkUrl),
          change_request: false,
        };
        return {
          decoration_type: mapBinatedDecorationType(imprintType, chargeName),
          decorator: null,
          placements: [placement],
        };
      }).filter(Boolean);
      if (!decoration.length) return null;
      const productUrl = firstNonEmpty(product?.ImageUrl, product?.imageUrl, product?.productUrl, product?.ProductUrl, product?.url);
      const entry = {
        product_sku: String(firstNonEmpty(product?.SKU, product?.sku, product?.ProductId, product?.productId, product?.Id, product?.id, `item-${productIndex + 1}`) || ""),
        product_category: String(firstNonEmpty(product?.Source, product?.source?.type, product?.source, product?.category, product?.Category, product?.productCategory, "") || ""),
        product: String(firstNonEmpty(product?.Name, product?.name, product?.ProductName, product?.productName, "") || ""),
        garment: buildGarmentLabel(product),
        priority: "Next Day",
        decoration,
      };
      if (isValidDirectUrl(productUrl)) entry.product_url = productUrl;
      return entry;
    }).filter(Boolean);

    return {
      data: {
        order_type: "sales_order",
        is_proofing: form?.is_proofing !== undefined ? Boolean(form.is_proofing) : true,
        email_users: emailUsers,
        sales_order: [{
          so_id: salesOrderId,
          so_inhands_date: inHandsDate,
          project_number: projectNumber,
          purchase_order: [{
            po_id: `SO-${salesOrderId || projectNumber || "UNKNOWN"}-SMART-SEND`,
            po_inhands_date: inHandsDate,
            vendor: null,
            sku,
          }],
        }],
      },
    };
  };

  const getBinatedSalesOrderSkuEntries = (payload = {}) => payload?.data?.sales_order?.[0]?.purchase_order?.[0]?.sku || [];
  const getBinatedSalesOrderPlacementUrlCount = (payload = {}) => getBinatedSalesOrderSkuEntries(payload).reduce((sum, sku = {}) => (
    sum + (Array.isArray(sku?.decoration) ? sku.decoration : []).reduce((decSum, decoration = {}) => (
      decSum + (Array.isArray(decoration?.placements) ? decoration.placements : []).reduce((placeSum, placement = {}) => (
        placeSum + (Array.isArray(placement?.url) ? placement.url.filter(Boolean).length : 0)
      ), 0)
    ), 0)
  ), 0);

  const getBinatedSalesOrderDecorationCount = (payload = {}) => getBinatedSalesOrderSkuEntries(payload).reduce((sum, sku = {}) => (
    sum + (Array.isArray(sku?.decoration) ? sku.decoration.length : 0)
  ), 0);

  const hasActionableBinatedArtwork = (payload = {}) => (
    payload?.data?.sales_order?.some((salesOrder) =>
      salesOrder?.purchase_order?.some((purchaseOrder) =>
        purchaseOrder?.sku?.some((sku) =>
          sku?.decoration?.some((decoration) =>
            decoration?.placements?.some((placement) =>
              Array.isArray(placement?.url) && placement.url.some((url) => String(url || "").trim())
            )
          )
        )
      )
    )
  );

  const hasIncludedSmartSendSku = (payload = {}) => hasIncludedSmartSendSkuPayload(payload);

  const cloneBinatedPayload = (payload = {}) => JSON.parse(JSON.stringify(payload || {}));

  const getSmartSendSkuKey = (sku = {}) => {
    const firstDecoration = Array.isArray(sku?.decoration) ? sku.decoration[0] : {};
    const firstPlacement = Array.isArray(firstDecoration?.placements) ? firstDecoration.placements[0] : {};
    const firstArtworkUrl = Array.isArray(firstPlacement?.url) ? firstPlacement.url[0] : "";
    return [
      firstNonEmpty(sku?.product_sku, sku?.product, "sku"),
      firstDecoration?.decoration_type || "decoration",
      firstPlacement?.placement_code || firstPlacement?.placement_name || "placement",
      firstArtworkUrl || "artwork",
    ].map((part) => String(part || "").trim()).join("|");
  };

  const setSmartSendValueAtPath = (target, path, value) => {
    if (!target || !Array.isArray(path) || !path.length) return;
    let cursor = target;
    path.slice(0, -1).forEach((part) => {
      if (cursor?.[part] == null) cursor[part] = typeof part === "number" ? [] : {};
      cursor = cursor[part];
    });
    cursor[path[path.length - 1]] = value;
  };

  const applySmartSendOverrides = (basePayload = {}, overrides = {}) => {
    const payload = cloneBinatedPayload(basePayload);
    Object.entries(overrides || {}).forEach(([pathKey, value]) => {
      const path = pathKey.split(".").map((part) => (/^\d+$/.test(part) ? Number(part) : part));
      setSmartSendValueAtPath(payload, path, value);
    });
    return payload;
  };

  const getIncludedSmartSendPayload = (basePayload = {}, selection = {}, overrides = {}) => {
    const payload = applySmartSendOverrides(basePayload, overrides);
    const baseSkuEntries = getBinatedSalesOrderSkuEntries(basePayload);
    const purchaseOrder = payload?.data?.sales_order?.[0]?.purchase_order?.[0];
    if (!purchaseOrder || !Array.isArray(purchaseOrder.sku)) return payload;
    purchaseOrder.sku = purchaseOrder.sku.filter((sku, index) => {
      const key = getSmartSendSkuKey(baseSkuEntries[index] || sku);
      return selection[key] !== false;
    });
    return payload;
  };

  const getSmartSendValidationError = (payload = {}, generatedPayload = {}) => {
    const generatedSkuEntries = getBinatedSalesOrderSkuEntries(generatedPayload);
    const skuEntries = getBinatedSalesOrderSkuEntries(payload);
    if (!hasActionableBinatedArtwork(generatedPayload)) {
      return "No decorated products with artwork files were found for this sales order.";
    }
    if (!skuEntries.length) {
      return "Select at least one decorated product to send to Binated.";
    }
    if (payload?.data?.order_type !== "sales_order") return "Smart sales order send payload must be a sales_order.";
    if (!Array.isArray(payload?.data?.sales_order) || !payload.data.sales_order.length) return "Smart sales order send payload requires a sales order.";
    if (!generatedSkuEntries.length) return "No decorated products with artwork files were found for this sales order.";
    for (const sku of skuEntries) {
      if (!String(sku?.product_sku || "").trim() || !String(sku?.priority || "").trim()) {
        return "Each included Smart sales order send SKU requires a SKU and priority.";
      }
      if (sku.priority === "Custom" && !String(sku?.due_hours || "").trim()) {
        return "Custom priority Smart sales order send SKUs require due hours.";
      }
      const decorations = Array.isArray(sku?.decoration) ? sku.decoration : [];
      if (!decorations.length) return "Each included Smart sales order send SKU requires at least one decoration.";
      for (const decoration of decorations) {
        if (!String(decoration?.decoration_type || "").trim()) return "Each included Smart sales order send decoration requires a decoration type.";
        const placements = Array.isArray(decoration?.placements) ? decoration.placements : [];
        if (!placements.length) return "Each included Smart sales order send decoration requires at least one placement.";
        for (const placement of placements) {
          const urls = Array.isArray(placement?.url) ? placement.url : [];
          if (!urls.some((url) => String(url || "").trim())) {
            return "Each included Smart sales order send placement requires an artwork/reference URL.";
          }
          if (placement?.change_request === true && (!String(placement?.change_comments || "").trim() || !String(placement?.previous_order_reference || "").trim())) {
            return "Change request placements require change comments and previous order reference.";
          }
        }
      }
    }
    return "";
  };

  const buildArtPayloadFromForm = (form) => {
    const safe = form || buildInitialArtForm({});
    const media = Array.isArray(safe.media) ? safe.media : [];
    return {
      request_type: "art",
      media: media.map((m) => {
        const decorations = Array.isArray(m?.decoration_info) && m.decoration_info.length
          ? m.decoration_info
          : [{ decoration: "Vector Art", decoration_instructions: "", placement_info: [{}] }];
        return {
          product_sku: String(m?.product_sku || ""),
          priority: String(m?.priority || "5 Days"),
          due_hours: Number(m?.due_hours || PRIORITY_TO_HOURS["5 Days"]),
          description: String(m?.description || ""),
          reference: buildBinatedReference(instanceUniqueId, orderId, tabId),
          instructions: String(m?.instructions || ""),
          product_category: String(m?.product_category || ""),
          product_name: String(m?.product_name || m?.product || ""),
          product: String(m?.product_name || m?.product || ""),
          product_url: String(m?.product_url || ""),
          garment: String(m?.garment || ""),
          change_request: !!m?.change_request,
          decoration_info: decorations.map((deco) => {
            const placements = Array.isArray(deco?.placement_info) && deco.placement_info.length
              ? deco.placement_info
              : [{}];
            return {
              decoration: String(deco?.decoration || "Vector Art"),
              decoration_instructions: String(m?.instructions || deco?.decoration_instructions || ""),
              placement_info: placements.map((place) => ({
                placement_name: String(place?.placement_name || ""),
                placement_code: String(
                  place?.placement_code || placementCodeFromName(place?.placement_name || "")
                ),
                process_type: String(place?.process_type || "VECTOR"),
                art_type: String(place?.art_type || deco?.decoration || "Vector Art"),
                height: Number(place?.height || 100),
                width: Number(place?.width || 100),
                measurement_unit: String(place?.measurement_unit || "px"),
                product_color: String(place?.product_color || ""),
                colors: Array.isArray(place?.colors) ? place.colors : splitCsv(place?.colors || ""),
                background_color: String(place?.background_color || ""),
                text: Array.isArray(place?.text) ? place.text : splitCsv(place?.text || ""),
                url: Array.isArray(place?.url) ? place.url : splitCsv(place?.url || ""),
                sewout_logo_recreation: String(place?.sewout_logo_recreation || "No"),
                output_file_format: normalizeOutputFormat(place?.output_file_format),
                is_proofing: !!place?.is_proofing,
                email_users: Array.isArray(place?.email_users) ? place.email_users : [],
                reference_decoration_id: String(place?.reference_decoration_id || ""),
              })),
            };
          }),
        };
      }),
    };
  };

  useEffect(() => {
    const loadRequestArtDependencies = async () => {
      try {
        const [designersRes, settingsRes] = await Promise.all([
          fetchAllDesignReps(),
          axios.get(
            `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceUniqueId}/proof-provider-settings`,
            { headers: { accessToken: localStorage.getItem("accessToken") } }
          ),
        ]);

        const designers = Array.isArray(designersRes?.designers) ? designersRes.designers : [];
        setDesignRepOptions(
          designers.map((u) => ({
            id: String(u.id),
            name: u.name || u.email || `User ${u.id}`,
          }))
        );

        const proofProvider = settingsRes?.data?.proofProvider || {};
        setBinatedSettings({
          enabled: proofProvider?.enabled === true,
          provider: proofProvider?.provider || "binated",
          mvpTalentEnabled: proofProvider?.mvpTalentEnabled === true,
          ready: getBinatedProofProviderReadiness(proofProvider),
        });
      } catch (err) {
        console.warn("Failed to initialize Request Art dependencies", err?.message || err);
      }
    };
    if (instanceUniqueId) loadRequestArtDependencies();
  }, [instanceUniqueId]);

  useEffect(() => {
    if (!docRelatedPurchaseOrders.length) {
      setSelectedRequestPoId("");
      setArtForm(buildInitialArtForm({}));
      bumpArtFormUiVersion();
      setSelectedMediaIndex(0);
      setSelectedPlacementIndex(0);
      return;
    }
    const firstId = String(docRelatedPurchaseOrders[0]?.id || "");
    setSelectedRequestPoId((prev) => (prev ? prev : firstId));
  }, [docRelatedPurchaseOrders]);

  useEffect(() => {
    if (!selectedRequestPoId) return;
    const po = docRelatedPurchaseOrders.find((p) => String(p.id) === String(selectedRequestPoId));
    if (!po) return;
    setArtForm(buildInitialArtForm(po));
    bumpArtFormUiVersion();
    setSelectedMediaIndex(0);
    setSelectedPlacementIndex(0);
  }, [selectedRequestPoId, docRelatedPurchaseOrders]);

  const updateMediaField = (field, value) => {
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      const idx = Math.max(0, Math.min(selectedMediaIndex, media.length - 1));
      const mediaDraft = { ...(media[idx] || buildMediaItem()) };
      mediaDraft[field] = value;
      media[idx] = mediaDraft;
      return { ...next, media };
    });
  };

  const updatePlacementField = (field, value) => {
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      const idx = Math.max(0, Math.min(selectedMediaIndex, media.length - 1));
      const mediaDraft = { ...(media[idx] || buildMediaItem()) };
      const deco0 = { ...((mediaDraft.decoration_info || [])[0] || {}) };
      const placements = Array.isArray(deco0.placement_info) ? [...deco0.placement_info] : [];
      const placeIdx = Math.max(0, Math.min(selectedPlacementIndex, Math.max(placements.length - 1, 0)));
      const placeDraft = {
        placement_code: "",
        placement_name: "",
        process_type: ART_TYPE_TO_PROCESS[String(deco0?.decoration || "Vector Art")] || "VECTOR",
        art_type: String(deco0?.decoration || "Vector Art"),
        height: 100,
        width: 100,
        measurement_unit: "px",
        product_color: "",
        colors: [],
        background_color: "",
        text: [],
        url: [],
        sewout_logo_recreation: "No",
        output_file_format: "png",
        is_proofing: false,
        email_users: [],
        reference_decoration_id: "",
        ...(placements[placeIdx] || {}),
      };
      placeDraft[field] = value;
      placements[placeIdx] = placeDraft;
      deco0.placement_info = placements;
      mediaDraft.decoration_info = [deco0];
      media[idx] = mediaDraft;
      return { ...next, media };
    });
  };

  const updateDecorationField = (field, value) => {
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      const idx = Math.max(0, Math.min(selectedMediaIndex, media.length - 1));
      const mediaDraft = { ...(media[idx] || buildMediaItem()) };
      const deco0 = { ...((mediaDraft.decoration_info || [])[0] || {}) };
      deco0[field] = value;
      mediaDraft.decoration_info = [deco0];
      media[idx] = mediaDraft;
      return { ...next, media };
    });
  };

  const addMediaItem = () => {
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      if (media.length >= 99) return next;
      const po = docRelatedPurchaseOrders.find((p) => String(p.id) === String(selectedRequestPoId)) || {};
      media.push(buildMediaItem({ po }));
      return { ...next, media };
    });
    bumpArtFormUiVersion();
    setSelectedMediaIndex((prev) => prev + 1);
    setSelectedPlacementIndex(0);
  };

  const removeCurrentMediaItem = () => {
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      if (media.length <= 1) return next;
      media.splice(selectedMediaIndex, 1);
      return { ...next, media };
    });
    bumpArtFormUiVersion();
    setSelectedMediaIndex((prev) => Math.max(0, prev - 1));
    setSelectedPlacementIndex(0);
  };

  const addPlacementItem = () => {
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      const idx = Math.max(0, Math.min(selectedMediaIndex, media.length - 1));
      const mediaDraft = { ...(media[idx] || buildMediaItem()) };
      const deco0 = { ...((mediaDraft.decoration_info || [])[0] || {}) };
      const placements = Array.isArray(deco0.placement_info) ? [...deco0.placement_info] : [];
      if (placements.length >= 25) return next;
      const artType = String(deco0?.decoration || "Vector Art");
      placements.push({
        placement_code: "",
        placement_name: "",
        process_type: ART_TYPE_TO_PROCESS[artType] || "VECTOR",
        art_type: artType,
        height: 100,
        width: 100,
        measurement_unit: "px",
        product_color: "",
        colors: [],
        background_color: "",
        text: [],
        url: [],
        sewout_logo_recreation: "No",
        output_file_format: "png",
        is_proofing: false,
        email_users: [],
        reference_decoration_id: "",
      });
      deco0.placement_info = placements;
      mediaDraft.decoration_info = [deco0];
      media[idx] = mediaDraft;
      return { ...next, media };
    });
    bumpArtFormUiVersion();
    setSelectedPlacementIndex((prev) => prev + 1);
  };

  const removeCurrentPlacementItem = () => {
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      const idx = Math.max(0, Math.min(selectedMediaIndex, media.length - 1));
      const mediaDraft = { ...(media[idx] || buildMediaItem()) };
      const deco0 = { ...((mediaDraft.decoration_info || [])[0] || {}) };
      const placements = Array.isArray(deco0.placement_info) ? [...deco0.placement_info] : [];
      if (placements.length <= 1) return next;
      const placeIdx = Math.max(0, Math.min(selectedPlacementIndex, placements.length - 1));
      placements.splice(placeIdx, 1);
      deco0.placement_info = placements;
      mediaDraft.decoration_info = [deco0];
      media[idx] = mediaDraft;
      return { ...next, media };
    });
    bumpArtFormUiVersion();
    setSelectedPlacementIndex((prev) => Math.max(0, prev - 1));
  };

  const importCurrentMediaFromCart = () => {
    const selected = cartItemOptions.find((c) => c.key === selectedCartImportKey);
    if (!selected) return;
    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) ? [...next.media] : [];
      const idx = Math.max(0, Math.min(selectedMediaIndex, media.length - 1));
      const current = media[idx] || buildMediaItem();
      const imported = buildMediaItem({ source: selected.raw });
      const currentPlacements = Array.isArray(current?.decoration_info?.[0]?.placement_info)
        ? current.decoration_info[0].placement_info
        : [];
      const importedPlacements = Array.isArray(imported?.decoration_info?.[0]?.placement_info)
        ? imported.decoration_info[0].placement_info
        : [];
      const mergedByPlacement = new Map();
      currentPlacements.forEach((place) => {
        const name = String(place?.placement_name || "").trim();
        const key = name.toLowerCase() || String(place?.placement_code || "").toLowerCase();
        mergedByPlacement.set(key, {
          ...place,
          url: uniqueNonEmpty(Array.isArray(place?.url) ? place.url : []),
        });
      });
      importedPlacements.forEach((place) => {
        const name = String(place?.placement_name || "").trim();
        const key = name.toLowerCase() || String(place?.placement_code || "").toLowerCase();
        const existing = mergedByPlacement.get(key);
        const importedUrls = uniqueNonEmpty(Array.isArray(place?.url) ? place.url : []);
        if (existing) {
          mergedByPlacement.set(key, {
            ...existing,
            ...place,
            url: uniqueNonEmpty([...(existing.url || []), ...importedUrls]),
          });
        } else {
          mergedByPlacement.set(key, { ...place, url: importedUrls });
        }
      });
      media[idx] = {
        ...current,
        ...imported,
        decoration_info: [
          {
            ...((imported.decoration_info || [])[0] || {}),
            placement_info: Array.from(mergedByPlacement.values()),
          },
        ],
      };
      return { ...next, media };
    });
    bumpArtFormUiVersion();
  };

  useEffect(() => {
    setSelectedPlacementIndex(0);
  }, [selectedMediaIndex, artFormUiVersion]);

  const currentMedia = artForm?.media?.[selectedMediaIndex] || artForm?.media?.[0] || {};
  const currentDecoration = currentMedia?.decoration_info?.[0] || {};
  const currentPlacements = Array.isArray(currentDecoration?.placement_info) && currentDecoration.placement_info.length
    ? currentDecoration.placement_info
    : [{}];
  const currentPlacement = currentPlacements?.[selectedPlacementIndex] || currentPlacements?.[0] || {};
  const smartSendDerived = useMemo(() => {
    if (!requestArtSmartSend) {
      return {
        baseSmartSendPayload: null,
        smartSendReviewPayload: null,
        finalSmartSendPayload: null,
        baseSmartSendSkuEntries: [],
        includedSmartSendSkuEntries: [],
        smartSendHasActionableArtwork: false,
      };
    }

    const generatedBasePayload = buildBinatedSalesOrderSmartSendPayloadFromSalesOrder(artForm);
    const generatedReviewPayload = generatedBasePayload
      ? applySmartSendOverrides(generatedBasePayload, smartSendOverrides)
      : null;
    const generatedFinalPayload = generatedBasePayload
      ? getIncludedSmartSendPayload(generatedBasePayload, smartSendSkuSelection, smartSendOverrides)
      : null;

    return {
      baseSmartSendPayload: generatedBasePayload,
      smartSendReviewPayload: generatedReviewPayload,
      finalSmartSendPayload: generatedFinalPayload,
      baseSmartSendSkuEntries: getBinatedSalesOrderSkuEntries(generatedBasePayload),
      includedSmartSendSkuEntries: getBinatedSalesOrderSkuEntries(generatedFinalPayload),
      smartSendHasActionableArtwork: generatedBasePayload ? hasActionableBinatedArtwork(generatedBasePayload) : false,
    };
  }, [artForm, requestArtSmartSend, smartSendOverrides, smartSendSkuSelection]);
  const {
    baseSmartSendPayload,
    smartSendReviewPayload,
    finalSmartSendPayload,
    baseSmartSendSkuEntries,
    includedSmartSendSkuEntries,
    smartSendHasActionableArtwork,
  } = smartSendDerived;
  const currentRequestArtScopeKey = useMemo(() => {
    try {
      const payload = requestArtSmartSend
        ? getIncludedSmartSendPayload(baseSmartSendPayload, smartSendSkuSelection, getSmartSendOverrideSnapshot())
        : buildArtPayloadFromForm(artForm);
      return buildRequestArtScopeKeyFromPayload(payload || {}, resolvedProofWorkProvider);
    } catch (_error) {
      return null;
    }
  }, [
    artForm,
    artFormUiVersion,
    baseSmartSendPayload,
    requestArtSmartSend,
    resolvedProofWorkProvider,
    smartSendOverrides,
    smartSendSkuSelection,
  ]);
  const activeDuplicateRequestArtStatus = useMemo(
    () =>
      requestArtStatusesForProvider.find(
        (statusRow) =>
          statusRow?.isActive &&
          currentRequestArtScopeKey &&
          String(statusRow?.scopeKey || "") === String(currentRequestArtScopeKey)
      ) || null,
    [currentRequestArtScopeKey, requestArtStatusesForProvider]
  );
  const lifecycleSubmittedPayload = binatedLifecycle.lifecycle?.submittedPayload || null;
  const isSubmittedRequestLocked = Boolean(binatedLifecycle.lifecycle?.summary?.providerOrderId);
  const submittedSmartSendPayload = requestArtSmartSend &&
    lifecycleSubmittedPayload &&
    Array.isArray(lifecycleSubmittedPayload?.data?.sales_order)
    ? lifecycleSubmittedPayload
    : null;
  const smartSendDisplayPayload = isSubmittedRequestLocked && submittedSmartSendPayload
    ? submittedSmartSendPayload
    : smartSendReviewPayload;
  const smartSendDisplaySalesOrders = Array.isArray(smartSendDisplayPayload?.data?.sales_order)
    ? smartSendDisplayPayload.data.sales_order
    : [];
  const smartSendDisplaySkuEntries = getBinatedSalesOrderSkuEntries(smartSendDisplayPayload);
  const isSmartSendSubmittedDisplay = Boolean(isSubmittedRequestLocked && submittedSmartSendPayload);
  const smartSendDisplayHasActionableArtwork = isSmartSendSubmittedDisplay
    ? hasActionableBinatedArtwork(smartSendDisplayPayload)
    : smartSendHasActionableArtwork;
  const includedSmartSendDisplaySkuEntries = isSmartSendSubmittedDisplay
    ? smartSendDisplaySkuEntries
    : includedSmartSendSkuEntries;
  const hasExistingBinatedRequest = Boolean(
    binatedLifecycle.lifecycle?.summary?.providerOrderId ||
    binatedLifecycle.lifecycle?.providerOrderId ||
    binatedLifecycle.lifecycle?.submittedPayload ||
    binatedLifecycle.lifecycle?.id
  );
  const isChangeRequest = !!currentMedia?.change_request;
  const showManualRequestArtFields = !requestArtSmartSend;
  const artFieldKey = `${selectedRequestPoId || "none"}-${selectedMediaIndex}-${artFormUiVersion}`;
  const canSubmitSmartSend =
    requestArtSmartSend &&
    hasIncludedSmartSendSku(finalSmartSendPayload) &&
    !requestArtLoading &&
    !binatedLifecycle.submitting &&
    !binatedLifecycle.lifecycleLoading &&
    !isSubmittedRequestLocked;
  const hasBinatedStandardsBlockingIssues =
    Boolean(binatedStandardsPreflight?.hasBlockingIssues);
  const sendToBinatedDisabled = requestArtSmartSend
    ? (!canSubmitSmartSend || !binatedSettings.ready || binatedStandardsChecking || hasBinatedStandardsBlockingIssues)
    : (
      requestArtLoading ||
      binatedLifecycle.submitting ||
      !selectedRequestPoId ||
      !binatedSettings.ready ||
      binatedStandardsChecking ||
      hasBinatedStandardsBlockingIssues
    );
  const sendToBinatedDisabledReason = hasBinatedStandardsBlockingIssues
    ? "Review the Binated-specific mappings before sending."
    : binatedStandardsChecking
      ? "Checking Binated-specific mappings..."
      : getSendToBinatedDisabledReason({
    finalSmartSendPayload,
    requestArtLoading,
    submitting: binatedLifecycle.submitting,
    lifecycleLoading: binatedLifecycle.lifecycleLoading,
    isSubmittedRequestLocked,
    settingsReady: binatedSettings.ready,
    requestArtSmartSend,
    selectedRequestPoId,
  });
  const coreNetworkSubmitDisabled =
    requestArtLoading ||
    (!requestArtSmartSend && !selectedRequestPoId) ||
    (
      isDirectTalentAssignment &&
      (!selectedCoreNetworkMemberId || !selectedCoreNetworkMembership?.id)
    ) ||
    (
      isCoreNetworkMarketplaceRequest &&
      marketplaceAudienceMode === "selected_talent" &&
      !selectedMarketplaceMemberIds.length
    );
  const sendProofRequestDisabled = isBinatedFulfillment
    ? sendToBinatedDisabled
    : coreNetworkSubmitDisabled;
  const previousBinatedDisabledSnapshotRef = useRef("");

  useEffect(() => {
    if (!requestArtOpen || requestArtTab !== "binated") return;
    if (!requestArtStatusesResolved || requestArtStatusesLoading) return;
    if (userSelectedBinatedArtViewRef.current) return;

    if (resolvedProofWorkProvider === "binated") return;

    setBinatedArtView(
      hasExistingDesignerRequest
        ? DESIGNER_REQUEST_TAB_OPTIONS.existing
        : DESIGNER_REQUEST_TAB_OPTIONS.create
    );
  }, [
    hasExistingDesignerRequest,
    requestArtStatusesLoading,
    requestArtStatusesResolved,
    requestArtOpen,
    requestArtTab,
    resolvedProofWorkProvider,
  ]);

  useEffect(() => {
    if (!isDirectTalentAssignment) return;
    if (selectedCoreNetworkMemberId) return;
    const firstMemberId = coreNetworkTalentOptions[0]?.id;
    if (firstMemberId) {
      setSelectedCoreNetworkMemberId(String(firstMemberId));
    }
  }, [coreNetworkTalentOptions, isDirectTalentAssignment, selectedCoreNetworkMemberId]);

  useEffect(() => {
    if (process.env.NODE_ENV === "production") return;
    if (!isBinatedFulfillment) return;

    const snapshot = {
      provider: resolvedProofWorkProvider,
      requestArtSmartSend,
      hasIncludedSku: hasIncludedSmartSendSku(finalSmartSendPayload),
      includedSkuCount: getBinatedSalesOrderSkuEntries(finalSmartSendPayload).length,
      requestArtLoading,
      lifecycleSubmitting: binatedLifecycle.submitting,
      lifecycleLoading: binatedLifecycle.lifecycleLoading,
      submittedRequestLocked: isSubmittedRequestLocked,
      settingsEnabled: binatedSettings.enabled,
      configuredProvider: binatedSettings.provider,
      settingsReady: binatedSettings.ready,
      sendToBinatedDisabled,
      sendProofRequestDisabled,
    };
    const snapshotKey = JSON.stringify(snapshot);
    if (snapshotKey === previousBinatedDisabledSnapshotRef.current) return;
    previousBinatedDisabledSnapshotRef.current = snapshotKey;
    console.table(snapshot);
  }, [
    isBinatedFulfillment,
    resolvedProofWorkProvider,
    requestArtSmartSend,
    finalSmartSendPayload,
    requestArtLoading,
    binatedLifecycle.submitting,
    binatedLifecycle.lifecycleLoading,
    isSubmittedRequestLocked,
    binatedSettings,
    sendToBinatedDisabled,
    sendProofRequestDisabled,
  ]);
  const proofingSourceLabel =
    PROOF_SOURCE_OPTIONS[proofMappingSourceType]?.selectedLabel ||
    "Proof files";
  const latestProofTalentName = String(
    latestProofWorkRequestStatus?.assignedTalent?.displayName ||
    latestProofWorkRequestStatus?.selectedTalent?.displayName ||
    ""
  ).trim();
  const selectedProofSourceOption =
    PROOF_SOURCE_OPTIONS[proofMappingSourceType] || PROOF_SOURCE_OPTIONS.design_rep;
  const selectedProofSourceStatus =
    !proofMappingSourceType
      ? {
          summary: "No artwork proof request exists for this Sales Order yet.",
          approvalStatus: "",
        }
      : proofMappingSourceType === "core-network"
      ? buildCoreNetworkProofStatusLine(proofSourceStatusMeta, latestProofTalentName)
      : {
          summary: selectedProofSourceOption.shortDescription,
          approvalStatus: "",
        };
  const handleProofSourceSummaryChange = useCallback((summaryMeta) => {
    if (summaryMeta?.sourceType !== "core-network") {
      setProofSourceStatusMeta((current) => (current == null ? current : null));
      return;
    }

    const nextMeta = getProofSourceResponseMeta("core-network", {
      sourceSyncSummary: summaryMeta?.sourceSyncSummary || null,
    });
    nextMeta.primaryGroup = summaryMeta?.primaryGroup || nextMeta.fileGroups?.[0] || null;
    nextMeta.proofingComplete = Boolean(summaryMeta?.proofingComplete);
    nextMeta.hasPendingProofs = Boolean(summaryMeta?.hasPendingProofs);
    nextMeta.hasRejectedProofs = Boolean(summaryMeta?.hasRejectedProofs);

    setProofSourceStatusMeta((current) => {
      const currentKey = current ? JSON.stringify(current) : "";
      const nextKey = JSON.stringify(nextMeta);
      return currentKey === nextKey ? current : nextMeta;
    });
  }, []);
  const getSmartSendOverrideKey = (path) => path.join(".");
  const updateSmartSendDraftOverride = (path, value) => {
    smartSendDraftOverridesRef.current = {
      ...smartSendDraftOverridesRef.current,
      [getSmartSendOverrideKey(path)]: value,
    };
  };
  const getSmartSendOverrideSnapshot = () => ({
    ...smartSendOverrides,
    ...smartSendDraftOverridesRef.current,
  });
  const updateSmartSendOverride = (path, value) => {
    const key = getSmartSendOverrideKey(path);
    smartSendDraftOverridesRef.current = {
      ...smartSendDraftOverridesRef.current,
      [key]: value,
    };
    setSmartSendOverrides((prev) => ({ ...prev, [key]: value }));
  };

  const clearSmartSendOverride = (path) => {
    const key = getSmartSendOverrideKey(path);
    const draft = { ...smartSendDraftOverridesRef.current };
    delete draft[key];
    smartSendDraftOverridesRef.current = draft;
    setSmartSendOverrides((previous) => {
      if (!Object.prototype.hasOwnProperty.call(previous, key)) return previous;
      const next = { ...previous };
      delete next[key];
      return next;
    });
  };

  useEffect(() => {
    if (
      !requestArtOpen ||
      requestArtTab !== "binated" ||
      resolvedProofWorkProvider !== "binated" ||
      isSubmittedRequestLocked
    ) {
      setBinatedStandardsPreflight(null);
      setBinatedStandardsChecking(false);
      return undefined;
    }

    const payloadForPreflight = requestArtSmartSend
      ? finalSmartSendPayload
      : buildArtPayloadFromForm(artForm);

    if (!payloadForPreflight) {
      setBinatedStandardsPreflight(null);
      return undefined;
    }

    let cancelled = false;
    const timer = window.setTimeout(async () => {
      try {
        setBinatedStandardsChecking(true);
        const result = await preflightBinatedProofForOrder(orderId, payloadForPreflight);
        if (!cancelled) setBinatedStandardsPreflight(result || null);
      } catch (error) {
        if (!cancelled) {
          setBinatedStandardsPreflight({
            hasBlockingIssues: true,
            issues: [{
              field: "preflight",
              message: error?.response?.data?.message || "Unable to validate Binated mappings.",
              blocking: true,
            }],
            items: [],
            standards: null,
          });
        }
      } finally {
        if (!cancelled) setBinatedStandardsChecking(false);
      }
    }, 300);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [
    artForm,
    artFormUiVersion,
    finalSmartSendPayload,
    isSubmittedRequestLocked,
    orderId,
    requestArtOpen,
    requestArtSmartSend,
    requestArtTab,
    resolvedProofWorkProvider,
  ]);
  const setSmartSendSkuIncluded = (key, included) => {
    setSmartSendSkuSelection((prev) => ({ ...prev, [key]: included }));
  };

  useEffect(() => {
    if (!requestArtSmartSend) return;
    setSmartSendSkuSelection((prev) => {
      const next = { ...prev };
      baseSmartSendSkuEntries.forEach((sku) => {
        const key = getSmartSendSkuKey(sku);
        if (next[key] === undefined) next[key] = true;
      });
      return next;
    });
  }, [requestArtSmartSend, artFormUiVersion, baseSmartSendSkuEntries.length]);

  useEffect(() => {
    if (requestArtTab === "binated" && binatedArtView === "payload") {
      const payloadForPreview = requestArtSmartSend
        ? (isSmartSendSubmittedDisplay ? submittedSmartSendPayload : finalSmartSendPayload)
        : buildArtPayloadFromForm(artForm);
      setPayloadPreviewText(JSON.stringify(payloadForPreview, null, 2));
    }
  }, [
    requestArtTab,
    binatedArtView,
    requestArtSmartSend,
    artFormUiVersion,
    smartSendSkuSelection,
    smartSendOverrides,
    isSmartSendSubmittedDisplay,
    submittedSmartSendPayload,
  ]);
  const getSmartSendFileUrl = useCallback(() => {
    if (typeof window === "undefined") return "";
    const origin = window.location.origin || "";
    const path = window.location.pathname || "";
    const docId = String(tabId || "").trim();

    if (!docId) return "";
    if (path.includes("/sales-order/") || isSalesOrderRoute) {
      return `${origin}/generated-sales-order/${docId}`;
    }
    if (path.includes("/estimation/") || isEstimateRoute) {
      return `${origin}/generated-estimate/${docId}`;
    }
    return "";
  }, [isEstimateRoute, isSalesOrderRoute, tabId]);
  const isGeneratedSmartSendFileUrl = useCallback(
    (value) => /\/generated-(sales-order|estimate)\//.test(String(value || "")),
    []
  );
  const applySmartSendFileUrl = useCallback(({ force = false } = {}) => {
    const smartSendFileUrl = getSmartSendFileUrl();
    if (!smartSendFileUrl) return;

    setArtForm((prev) => {
      const next = prev || buildInitialArtForm({});
      const media = Array.isArray(next.media) && next.media.length ? [...next.media] : [buildMediaItem()];
      const mediaIdx = Math.max(0, Math.min(selectedMediaIndex, media.length - 1));
      const mediaDraft = { ...(media[mediaIdx] || buildMediaItem()) };
      const deco0 = { ...((mediaDraft.decoration_info || [])[0] || {}) };
      const placements = Array.isArray(deco0.placement_info) && deco0.placement_info.length
        ? [...deco0.placement_info]
        : [{}];
      const placeIdx = Math.max(0, Math.min(selectedPlacementIndex, placements.length - 1));
      const placeDraft = { ...(placements[placeIdx] || {}) };
      const currentUrls = Array.isArray(placeDraft.url)
        ? placeDraft.url.filter(Boolean)
        : splitCsv(placeDraft.url);
      const shouldReplace = force || !currentUrls.length || currentUrls.every(isGeneratedSmartSendFileUrl);

      if (!shouldReplace) return next;

      placeDraft.url = [smartSendFileUrl];
      placements[placeIdx] = placeDraft;
      deco0.placement_info = placements;
      mediaDraft.decoration_info = [deco0];
      media[mediaIdx] = mediaDraft;
      return { ...next, media };
    });
  }, [getSmartSendFileUrl, isGeneratedSmartSendFileUrl, selectedMediaIndex, selectedPlacementIndex]);
  const selectedCartImportPreview = useMemo(() => {
    const selected = cartItemOptions.find((c) => c.key === selectedCartImportKey)?.raw;
    if (!selected) return null;
    const media = buildMediaItem({ source: selected });
    const seed = buildCartImportSeed({ item: selected });
    return {
      sku: media.product_sku || "—",
      product: media.product_name || media.product || "—",
      colors: (media?.decoration_info?.[0]?.placement_info?.[0]?.colors || []).join(", ") || "—",
      logoSize: seed.logoSizeLabel || "—",
      image: seed.previewImage,
    };
  }, [selectedCartImportKey, cartItemOptions]);

  useEffect(() => {
    if (!requestArtOpen || requestArtTab !== "binated" || !isBinatedFulfillment) return;
    if (!lifecycleSubmittedPayload || typeof lifecycleSubmittedPayload !== "object") return;
    setArtForm(lifecycleSubmittedPayload);
    setSelectedMediaIndex(0);
    setSelectedPlacementIndex(0);
    bumpArtFormUiVersion();
  }, [isBinatedFulfillment, requestArtOpen, requestArtTab, lifecycleSubmittedPayload]);

  useEffect(() => {
    if (!requestArtOpen || requestArtTab !== "binated" || !isBinatedFulfillment || !requestArtSmartSend) return;
    applySmartSendFileUrl();
  }, [isBinatedFulfillment, requestArtOpen, requestArtTab, requestArtSmartSend, applySmartSendFileUrl, artFormUiVersion]);

  useEffect(() => {
    if (!requestArtOpen || requestArtTab !== "binated" || !isBinatedFulfillment) return;
    if (!hasExistingBinatedRequest || binatedLifecycle.mode !== "status") return;
    if (userSelectedBinatedArtViewRef.current) return;
    if (binatedArtView === "status") return;
    setBinatedArtView("status");
  }, [
    binatedArtView,
    hasExistingBinatedRequest,
    binatedLifecycle.mode,
    isBinatedFulfillment,
    requestArtOpen,
    requestArtTab,
  ]);

  const openRequestArtDialog = () => {
    userSelectedBinatedArtViewRef.current = false;
    smartSendDraftOverridesRef.current = {};
    proofSourceManualOverrideRef.current = false;
    proofSourceAutoDetectionStartedRef.current = false;
    setRequestArtNote("");
    setProofFulfillmentProvider("binated");
    setProofMappingSourceType("");
    setProofSourceLinkageBanner(null);
    setCoreNetworkCapabilityFilter("artwork-proof");
    setSelectedCoreNetworkMemberId("");
    setCoreNetworkTalentOptions([]);
    setRequestArtStatuses([]);
    setRequestArtStatusesResolved(false);
    setRequestArtPriorityLevel("normal");
    setRequestArtFeeEstimate("");
    setRequestArtDueDate(dayjs(order?.inHandsDate).isValid() ? dayjs(order?.inHandsDate).format("YYYY-MM-DD") : "");
    setRequestArtTab(binatedSettings.ready ? "binated" : "designer");
    setBinatedArtView(hasExistingBinatedRequest ? "status" : "form");
    setRequestArtSmartSend(true);
    applySmartSendFileUrl({ force: true });
    setSelectedCartImportKey("");
    binatedLifecycle.resetLifecycleState();
    setShowActions(false);
    setRequestArtOpen(true);
  };

  const openCurrentBinatedOrderDialog = async () => {
    if (!orderId) return;
    try {
      setCurrentBinatedOrderLoading(true);
      const response = await getBinatedCurrentOrderByDocument(orderId, {
        documentType: lifecycleDocumentType,
        documentId: resolvedBinatedDocumentId,
        requestType: "design_service",
      });
      setCurrentBinatedOrderData(response || null);
      setCurrentBinatedOrderOpen(true);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to load current Binated order.");
    } finally {
      setCurrentBinatedOrderLoading(false);
    }
  };

  const deleteCurrentBinatedOrder = async () => {
    const confirmed = window.confirm("Delete this Binated order? This action cannot be undone.");
    if (!confirmed) return;
    try {
      setCurrentBinatedOrderDeleting(true);
      await deleteBinatedCurrentOrderByDocument(orderId, {
        documentType: lifecycleDocumentType,
        documentId: resolvedBinatedDocumentId,
        requestType: "design_service",
      });
      toast.success("Binated order deleted.");
      setCurrentBinatedOrderOpen(false);
      setCurrentBinatedOrderData(null);
      await binatedLifecycle.refreshLifecycle();
      setBinatedArtView("status");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to delete Binated order.");
    } finally {
      setCurrentBinatedOrderDeleting(false);
    }
  };

  const openRequestArtWorkRequest = (statusRow, tab = "overview") => {
    if (!statusRow?.requestId) return;
    window.open(
      `/instance/${instanceUniqueId}/core-network/work-requests/${statusRow.requestId}?tab=${encodeURIComponent(tab)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const reviewRequestArtSubmission = (statusRow) => {
    if (!statusRow?.requestId) return;
    proofSourceManualOverrideRef.current = true;
    setProofSourceLinkageBanner(null);
    setProofMappingSourceType(
      getProofSourceTypeForFulfillmentProvider(statusRow?.fulfillmentProvider) ||
      proofMappingSourceType ||
      firstApplicableProofSourceType
    );
    setRequestArtTab("proofing");
  };

  const cancelRequestArtWorkRequest = async (statusRow) => {
    if (!statusRow?.requestId) return;
    const confirmed = window.confirm("Cancel this design request?");
    if (!confirmed) return;
    try {
      setRequestArtLoading(true);
      await cancelCoreNetworkWorkRequest(statusRow.requestId, {
        instanceUniqueId,
        reason: "Cancelled from Sales Order Request Art dialog.",
      });
      toast.success("Design request cancelled.");
      await loadRequestArtStatuses();
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Failed to cancel work request.");
    } finally {
      setRequestArtLoading(false);
    }
  };

  const submitDesignRepRequest = async () => {
    try {
      setRequestArtLoading(true);
      const formData = new FormData();
      formData.append("documentType", routeDocType || "sales-order");
      formData.append("documentId", String(tabId || ""));
      formData.append("orderId", String(orderId || ""));
      formData.append("documentUrl", `${window.location.origin}${history.location.pathname}`);
      formData.append("note", requestArtNote || "");
      if (selectedDesignRepId) formData.append("designerId", selectedDesignRepId);
      (requestArtFiles || []).forEach((file) => formData.append("attachments", file));

      await requestArtworkForDocument(formData);
      toast.success("Design rep request sent.");
      setRequestArtOpen(false);
      setRequestArtNote("");
      setRequestArtFiles([]);
      setSelectedDesignRepId("");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to send design rep request.");
    } finally {
      setRequestArtLoading(false);
    }
  };

  const submitBinatedArtRequest = async () => {
    let payload = null;
    let requestArtOptions = null;
    let binatedResponse = null;
    try {
      if (document?.activeElement && typeof document.activeElement.blur === "function") {
        document.activeElement.blur();
      }
      payload = requestArtSmartSend
        ? getIncludedSmartSendPayload(baseSmartSendPayload, smartSendSkuSelection, getSmartSendOverrideSnapshot())
        : buildArtPayloadFromForm(artForm);
      if (requestArtSmartSend) {
        const skuEntries = getBinatedSalesOrderSkuEntries(payload);
        const decorationCount = getBinatedSalesOrderDecorationCount(payload);
        const placementUrlCount = getBinatedSalesOrderPlacementUrlCount(payload);
        const validationError = getSmartSendValidationError(payload, baseSmartSendPayload);
        if (validationError) {
          toast.error(validationError);
          return;
        }
        if (process.env.NODE_ENV !== "production" || process.env.REACT_APP_BINATED_DEBUG_PAYLOADS === "true" || process.env.BINATED_DEBUG_PAYLOADS === "true") {
          console.info("[Binated Smart Send] payload summary", {
            orderType: payload?.data?.order_type,
            hasSalesOrder: Array.isArray(payload?.data?.sales_order) && payload.data.sales_order.length > 0,
            hasDecoration: Boolean(payload?.data?.decoration),
            skuCount: skuEntries.length,
            decorationCount,
            placementUrlCount,
          });
        }
      } else {
        const missingUrlField = (payload?.media || []).some((m) =>
          (m?.decoration_info || []).some((d) =>
            (d?.placement_info || []).some((p) => !Array.isArray(p?.url) || p.url.filter(Boolean).length === 0)
          )
        );
        if (missingUrlField) {
          toast.error("At least one File URL is required for each placement.");
          return;
        }
      }
      if (isBinatedFulfillment) {
        try {
          setBinatedStandardsChecking(true);
          const standardsResult = await preflightBinatedProofForOrder(orderId, payload);
          setBinatedStandardsPreflight(standardsResult || null);
          if (standardsResult?.payload) payload = standardsResult.payload;

          if (standardsResult?.hasBlockingIssues) {
            if (requestArtSmartSend) setSmartSendView("fields");
            toast.error("Review the Binated-specific mappings before sending.");
            return;
          }
        } catch (preflightError) {
          toast.error(
            preflightError?.response?.data?.message ||
            "Unable to validate Binated-specific mappings."
          );
          return;
        } finally {
          setBinatedStandardsChecking(false);
        }
      }

      if (!isBinatedFulfillment) {
        if (resolvedProofWorkProvider === "core-network" && !binatedSettings.mvpTalentEnabled) {
          toast.error("Core Network is not enabled for this instance.");
          return;
        }
        if (!instanceUniqueId) {
          toast.error("Missing instanceId.");
          return;
        }
        if (!resolvedBinatedDocumentId || !lifecycleDocumentType) {
          toast.error("Missing document context.");
          return;
        }
        if (isDirectTalentAssignment) {
          if (!coreNetworkTalentOptions.length) {
            toast.error("No eligible network members found.");
            return;
          }
          if (!selectedCoreNetworkMemberId || !selectedCoreNetworkMembership?.id) {
            toast.error("Missing active membership.");
            return;
          }
        } else if (isCoreNetworkMarketplaceRequest) {
          if (!coreNetworkTalentOptions.length && marketplaceAudienceMode !== "top_matches") {
            toast.error("No eligible network members found.");
            return;
          }
          if (marketplaceAudienceMode === "selected_talent" && !selectedMarketplaceMemberIds.length) {
            toast.error("Select at least one eligible talent.");
            return;
          }
        }

        setRequestArtLoading(true);
        requestArtOptions = {
          fulfillmentProvider: resolvedProofWorkProvider,
          instanceUniqueId,
          documentType: routeDocType || "sales-order",
          documentId: resolvedBinatedDocumentId,
          memberId: isDirectTalentAssignment ? selectedCoreNetworkMemberId : undefined,
          membershipId: isDirectTalentAssignment ? selectedCoreNetworkMembership?.id : undefined,
          assignmentMode: isDirectTalentAssignment ? "direct" : isCoreNetworkMarketplaceRequest ? "marketplace" : undefined,
          capabilityType: resolvedProofWorkProvider === "core-network" ? coreNetworkCapabilityFilter : undefined,
          priority: requestArtPriorityLevel,
          deadlineAt: requestArtDueDate || undefined,
          note: requestArtNote || "",
          instructions: requestArtNote || "",
          feeType: resolvedProofWorkProvider === "core-network" ? "fixed" : undefined,
          feeAmount: resolvedProofWorkProvider === "core-network"
            ? isDirectTalentAssignment
              ? "0"
              : requestArtFeeEstimate || undefined
            : undefined,
          feeCurrency: resolvedProofWorkProvider === "core-network" ? (marketplaceCurrency || "CAD") : undefined,
          audienceMode: isCoreNetworkMarketplaceRequest ? marketplaceAudienceMode : undefined,
          topMatchLimit: isCoreNetworkMarketplaceRequest ? marketplaceTopMatchLimit : undefined,
          selectedMemberIds: isCoreNetworkMarketplaceRequest ? selectedMarketplaceMemberIds : undefined,
          maxOffers: isCoreNetworkMarketplaceRequest ? marketplaceMaxOffers : undefined,
          offerExpiryHours: isCoreNetworkMarketplaceRequest ? marketplaceOfferExpiryHours : undefined,
          budgetCurrency: isCoreNetworkMarketplaceRequest ? (marketplaceCurrency || "CAD") : undefined,
          budgetMode: isCoreNetworkMarketplaceRequest ? marketplaceBudgetMode : undefined,
          budgetAmount:
            isCoreNetworkMarketplaceRequest && marketplaceBudgetMode === "fixed"
              ? requestArtFeeEstimate || undefined
              : undefined,
          budgetRangeMin:
            isCoreNetworkMarketplaceRequest && marketplaceBudgetMode === "range"
              ? marketplaceBudgetRangeMin || undefined
              : undefined,
          budgetRangeMax:
            isCoreNetworkMarketplaceRequest && marketplaceBudgetMode === "range"
              ? marketplaceBudgetRangeMax || undefined
              : undefined,
          allowDuplicate: false,
          proofContext: {
            documentUrl: `${window.location.origin}${history.location.pathname}`,
            requestArtSmartSend,
            selectedRequestPoId: selectedRequestPoId || null,
            routeDocumentType: lifecycleDocumentType,
            fulfillmentMode: isDirectTalentAssignment ? "direct-talent-assignment" : isCoreNetworkMarketplaceRequest ? "marketplace" : resolvedProofWorkProvider,
          },
          productContext: {
            salesOrderId: currentSO?.id || null,
            estimationId: currentSO?.estimationId || null,
            customerId: binatedCustomerId || null,
            companyName: order?.CompanyName || "",
            customerName: order?.Client || "",
          },
          placementContext: {
            mediaCount: Array.isArray(payload?.media) ? payload.media.length : 0,
          },
        };
        const response = await initiateProofWorkRequestForOrder(orderId, payload, requestArtOptions);
        await loadRequestArtStatuses();
        if (typeof fetchOrder === "function") {
          try {
            await fetchOrder({ suppressLoader: true });
          } catch (refreshError) {
            console.warn("Fulfillment request created, but cart refresh failed:", refreshError);
          }
        }
        if (response?.cartSync?.success === false) {
          toast.warn(response?.cartSync?.message || "Fulfillment request succeeded, but Order Cart sync needs attention.");
        }
        setProofMappingSourceType(
          getProofSourceTypeForFulfillmentProvider(resolvedProofWorkProvider) ||
          firstApplicableProofSourceType
        );
        setRequestArtTab("proofing");
        toast.success(response?.message || (
          resolvedProofWorkProvider === "internal"
            ? "Internal request created."
            : isDirectTalentAssignment
              ? "Core Network request created. Assignment created."
              : isCoreNetworkMarketplaceRequest
                ? "Core Network request created."
                : "Core Network request created."
        ));
        return;
      }
      await binatedLifecycle.submitLifecycleRequest(async () => {
        binatedResponse = await initiateBinatedProofForOrder(orderId, payload, {
          documentType: routeDocType || "sales-order",
          documentId: resolvedBinatedDocumentId,
        });
      });
      await binatedLifecycle.refreshLifecycle();
      if (typeof fetchOrder === "function") {
        try {
          await fetchOrder({ suppressLoader: true });
        } catch (refreshError) {
          console.warn("Binated fulfillment created, but cart refresh failed:", refreshError);
        }
      }
      if (binatedResponse?.cartSync?.success === false) {
        toast.warn(binatedResponse?.cartSync?.message || "Fulfillment request succeeded, but Order Cart sync needs attention.");
      }
      toast.success("Binated art request submitted.");
      setBinatedArtView("status");
    } catch (err) {
      if (
        resolvedProofWorkProvider === "core-network" &&
        Number(err?.response?.status) === 409 &&
        err?.response?.data?.existingRequestId &&
        requestArtOptions
      ) {
        await loadRequestArtStatuses();
        const allowDuplicate = window.confirm(
          "An active Core Network request already exists for this artwork scope.\n\nPress OK to create another anyway, or Cancel to open the existing request from the list below."
        );
        if (allowDuplicate) {
          const retryResponse = await initiateProofWorkRequestForOrder(orderId, payload, {
            ...requestArtOptions,
            allowDuplicate: true,
          });
          await loadRequestArtStatuses();
          setProofMappingSourceType(
            getProofSourceTypeForFulfillmentProvider(resolvedProofWorkProvider) ||
            firstApplicableProofSourceType
          );
          setRequestArtTab("proofing");
          toast.success(retryResponse?.message || "Core Network request created.");
          return;
        }
      }
      toast.error(err?.response?.data?.message || "Failed to submit artwork request.");
    } finally {
      setRequestArtLoading(false);
    }
  };

  const submitLifecycleRevision = async () => {
    const trimmed = String(binatedLifecycle.revisionNote || "").trim();
    if (!trimmed) {
      toast.error("Revision note is required.");
      return;
    }
    try {
      await binatedLifecycle.submitRevision({
        note: trimmed,
        file: binatedLifecycle.revisionTargetFile,
      });
      toast.success("Revision request submitted.");
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to request revision.");
    }
  };

  const submitStatusItemDecorationUpdate = async ({ statusItem = null, data = {}, internalNote = "" } = {}) => {
    try {
      await binatedLifecycle.updateStatusItemDecoration({
        statusItem,
        data,
        internalNote,
      });
      toast.success("Binated artwork update submitted.");
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to update Binated artwork.");
      throw err;
    }
  };

  const uploadBinatedReplacementFiles = async (selectedFiles = []) => {
    if (!binatedCustomerId) {
      throw new Error("Customer is required before uploading replacement artwork.");
    }
    const uploadedUrls = [];
    for (const selectedFile of selectedFiles) {
      const uploaded = await uploadFile(binatedCustomerId, {
        file: selectedFile,
        folder: "binated-held-artwork",
      });
      const nextUrl =
        uploaded?.publicUrl ||
        uploaded?.downloadUrl ||
        uploaded?.url ||
        uploaded?.previewUrl ||
        uploaded?.filePath ||
        "";
      if (nextUrl) uploadedUrls.push(nextUrl);
    }
    return uploadedUrls;
  };

  useEffect(() => {
    if (!cartHistoryOpen || !orderId) return;
    let cancelled = false;
    (async () => {
      try {
        setCartHistoryLoading(true);
        const [historyRes, snapsRes] = await Promise.all([
          fetchCartHistory(orderId),
          fetchCartSnapshots(orderId),
        ]);
        if (cancelled) return;
        setCartActivity(Array.isArray(historyRes?.history) ? historyRes.history : []);
        setCartSnapshots(Array.isArray(snapsRes?.snapshots) ? snapsRes.snapshots : []);
      } catch (err) {
        if (!cancelled) toast.error("Failed to load cart history.");
      } finally {
        if (!cancelled) setCartHistoryLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [cartHistoryOpen, orderId]);

  const invoiceEditCartIsResolved = isInvoiceEditRoute &&
    Boolean(selectedInvoicingCartKey) &&
    !invoiceCartResolution.loading &&
    !invoiceCartResolution.error &&
    invoiceCartResolution.data?.invoicingCartKey === selectedInvoicingCartKey;
  const cartWorkspace = useCartWorkspace({
    orderId,
    order,
    cartView: effectiveCartView,
    // Invoice routes never mount/fetch an Order Cart or Sales Order snapshot.
    // A selected invoice-owned cart (or validated /invoice/:id link) is required.
    enabled: !isInvoiceRoute || (isInvoiceEditRoute ? invoiceEditCartIsResolved : (isInvoiceListRoute && selectedInvoiceCartIsValid)),
    salesOrderDocumentId: isSalesOrderRoute && tabId ? tabId : null,
    fetchOrder,
    invoicingCartKey: selectedInvoicingCartKey,
    salesOrderCartUnlocked: effectiveSalesOrderCartUnlocked,
  });
  const { updateCartPayload, resetDirty } = cartWorkspace;
  const canOpenSalesOrderCart = useMemo(() => (
    (salesOrderData || []).some((so) => isSalesOrderCartEligible(so))
  ), [salesOrderData]);
  const showDesignRepNotifyFooterAction =
    requestArtTab === "designer";
  useEffect(() => {
    setOrderHydrated(false);
  }, [orderId]);

  useEffect(() => {
    setSalesOrderCartUnlocked(false);
    hasAutoSelectedSalesOrderCartRef.current = false;
  }, [orderId, tabtype, tabId]);

  useEffect(() => {
    if (!orderHydrated) return;

    const shouldUseSalesOrderCart = shouldDefaultToSalesOrderCart({ tabtype, tabId, order });

    if (!shouldUseSalesOrderCart) {
      if (cartViewRef.current === "sales-order-cart") {
        setCartView("order-cart");
      }
      hasAutoSelectedSalesOrderCartRef.current = true;
      return;
    }

    if (hasAutoSelectedSalesOrderCartRef.current) return;
    if (!order?.id && !order?.OrderId) return;
    if (cartViewRef.current === "sales-order-cart") {
      hasAutoSelectedSalesOrderCartRef.current = true;
      return;
    }

    setCartView("sales-order-cart");
    hasAutoSelectedSalesOrderCartRef.current = true;
  }, [order, tabtype, tabId, orderHydrated]);

  useEffect(() => {
    if (!orderHydrated) return;
    if (cartView === "sales-order-cart" && !canOpenSalesOrderCart) {
      setCartView("order-cart");
      toast("Sales Order Cart is unavailable until Sales Order is approved/booked.");
    }
  }, [cartView, canOpenSalesOrderCart, orderHydrated]);

  useEffect(() => {
    if (!orderHydrated) return;
    if (!isSalesOrderRoute || !tabId) return;
    if (!shouldDefaultToSalesOrderCart({ tabtype, tabId, order })) return;
    if (cartViewRef.current === "sales-order-cart") return;
    setCartView("sales-order-cart");
  }, [orderHydrated, isSalesOrderRoute, tabtype, tabId, order]);

  // Presentations are created from the Order Cart, not a booked Sales Order Cart.
  // Reset the selected cart when entering a numbered presentation route.
  useEffect(() => {
    if (normalizedTabType === 'presentation' && hasDocumentId) {
      setCartView('order-cart');
    }
  }, [normalizedTabType, hasDocumentId, tabId]);

  const orderForCartView = cartWorkspace.orderForView;
  const isInvoicingCartView = effectiveCartView === "invoicing-cart";
  const isSalesOrderCartView = effectiveCartView === "sales-order-cart";
  const selectedInvoicingCartLines = selectedInvoicingCartKey
    ? (invoicingCartLinesByKey[selectedInvoicingCartKey] || [])
    : [];
  const viewedCartLines = isInvoicingCartView
    ? (Array.isArray(orderForCartView?.Products) ? orderForCartView.Products : selectedInvoicingCartLines)
    : (Array.isArray(orderForCartView?.Products) ? orderForCartView.Products : []);
  const invoicingCartState = {
    loading: cartWorkspace.loading,
    error: cartWorkspace.error,
    missing: cartWorkspace.missing,
    data: cartWorkspace.cartPayload?.meta || null,
  };
  const selectedInvoicingCartSummary = (isInvoiceListRoute ? selectableInvoicingCarts : invoicingCarts).find((c) => c.invoicingCartKey === selectedInvoicingCartKey)
    || (invoiceCartResolution?.data?.activeCart?.invoicingCartKey === selectedInvoicingCartKey ? invoiceCartResolution.data.activeCart : null)
    || (selectedInvoicingCartKey && String(selectedInvoicingCartRecord?.documentId || '') === String(selectedInvoicingCartKey) ? selectedInvoicingCartRecord : null);
  const formatInvoicingCartOptionLabel = useCallback((cart = {}) => {
    const key = cart.invoicingCartKey || "Unknown cart";
    const invoice = cart.linkedInvoiceNumber || cart.linkedInvoiceId;
    const invoicePrefix = invoice ? `Invoice ${invoice} - ` : "";
    const lifecycle = cart.lifecycleStatus || "Unknown";
    const revision = cart.revisionNumber ? `Revision ${cart.revisionNumber}` : null;
    const items = cart.itemCount != null
      ? `${cart.itemCount} item${Number(cart.itemCount) === 1 ? "" : "s"}`
      : null;

    return `${invoicePrefix}${[
      key,
      lifecycle,
      revision,
      items,
    ].filter(Boolean).join(" · ")}`;
  }, []);
  const selectedInvoicingCartIsSelectable = selectedInvoiceCartIsValid;
  const cartViewSelectValue = effectiveCartView === "invoicing-cart" && selectedInvoicingCartKey && selectedInvoicingCartIsSelectable
    ? `invoicing-cart:${selectedInvoicingCartKey}`
    : effectiveCartView === "invoicing-cart"
      ? ""
      : effectiveCartView;
  const selectedInvoicingLifecycle = String(selectedInvoicingCartSummary?.lifecycleStatus || '').toLowerCase();
  const owningInvoiceForSelectedCart = orderInvoices.find((invoice) =>
    String(invoice?.id || '') === String(
      selectedInvoicingCartSummary?.linkedInvoiceId || (isInvoiceEditRoute ? activeInvoiceId : '')
    )
  ) || null;
  const selectedInvoiceIsPaid = ['paid', 'completed', 'success', 'succeeded'].some((status) =>
    status === String(owningInvoiceForSelectedCart?.paymentStatus || '').trim().toLowerCase() ||
    status === String(owningInvoiceForSelectedCart?.invoiceStatus || '').trim().toLowerCase()
  );
  const canEditSelectedInvoicingCart = !isInvoicingCartView
    ? true
    : ['draft', 'active'].includes(selectedInvoicingLifecycle) && !selectedInvoiceIsPaid;
  const selectedInvoicingCartEditReason = !selectedInvoicingCartKey
    ? "Select or create an invoicing cart first."
    : selectedInvoiceIsPaid
      ? "Invoice has been paid; its invoicing cart is read-only."
      : selectedInvoicingLifecycle === 'finalized'
      ? "Invoice already generated. Create a revision before editing."
      : ['locked', 'voided', 'superseded'].includes(selectedInvoicingLifecycle)
        ? `Invoicing cart is ${selectedInvoicingCartSummary?.lifecycleStatus || selectedInvoicingLifecycle} and is read-only.`
        : "";
  const selectedInvoicingCartStatusCopy = !selectedInvoicingCartKey
    ? ''
    : (selectedInvoiceIsPaid || selectedInvoicingLifecycle === 'finalized' || ['locked', 'voided', 'superseded'].includes(selectedInvoicingLifecycle))
      ? 'Invoice is frozen — cart is read-only.'
      : (selectedInvoicingCartSummary?.linkedInvoiceId
        ? 'Linked to open invoice — edits update generated invoice.'
        : 'This invoicing cart is editable until invoice freeze/finalization.');
  const cartWorkspaceForPresentation = useMemo(() => ({
    ...cartWorkspace,
    editable: effectiveCartView === "invoicing-cart"
      ? Boolean(cartWorkspace?.editable && canEditSelectedInvoicingCart)
      : cartWorkspace?.editable,
    editReason: effectiveCartView === "invoicing-cart"
      ? selectedInvoicingCartEditReason
      : effectiveCartView === "sales-order-cart" && !effectiveSalesOrderCartUnlocked
        ? "Sales Order Cart is read-only until unlocked."
        : "",
    selectedInvoicingCartLifecycle: selectedInvoicingLifecycle,
    selectedInvoicingCartKey,
    save: effectiveCartView === "sales-order-cart" ? null : cartWorkspace?.save,
  }), [
    cartWorkspace,
    effectiveCartView,
    canEditSelectedInvoicingCart,
    selectedInvoicingCartEditReason,
    selectedInvoicingLifecycle,
    selectedInvoicingCartKey,
    effectiveSalesOrderCartUnlocked,
  ]);

  const applyCartLineMutation = useCallback((mutator) => {
    if (isSalesOrderCartView) {
      if (!effectiveSalesOrderCartUnlocked) {
        toast("Sales Order Cart is read-only.");
        return;
      }
      const nextLines = mutator(Array.isArray(viewedCartLines) ? viewedCartLines : []);
      updateCartPayload((current) => ({
        ...(current || {}),
        Products: nextLines,
        products: nextLines,
        items: nextLines,
      }));
      return;
    }
    if (isInvoicingCartView) {
      if (!selectedInvoicingCartKey) {
        toast("Create or select an Invoicing Cart first.");
        return;
      }
      if (!canEditSelectedInvoicingCart) {
        toast(selectedInvoicingCartEditReason || "Selected invoicing cart is read-only.");
        return;
      }
      const nextLines = mutator(Array.isArray(viewedCartLines) ? viewedCartLines : []);
      setInvoicingCartLinesByKey((prev) => ({
        ...prev,
        [selectedInvoicingCartKey]: nextLines,
      }));
      updateCartPayload((current) => ({
        ...(current || {}),
        Products: nextLines,
        products: nextLines,
        items: nextLines,
      }));
      return;
    }
    const nextLines = mutator(Array.isArray(viewedCartLines) ? viewedCartLines : []);
    setOrder((prevOrder) => ({ ...prevOrder, Products: nextLines }));
  }, [canEditSelectedInvoicingCart, isInvoicingCartView, isSalesOrderCartView, effectiveSalesOrderCartUnlocked, selectedInvoicingCartEditReason, selectedInvoicingCartKey, updateCartPayload, viewedCartLines]);

  const handleReorderProducts = useCallback(async (activeIdentity, overIdentity) => {
    const currentLines = Array.isArray(viewedCartLines) ? viewedCartLines : [];
    const identityKey = (product = {}) => String(
      product?.cartLineId ??
      product?.orderItemId ??
      product?.OrderItemId ??
      product?.id ??
      ""
    );
    const nextPayload = reorderProductsInPayload(
      {
        Products: currentLines,
        OtherService: [],
        meta: { source: "order-cart" },
      },
      activeIdentity,
      overIdentity,
    );
    const nextLines = Array.isArray(nextPayload?.Products)
      ? nextPayload.Products
      : [];

    if (
      !nextLines.length ||
      nextLines.length !== currentLines.length ||
      nextLines.every(
        (line, index) => identityKey(line) === identityKey(currentLines[index]),
      )
    ) {
      return;
    }

    applyCartLineMutation(() => nextLines);

    try {
      const items = nextLines.map((product, index) => {
        const orderItemId = Number(
          product?.orderItemId ?? product?.OrderItemId ?? product?.id,
        );

        if (!Number.isFinite(orderItemId)) return null;

        return {
          orderItemId,
          sortOrder: index,
        };
      });

      if (items.some((item) => !item)) {
        throw new Error("Unable to determine product reorder ids.");
      }

      await reorderOrderProducts(orderId, items);
    } catch (error) {
      console.error("Failed to reorder cart products", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to save product order.",
      );
      await fetchOrder({ suppressLoader: true });
    }
  }, [applyCartLineMutation, fetchOrder, orderId, viewedCartLines]);

  const handleReorderLayout = useCallback(async (activeLayoutId, overLayoutId) => {
    const currentProducts = Array.isArray(viewedCartLines) ? viewedCartLines : [];
    const currentSections = Array.isArray(orderForCartView?.cartSections) ? orderForCartView.cartSections : [];
    const nextPayload = reorderCartLayoutInPayload(
      {
        Products: currentProducts,
        cartSections: currentSections,
        OtherService: [],
        meta: { source: "order-cart" },
      },
      activeLayoutId,
      overLayoutId,
    );

    const nextProducts = Array.isArray(nextPayload?.Products) ? nextPayload.Products : currentProducts;
    const nextSections = Array.isArray(nextPayload?.cartSections) ? nextPayload.cartSections : currentSections;

    setOrder((prevOrder) => ({
      ...prevOrder,
      Products: nextProducts,
      cartSections: nextSections,
    }));

    try {
      await reorderOrderCartLayout(orderId, nextPayload.layout || []);
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Failed to save cart layout.");
      await fetchOrder({ suppressLoader: true });
    }
  }, [fetchOrder, orderForCartView?.cartSections, orderId, viewedCartLines]);

  const loadInvoicingCarts = useCallback(async () => {
    if (!orderId) return;
    const requestId = ++invoicingCartListRequestRef.current;
    setInvoicingCartsLoading(true);
    setInvoicingCartsError('');
    try {
      const res = await listInvoicingCarts(orderId);
      if (requestId !== invoicingCartListRequestRef.current) return;
      const carts = Array.isArray(res?.carts) ? res.carts : [];
      setInvoicingCarts(carts);
    } catch (err) {
      if (requestId !== invoicingCartListRequestRef.current) return;
      setInvoicingCarts([]);
      setInvoicingCartsError(err?.response?.data?.message || 'Unable to load invoice-owned carts. Refresh to retry.');
      console.error('loadInvoicingCarts failed', err);
    } finally {
      if (requestId === invoicingCartListRequestRef.current) {
        setInvoicingCartsLoading(false);
        setInvoiceCartsSettledOrderId(String(orderId));
      }
    }
  }, [orderId]);

  const loadSelectedInvoicingCart = useCallback(async (invoicingCartKey) => {
    if (!orderId || !invoicingCartKey) return;
    const requestId = ++invoicingCartHydrationRequestRef.current;
    const isCurrent = () =>
      requestId === invoicingCartHydrationRequestRef.current &&
      String(selectedInvoicingCartOrderIdRef.current) === String(orderId) &&
      (!isInvoiceRoute || selectedInvoicingCartKeyRef.current === invoicingCartKey);

    try {
      const res = await fetchInvoicingCartByKey(orderId, invoicingCartKey);
      if (!isCurrent()) return;
      const fetchedCart = res?.cart || null;
      const payload = normalizeCartPayload(
        fetchedCart?.payload || {},
        { meta: { source: "invoicing-cart" } },
        "invoicing-cart"
      );

      payload.Products = hydrateCartProductTaxDetails(payload.Products, order);
      const nextProducts = Array.isArray(payload?.Products) ? payload.Products : [];
      const nextOtherServices = Array.isArray(payload?.OtherService) ? payload.OtherService : [];

      setInvoicingCartLinesByKey((prev) => ({
        ...prev,
        [invoicingCartKey]: nextProducts,
      }));
      // useCartWorkspace owns the invoice-route payload and its keyed fetch.
      // Do not let this secondary metadata fetch overwrite a newer invoice.
      if (!isInvoiceRoute && cartView === "invoicing-cart" && cartViewRef.current === "invoicing-cart") {
        updateCartPayload((current) => ({
          ...(current || {}),
          ...payload,
          Products: nextProducts,
          products: nextProducts,
          items: nextProducts,
          OtherService: nextOtherServices,
          otherServices: nextOtherServices,
        }), { markDirty: false });
      }

      setSelectedInvoicingCartRecord(fetchedCart);

      const summary = (invoicingCarts || []).find((c) => c.invoicingCartKey === invoicingCartKey) || null;
      const summaryCount = Number(summary?.itemCount || 0);
      if (summaryCount > 0 && nextProducts.length === 0 && nextOtherServices.length === 0) {
        setInvoicingCartHydrationWarning('Persisted cart summary reports items, but latest fetched payload is empty.');
      } else {
        setInvoicingCartHydrationWarning('');
      }

      console.log('[invoicing-cart][hydrate]', {
        selectedInvoicingCartKey: invoicingCartKey,
        revisionNumber: summary?.revisionNumber ?? fetchedCart?.revisionNumber ?? null,
        lifecycleStatus: summary?.lifecycleStatus ?? fetchedCart?.lifecycleStatus ?? null,
        summaryItemCount: summary?.itemCount ?? null,
        fetchedProductsLength: nextProducts.length,
        fetchedOtherServiceLength: nextOtherServices.length,
      });
    } catch (err) {
      if (!isCurrent()) return;
      setInvoicingCartHydrationWarning('Failed to fetch latest persisted invoicing cart payload.');
      setInvoicingCartLinesByKey((prev) => ({ ...prev, [invoicingCartKey]: [] }));
      console.error("loadSelectedInvoicingCart failed", err);
    }
  }, [cartView, isInvoiceRoute, orderId, order, invoicingCarts, updateCartPayload]);

  const resolveActiveInvoiceCart = useCallback(async () => {
    if (!orderId || !activeInvoiceId) return;
    try {
      setInvoiceCartResolution({ loading: true, error: '', data: null });
      const res = await resolveInvoiceInvoicingCart(orderId, activeInvoiceId, invoiceRouteInvoicingCartKey);
      const key = res?.invoicingCartKey || res?.activeCart?.invoicingCartKey || null;
      if (!key) throw new Error('No invoicing cart key returned for this invoice.');
      setSelectedInvoicingCartKey(key);
      setSelectedInvoicingCartRecord(res?.cart || null);
      setInvoicingCarts((prev) => {
        const existing = Array.isArray(prev) ? prev : [];
        const summary = res?.activeCart ? { ...res.activeCart, invoicingCartKey: key } : null;
        if (!summary) return existing;
        const without = existing.filter((cart) => cart.invoicingCartKey !== key);
        return [summary, ...without];
      });
      setCartView('invoicing-cart');
      await loadSelectedInvoicingCart(key);
      setInvoiceCartResolution({ loading: false, error: '', data: res || null });
    } catch (err) {
      const message = err?.response?.data?.message || err?.message || 'No invoice-specific invoicing cart was found.';
      setSelectedInvoicingCartKey(null);
      setInvoiceCartResolution({ loading: false, error: message, data: err?.response?.data || null });
      setCartView('invoicing-cart');
      console.warn('[invoice-edit cart resolution] failed', { orderId, invoiceId: activeInvoiceId, message });
    }
  }, [activeInvoiceId, invoiceRouteInvoicingCartKey, loadSelectedInvoicingCart, orderId]);

  useEffect(() => {
    if (!isInvoiceEditRoute) return;
    setCartView('invoicing-cart');
    resolveActiveInvoiceCart();
  }, [isInvoiceEditRoute, activeInvoiceId, invoiceRouteInvoicingCartKey, orderId]);

  useEffect(() => {
    if (!isInvoiceListRoute) return;
    setCartView('invoicing-cart');
    // An existing valid manual choice wins. Otherwise pick the newest
    // invoice-owned cart returned for this project, never the Order Cart.
    const key = selectInvoiceOwnedCartKey({
      carts: selectableInvoicingCarts,
      selectedKey: selectedInvoicingCartKey,
    });
    if (key === selectedInvoicingCartKey) return;
    resetDirty?.();
    setSelectedInvoicingCartKey(key);
    setSelectedInvoicingCartRecord(null);
    setInvoicingCartHydrationWarning('');
  }, [isInvoiceListRoute, selectableInvoicingCarts, selectedInvoicingCartKey, resetDirty]);

  useEffect(() => {
    if (!orderHydrated) return;
    if (routeDocType === "invoice") return;
    if (cartViewRef.current !== "invoicing-cart") return;

    setCartView(resolveCartViewAfterInvoice({ tabtype, tabId, order }));
  }, [orderHydrated, order, routeDocType, tabId, tabtype]);

  useEffect(() => {
    // Prevent another project's previous invoice from appearing while the new
    // project's invoice list and cart selection are being requested.
    invoicingCartHydrationRequestRef.current += 1;
    setOrderInvoices([]);
    setInvoicingCarts([]);
    setSelectedInvoicingCartKey(null);
    setSelectedInvoicingCartRecord(null);
    setInvoicingCartLinesByKey({});
    setInvoicingCartHydrationWarning('');
  }, [orderId]);

  useEffect(() => {
    if (!orderId) return;
    // Even with zero invoices, check for an existing invoice-owned cart.
    // The endpoint does not create anything and ignores orphan snapshots.
    loadInvoicingCarts();
    return () => { invoicingCartListRequestRef.current += 1; };
  }, [orderId, loadInvoicingCarts]);

  useEffect(() => {
    if (!orderId || isInvoiceRoute || cartView !== "invoicing-cart") return;
    loadInvoicingCarts();
  }, [cartView, orderId, isInvoiceRoute, loadInvoicingCarts]);

  const handleCartViewChange = useCallback(async (event) => {
    const value = String(event?.target?.value || "");

    if (value.startsWith("invoicing-cart:")) {
      const key = value.slice("invoicing-cart:".length);
      if (!isInvoiceRoute || isInvoiceEditRoute || !key ||
        !selectableInvoicingCarts.some((cart) => cart.invoicingCartKey === key)) return;
      if (key === selectedInvoicingCartKey) return;
      if (isInvoiceRoute && cartWorkspace.dirty &&
        !window.confirm('This invoicing cart has unsaved changes. Switch carts and discard those changes?')) return;
      resetDirty?.();
      setSelectedInvoicingCartKey(key);
      setSelectedInvoicingCartRecord(null);
      setCartView("invoicing-cart");
      if (!isInvoiceRoute) await loadSelectedInvoicingCart(key);
      return;
    }

    // Invoice pages cannot switch to project or Sales Order carts, including
    // through the Cart History drawer.
    if (isInvoiceRoute) return;
    if (value === "order-cart" || value === "sales-order-cart") {
      setCartView(value);
    }
  }, [isInvoiceRoute, isInvoiceEditRoute, selectableInvoicingCarts, selectedInvoicingCartKey, cartWorkspace.dirty, loadSelectedInvoicingCart, resetDirty]);

  const selectedInvoicingCartRefreshToken = selectedInvoicingCartSummary
    ? `${selectedInvoicingCartSummary.revisionNumber || ''}:${selectedInvoicingCartSummary.updatedAt || ''}`
    : '';

  useEffect(() => {
    if (effectiveCartView !== "invoicing-cart" || (isInvoiceRoute && !isInvoiceListRoute && !isInvoiceEditRoute)) return;
    if (selectedInvoicingCartKey) loadSelectedInvoicingCart(selectedInvoicingCartKey);
  }, [effectiveCartView, isInvoiceRoute, isInvoiceListRoute, isInvoiceEditRoute, selectedInvoicingCartKey, selectedInvoicingCartRefreshToken, loadSelectedInvoicingCart]);

  useEffect(() => {
    if (activeTab !== "Invoice" || !orderId) return;
    if (!selectedInvoicingCartKey) {
      setInvoiceDiffState({ loading: false, error: "Select an invoicing cart to view changes.", data: null });
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        setInvoiceDiffState({ loading: true, error: "", data: null });
        const res = await fetchInvoicingCartDiffByKey(orderId, selectedInvoicingCartKey);
        if (!cancelled) setInvoiceDiffState({ loading: false, error: "", data: res || null });
      } catch (err) {
        if (!cancelled) {
          setInvoiceDiffState({
            loading: false,
            error: err?.response?.status === 404 ? "" : (err?.response?.data?.message || "Unable to load cart diff."),
            data: null,
          });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [activeTab, orderId, selectedInvoicingCartKey]);

  // ── BLOCK new document creation once SO is signed or further in lifecycle
  const hasCompletedSO = React.useMemo(
    () => salesOrderData.some(so => APPROVED_OR_LATER_SO_STATUSES.has(String(so?.status))),
    [salesOrderData]
  );
  const soStageRaw = String(order?.OrderStatus?.SO || '').trim().toLowerCase();
  const signedOrLaterStages = new Set([
    'sales order ready',         // customer signed / client approved
    'client approved',
    'sales order - customer signed',
    'in production',
    'shipped',
    'ready to be invoiced',
    'invoiced',
    'paid',
  ]);
  const isSignedOrLaterByStage = signedOrLaterStages.has(soStageRaw);
  const blockCreateDocs = hasCompletedSO || isSignedOrLaterByStage;
  const blockTip =
    "A signed/advanced sales order already exists (Client Approved, In Production, Shipped, Ready to be Invoiced, Invoiced, or Paid). Creating new Presentation/Estimate/Sales Order is blocked for this project.";

  const documentCreationGuards = resolveDocumentCreationGuards({
    records: salesOrderData,
    globalLocked: blockCreateDocs,
    loading: !orderHydrated,
  });
  const estimateCreationTip = blockCreateDocs
    ? blockTip
    : !orderHydrated
      ? "Project document status is still loading."
      : documentCreationGuards.hasSalesOrder
        ? "A sales order already exists for this project. You cannot create a new estimate after the project has progressed to Sales Order."
        : documentCreationGuards.hasEstimate
          ? "An estimate already exists for this project."
          : "";
  const salesOrderCreationTip = blockCreateDocs
    ? blockTip
    : !orderHydrated
      ? "Project document status is still loading."
      : documentCreationGuards.hasSalesOrder
        ? "A sales order already exists for this project."
        : "";

    const openEstimationPopup = (requestedConversionStatus) => {
      const requestedStatus = Number(requestedConversionStatus);
      const blockReason = requestedStatus === 1
        ? estimateCreationTip
        : requestedStatus === 2
          ? salesOrderCreationTip
          : blockTip;
      const isBlocked = isDocumentCreationBlocked(documentCreationGuards, requestedStatus);

      if (isBlocked) {
        toast.error(blockReason || "Creating this document is currently unavailable.");
        setShowActions(false);
        return false;
      }
      setConversionStatus(requestedStatus);
      setEstimationPopup(true);
      setShowActions(false);
      return true;
    };
    

  const toEmailIds = (list = []) =>
    list
      .map((entry) => entry?.id)
      .filter(Boolean)
      .filter((email, index, arr) => arr.indexOf(email) === index);

  const handleCreateInvoice = async() => {
    if (invoiceOpenRequestRef.current) return;
    invoiceOpenRequestRef.current = true;
    setInvoiceOpenLoading(true);
    try {
    const toNumberSafe = (value) => {
      if (value && typeof value === "object") {
        if (value.amount != null) return toNumberSafe(value.amount);
        if (value.total != null) return toNumberSafe(value.total);
      }
      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    };
    const extractCompletedSoTotal = (salesOrder) => {
      if (!salesOrder) return 0;
      const invoiceable = toNumberSafe(salesOrder?.invoiceableTotal);
      if (invoiceable > 0) return invoiceable;
      const directTotal = toNumberSafe(salesOrder?.salesOrderTotal);
      if (directTotal > 0) return directTotal;
      const rawStamp = salesOrder?.stampedBookedAmount;
      let stamp = rawStamp;
      if (typeof rawStamp === "string") {
        try { stamp = JSON.parse(rawStamp); } catch { stamp = null; }
      }
      return toNumberSafe(stamp?.targetRevenue);
    };
    const salesOrderTotal =
      toNumberSafe(currentSO?.Total) ||
      toNumberSafe(currentSO?.total) ||
      toNumberSafe(order?.Total);
    let completedSoTotal = 0;
    try {
      const latestCompletedSO = await fetchLatestCompletedSalesOrderForOrder(orderId);
      completedSoTotal = extractCompletedSoTotal(latestCompletedSO);
    } catch (_) {}
    const baseTotal = completedSoTotal > 0 ? completedSoTotal : salesOrderTotal;
    // An unpaid *active* invoice also covers the order's invoiceable amount.
    // Subtracting only paid invoices can offer a duplicate invoice here.
    // Use Finance's existing authoritative balance-status endpoint, with the
    // same active-invoice calculation as a fallback if that read fails.
    // This dialog may be opened long after the project was hydrated. Fetch
    // the actual invoice list now instead of explaining coverage using stale
    // page state. If the request fails, surface uncertainty rather than
    // saying the project has no invoices.
    let refreshedInvoices = Array.isArray(orderInvoices) ? orderInvoices : [];
    let invoiceHistoryError = false;
    try {
      refreshedInvoices = await fetchInvoicesListByOrder(orderId, { throwOnError: true });
      setOrderInvoices(refreshedInvoices);
    } catch (historyError) {
      invoiceHistoryError = true;
      console.warn('Sales Order invoice history unavailable; using current project list.', historyError);
    }
    const locallyCoveredAmount = sumActiveInvoiceTotal(refreshedInvoices);
    let remainingInvoiceable = Math.max(0, baseTotal - locallyCoveredAmount);
    let liveInvoiceBalance = null;
    let invoiceBalanceError = false;
    try {
      const currentBalance = await fetchOrderBalanceStatus(orderId);
      liveInvoiceBalance = currentBalance;
      const serverUninvoiced = Number(currentBalance?.uninvoicedAdditionalBalance);
      const serverSourceMatches = !currentBalance?.latestSalesOrderId ||
        !invoiceCreationSalesOrderId ||
        String(currentBalance.latestSalesOrderId) === String(invoiceCreationSalesOrderId);
      if (serverSourceMatches && Number(currentBalance?.currentOrderTotal) > 0 &&
        currentBalance?.uninvoicedAdditionalBalance != null && Number.isFinite(serverUninvoiced)) {
        remainingInvoiceable = Math.max(0, serverUninvoiced);
      }
    } catch (balanceError) {
      invoiceBalanceError = true;
      console.warn('Sales Order invoice balance check unavailable; using active invoice coverage.', balanceError);
    }
    setSalesOrderInvoiceHistoryReview({
      invoices: refreshedInvoices,
      balanceStatus: liveInvoiceBalance,
      historyError: invoiceHistoryError,
      balanceError: invoiceBalanceError,
    });
    // Cart comparison is informational only: the new invoice is prepared
    // from the approved Sales Order, never from an older invoice-owned cart.
    let latestDiffState = { loading: false, error: "", data: null };
    setInvoiceDiffState(latestDiffState);
    try {
      if (selectedInvoicingCartKey) {
        const liveDiff = await fetchInvoicingCartDiffByKey(orderId, selectedInvoicingCartKey);
        latestDiffState = { loading: false, error: "", data: liveDiff || null };
        setInvoiceDiffState(latestDiffState);
      }
    } catch (err) {
      // Keep fallback behavior when invoicing cart does not exist yet.
      if (Number(err?.response?.status) !== 404) {
        setInvoiceDiffState({
          loading: false,
          error: err?.response?.data?.message || "Unable to load cart diff.",
          data: null,
        });
      }
    }
    // Differences with an old invoicing cart are shown as a helpful note
    // inside the composer; they are not a pre-creation approval gate.
    setPreparedInvoiceReview(null);
    setInvoiceAddressPrecheck(null);
    setInvoiceAddressPrecheckError('');
    setInvoiceAddressPrecheckSettled(false);
    setInvoiceAddressReminderSent(false);
    setInvoiceInitialReviewSettled(false);
    setInvoiceComposerPreparing(true);
    setInvoiceCreateMode(resolveDefaultCreateInvoiceMode());
    setManualAdditionalInvoice(false);
    setManualAdditionalReason('');
    setConfirmAdditionalInvoice(false);
    setInvoiceSuggestedAmount(remainingInvoiceable);
    setInvoiceCreateAmount(remainingInvoiceable > 0 ? remainingInvoiceable.toFixed(2) : "");
    // A new invoice must not inherit an earlier unsent email body, especially
    // its amount. The email auto-fill effect will build the current draft.
    invoiceEmailLastAutofillRef.current = { subject: null, body: null };
    setInvoiceEmailValue((previous) => ({ ...previous, subject: '', body: '' }));
    setSendInvoiceEmailNow(false);
    setQueueInvoiceForQuickBooks(defaultQboQueueOnCreate);
    setInvoiceComposerOpen(true);
    setShowActions(false);
    } finally {
      invoiceOpenRequestRef.current = false;
      setInvoiceOpenLoading(false);
    }
  }

  const canOfferManualAdditionalInvoice =
    String(currentUser?.role || '').trim().toLowerCase() === 'administrator' &&
    salesOrderInvoiceHistorySummary.nonDepositCount > 0 &&
    !salesOrderInvoiceHistoryReview.historyError &&
    !salesOrderInvoiceHistoryReview.balanceError &&
    Boolean(salesOrderInvoiceHistorySummary.balance) &&
    Number(salesOrderInvoiceHistorySummary.balance.remaining) <= 0;

  const invoiceCreateAssessment = assessSalesOrderInvoiceCreateAmount({
    amount: invoiceCreateAmount,
    remainingInvoiceable: invoiceSuggestedAmount,
    hasPriorCoverage: sumActiveInvoiceTotal(orderInvoices || []) > 0,
    manualAdditional: manualAdditionalInvoice && canOfferManualAdditionalInvoice,
    approvedSalesOrderTotal: salesOrderInvoiceHistorySummary.balance?.orderTotal || 0,
  });

  const handleCreateInvoiceWithEmail = async(options = {}) => {
    // The preparation request is async; protect it as well as the final POST
    // from rapid double clicks, not just the network create step.
    if (invoiceCreateSubmissionRef.current) {
      if (options.invoiceAmount != null) throw new Error('Invoice creation is already in progress.');
      return;
    }
    try {
      console.log("[invoice-create Path A] handler entered", {
        orderId,
        tabId,
        cartView,
        selectedInvoicingCartKey,
        invoiceCreateAmount: options.invoiceAmount ?? invoiceCreateAmount,
      });
      // The Finance /invoice page also calls this handler with explicit options.
      // Preserve that path's already-selected role/amount and its own review.
      const isSalesOrderComposerSubmit = options.invoiceAmount == null;
      const isManualAdditionalSubmit = isSalesOrderComposerSubmit && manualAdditionalInvoice;
      if (isManualAdditionalSubmit && (!canOfferManualAdditionalInvoice ||
          !confirmAdditionalInvoice || manualAdditionalReason.trim().length < 12)) {
        toast.error('Confirm the additional manual invoice and enter a reason (at least 12 characters).');
        return;
      }
      if (isSalesOrderComposerSubmit && !invoiceCreateAssessment.valid) {
        toast.error(invoiceCreateAssessment.message);
        return;
      }
      let preparation = options.preparation || preparedInvoiceReview?.preparation || null;
      // The editable field is the submitted amount. Never substitute a stale
      // review's proposed amount or silently change Finance's selection.
      const effectiveInvoiceCreateAmount = options.invoiceAmount ?? invoiceCreateAmount;
      const effectiveInvoiceRole = isManualAdditionalSubmit
        ? 'partial'
        : options.role || (isSalesOrderComposerSubmit ? invoiceCreateAssessment.role : 'full');
      const requestedInvoiceCreateMode = options.invoiceMode ?? invoiceCreateMode;
      const effectiveInvoiceCreateMode = isManualAdditionalSubmit
        ? 'manual'
        : visibleCreateInvoiceModeOptions.some((option) => option.id === requestedInvoiceCreateMode)
          ? requestedInvoiceCreateMode
          : visibleCreateInvoiceModeOptions[0]?.id;
      if (!effectiveInvoiceCreateMode) {
        toast.error("No invoice creation option is enabled.");
        return;
      }
      const effectiveSendEmailNow = isManualAdditionalSubmit ? false : (options.sendEmailNow ?? sendInvoiceEmailNow);
      const effectiveQboQueueOnCreate = isManualAdditionalSubmit ? false : (options.qboQueueOnCreate ?? queueInvoiceForQuickBooks);
      let parsedInvoiceAmount = Number(effectiveInvoiceCreateAmount);
      if (!Number.isFinite(parsedInvoiceAmount) || parsedInvoiceAmount <= 0) {
        toast.error("Enter an invoice amount greater than 0.");
        return;
      }
      const shouldSendEmailNow = Boolean(effectiveSendEmailNow);
      const to = toEmailIds(invoiceEmailValue.to);
      const ccRaw = toEmailIds(invoiceEmailValue.cc);
      const bccRaw = toEmailIds(invoiceEmailValue.bcc);
      const cc = ccRaw.filter((email) => !to.includes(email));
      const bcc = bccRaw.filter((email) => !to.includes(email) && !cc.includes(email));

      if (shouldSendEmailNow && !to.length) {
        toast.error("Choose at least one recipient in 'To'.");
        return;
      }


      // Exactly the same saved Sales Order used by the preview and
      // informational address pre-check.
      const targetedSalesOrder = invoiceCreationSourceSO;
      const targetedSalesOrderId = targetedSalesOrder?.id || null;
      const targetedSalesOrderDocumentId = targetedSalesOrder?.estimationId || null;

      if (!targetedSalesOrderDocumentId && !targetedSalesOrderId) {
        throw new Error("No approved Sales Order is available to create an invoicing cart.");
      }

      invoiceCreateSubmissionRef.current = true;
      setInvoiceEmailSending(true);

      if (!preparation?.preparationToken) {
        const resolvedReview = await resolveInvoiceCreationPreparation({
          reviewEnabled: enableInvoiceCreationReview,
          preparedReview: preparedInvoiceReview,
          orderId,
          request: {
            instanceUniqueId,
            salesOrderId: targetedSalesOrderDocumentId || targetedSalesOrderId,
            invoiceRole: effectiveInvoiceRole,
            invoiceMode: effectiveInvoiceCreateMode,
            invoiceAmount: parsedInvoiceAmount,
            ...(isManualAdditionalSubmit ? {
              manualAdditionalInvoice: true,
              manualAdditionalReason: manualAdditionalReason.trim(),
              confirmAdditionalInvoice: true,
              sendEmailNow: false, qboQueueOnCreate: false,
            } : {}),
            deriveTermsTaxesFrom: 'customer',
          },
        });
        preparation = resolvedReview?.preparation || null;
        const preparedAmountCents = Math.round(Number(resolvedReview?.payments?.proposedInvoiceAmount) * 100);
        if (!Number.isSafeInteger(preparedAmountCents) ||
            preparedAmountCents !== Math.round(parsedInvoiceAmount * 100)) {
          throw new Error('Invoice preparation did not preserve your selected amount. Review the remaining balance and try again.');
        }
      }
      // Preview and creation must use exactly the amount chosen by Finance.
      // The preparation service caps over-limit requests; never silently bill
      // a different amount or reuse a token for another requested amount.
      const reviewedAmountCents = Math.round(Number(
        options.invoiceAmount != null
          ? options.invoiceAmount
          : preparedInvoiceReview?.payments?.proposedInvoiceAmount ?? parsedInvoiceAmount
      ) * 100);
      if (!Number.isSafeInteger(reviewedAmountCents) ||
          reviewedAmountCents !== Math.round(parsedInvoiceAmount * 100)) {
        throw new Error('Prepared invoice amount differs from your selected amount. Refresh the review before creating.');
      }
      if (!preparation?.preparationToken) {
        throw new Error("Invoice preparation did not validate the Sales Order snapshot.");
      }

      console.log("[invoice-create Path A] posting createInvoice", {
        orderId,
        sourceSalesOrderDocumentId: targetedSalesOrderDocumentId,
        invoiceAmount: parsedInvoiceAmount,
      });
      const response = await createInvoice(orderId, {
        instanceUniqueId,
        salesOrderId: targetedSalesOrderDocumentId || targetedSalesOrderId || null,
        role: effectiveInvoiceRole,
        sendEmailNow: shouldSendEmailNow,
        qboQueueOnCreate: effectiveQboQueueOnCreate,
        invoiceMode: effectiveInvoiceCreateMode,
        invoiceAmount: parsedInvoiceAmount,
        ...(isManualAdditionalSubmit ? {
          manualAdditionalInvoice: true,
          manualAdditionalReason: manualAdditionalReason.trim(),
          confirmAdditionalInvoice: true,
        } : {}),
        // The server creates the invoicing cart after it creates the invoice.
        preparationRevision: preparation?.revisionNumber || null,
        preparationToken: preparation?.preparationToken || null,
        deriveTermsTaxesFrom: "customer",
        ...(shouldSendEmailNow ? {
          email: {
            to,
            cc,
            bcc,
            subject: invoiceEmailValue.subject,
            body: invoiceEmailValue.body,
            templateId: invoiceEmailValue.templateId || null,
            layout: invoiceEmailValue.layout || 'plain',
          },
        } : {}),
      })
      
      const newInvoiceCartKey = response?.data?.invoicingCartKey || response?.invoicingCartKey || null;
      if (!newInvoiceCartKey) throw new Error("Invoice was created but its Invoicing Cart link was not returned.");
      setSelectedInvoicingCartKey(newInvoiceCartKey);
      await loadInvoicingCarts();
      await loadSelectedInvoicingCart(newInvoiceCartKey);
      toast.success(isManualAdditionalSubmit
        ? "Additional manual invoice created. Review and update its cart before sending."
        : "Invoice created successfully!");
      setInvoiceComposerOpen(false);
      setInvoiceCreateAmount("");
      history.push(`/instance/${instanceUniqueId}/sales/orders/${orderId}/invoice`);
      return response.data
    } catch (error) {
      console.log("Unable to create Invoice", error)
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Unable to create Invoice!";
      // The Finance /invoice view has its own catch/toast. Propagate errors
      // so it cannot report "Invoice created" when this shared handler failed.
      if (options.invoiceAmount != null) throw error;
      toast.error(backendMessage);
    } finally {
      invoiceCreateSubmissionRef.current = false;
      setInvoiceEmailSending(false);
    }
  }

  const closeSalesOrderInvoiceComposer = () => {
    // A submitted invoice may still be in the preparation/create chain.
    if (invoiceEmailSending || invoiceCreateSubmissionRef.current) return;
    setInvoiceComposerOpen(false);
    setInvoiceComposerPreparing(false);
    setPreparedInvoiceReview(null);
    setInvoiceCreateAmount('');
    setManualAdditionalInvoice(false);
    setManualAdditionalReason('');
    setConfirmAdditionalInvoice(false);
    setSendInvoiceEmailNow(false);
    setQueueInvoiceForQuickBooks(defaultQboQueueOnCreate);
    setInvoiceCreateMode(resolveDefaultCreateInvoiceMode());
  };

  // This Sales Order route has its own Create Invoice dialog. Share the
  // administrator reset service with Finance's Invoice tab, not its UI state.
  const handleOpenSalesOrderReset = async () => {
    if (!isAdministrator || !salesOrderResetAccessAllowed || invoiceEmailSending) return;
    setSalesOrderResetOpen(true);
    setSalesOrderResetPreview(null);
    setSalesOrderResetReason('');
    setSalesOrderResetAcknowledged(false);
    setSalesOrderResetError('');
    setSalesOrderResetLoading(true);
    try {
      setSalesOrderResetPreview(await previewResetInvoiced({ orderId, instanceUniqueId }));
    } catch (error) {
      setSalesOrderResetError(error?.response?.data?.message || 'Could not check the invoice reset.');
    } finally {
      setSalesOrderResetLoading(false);
    }
  };

  const handleConfirmSalesOrderReset = async () => {
    if (!isAdministrator || !salesOrderResetAccessAllowed ||
        !salesOrderResetPreview?.canReset || salesOrderResetSubmitting ||
        !salesOrderResetAcknowledged || salesOrderResetReason.trim().length < 8) return;
    setSalesOrderResetSubmitting(true);
    setSalesOrderResetError('');
    try {
      const result = await confirmResetInvoiced({
        orderId, instanceUniqueId,
        invoiceId: salesOrderResetPreview.invoiceId,
        reason: salesOrderResetReason.trim(),
        acknowledgeCustomerNotice: salesOrderResetAcknowledged,
      });
      toast.success(`Invoice #${result.voidedInvoiceId} reset. All deposit invoices remain unchanged.`);
      setSalesOrderResetOpen(false);
      setInvoiceComposerOpen(false);
      // The project and the current Sales Order have both changed status.
      // Reload this uncommon admin workflow instead of keeping stale
      // navigation, order header, Sales Order, and finance drawer state.
      window.location.reload();
    } catch (error) {
      setSalesOrderResetError(error?.response?.data?.message || 'Unable to reset invoicing. No changes were applied.');
      setSalesOrderResetPreview(null); // A stale preview cannot be submitted again.
    } finally {
      setSalesOrderResetSubmitting(false);
    }
  };

  const handleSearch = async (page = 1) => {
    setLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/get-orders`, {
        params: { q: query, page: page, rpp: 10 }
      });
      setOrder(response.data.Results || {});
      setTotalPages(response.data.TotalPages || 1);
      setCurrentPage(page);
      setError('');
    } catch (error) {
      setError('An error occurred while fetching orders.');
    } finally {
      setLoading(false);
    }
  };

  const [noteFilterUser, setNoteFilterUser] = useState('all');
  const [noteSortAsc, setNoteSortAsc] = useState(false); // false = newest first

  // sort with pinned first, then newest→oldest
  const displayNotes = React.useMemo(() => {
    // 1) filter
    let list = Array.isArray(allNotes) ? [...allNotes] : [];

    if (!showCartChanges) {
      list = list.filter((note) => !CART_CHANGE_NOTE_ACTIONS.has(String(note?.action || "")));
    }
  
    if (noteFilterUser !== 'all') {
     list = list.filter(n => {
       // direct id match
       if (n.userId != null && String(n.userId) === String(noteFilterUser)) return true;
       // name-only option selected? match by note userName
       if (String(noteFilterUser).startsWith('name:')) {
         const target = String(noteFilterUser).slice(5).trim().toLowerCase();
         return (n.userName || '').trim().toLowerCase() === target;
       }
       // final fallback: match by full name from availableUsers
       const chosen = (availableUsers || []).find(u => String(u.id) === String(noteFilterUser));
       const chosenName = `${chosen?.first_name || ''} ${chosen?.last_name || ''}`.trim().toLowerCase();
       const noteName = `${n.userName || ''}`.trim().toLowerCase();
       return !!chosenName && chosenName === noteName;
     });
    }
  
    // 2) pin first, then by timestamp asc/desc
    return list.sort((a, b) => {
      const pa = a.pinned ? 1 : 0;
      const pb = b.pinned ? 1 : 0;
      if (pb !== pa) return pb - pa; // pinned at top
  
      const ta = new Date(a.timestamp || 0).getTime();
      const tb = new Date(b.timestamp || 0).getTime();
      return noteSortAsc ? (ta - tb) : (tb - ta);
    });
  }, [allNotes, noteFilterUser, noteSortAsc, availableUsers, showCartChanges]);
    
  const totalNotes = displayNotes.length;
  const notesTotalPages = Math.max(1, Math.ceil(totalNotes / NOTES_PAGE_SIZE));
  const pageStartIdx = infiniteNotesEnabled ? 0 : (notesPage - 1) * NOTES_PAGE_SIZE;
  const pageEndIdx = Math.min(
    totalNotes,
    infiniteNotesEnabled ? notesPage * NOTES_PAGE_SIZE : pageStartIdx + NOTES_PAGE_SIZE
  );
  const paginatedNotes = displayNotes.slice(pageStartIdx, pageEndIdx);
  const hasMoreProjectNotes = pageEndIdx < totalNotes;
  const isManualProjectNote = (note) => {
    const action = String(note?.action || "").toLowerCase();
    const noteType = String(note?.noteType || "").toLowerCase();
    if (noteType === "manual") return true;
    return action === "written-project-note" || action === "purchasing-note" || action === "order-note";
  };
  const threadedPaginatedNotes = React.useMemo(() => {
    const nodes = (paginatedNotes || []).map((n) => ({
      ...n,
      __id: String(n?.sequence || n?.id || ""),
      __parent: String(n?.parentSequence || ""),
    }));
    const byParent = new Map();
    nodes.forEach((n) => {
      const key = n.__parent || "__root__";
      if (!byParent.has(key)) byParent.set(key, []);
      byParent.get(key).push(n);
    });
    const build = (key) => (byParent.get(key) || []).map((n) => ({ ...n, children: build(n.__id) }));
    return build("__root__");
  }, [paginatedNotes]);

  useEffect(() => {
    if (!orderId) return;
    const id = String(orderId);
  
    socket.emit("joinOrder", { orderId: id }, (res) => {
      console.log("joinOrder ack:", res); // expect { ok:true, room:'order_...' }
      if (!res?.ok) console.warn("joinOrder failed:", res?.reason);
    });
  
    const onTimeline = (item) => {
      if (String(item?.orderId) !== String(orderId)) return;

      if (item?.kind === "chat") {
        const first = String(item?.user?.first_name || "").trim();
        const last = String(item?.user?.last_name || "").trim();
        const fullName = `${first} ${last}`.trim();
        setChatLastAt(item.createdAt || new Date().toISOString());
        setChatLastBy(fullName || null);
        setLastMessageId(item.id || item.createdAt || null);
        return;
      }

      if (item?.kind === "note") {
        const first = String(item?.user?.first_name || "").trim();
        const last = String(item?.user?.last_name || "").trim();
        const fullName = `${first} ${last}`.trim();
        const timelineNote = {
          id: item.id,
          sequence: item.sequence,
          action: item.action || "written-project-note",
          message: item.rawHtml || item.message, // you render HTML already
          timestamp: item.createdAt,
          userName: fullName || "User",
          userAvatarUrl: item?.user?.profilePicture || null,
          attachments: item.attachments,
        };
        if (Number(timelineNote.sequence)) {
          setAllNotes((prev) => upsertProjectNote(prev, timelineNote));
        }
      }
    };
  
    socket.off("order:timeline:new", onTimeline); // de-dup
    socket.on("order:timeline:new", onTimeline);

    const onOrderStatusUpdated = (payload) => {
      if (String(payload?.orderId) !== String(orderId)) return;
      fetchOrder({ suppressLoader: true });
    };
    socket.off("order:status:updated", onOrderStatusUpdated);
    socket.on("order:status:updated", onOrderStatusUpdated);
  
    return () => {
      socket.emit("leaveOrder", { orderId: id });
      socket.off("order:timeline:new", onTimeline);
      socket.off("order:status:updated", onOrderStatusUpdated);
    };
  }, [orderId]);  

  useEffect(() => {
    const timer = setInterval(() => {
      setChatNowTick(Date.now());
    }, 30 * 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (!orderId) return;
  
    let cancelled = false;
    let timer = null;
  
    const fetchLast = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/chat/last-activity`,
          { params: { orderId } }
        );
        if (cancelled) return;
        setChatLastAt(data.lastMessageAt || null);
        setChatLastBy(
          data.lastUser
            ? `${data.lastUser.first_name || ""} ${data.lastUser.last_name || ""}`.trim()
            : null
        );

               // Prefer a true message id from your API; fall back to a composite if needed
               const idFromAPI = data.lastMessageId
                 ?? (data.lastMessageAt || data.lastUser?.id
                     ? `${data.lastMessageAt || ""}::${data.lastUser?.id || ""}`
                    : null);
               setLastMessageId(idFromAPI);

      } catch (_) {
        // ignore – banner will just hide
      }
    };
  
    fetchLast();
    timer = setInterval(fetchLast, 60 * 1000);
  
    return () => { cancelled = true; if (timer) clearInterval(timer); };
  }, [orderId]);  


   useEffect(() => {
       if (!chatLastAt) return;
    
       const ageMs = chatNowTick - new Date(chatLastAt).getTime();
       const idleNow = ageMs >= VISIBLE_WINDOW_MS;
    
       // Reset guard when we see a new message id (start a fresh "session")
       if (lastMessageId && lastMessageId !== lastSeenMessageIdRef.current) {
         lastSeenMessageIdRef.current = lastMessageId;
         wasIdleTriggeredRef.current = false;
       }
    
       if (idleNow && !wasIdleTriggeredRef.current && orderId) {
         wasIdleTriggeredRef.current = true; // prevent duplicates for this session
         axios.post(
           `${process.env.REACT_APP_NODEJS_SERVER_URL}/chat/finalize-digest`,
           { orderId },
           { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
         ).catch(() => { /* best-effort; no UI block */ });
       }
     }, [chatLastAt, chatNowTick, orderId, lastMessageId]);

     // Push overview notes to chat
     const DIGEST_ACTION = "chat-digest";
     const notesForChat = React.useMemo(
       () =>
         (displayNotes || []).filter(n => n.action !== DIGEST_ACTION),
       [displayNotes]
     );



  const checkShippingGate = React.useCallback(async () => {
    if (!orderId) return;
    try {
      setShippingGate(prev => ({ ...prev, loading: prev.totalProducts === 0 }));
      const { data } = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/shipping/has-records/${orderId}`
      );
      const payload = data?.data || {};
      setShippingGate({
        loading: false,
        has: !!payload.has,
        shippingExists: payload.shippingExists ?? !!payload.has,
        shippingComplete: payload.shippingComplete ?? !!payload.has,
        shippingApproved: payload.shippingApproved ?? !!payload.allApproved,
        shippingReady: payload.shippingReady ?? !!payload.allApproved,
        requireShippingConfirmation: payload.requireShippingConfirmation === true,
        totalProducts: payload.totalProducts || 0,
        missingProductIds: payload.missingProductIds || [],
        incompleteProductIds: payload.incompleteProductIds || [],
        allApproved: payload.shippingReady ?? !!payload.allApproved,
        unapprovedProductIds: payload.unapprovedProductIds || [],
        shippingSource: payload.shippingSource || null,
      });
    } catch {
      setShippingGate({
        loading: false,
        has: false,
        shippingExists: false,
        totalProducts: 0,
        missingProductIds: [],
        allApproved: false,
        shippingComplete: false,
        shippingApproved: false,
        shippingReady: false,
        requireShippingConfirmation: false,
        incompleteProductIds: [],
        unapprovedProductIds: [],
        shippingSource: null,
      });
    }
  }, [orderId]);

  const retryShipping = React.useCallback(async () => {
    if (!orderId) return;
    await axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/shipping/retry/${orderId}`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    });
    await checkShippingGate();
  }, [orderId, checkShippingGate]);

  const shippingSourceLabel = shippingGate.shippingSource === 'approved-sales-order'
    ? 'approved Sales Order items'
    : 'active order-cart items';

  useEffect(() => {
    checkShippingGate();
  }, [checkShippingGate]);

  const shippingGateLabelMap = React.useMemo(() => {
    const byOrderItemId = new Map();
    const byProductId = new Map();
    (order?.Products || []).forEach((p) => {
      const orderItemId = String(p?.id ?? "").trim();
      const productId = String(p?.ProductId ?? "").trim();
      const label = p?.Name || productId || orderItemId;
      if (orderItemId) byOrderItemId.set(orderItemId, label);
      if (productId && !byProductId.has(productId)) byProductId.set(productId, label);
    });
    return { byOrderItemId, byProductId };
  }, [order?.Products]);

  const formatShippingGateRefs = React.useCallback((refs = []) => {
    if (!Array.isArray(refs) || refs.length === 0) return "";
    return refs.map((raw) => {
      const key = String(raw ?? "").trim();
      const label =
        shippingGateLabelMap.byOrderItemId.get(key) ||
        shippingGateLabelMap.byProductId.get(key) ||
        key;
      return label;
    }).join(", ");
  }, [shippingGateLabelMap]);

  useEffect(() => {
    async function fetchUsers() {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/byinstanceUniqueId/${instanceUniqueId}`
        );
        setAvailableUsers(response.data.listOfUsers || []);
      } catch (error) {
        alert("Error fetching users");
        console.error("Error fetching users", error);
      }
    }
    fetchUsers();
  }, [instanceUniqueId]);

  useEffect(() => {
    const handleFetchCustomers = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/get-customers`);
        console.log("Customers: " + response.data);
        setCustomers(response.data.customers || []);
        setError('');
      } catch (error) {
        setError('An error occurred while fetching customers.');
      } finally {
        setLoading(false);
      }
    };
    handleFetchCustomers();
  }, []);

  const fetchClientContacts = async (id) => {
    setClientContacts([]);
    if (!id) return;
    try {
      const response = await getClientContacts(id)
      const contacts = response?.data?.clientContacts
      setClientContacts(Array.isArray(contacts) ? contacts : [])
    } catch (error) {
      console.log(error)
      setClientContacts([])
    }
  }

  const loadAttachedCustomer = useCallback(async (customerId) => {
    if (!customerId) {
      setCustomerData(null);
      setAllNotes([]);
      setCustomerDataLoading(false);
      return null;
    }

    setCustomerDataLoading(true);
    try {
      const customerResponse = await getCustomerDetailsForOrder(customerId, orderId);
      const nextCustomer = customerResponse?.customer || null;

      setCustomerData(nextCustomer);
      setAllNotes(Array.isArray(customerResponse?.notes) ? customerResponse.notes : []);

      return nextCustomer;
    } finally {
      setCustomerDataLoading(false);
    }
  }, [orderId]);
  //console.log(selectedPOList, "selectedPOList")

  const requestProofsApi = async (payload) => {
    try {
      if (selectedPOList.length > 0) {
        const response = await requestProofs({ purchaseOrders: selectedPOList })
        toast.success("Proofs requested successfully!");
      }
      console.log(payload)
    } catch (error) {
      toast.error(error?.response?.data?.message || "Proofs requested successfully!");
    }
  }

  
  const normalizeOrderForUi = React.useCallback((rawOrder) => {
    const orderData = rawOrder && typeof rawOrder === "object" ? rawOrder : {};
    const normalizeArray = (value) => (Array.isArray(value) ? value : []);

    const normalizedItems = normalizeArray(orderData.Items).map((item) => {
      const normalizedItem = item && typeof item === "object" ? item : {};
      return {
        ...normalizedItem,
        pricings: normalizeArray(normalizedItem.pricings),
        decorations: normalizeArray(normalizedItem.decorations),
        artworks: normalizeArray(normalizedItem.artworks),
      };
    });

    const normalizedProducts = normalizeArray(orderData.Products).map((item) => {
      const normalizedItem = item && typeof item === "object" ? item : {};
      return {
        ...normalizedItem,
        pricings: normalizeArray(normalizedItem.pricings),
        decorations: normalizeArray(normalizedItem.decorations),
        artworks: normalizeArray(normalizedItem.artworks),
      };
    });

    const canonicalItems = normalizedProducts.length > 0 ? normalizedProducts : normalizedItems;

    return {
      ...orderData,
      AssignedTo: normalizeArray(orderData.AssignedTo),
      Items: canonicalItems,
      Products: canonicalItems,
      OtherServices: normalizeArray(orderData.OtherServices),
    };
  }, []);

  async function fetchOrder({ suppressLoader = false } = {}) {
    if (debugRender) {
      console.log("[InstanceOrderSingle] fetchOrder:start", { orderId, suppressLoader });
    }
    if (!suppressLoader) setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/get-order/${orderId}`
      );

      console.log("############################")
      console.log(JSON.stringify(response.data.order.Products))

      const fetchedOrder = normalizeOrderForUi(response.data.order);
      const fetchedPresentation = response.data.presentation;
      const fetchedSalesOrder = response.data.salesOrder;
      const fetchedPurchaseOrder = response.data.purchaseOrder

      const attachedContactCustomer = fetchedOrder.attachedCustomers?.[0];
      const attachedContactCustomerId = typeof attachedContactCustomer === "object"
        ? attachedContactCustomer?.id
        : attachedContactCustomer;
      fetchClientContacts(attachedContactCustomerId);
      setOrder(fetchedOrder);
      setAssignedUsers(fetchedOrder.AssignedTo);
      setError('');

      // 2) if there’s an attached customer, fetch its full record (includes status)
      const attached = fetchedOrder.attachedCustomers;
      if (attached?.length) {
        // whether your API returns an array of IDs or objects, normalize to an ID:
        const customerId = typeof attached[0] === "object"
          ? attached[0].id
          : attached[0];


        const customer = await loadAttachedCustomer(customerId);
        console.log("Full customer object:", customer);
      } else {
        setCustomerData(null);
        setAllNotes([]);
        setCustomerDataLoading(false);
      }

      // Ensure presentation data is an array for the DataTable.
      // Ensure presentation data is an array and add an `id` property.
      let presentationsArray = [];
      if (fetchedPresentation) {
        presentationsArray = Array.isArray(fetchedPresentation)
          ? fetchedPresentation
          : [fetchedPresentation];
        presentationsArray = presentationsArray.map((presentation) => ({
          ...presentation,
          id: presentation.presentationId, // Add `id` property required by MUI
        }));
      }
      setPresentationData(presentationsArray);

      // Map sales order data to include `id` (from estimationId)
      let salesOrderArray = [];
      if (fetchedSalesOrder) {
        salesOrderArray = Array.isArray(fetchedSalesOrder)
          ? fetchedSalesOrder
          : [fetchedSalesOrder];
        salesOrderArray = salesOrderArray.map((salesOrder) => ({
          ...salesOrder,
          id: salesOrder.estimationId,
        }));
      }
      setSalesOrderData(salesOrderArray);

      const parseMaybeJson = (value, fallback = {}) => {
        if (!value) return fallback;
        if (typeof value === 'string') {
          try {
            return JSON.parse(value);
          } catch (_) {
            return fallback;
          }
        }
        return typeof value === 'object' ? value : fallback;
      };
      const latestSalesOrderByRevision = [...salesOrderArray].sort((a, b) => {
        const revDiff = Number(b?.revisionNumber || 0) - Number(a?.revisionNumber || 0);
        if (revDiff) return revDiff;
        return new Date(b?.updatedAt || 0) - new Date(a?.updatedAt || 0);
      })[0] || null;
      const parsedStamp = parseMaybeJson(latestSalesOrderByRevision?.stampedBookedAmount, {});
      const seededSnapshotPayload =
        parsedStamp?.cartSnapshot?.payload ||
        parsedStamp?.cartSnapshot ||
        null;
      setOrder((prev) => ({
        ...prev,
        SalesOrderData: salesOrderArray,
        ...(seededSnapshotPayload ? { salesOrderCartSnapshot: seededSnapshotPayload } : {}),
      }));

      // Map purchase order data
      const purchaseOrderArray = Array.isArray(fetchedPurchaseOrder)
        ? fetchedPurchaseOrder
        : (fetchedPurchaseOrder ? [fetchedPurchaseOrder] : []);
      // if you need to massage the shape or add an `id` field, do it here:
      // e.g. .map(po => ({ ...po, id: po.purchaseOrderId }))
      setPurchaseOrderData(purchaseOrderArray);

      try {
        const invoices = await fetchInvoicesListByOrder(orderId);
        setOrderInvoices(Array.isArray(invoices) ? invoices : []);
      } catch (_) {
        setOrderInvoices([]);
      }

      try {
        const billsRes = await fetchOrderBills(orderId);
        setOrderBills(Array.isArray(billsRes?.data?.billingData) ? billsRes.data.billingData : []);
      } catch (_) {
        setOrderBills([]);
      }



      setError("");
      if (debugRender) {
        console.log("[InstanceOrderSingle] fetchOrder:success", {
          orderId,
          items: fetchedOrder?.Items?.length || 0,
          products: fetchedOrder?.Products?.length || 0,
          presentationCount: Array.isArray(fetchedPresentation) ? fetchedPresentation.length : (fetchedPresentation ? 1 : 0),
        });
      }
    } catch (error) {
      setError("An error occurred while fetching the order.");
      if (debugRender) {
        console.error("[InstanceOrderSingle] fetchOrder:error", error);
      }
    } finally {
      setOrderHydrated(true);
      if (!suppressLoader) setLoading(false);
      if (debugRender) {
        console.log("[InstanceOrderSingle] fetchOrder:finally", { orderId, suppressLoader });
      }
    }
  }

  const handleProofingResetComplete = useCallback(async () => {
    proofSourceManualOverrideRef.current = false;
    proofSourceAutoDetectionStartedRef.current = false;
    setProofSourceLinkageBanner(null);
    setProofSourceStatusMeta(null);
    setProofMappingSourceType("internal");
    await fetchOrder({ suppressLoader: true });
    await loadRequestArtStatuses();
  }, [fetchOrder, loadRequestArtStatuses]);

  useEffect(() => {
    if (!debugRender) return;
    console.log("[InstanceOrderSingle] render checkpoint", {
      orderId,
      activeTab,
      loading,
      showProductManagerPopup,
      showAddNewProductManager,
      products: order?.Products?.length || 0,
      items: order?.Items?.length || 0,
    });
  }, [debugRender, orderId, activeTab, loading, showProductManagerPopup, showAddNewProductManager, order?.Products?.length, order?.Items?.length]);

  const soStatus = order?.OrderStatus?.SO || "";

  // Has any Sales Order with status code 2 (Agreement) or 3 (Customer Signed)?
  const hasSO2or3 = React.useMemo(
    () => salesOrderData.some(so => ["2","2_sent","3","6","7","8","9",2,3,6,7,8,9].includes(so?.status)),
    [salesOrderData]
  );
  
  // Allow shipping only after client approval (or later)
  const allowShippingNow =
    SO_POST_APPROVAL_STAGES.has(soStatus.trim().toLowerCase());
  
  
    const hasSO3 = React.useMemo(
      () => salesOrderData.some(so => APPROVED_OR_LATER_SO_STATUSES.has(String(so?.status))),
      [salesOrderData]
    );
    const invoiceCount = React.useMemo(() => {
      const summaryCount = Number(order?.invoiceSummary?.count);
      if (Number.isFinite(summaryCount) && summaryCount >= 0) return summaryCount;
      return Array.isArray(orderInvoices) ? orderInvoices.length : 0;
    }, [order?.invoiceSummary?.count, orderInvoices]);
    const hasInvoiceRows = React.useMemo(
      () => invoiceCount > 0,
      [invoiceCount]
    );
    const hasGeneratedPurchaseOrders = React.useMemo(
      () => hasRealGeneratedPurchaseOrders(purchaseOrderData),
      [purchaseOrderData]
    );
    const hasConvertedToPO = createdPO || hasGeneratedPurchaseOrders;
    const perPoProofEvaluationEnabled =
      poProofValidation?.evaluationScope === "purchase_order";
    const remainingPoCandidateCount =
      Number(poProofValidation?.summary?.remainingPurchaseOrderCount) || 0;
    const readyToCreatePoCount =
      Number(poProofValidation?.summary?.readyToCreatePurchaseOrderCount) || 0;
    const blockedPoCandidateCount =
      Number(poProofValidation?.summary?.blockedPurchaseOrderCount) || 0;
    const alreadyGeneratedPoCandidateCount =
      Number(poProofValidation?.summary?.alreadyGeneratedPurchaseOrderCount) || 0;
    const hasGeneratedIncrementalPoCandidates =
      perPoProofEvaluationEnabled && alreadyGeneratedPoCandidateCount > 0;
    const allIncrementalPosComplete =
      perPoProofEvaluationEnabled &&
      poProofValidation?.status === "complete";
    const hasRemainingPurchaseOrders =
      perPoProofEvaluationEnabled && remainingPoCandidateCount > 0;
    const hasBillRows = React.useMemo(
      () => Array.isArray(orderBills) && orderBills.length > 0,
      [orderBills]
    );
  
    const { disabled: disabledTabs, tips: tabTips } = React.useMemo(
      () => getTabGatingBySO(
        soStatus,                     // SO textual stage
        allowShippingNow,             // your existing shipping gate
        hasSO3,                       // your existing "signed" indicator
        order?.OrderStatus?.PO || '', // <-- NEW: the PO stage text
        hasInvoiceRows,
        hasGeneratedPurchaseOrders,
        hasBillRows,
        isFinanceRep
      ),
      [soStatus, allowShippingNow, hasSO3, order?.OrderStatus?.PO, hasInvoiceRows, hasGeneratedPurchaseOrders, hasBillRows, isFinanceRep]
    );

    const tabsToShow = React.useMemo(() => (
      getTabsToShow({
        canSeeCommissions,
        canManageInvoices,
        canViewInvoices,
        invoiceCount,
        customerStatus: customerData?.status,
      })
    ), [
      canSeeCommissions,
      canManageInvoices,
      canViewInvoices,
      invoiceCount,
      customerData?.status,
    ]);

  // console.log(salesOrderArray)


  /*const fetchOrder = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/get-order/${orderId}`
      );
      const fetchedOrder = response.data.order;
      if (response.data?.order?.attachedCustomers && response.data?.order?.attachedCustomers.length > 0) {
        fetchClientContacts(response.data?.order?.attachedCustomers[0])
      }
      setOrder(fetchedOrder);
      // Assume fetchedOrder.OrderStatus is now a JSON object like: {"PO": null, "SO": "processing"}
      setAssignedUsers(fetchedOrder.AssignedTo || []);
      setError('');
    } catch (error) {
      setError('An error occurred while fetching the order.');
    } finally {
      setLoading(false);
    }
  };*/

  const hasCartItems = Array.isArray(order?.Products) && order.Products.length > 0;

  const resolveRegenerateTarget = () => {
    const activeDoc = (salesOrderData || []).find((so) =>
      String(so?.estimationId) === String(tabId) || String(so?.id) === String(tabId)
    );
    const currentStatus = String(activeDoc?.status ?? '');
    const activeEstimationId = tabId || activeDoc?.estimationId || activeDoc?.id;
    if (isEstimateRoute) {
      return { docType: 'estimate', estimationId: activeEstimationId || null, label: 'Estimate' };
    }
    if (isSalesOrderRoute) {
      return { docType: 'sales-order', estimationId: activeEstimationId || null, label: 'Sales Order' };
    }
    if (['1', '1_sent'].includes(currentStatus.toLowerCase())) {
      return { docType: 'estimate', estimationId: activeEstimationId || null, label: 'Estimate' };
    }
    return { docType: 'sales-order', estimationId: activeEstimationId || null, label: 'Sales Order' };
  };

  const handleRegenerateDocFromCart = async (docType, targetId = null, approvalMode = null) => {
    if (!hasCartItems) {
      toast('Cart is empty. Add products before regenerating documents.');
      return;
    }

    const isEstimateOrSalesOrder = docType === 'estimate' || docType === 'sales-order';
    const activeDoc = (salesOrderData || []).find((so) =>
      String(so?.estimationId) === String(targetId || tabId) || String(so?.id) === String(targetId || tabId)
    );
    const currentStatus = Number(String(activeDoc?.status || "").split("_")[0]);
    if (docType === "sales-order" && currentStatus === 3 && !approvalMode) {
      setApprovalRegeneration({ open: true, mode: "reset", docType, targetId });
      return;
    }
    const workflowStage = canonicalizeSoDisplay(order?.OrderStatus?.SO);
    const { isEstimateSentDoc, isAgreementSentDoc } = resolveSentDocumentRegenerationState({
      docType,
      activeDoc,
      workflowStage,
    });

    if (isEstimateSentDoc) {
      if (!confirmSentEstimateRegeneration(true)) return;
    }

    if (isAgreementSentDoc) {
      toast('Regeneration is only available while this document is in draft mode.');
      return;
    }

    const requiresUpfrontPayment = isTruthyLike(
      activeDoc?.requireUpfrontPayment ?? activeDoc?.require_upfront_payment
    );
    const hasAttachedInvoice = Boolean(
      activeDoc?.depositInvoiceId ||
      activeDoc?.deposit_invoice_id ||
      activeDoc?.invoiceId ||
      activeDoc?.invoice_id ||
      activeDoc?.invoiceNumber ||
      activeDoc?.depositAmountSnapshot ||
      activeDoc?.deposit_amount_snapshot
    );
    const hasPaidInvoiceActivity = Array.isArray(orderInvoices) && orderInvoices.some((invoice) => isInvoicePaidStatus(invoice));
    const shouldRefreshUpfrontInvoice =
      isEstimateOrSalesOrder &&
      requiresUpfrontPayment &&
      !hasPaidInvoiceActivity &&
      currentStatus !== 3;

    if (currentStatus !== 3 && isEstimateOrSalesOrder && requiresUpfrontPayment) {
      const shouldProceed = window.confirm(
        hasPaidInvoiceActivity
          ? 'This Sales Order already has a paid invoice. Regenerating will update the Sales Order and related purchasing/billing details, but existing paid invoices will remain unchanged. If the revised total is higher, additional charges or an uninvoiced balance may be displayed later. Continue?'
          : 'This document requires upfront payment. Regenerating will recalculate and refresh the deposit/invoice pricing based on the revised total. Continue?'
      );
      if (!shouldProceed) return;
    }

    if (currentStatus !== 3 && isEstimateOrSalesOrder && hasAttachedInvoice && !hasPaidInvoiceActivity) {
      const shouldProceed = window.confirm(
        'Please note: an attached invoice/deposit will be revised when this document is regenerated. Click OK to continue or Cancel to stop.'
      );
      if (!shouldProceed) return;
    }

    const activeCartView = cartViewRef.current;
    const isSalesOrderWorkspaceRegeneration =
      docType === 'sales-order' && activeCartView === 'sales-order-cart';

    if (isSalesOrderWorkspaceRegeneration) {
      const payloadSource = String(
        cartWorkspace?.cartPayload?.meta?.source ||
        cartWorkspace?.cartPayload?.cartSource ||
        ''
      ).trim().toLowerCase();

      if (payloadSource && payloadSource !== 'sales-order-cart') {
        toast.error('Sales Order Cart regeneration was blocked because the staged cart source is inconsistent. Refresh the Sales Order Cart and try again.');
        return;
      }

      if (!Array.isArray(cartWorkspace?.cartPayload?.Products)) {
        toast.error('Sales Order Cart regeneration was blocked because the staged Sales Order Cart payload is unavailable.');
        return;
      }
    }

    try {
      setActiveRegenerationDocType(docType);
      setDocRegenerationInProgress(true);
      setLoading(true);

      if (!isSalesOrderWorkspaceRegeneration && Array.isArray(order?.Products)) {
        await updateItemsToOrder(order.Products);
      }

      let response;
      const regenerateOptions = {
        ...(docType === 'presentation' && approvalMode && typeof approvalMode.showCatalogueDetails === 'boolean' ? { showCatalogueDetails: approvalMode.showCatalogueDetails } : {}),
        recalculateUpfrontPayment: shouldRefreshUpfrontInvoice,
        reviseAttachedInvoice:
          (currentStatus !== 3 && isEstimateOrSalesOrder && hasAttachedInvoice && !hasPaidInvoiceActivity)
          || shouldRefreshUpfrontInvoice,
        recreateDraftDepositInvoice: shouldRefreshUpfrontInvoice,
        recreateDepositInvoice: shouldRefreshUpfrontInvoice,
        regenerateDepositInvoice: shouldRefreshUpfrontInvoice,
        forceRecreateDepositInvoice: shouldRefreshUpfrontInvoice,
        currency: activeDoc?.currency || undefined,
      };

      if (isSalesOrderWorkspaceRegeneration) {
        console.info('[sales-order-regeneration-client-source]', {
          docType,
          targetId,
          activeCartView,
          payloadSource: cartWorkspace?.cartPayload?.meta?.source || cartWorkspace?.cartPayload?.cartSource || null,
          productCount: Array.isArray(cartWorkspace?.cartPayload?.Products)
            ? cartWorkspace.cartPayload.Products.length
            : null,
          otherServiceCount: Array.isArray(cartWorkspace?.cartPayload?.OtherService)
            ? cartWorkspace.cartPayload.OtherService.length
            : null,
          dirty: cartWorkspace?.dirty === true,
        });
        regenerateOptions.source = 'sales-order-cart';
        regenerateOptions.payload = cartWorkspace?.cartPayload || {};
        regenerateOptions.approvalMode = approvalMode;
        regenerateOptions.regenerateReason = 'pricing-update-from-approved-sales-order-cart';

        if (!cartWorkspace?.dirty) {
          const shouldProceed = window.confirm(
            'No staged Sales Order Cart changes were detected. Regenerate Sales Order anyway?'
          );
          if (!shouldProceed) {
            setDocRegenerationInProgress(false);
            setLoading(false);
            return;
          }
        } else {
          toast('Regenerating Sales Order from staged cart changes...');
        }
      } else if (docType === 'sales-order') {
        regenerateOptions.source = 'order-cart';
        if (approvalMode) regenerateOptions.approvalMode = approvalMode;
        regenerateOptions.regenerateReason = 'regenerate-from-order-cart';
      }

      if (docType === 'presentation') {
        response = await regeneratePresentationFromCart(orderId, targetId, regenerateOptions);
      } else if (docType === 'estimate') {
        response = await regenerateEstimateFromCart(orderId, targetId, regenerateOptions);
      } else {
        response = await regenerateSalesOrderFromCart(orderId, targetId, regenerateOptions);
      }

      if (shouldRefreshUpfrontInvoice) {
        await createInvoice(orderId, {
          instanceUniqueId,
          salesOrderId: docType === 'sales-order' ? (targetId || null) : null,
          role: 'deposit',
          sendEmailNow: false,
          invoiceMode: 'customer_selection',
        });
      }

      setShowActions(false);
      await fetchOrder({ suppressLoader: true });
      if (isSalesOrderWorkspaceRegeneration) {
        cartWorkspace?.resetDirty?.();
        setSalesOrderCartUnlocked(false);
      }

      const refreshedId = response?.document?.estimationId;
      if (isEstimateOrSalesOrder && refreshedId && String(refreshedId) !== String(tabId)) {
        const tabType = docType === 'estimate' ? 'estimation' : 'sales-order';
        history.replace(`/instance/${instanceUniqueId}/sales/orders/${orderId}/${tabType}/${refreshedId}`);
      }

      const completionMessage = isSalesOrderWorkspaceRegeneration
        ? (response?.message || `Sales Order regenerated. Revision ${response?.document?.revisionNumber ?? 'updated'} is now active.`)
        : docType === 'sales-order'
          ? (response?.message || 'Sales regeneration from cart completed')
          : (response?.message || 'Document regenerated from cart.');
      const regenerationToastId = toast.success(
        (toastState) => (
          <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span>{completionMessage}</span>
            <button
              type="button"
              aria-label="Dismiss notification"
              onClick={() => toast.dismiss(toastState.id)}
              style={{
                border: 0,
                background: 'transparent',
                cursor: 'pointer',
                fontSize: 18,
                lineHeight: 1,
                padding: 0,
              }}
            >
              ×
            </button>
          </span>
        ),
        { duration: 4000 }
      );
      // react-hot-toast should auto-dismiss this success message, but regeneration
      // can trigger several state refreshes on this page. Keep a hard cleanup so
      // a stale toast can never remain until the user refreshes the browser.
      window.setTimeout(() => toast.dismiss(regenerationToastId), 5000);
      return true;
    } catch (error) {
      console.error('regenerate from cart failed', error);
      const routingError = getDecorationRoutingError(error);
      if (routingError) {
        console.error('Sales Order decoration routing validation failed', {
          code: error?.response?.data?.code,
          issues: routingError.issues.map(({ orderItemId, decorationId, reason }) => ({ orderItemId, decorationId, reason })),
        });
        setDecorationRoutingError({ open: true, issues: routingError.issues });
        return false;
      }
      toast.error(error?.response?.data?.message || 'Failed to regenerate document from cart.');
      return false;
    } finally {
      setActiveRegenerationDocType(null);
      setDocRegenerationInProgress(false);
      setLoading(false);
    }
  };

  const handleActionsClick = () => {
    if (!showActions && isSalesOrderRoute) {
      // Never flash a stale "Invoice Created" check from an earlier menu open.
      setInvoiceCreatedActionCheck((previous) => ({
        ...previous, verified: false, loading: true, error: false,
      }));
    }
    setShowActions(!showActions);
  };

  const handleRegenerateActiveDoc = async () => {
    const target = resolveRegenerateTarget();
    await handleRegenerateDocFromCart(target.docType, target.estimationId);
  };


  const regenerateActionLabel = (() => {
    const target = resolveRegenerateTarget();
    return `Regenerate ${target.label}`;
  })();
  const activeRegenerateDoc = (salesOrderData || []).find((so) =>
    String(so?.estimationId) === String(tabId) || String(so?.id) === String(tabId)
  );
  const parseLifecycle = (doc) => {
    const raw = doc?.stampedBookedAmount;
    if (!raw) return 'active';
    if (typeof raw === 'string') {
      try { return String(JSON.parse(raw)?.lifecycleStatus || 'Active').toLowerCase(); } catch { return 'active'; }
    }
    return String(raw?.lifecycleStatus || 'Active').toLowerCase();
  };
  const latestActiveSalesOrderDoc = (salesOrderData || [])
    .filter((so) => ['2', '2_sent', '3'].includes(String(so?.status)) && parseLifecycle(so) === 'active')
    .sort((a, b) => new Date(b?.updatedAt || b?.orderDate || 0) - new Date(a?.updatedAt || a?.orderDate || 0))
    [0] || null;
  const isNonLatestSalesOrderRevision =
    ['2', '2_sent', '3'].includes(String(activeRegenerateDoc?.status ?? '')) &&
    latestActiveSalesOrderDoc &&
    String(activeRegenerateDoc?.estimationId || activeRegenerateDoc?.id) !==
      String(latestActiveSalesOrderDoc?.estimationId || latestActiveSalesOrderDoc?.id);
  const activeDocStatusCode = String(activeRegenerateDoc?.status ?? '');
  const activeWorkflowStageRaw = String(order?.OrderStatus?.SO || '').trim().toLowerCase();
  const isEstimateSentActiveDoc =
    activeDocStatusCode === '1' && activeWorkflowStageRaw === 'estimate sent';
  const isSalesOrderSentActiveDoc =
    activeDocStatusCode === '2' && ['agreement sent', 'sales order sent', 'sent for agreement'].includes(activeWorkflowStageRaw);
  const isChangeRequestedActiveDoc = activeDocStatusCode === '4';
  const canRegenerateActiveDoc =
    hasCartItems &&
    !isEstimateSentActiveDoc &&
    !isSalesOrderSentActiveDoc &&
    // A client change request is editable and must not block document regeneration.
    !isNonLatestSalesOrderRevision;
  const regenerateTooltip = !hasCartItems
    ? 'Cart is empty. Add products first.'
    : isNonLatestSalesOrderRevision
      ? 'Only the latest active Sales Order revision can be regenerated.'
    : (isEstimateSentActiveDoc || isSalesOrderSentActiveDoc)
      ? 'Regenerate is disabled after this document has been sent. Use draft mode only.'
      : cartView === 'sales-order-cart'
        ? (effectiveSalesOrderCartUnlocked
          ? 'Applies staged Sales Order Cart changes and creates a new Sales Order revision.'
          : 'Regenerates the current Sales Order Cart snapshot. Unlock is only required to edit the cart.')
      : '';
  useEffect(() => {
    fetchOrder();
  }, [orderId]);

  const customerTermsLabel = resolveCustomerTermsLabel(customerData);
  const customerTermsTooltip = resolveCustomerTermsTooltip(customerData);
  const customerIsCreditHold = resolveCustomerCreditHold(customerData);
  const customerTermsChip = customerTermsLabel ? (
    <Chip
      size="small"
      icon={<ReceiptLongIcon sx={{ fontSize: "13px !important" }} />}
      label={customerTermsLabel}
      sx={{
        fontFamily: '"Nunito"', fontWeight: 600, fontSize: "0.72rem", height: 22,
        ...(customerIsCreditHold
          ? { bgcolor: "#fef2f2", color: "#dc2626", borderColor: "#fca5a5", border: "1px solid" }
          : { bgcolor: "#f8fafc", color: "#475569", border: "1px solid #e2e8f0" }
        ),
      }}
    />
  ) : null;

  const customerReviewGate = React.useMemo(
    () => getCustomerReviewGate(customerData, customerDataLoading),
    [customerData, customerDataLoading]
  );

  const handleRequestCustomerConversion = useCallback(async () => {
    if (!customerData?.id || requestingCustomerConversion) return;

    const confirmed = window.confirm(
      "Request approval to convert this lead to a customer?",
    );
    if (!confirmed) return;

    setRequestingCustomerConversion(true);
    try {
      const response = await requestCustomerConversion(customerData.id);
      await loadAttachedCustomer(customerData.id);
      toast.success(
        response?.data?.message || "Conversion requested — email will be sent.",
      );
    } catch (error) {
      if (error?.response?.status === 409) {
        const refreshedCustomer = await loadAttachedCustomer(customerData.id);
        toast(
          error?.response?.data?.message ||
          (refreshedCustomer?.status === "in-review"
            ? "A customer conversion review is already pending."
            : "A pending client review request already exists for this customer."),
        );
        return;
      }

      toast.error(
        error?.response?.data?.message ||
        "Unable to request customer conversion.",
      );
    } finally {
      setRequestingCustomerConversion(false);
    }
  }, [customerData?.id, loadAttachedCustomer, requestingCustomerConversion]);

  useEffect(() => {
    let mounted = true;
    const loadProjectEmail = async () => {
      try {
        const data = await fetchProjectEmailAddressByOrder(orderId, instanceUniqueId);
        if (mounted) setProjectEmailAddress(data?.projectEmail || "");
      } catch (err) {
        if (mounted) setProjectEmailAddress("");
      }
    };

    if (orderId) loadProjectEmail();
    return () => {
      mounted = false;
    };
  }, [orderId, instanceUniqueId]);

  // Placeholder functions for product handling and field changes
  const handleChange = (field, value) => {
    if (field === 'OrderStatus') {
      // Map "Quote Requested" (case-insensitive) to "Lead"
      const mappedValue = value.toLowerCase() === "quote requested".toLowerCase() ? "Lead" : value;

      // Build a new OrderStatus object based on the current one (or an empty object if not defined)
      let newOrderStatus = { ...(order.OrderStatus || {}), SO: mappedValue };

      // Automatically trigger the PO stage once SO reaches "Ready For Shipping"
      if (mappedValue === "Ready For Shipping" && (!order.OrderStatus || order.OrderStatus.PO === null)) {
        newOrderStatus.PO = "Draft";
      }

      setOrder(prev => ({
        ...prev,
        OrderStatus: newOrderStatus
      }));
    } else {
      setOrder(prev => ({ ...prev, [field]: value }));
    }
  };

  const isPresentationWorkspace = /\/sales\/orders\/[^/]+\/presentation(?:\/|$)/.test(window.location.pathname);
  const [presentationActionsAnchor, setPresentationActionsAnchor] = useState(null);
  // Match recorded sends to the specific presentation, never the project's overall SO stage.
  const presentationEmailHistory = React.useMemo(() => {
    const status = typeof order?.OrderStatus === 'string'
      ? (() => { try { return JSON.parse(order.OrderStatus); } catch (_) { return {}; } })()
      : (order?.OrderStatus || {});
    const lifecycle = (Array.isArray(status?.soLifecycleLog) ? status.soLifecycleLog : [])
      .filter((entry) => entry?.documentType === 'presentation'
        && entry?.documentId != null
        && !entry?.simulated
        && ['crm-email-send', 'crm-email-resend'].includes(entry?.source))
      .map((entry) => ({
        id: String(entry.documentId),
        at: entry.at,
        recipients: entry.recipients || [],
      }));
    // Customer notes from the dedicated send endpoint include the presentation URL.
    // Do not infer delivery from a generic project note or generation-only record.
    const notes = (Array.isArray(allNotes) ? allNotes : [])
      .filter((note) => ['presentation-sent', 'presentation-resent'].includes(note?.action)
        && !note?.simulated && !note?.deletedAt)
      .map((note) => {
        const match = String(note?.message || '').match(/\/presentations\/(\d+)/);
        return match ? { id: match[1], at: note.timestamp || note.createdAt, recipients: note.recipients || [] } : null;
      }).filter(Boolean);
    return [...lifecycle, ...notes];
  }, [order?.OrderStatus, allNotes]);
  const selectedPresentationSend = React.useMemo(() => {
    if (!tabId) return null;
    return presentationEmailHistory
      .filter((entry) => entry.id === String(tabId))
      .sort((a, b) => new Date(b.at || 0) - new Date(a.at || 0))[0] || null;
  }, [presentationEmailHistory, tabId]);
  const presentationEditInputSx = { '& .MuiOutlinedInput-root': { minHeight: 40, borderRadius: '8px', bgcolor: 'background.paper', fontSize: '0.875rem', '& fieldset': { borderColor: 'divider' }, '&:hover fieldset': { borderColor: 'text.disabled' }, '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: '1.5px' } }, '& .MuiInputBase-input': { fontSize: '0.875rem' } };
  const [editPresOpen, setEditPresOpen] = useState(false);
  const [editPresTab, setEditPresTab] = useState('details');
  const [editPresRevisions, setEditPresRevisions] = useState([]);
  const [presentationRevisionMap, setPresentationRevisionMap] = useState({});
  const [presentationRevisionLoading, setPresentationRevisionLoading] = useState(false);
  const [editPresRevisionsLoading, setEditPresRevisionsLoading] = useState(false);
  const [editPresRevisionsError, setEditPresRevisionsError] = useState(false);
  useEffect(() => {
    if (!showPresentationHistory || !orderId || !presentationData?.length) {
      setPresentationRevisionMap({});
      return;
    }
    let cancelled = false;
    setPresentationRevisionLoading(true);
    Promise.all(presentationData.map(async (presentation) => {
      const id = presentation.id ?? presentation.presentationId;
      if (!id) return [null, []];
      try {
        const res = await fetchDocumentSnapshots(orderId, 'presentation', id);
        return [String(id), Array.isArray(res?.snapshots) ? res.snapshots : []];
      } catch (_) {
        return [String(id), []];
      }
    })).then((pairs) => {
      if (!cancelled) setPresentationRevisionMap(Object.fromEntries(pairs.filter(([id]) => id)));
    }).finally(() => { if (!cancelled) setPresentationRevisionLoading(false); });
    return () => { cancelled = true; };
  }, [showPresentationHistory, orderId, presentationData]);

  const [orderSaving, setOrderSaving] = useState(false);
  const [editPresSaving, setEditPresSaving] = useState(false);
  const [editPresRegenerating, setEditPresRegenerating] = useState(false);
  const [editPresLoadingComments, setEditPresLoadingComments] = useState(false);
  const [editPresComments, setEditPresComments] = useState([]);
  
  const [editPresForm, setEditPresForm] = useState({
    id: null,
    hidePrice: false,
    hideProductTotals: true,
    showCatalogueDetails: true,
    introduction: '',
    presentationDate: '',
    currency: 'CAD',
    inhandsDate: '',
    clientContactEmail: '', // optional, if you want to show in dialog header later
  });

  useEffect(() => {
    if (!editPresOpen || editPresTab !== 'history' || !editPresForm.id || !orderId) return;
    let cancelled = false;
    setEditPresRevisionsLoading(true);
    setEditPresRevisionsError(false);
    fetchDocumentSnapshots(orderId, 'presentation', editPresForm.id)
      .then((res) => { if (!cancelled) setEditPresRevisions(Array.isArray(res?.snapshots) ? res.snapshots : []); })
      .catch(() => { if (!cancelled) { setEditPresRevisions([]); setEditPresRevisionsError(true); } })
      .finally(() => { if (!cancelled) setEditPresRevisionsLoading(false); });
    return () => { cancelled = true; };
  }, [editPresOpen, editPresTab, editPresForm.id, orderId]);

  // Consistent colors for each stage
const STATUS_COLORS = {
  SO: {
    'Quote Requested':   '#757575',  // grey
    'Lead':              '#6D4C41',  // brown
    'Presentation Draft':'#3949AB',  // indigo
    'Presentation Sent': '#1E88E5',  // blue
    'Estimate Sent':     '#3949AB',  // indigo
    'Sales Order Ready': '#ff8100',  // orange
    'Client Approved':   '#ff8100',
    'In Production':     '#ab47bc',
    'Shipped':           '#00acc1',
    'Ready to be Invoiced': '#7cb342',
    'Invoiced':          '#2e7d32',
    'Paid':              '#1b5e20',
  },
  PO: {
    'Created':           '#8E24AA',  // purple
    'Submitted':         '#5E35B1',  // deep purple
    'Confirmed':         '#00897B',  // teal
    'Production Scheduled':'#5C6BC0',
    'Production Complete':'#7E57C2', // purple
    'Follow Up':         '#F9A825',  // amber
    'Open':              '#1976D2',  // blue
    'Shipped':           '#0288D1',  // light blue
    'Received':          '#26A69A',  // green teal
    'Partially Received':'#8D6E63', // brown
    'Ready For Billing': '#7CB342',  // light green
    'Closed':            '#546E7A',  // blue grey
    'Billed':            '#FB8C00',  // orange
  },
  GLOBAL: {
    'Open':     '#1976D2',
    'Closed':   '#2E7D32',
  },
};

const getStatusColor = (type, value) =>
  STATUS_COLORS?.[type]?.[String(value || '').trim()] || '#9E9E9E';

const itemSx = (type, value) => {
  const c = getStatusColor(type, value);
  return {
    '& .status-swatch': { width: 10, height: 10, borderRadius: '50%', bgcolor: c, mr: 1 },
    '&.Mui-selected': { backgroundColor: alpha(c, 0.18) },
    '&.Mui-selected:hover': { backgroundColor: alpha(c, 0.26) },
    '&:hover': { backgroundColor: alpha(c, 0.10) },
  };
};

const chipSx = (type, value) => {
  const c = getStatusColor(type, value);
  return {
    bgcolor: alpha(c, 0.10),
    border: `1px solid ${alpha(c, 0.35)}`,
    color: c,
    fontWeight: 600,
  };
};

 // Canonical PO rank (lowest → highest). We advise the lowest present until ALL POs reach the next.
 const PO_RANK = [
   'Created',
   'Open',
   'Follow Up',
   'Submitted',
   'Confirmed',
   'Shipped',
   'Partially Received',
   'Received',
   'Production Scheduled',
   'In Progress',
   'Production Complete',
   'Ready For Billing',
   'Billed',
   'Closed',
 ];

 // Normalize legacy / synonym labels into our canonical PO_RANK
 const normalizePOStatus = (s) => {
   const v = String(s || '').trim().toLowerCase();
   if (!v) return null;
   if (v === 'supplier confirmed') return 'Confirmed';
   if (v === 'shipped from supplier') return 'Shipped';
   if (v === 'confirmed by shipping') return 'Open';
   // already canonical?
   const found = PO_RANK.find(x => x.toLowerCase() === v);
   return found || null;
 };


// ───────────────────────────────────────────
// Unified status options (SO + PO + Global)
// ───────────────────────────────────────────
const UNIFIED_STATUS_OPTIONS = [
  // SO
  { key: 'so-quote', group: 'Sales Order', type: 'SO', value: 'Quote Requested', label: 'SO • Opportunity' },
  { key: 'so-waiting', group: 'Sales Order', type: 'SO', value: 'Waiting', label: 'SO • Waiting' },
  { key: 'so-pres-draft', group: 'Sales Order', type: 'SO', value: 'Presentation Draft', label: 'SO • Presentation Draft' },
  { key: 'so-pres', group: 'Sales Order', type: 'SO', value: 'Presentation Sent', label: 'SO • Presentation' },
  { key: 'so-est-draft', group: 'Sales Order', type: 'SO', value: 'Estimate Draft', label: 'SO • Estimate Draft' },
  { key: 'so-est',  group: 'Sales Order', type: 'SO', value: 'Estimate Sent', label: 'SO • Estimate Sent' },
  { key: 'so-agreement-pending',group: 'Sales Order', type: 'SO', value: 'Agreement Pending', label: 'SO • Agreement Pending' },
  { key: 'so-agreement-sent',group: 'Sales Order', type: 'SO', value: 'Agreement Sent', label: 'SO • Agreement Sent' },
  { key: 'so-client-change-requested',group: 'Sales Order', type: 'SO', value: 'Client Change Requested', label: 'SO • Client Change Requested' },
  { key: 'so-client-approved',group: 'Sales Order', type: 'SO', value: 'Client Approved', label: 'SO • Client Approved' },
  { key: 'so-in-production',group: 'Sales Order', type: 'SO', value: 'In Production', label: 'SO • In Production' },
  { key: 'so-shipped',group: 'Sales Order', type: 'SO', value: 'Shipped', label: 'SO • Shipped' },
  { key: 'so-ready-to-be-invoiced',group: 'Sales Order', type: 'SO', value: 'Ready to be Invoiced', label: 'SO • Ready to be Invoiced' },
  { key: 'so-invoiced',group: 'Sales Order', type: 'SO', value: 'Invoiced', label: 'SO • Invoiced' },
  { key: 'so-paid',group: 'Sales Order', type: 'SO', value: 'Paid', label: 'SO • Paid' },
  { key: 'so-closed',group: 'Sales Order', type: 'SO', value: 'Closed', label: 'SO • Closed' },

  // PO (per your list)
  { key: 'po-created',     group: 'Purchase Order', type: 'PO', value: 'Created',            label: 'PO • Created' },
  { key: 'po-open',        group: 'Purchase Order', type: 'PO', value: 'Open',               label: 'PO • Open' },
  { key: 'po-followup',    group: 'Purchase Order', type: 'PO', value: 'Follow Up',          label: 'PO • Follow Up' },
  { key: 'po-submitted',   group: 'Purchase Order', type: 'PO', value: 'Submitted',          label: 'PO • Submitted' },
  { key: 'po-confirmed',   group: 'Purchase Order', type: 'PO', value: 'Confirmed',          label: 'PO • Confirmed' }, // aka Supplier Confirmed
  { key: 'po-shipped',     group: 'Purchase Order', type: 'PO', value: 'Shipped',            label: 'PO • Shipped' }, // aka Shipped From Supplier
  { key: 'po-partially-received', group: 'Purchase Order', type: 'PO', value: 'Partially Received', label: 'PO • Partially Received' },
  { key: 'po-received',    group: 'Purchase Order', type: 'PO', value: 'Received',           label: 'PO • Received' },
  { key: 'po-production-scheduled', group: 'Purchase Order', type: 'PO', value: 'Production Scheduled', label: 'PO • Production Scheduled' },
  { key: 'po-in-progress', group: 'Purchase Order', type: 'PO', value: 'In Progress', label: 'PO • In Progress' },
  { key: 'po-production-complete', group: 'Purchase Order', type: 'PO', value: 'Production Complete', label: 'PO • Production Complete' },
  { key: 'po-rfb',         group: 'Purchase Order', type: 'PO', value: 'Ready For Billing',  label: 'PO • Ready For Billing' },
  { key: 'po-billed',      group: 'Purchase Order', type: 'PO', value: 'Billed',             label: 'PO • Billed' },
  { key: 'po-closed',      group: 'Purchase Order', type: 'PO', value: 'Closed',             label: 'PO • Closed' },

  // Global (optional: applies to both)
  //{ key: 'g-onhold', group: 'Global', type: 'GLOBAL', value: 'On-hold',  label: 'Global • On-hold' },
  { key: 'g-open',   group: 'Global', type: 'GLOBAL', value: 'Open',     label: 'Project • Open' },
  { key: 'g-closed', group: 'Global', type: 'GLOBAL', value: 'Closed',   label: 'Project • Closed' },
  //{ key: 'g-refund', group: 'Global', type: 'GLOBAL', value: 'Refunded', label: 'Global • Refunded' },
];

const manualSalesOrderStatusOptions = filterManualSalesOrderStatusOptions(UNIFIED_STATUS_OPTIONS, roleSet);
const canManuallyManageProjectStage = isAdministrator || manualSalesOrderStatusOptions.length > 0;

const LEGACY_SO_DISPLAY_MAP = {
  'presentation': 'Presentation Draft',
  'sent for agreement': 'Agreement Pending',
  'rejected': 'Client Change Requested',
  'changes requested': 'Client Change Requested',
  'completed': 'Client Approved',
  'sales order ready': 'Client Approved',
  'customer signed': 'Client Approved',
  'ready to be invoiced': 'Ready to be Invoiced',
  'paid': 'Paid',
};

const canonicalizeSoDisplay = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return raw;
  const mapped = LEGACY_SO_DISPLAY_MAP[raw.toLowerCase()];
  return mapped || raw;
};

const renderStatusChips = (so, po, getLabel) => {
  const soCanonical = canonicalizeSoDisplay(so);
  const soLabel = soCanonical ? getLabel("SO", soCanonical) : "—";
  const poLabel = po ? getLabel("PO", po) : "—";
  return (
    <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
      <Chip size="small" label={`SO: ${soLabel}`} sx={chipSx('SO', soCanonical)} />
      <Chip size="small" label={`PO: ${poLabel}`} sx={chipSx('PO', po)} />
    </Stack>
  );
};
  
  // helper
  const handleEditPresChange = (field, value) =>
    setEditPresForm((s) => ({ ...s, [field]: value }));
  
  // open + prefill + fetch comments
  const openEditPresentation = async (row) => {
    const rawInHands = row.inhandsDate || row.inHandsDate || row.in_hands_date || null;
    const rawMeta = row.snapshotMeta;
    let meta = rawMeta && typeof rawMeta === 'object' ? rawMeta : {};
    if (typeof rawMeta === 'string') {
      try { meta = JSON.parse(rawMeta) || {}; } catch (_) { meta = {}; }
    }

    setEditPresForm({
      id: row.id,
      hidePrice: !!(row.hidePrice ?? row.hide_price),
      // The project endpoint stores this choice inside snapshotMeta, not at the top level.
      hideProductTotals: typeof row.hideProductTotals === 'boolean'
        ? row.hideProductTotals
        : meta.hideProductTotals !== false,
      showCatalogueDetails: typeof row.showCatalogueDetails === 'boolean'
        ? row.showCatalogueDetails
        : meta.showCatalogueDetails !== false,
      introduction: row.introduction || '',
      presentationDate: toDateInput(row.presentationDate),
      currency: row.currency || 'CAD',
      inhandsDate: toDateInput(rawInHands),
      clientContactEmail: row.clientContactEmail || row.client_email || '',
    });
  
    setEditPresComments([]);
    setEditPresTab('details');
    setEditPresRevisions([]);
    setEditPresOpen(true);
  
    try {
      setEditPresLoadingComments(true);
      const comments = await loadPresentationComments(row.id);
      setEditPresComments(comments);
    } finally {
      setEditPresLoadingComments(false);
    }
  };
  

  useEffect(() => {
    if (!isPresentationWorkspace || !showPresentationHistory || !presentationData.length) return;
    const selected = tabId
      ? presentationData.find((p) => String(p.id ?? p.presentationId) === String(tabId))
      : presentationData[0];
    if (!selected) return; // Never silently display another presentation for an invalid ID.
    const selectedId = String(selected.id ?? selected.presentationId);
    if (!tabId) {
      if (presentationData.length === 1) history.replace(`/instance/${instanceUniqueId}/sales/orders/${orderId}/presentation/${selectedId}`);
      return; // Multiple presentations belong in the project-level selection table.
    }
    if (String(editPresForm.id) !== selectedId) openEditPresentation(selected);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPresentationWorkspace, showPresentationHistory, presentationData, tabId, editPresForm.id, history, instanceUniqueId, orderId]);

  const savePresentationEdits = async () => {
    try {
      setEditPresSaving(true);
      const { data } = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/presentation/${editPresForm.id}`,
        {
          hidePrice: editPresForm.hidePrice ? 1 : 0,
          hideProductTotals: editPresForm.hideProductTotals,
          presentationDate: editPresForm.presentationDate,
          clientContactEmail: editPresForm.clientContactEmail,
          currency: editPresForm.currency,
          introduction: editPresForm.introduction,
          inhandsDate: editPresForm.inhandsDate || null,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );
  
      console.log("PUT ok:", data);
  
      setPresentationData(prev =>
        prev.map(p =>
          String(p.id) === String(editPresForm.id)
            ? { ...p,
                hidePrice: editPresForm.hidePrice ? 1 : 0,
                hideProductTotals: editPresForm.hideProductTotals,
                presentationDate: editPresForm.presentationDate,
                clientContactEmail: editPresForm.clientContactEmail,
                currency: editPresForm.currency,
                introduction: editPresForm.introduction,
                inhandsDate: editPresForm.inhandsDate
              }
            : p
        )
      );
  
      toast.success(data?.message || 'Presentation updated');
      if (!isPresentationWorkspace) setEditPresOpen(false);
    } catch (e) {
      console.error("PUT failed:", e?.response?.status, e?.response?.data, e);
      toast.error(e?.response?.data?.message || 'Failed to update presentation');
    } finally {
      setEditPresSaving(false);
    }
  };

  const regenerateEditedPresentation = async () => {
    if (!editPresForm.id) return;
    try {
      setEditPresRegenerating(true);
      await handleRegenerateDocFromCart('presentation', editPresForm.id, { showCatalogueDetails: editPresForm.showCatalogueDetails });
    } finally {
      setEditPresRegenerating(false);
    }
  };
  
  
// Normalize various shapes to an array
const asArray = (x) => (
  Array.isArray(x) ? x :
  Array.isArray(x?.comments) ? x.comments :
  Array.isArray(x?.data) ? x.data :
  []
);

const loadPresentationComments = async (presentationId) => {
  if (!presentationId) return [];

  // 1) Prefer product list from the presentation itself
  let productList = [];
  try {
    const pres = await svcFetchPresentationDetails(presentationId);
    const details = pres?.presentation || pres;
    productList = Array.isArray(details?.productDetails) ? details.productDetails : [];
  } catch (_) {
    // ignore; we'll fallback to order.Products below
  }

  // 2) Fallback to products on the order if needed
  if (productList.length === 0 && Array.isArray(order?.Products)) {
    productList = order.Products;
  }

  // 3) Build unique {id, name}
  const getId = (p) => p?.ProductId ?? p?.Id ?? p?.id;
  const getName = (p) => p?.Name ?? p?.name ?? `Product ${getId(p) ?? ""}`;
  const uniqueProducts = [...new Map(
    productList
      .map((p) => [getId(p), { id: getId(p), name: getName(p) }])
      .filter(([pid]) => !!pid)
  ).values()];

  if (uniqueProducts.length === 0) return [];

  // 4) Fetch each thread via your existing service
  const results = await Promise.allSettled(
    uniqueProducts.map(async ({ id: productId, name: productName }) => {
      const raw = await svcGetProductComments(presentationId, productId);
      const list = asArray(raw);
      return list.map((c) => ({
        id: c.id || c.commentId || c._id || `${presentationId}-${productId}-${Math.random().toString(36).slice(2)}`,
        productId,
        productName,
        authorName: c.authorName || c.userName || c.author || c.user?.name || "User",
        message: c.comment || c.message || c.text || "",
        timestamp: c.timestamp || c.createdAt || c.created_at || c.date || null,
      }));
    })
  );

  // 5) Merge + sort by newest
  const merged = results.flatMap((r) => (r.status === "fulfilled" ? r.value : []));
  merged.sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0));
  return merged;
};

 const assignedUsersDetailed = React.useMemo(() => {
     const base = Array.isArray(assignedUsers) ? assignedUsers : [];
     return base.map(u => {
       const full = (availableUsers || []).find(au => String(au.id) === String(u.id));
       return { ...u, ...(full || {}) };
     });
  }, [assignedUsers, availableUsers]);

 const normalizedMentionUsers = React.useMemo(() => {
     const seen = new Set();
     return (availableUsers || [])
       .map(normalizeMentionUser)
       .filter((user) => {
         if (!user.id || !user.display) return false;
         if (seen.has(user.id)) return false;
         seen.add(user.id);
         return true;
       });
  }, [availableUsers]);

 const normalizedAssignedMentionUsers = React.useMemo(() => {
     const seen = new Set();
     return (assignedUsersDetailed || [])
       .map(normalizeMentionUser)
       .filter((user) => {
         if (!user.id || !user.display) return false;
         if (seen.has(user.id)) return false;
         seen.add(user.id);
         return true;
       });
  }, [assignedUsersDetailed]);

 const projectMentionUsers = React.useMemo(() => {
     const assigned = normalizedAssignedMentionUsers.map((u) => ({
       id: u.id,
       display: u.display,
     }));
     const others = normalizedMentionUsers
       .filter((u) => !normalizedAssignedMentionUsers.some((au) => au.id === u.id))
       .map((u) => ({
         id: u.id,
         display: u.display,
       }));
     return [...assigned, ...others];
  }, [normalizedAssignedMentionUsers, normalizedMentionUsers]);

 const isAssignedMentionUser = useCallback(
   (userId) => normalizedAssignedMentionUsers.some((u) => String(u.id) === String(userId)),
   [normalizedAssignedMentionUsers]
 );

  const handleEditProduct = (updatedProduct) => {
    const productLineKey = (p) =>
      String(p?.orderItemId ?? p?.OrderItemId ?? p?.lineId ?? p?.ProductId ?? p?.Id ?? p?.id ?? "");
    // Set the current product state to the product's ID
    setCurrentProduct(updatedProduct);

    applyCartLineMutation((lines) => lines.map((prod) =>
      productLineKey(prod) === productLineKey(updatedProduct)
        ? updatedProduct
        : prod
    ));


    setPopupInitialView("edit")
    // For demonstration, you can alert the current product ID
    setShowProductManagerPopup(true)
  };

  const handleRemoveProduct = (index) => {
    applyCartLineMutation((lines) => {
      const updatedProducts = [...lines];
      updatedProducts.splice(index, 1);
      return updatedProducts;
    });
  };

  const handleAddProduct = () => {
    if (isSalesOrderCartView && !effectiveSalesOrderCartUnlocked) {
      toast("Sales Order Cart is read-only.");
      return;
    }
    setShowAddNewProductManager(true);
    setPopupInitialView("addprod")
  };

  const handleQuantityChange = (product, newQuantity) => {
    const productLineKey = (p) =>
      String(p?.orderItemId ?? p?.OrderItemId ?? p?.lineId ?? p?.ProductId ?? p?.Id ?? p?.id ?? "");
    applyCartLineMutation((lines) => lines.map((prod) =>
        productLineKey(prod) === productLineKey(product)
          ? { ...prod, Quantity: parseInt(newQuantity, 10) }
          : prod
    ));
  };

  // Generate Purchase Orders button logic
  const handleGeneratePO = async () => {
    const conversionComplete = perPoProofEvaluationEnabled
      ? allIncrementalPosComplete
      : (createdPO || hasGeneratedPurchaseOrders);
    if (!tryBeginConvertToPo(
      poConversionInFlightRef,
      conversionComplete,
      { allowAdditionalGeneration: perPoProofEvaluationEnabled }
    )) {
      return;
    }

    if (!isSOCompleted) {
      poConversionInFlightRef.current = false;
      toast.error("Sales order must be Completed before converting to PO.");
      return;
    }
  
    if (shippingGate.loading) {
      poConversionInFlightRef.current = false;
      toast("Still checking shipping records…");
      return;
    }
    if (customerReviewGate.loading) {
      poConversionInFlightRef.current = false;
      toast("Still checking attached customer status…");
      return;
    }
    if (!customerReviewGate.passed) {
      poConversionInFlightRef.current = false;
      toast.error(
        customerReviewGate.tooltipMessage ||
        "Purchase Orders cannot be generated until customer review is complete."
      );
      return;
    }
    if (!perPoProofEvaluationEnabled && !shippingGate.has) {
      poConversionInFlightRef.current = false;
      toast.error(
        shippingGate.totalProducts > 0
          ? `Cannot convert to PO. Missing shipping for product(s): ${formatShippingGateRefs(shippingGate.missingProductIds)}`
          : "Cannot convert to PO. No products found on this order."
      );
      return;
    }
    if (!perPoProofEvaluationEnabled && !shippingGate.allApproved) {
      poConversionInFlightRef.current = false;
      toast.error(
        shippingGate.requireShippingConfirmation
          ? `All shipping must be approved. Unapproved product(s): ${formatShippingGateRefs(shippingGate.unapprovedProductIds)}`
          : `Cannot convert to PO. Incomplete shipping for product(s): ${formatShippingGateRefs(shippingGate.incompleteProductIds?.length ? shippingGate.incompleteProductIds : shippingGate.missingProductIds)}`
      );
      return;
    }
  
    setCreatingPO(true);
    try {
      if (tabId) {
        const response = await createPurchaseOrderApi(tabId);
        const result = response || {};
        if ((Number(result?.summary?.created) || 0) > 0) {
          setCreatedPO(true);
        }
        await fetchOrder({ suppressLoader: true });
        try {
          const validation = await fetchPurchaseOrderProofPreflight(tabId);
          const mode = normalizeProofEnforcementMode(validation?.mode);
          setProofEnforcementMode(mode);
          setPoProofValidation(validation);
          setPoProofReadiness({
            status: normalizeProofReadinessStatus({ mode, validation }),
            error: null,
          });
        } catch (proofError) {
          setPoProofReadiness({
            status: "error",
            error: proofError?.response?.data?.message || "Proof readiness could not be checked.",
          });
        }
        history.push(`/instance/elite-promo-marketing/sales/orders/${orderId}/sales-order/${tabId}`);
        if ((Number(result?.summary?.created) || 0) > 0) {
          toast.success(result?.message || "Purchase Order generated successfully!");
        } else {
          toast(result?.message || "No additional Purchase Orders are ready yet.");
        }
        return result;
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.code === "CUSTOMER_REVIEW_REQUIRED") {
        if (customerData?.id) {
          await loadAttachedCustomer(customerData.id);
        }
        setCreatedPO(false);
        toast.error(
          error?.response?.data?.message ||
          "Purchase Orders cannot be generated until this Lead has been converted to a Customer."
        );
        return;
      }
      if (error?.response?.status === 409) {
        setCreatedPO(true);
        await fetchOrder({ suppressLoader: true });
        toast("Purchase Orders have already been generated for this order.");
        return;
      }
      setCreatedPO(false);
      toast.error(error?.response?.data?.message || "Failed to convert Sales Order to Purchase Orders.");
    } finally {
      poConversionInFlightRef.current = false;
      setCreatingPO(false);
    }
  };

  const handleWorkspaceMutationCommitted = useCallback(async ({
    source,
    mutationType,
    nextPayload,
  }) => {
    const activeSalesOrder = (salesOrderData || []).find((row) =>
      String(row?.estimationId || row?.id) === String(tabId)
    );
    const activeSalesOrderId = activeSalesOrder?.estimationId || activeSalesOrder?.id || tabId;
    try {
      const result = await handleSalesOrderWorkspaceMutationCommitted({
        source,
        mutationType,
        unlocked: effectiveSalesOrderCartUnlocked,
        updateMode: salesOrderSnapshotUpdateMode,
        nextPayload,
        orderId,
        salesOrderId: activeSalesOrderId,
        regenerateSalesOrderFromCart,
        resetDirty: cartWorkspace.resetDirty,
        refreshOrder: fetchOrder,
      });
      if (result.error === "missing-payload") {
        toast.error("Unable to regenerate Sales Order because the edited cart payload was unavailable.");
      } else if (result.regenerated) {
        toast.success("Sales Order saved and regenerated.");
      } else if (result.handled) {
        toast.success("Sales Order Cart changes staged. Use Regenerate Sales Order to apply them.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Failed to regenerate Sales Order.");
    }
  }, [cartWorkspace.resetDirty, fetchOrder, orderId, effectiveSalesOrderCartUnlocked, salesOrderData, salesOrderSnapshotUpdateMode, tabId]);

  const handleSaveProduct = async (updatedProductData) => {
    const productLineKey = (p) =>
      String(p?.orderItemId ?? p?.OrderItemId ?? p?.lineId ?? p?.ProductId ?? p?.Id ?? p?.id ?? "");
    applyCartLineMutation((lines) => lines.map((prod) =>
        productLineKey(prod) === productLineKey(updatedProductData)
          ? { ...prod, ...updatedProductData }
          : prod
    ));
    if (isInvoicingCartView) {
      if (!selectedInvoicingCartKey) {
        toast("Create or select an Invoicing Cart first.");
        return;
      }
      await saveInvoicingCartByKey(orderId, selectedInvoicingCartKey, viewedCartLines);
      await loadSelectedInvoicingCart(selectedInvoicingCartKey);
      await loadInvoicingCarts();
      toast.success("Saved Invoicing Cart — Sales Order remains unchanged.");
      return;
    }
    await handleSaveChanges();
  };
  const updateItemsToOrder = async (products) => {
    if (isSalesOrderCartView) {
      if (!effectiveSalesOrderCartUnlocked) {
        toast("Sales Order Cart is read-only.");
        return { ok: false, reason: "cart-locked" };
      }

      const currentProducts = cartWorkspace?.cartPayload?.Products ?? [];
      const mutationResult = await commitSalesOrderWorkspaceProductListMutation({
        currentProducts,
        nextProducts: products,
        mutationHandlers: cartWorkspace?.mutationHandlers,
        onWorkspaceMutationCommitted: handleWorkspaceMutationCommitted,
      });

      if (!mutationResult?.ok) {
        toast.error("Unable to update the Sales Order Cart product list. Refresh and try again.");
      }
      return mutationResult;
    }

    try {
      const normalizedItems = (products || []).map((p) => ({
        ...p,
        orderItemId:
          p?.orderItemId ??
          p?.OrderItemId ??
          p?.persistedOrderItemId ??
          p?.PersistedOrderItemId ??
          p?.dbItemId ??
          null,
      }));
      if (isInvoicingCartView) {
        if (invoicingCartState?.missing) {
          await cartWorkspace.createFromSalesOrder();
        }
        const addProductToInvoicingCart = cartWorkspace?.mutationHandlers?.addProduct;
        if (typeof addProductToInvoicingCart !== "function") {
          toast("Invoicing Cart workspace is not ready.");
          return;
        }
        normalizedItems.forEach((item) => {
          addProductToInvoicingCart({
            ...item,
            persistedOrderItemId: null,
            PersistedOrderItemId: null,
            orderItemId: null,
            OrderItemId: null,
            dbItemId: null,
            DBItemId: null,
          });
        });
        toast.success("Added to Invoicing Cart workspace. Save to persist snapshot.");
        return;
      }
      if (isSalesOrderCartView) {
        if (!effectiveSalesOrderCartUnlocked) {
          toast("Sales Order Cart is read-only.");
          return;
        }
        const addProductToSalesOrderCart = cartWorkspace?.mutationHandlers?.addProduct;
        if (typeof addProductToSalesOrderCart !== "function") {
          toast("Sales Order Cart workspace is not ready.");
          return;
        }
        normalizedItems.forEach((item) => {
          addProductToSalesOrderCart({
            ...item,
            persistedOrderItemId: null,
            PersistedOrderItemId: null,
            orderItemId: null,
            OrderItemId: null,
            dbItemId: null,
            DBItemId: null,
          });
        });
        toast.success("Added to Sales Order Cart workspace. Regenerate Sales Order to persist changes.");
        return;
      }
      // const formattedAssignedUsers =assignedUsers?.length>0? assignedUsers?.map(({ id, role }) => ({ id, role })):[]
      const payload = {
        customer_name: order.CustomerName,
        email: order.Email,
        phone: order.Phone,
        total: order.Total,
        items: normalizedItems,
        siteURL: order.SiteURL,
        CurrencyCode: normalizeCurrencyCode(order.CurrencyCode || order.currency, "CAD"),
        order_status: order.OrderStatus,
        subStatusId: order?.subStatusId ?? null,
        assigned_to: order.AssignedTo,
        AttachedCustomerId: order?.attachedCustomers?.length > 0 ? order?.attachedCustomers[0] : '',
        clientContactId: order?.clientContactId || null,

      }
      
      const res = await updateProductsToOrder(orderId, payload)
      await fetchOrder()
      console.log(res)
    } catch (error) {
      console.log(error)

    }

  }

  const handleSaveChanges = async () => {
    if (orderSaving) return;
    setOrderSaving(true);
    try {
      if (cartView === "sales-order-cart") {
        const result = await cartWorkspace.save();
        if (result?.ok) {
          toast.success(result?.message || "Sales Order Cart saved.");
        } else {
          toast(result?.message || "Changes are staged. Use Actions → Regenerate Sales Order to apply them.");
        }
        return;
      }
      if (cartView === "invoicing-cart") {
        if (!selectedInvoicingCartKey) {
          toast("Create or select an Invoicing Cart first.");
          return;
        }
        if (!canEditSelectedInvoicingCart) {
          toast(selectedInvoicingCartEditReason || "Selected invoicing cart is read-only.");
          return;
        }
        await cartWorkspace.save();
        await loadSelectedInvoicingCart(selectedInvoicingCartKey);
        await loadInvoicingCarts();
        toast.success("Saved Invoicing Cart — Sales Order remains unchanged.");
        return;
      }
      const formattedAssignedUsers = assignedUsers?.map(({ id, role }) => ({ id, role }));
      await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/edit/${orderId}`,
        {
          customer_name: order.CustomerName,
          attachedCustomers: order.attachedCustomers, // Updated field using JSON array format
          email: order.Email,
          phone: order.Phone,
          total: order.Total,
          items: order.Products,
          siteURL: order.SiteURL,
          CurrencyCode: normalizeCurrencyCode(order.CurrencyCode || order.currency, "CAD"),
          order_status: order.OrderStatus,
          subStatusId: order?.subStatusId ?? null,
          assigned_to: formattedAssignedUsers,
          project_name: order.ProjectName || "",
          event_type: order.EventType || "",
          inHandsDate: toDateInput(order?.inHandsDate || order?.inhandsDate) || null,
          clientContactId: order?.clientContactId || null,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }}
      );
      await fetchOrder();
      toast.success("Your project has been updated successfully.");
    } catch (error) {
      console.error('Error saving order:', error);

      if (error?.response?.status === 423) {
        toast.error('This order is invoiced and locked.');

        if (isAdministrator) {
          const reason = window.prompt('Override reason (required):');
          if (reason && reason.trim()) {
            try {
              const formattedAssignedUsers = assignedUsers?.map(({ id, role }) => ({ id, role }));
              await axios.put(
                `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/edit/${orderId}`,
                {
                  customer_name: order.CustomerName,
                  attachedCustomers: order.attachedCustomers,
                  email: order.Email,
                  phone: order.Phone,
                  total: order.Total,
                  items: order.Products,
                  siteURL: order.SiteURL,
                  CurrencyCode: normalizeCurrencyCode(order.CurrencyCode || order.currency, "CAD"),
                  order_status: order.OrderStatus,
                  subStatusId: order?.subStatusId ?? null,
                  assigned_to: formattedAssignedUsers,
                  project_name: order.ProjectName || "",
                  event_type: order.EventType || "",
                  inHandsDate: toDateInput(order?.inHandsDate || order?.inhandsDate) || null,
                  clientContactId: order?.clientContactId || null,
                  overrideLock: true,
                  overrideReason: reason.trim(),
                },
                { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
              );
              await fetchOrder();
              toast.success('Override accepted. Project updated.');
              return;
            } catch (overrideErr) {
              console.error('Override save failed:', overrideErr);
              toast.error('Override failed.');
            }
          }
        }
      }

      toast.error(error?.response?.data?.message || 'An error occurred while saving the order.');
    } finally {
      setOrderSaving(false);
    }
  };


  const togglePopupMode = () => {
    setShowProductManagerPopup(false);
  };

  const addProductToOrder = (product) => {
    applyCartLineMutation((lines) => [...lines, product]);
  };

  function handleAddImprinting(product, index, isNew = false) {
    const updatedProducts = [...viewedCartLines];
    const updatedProduct = {
      ...product,
      imprinting: true,
      showImprintingOptions: isNew ? true : !product.showImprintingOptions,
    };
    updatedProducts[index] = updatedProduct;
    applyCartLineMutation(() => updatedProducts);
  }

  const handleShowProductsPopup = () => {
    if (isSalesOrderCartView && !effectiveSalesOrderCartUnlocked) {
      toast("Sales Order Cart is read-only.");
      return;
    }
    setShowProductPopup(!showProductPopup)
  }

  // Example: hide Assigned Users section if the order is Delivered or Cancelled
  const showAssignedUsersSection = order.OrderStatus && !["Delivered", "Cancelled"].includes(order.OrderStatus.SO);
  const closeProductListPopup = () => {
    setShowProductPopup(false)
  }



  const handleTabChange = (tab) => {
    const path = `/instance/${instanceUniqueId}/sales/orders/${orderId}`;
    switch (tab) {
      case 'Estimates':
        history.push(smartEstimateRoute || `${path}/estimates`);
        break;
      case 'Sales Order':
        history.push(smartSalesOrderRoute || `${path}/sales-order`);
        break;
      case 'Purchase Orders / Proofs':
          history.push(`${path}/purchase-order-home`);
          break;
      case 'Presentation':
        history.push(`${path}/presentation`);
        break;
      case 'Files':
        history.push(`${path}/files`);
        break;
      case 'Shipping':
        history.push(`${path}/shipping`);
        break;
      case 'POs/Proofs':
        history.push(`${path}/pos-proofs`);
        break;
      case 'Invoice':
        history.push(`${path}/invoice`);
        break;
      case 'Bills':
        history.push(`${path}/bills`);
        break;
      case 'Commissions':
        history.push(`${path}/commissions`);
        break;
      case 'Overview':
      default:
        history.push(`${path}/overview`);
        break;
    }
    //if (tab !== 'Estimate / Sales Order') setActiveTab(tab);
  };

  useEffect(() => {
    const next = resolveActiveOrderTab({
      pathname,
      tabtype,
      canSeeCommissions,
      tabsToShow,
    });
    setActiveTab(next);
  }, [pathname, tabtype, canSeeCommissions, tabsToShow])

  // Is PO selection allowed right now?
const poUnlocked = React.useMemo(() => {
  const soText = canonicalizeSoDisplay(order?.OrderStatus?.SO);
  return hasSO2or3 || soText === 'Client Approved';
}, [order?.OrderStatus?.SO, hasSO2or3]);

// Disable PO options in the menu if locked
const isPOOptionDisabled = (opt) =>
  opt.type === 'PO' && !poUnlocked;

// Nice combined display text in the closed Select
const unifiedCurrentLabel = React.useMemo(() => {
  const soCanonical = canonicalizeSoDisplay(order?.OrderStatus?.SO);
  const so = soCanonical ? getWorkflowLabel('SO', soCanonical) : '—';
  const po = order?.OrderStatus?.PO ? getWorkflowLabel('PO', order?.OrderStatus?.PO) : '—';
  return `SO: ${so}   |   PO: ${po}`;
}, [order?.OrderStatus?.SO, order?.OrderStatus?.PO, getWorkflowLabel]);

// Single onChange for unified menu
const handleUnifiedStatusChange = async (e) => {
  const key = e.target.value;
  const opt = UNIFIED_STATUS_OPTIONS.find(o => o.key === key);
  if (!opt) return;

  if (opt.type === 'SO' && !isAdministrator && !manualSalesOrderStatusOptions.some((item) => item.key === opt.key)) {
    toast.error(`You do not have permission to manually set this Sales Order to ${opt.value}.`);
    return;
  }

  if (opt.type === 'SO') {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/update-order-status`,
        { orderId, soStatus: opt.key },
        { headers: { accessToken: localStorage.getItem('accessToken') } }
      );
      setOrder((prev) => ({ ...prev, OrderStatus: response.data.orderStatus }));
      toast.success(`Sales Order status updated to ${opt.value}.`);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to update Sales Order status.');
    }
    return;
  }

  if (!isAdministrator) return;

  setOrder(prev => {
    const next = { ...prev, OrderStatus: { ...(prev.OrderStatus || {}) } };

    if (opt.type === 'SO') {
      const mapped = canonicalizeSoDisplay(opt.value);
      next.OrderStatus.SO = mapped;

      // Optional: auto-initialize PO when SO unlocks it
      if (['Client Approved', 'In Production', 'Shipped', 'Ready to be Invoiced', 'Invoiced', 'Paid'].includes(mapped) && !next.OrderStatus.PO) {
        next.OrderStatus.PO = 'Created';
      }
    } else if (opt.type === 'PO') {
      if (!poUnlocked) {
        toast('PO statuses unlock after Client Approved (or signed SO).');
        return prev; // no change
      }
      next.OrderStatus.PO = opt.value;
    } else if (opt.type === 'GLOBAL') {
      // If you want Global to affect both:
      next.OrderStatus.SO = opt.value;
      next.OrderStatus.PO = opt.value;
    }

    return next;
  });
};

// --- Unlocked status tooltip data ---
const poStatusesUnlocked =
  ["Client Approved", "In Production", "Shipped", "Ready to be Invoiced", "Invoiced", "Paid"].includes(canonicalizeSoDisplay(order?.OrderStatus?.SO));

const financeUnlocked =
  !!order?.OrderStatus?.PO &&
  isFinancialsOpen({ so: order?.OrderStatus?.SO, po: order?.OrderStatus?.PO });

const unlockedMessages = React.useMemo(
  () => [
    ...(poStatusesUnlocked ? ["PO statuses unlocked"] : []),
    ...(financeUnlocked ? ["Finance generation unlocked"] : []),
  ],
  [poStatusesUnlocked, financeUnlocked]
);

const valEq = (a, b) => String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();
const soTint = getStatusColor('SO', order?.OrderStatus?.SO);

  // Add / refresh a note
  const handleAddNote = useCallback(async (draftFromComposer, mentionsFromComposer = [], attachment = null) => {
    const draft = String(draftFromComposer || "").trim();
    if (!draft) return false;
  
    const html = buildMentionPreviewHtml(draft);
  
    try {
      const mentions = mentionsFromComposer.length ? mentionsFromComposer : extractMentionIdsFromText(draft);
      const payload = attachment
        ? (() => {
            const form = new FormData();
            form.append("orderId", orderId);
            form.append("messageText", draft);
            form.append("messageHtml", html);
            form.append("mentions", JSON.stringify(mentions));
            form.append("file", attachment);
            return form;
          })()
        : {
            orderId,
            messageText: draft,  // carries @[Name](id) for backend parsing/emails
            messageHtml: html,
            mentions,
          };

      const res = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/chat/order-note`,
        payload,
        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      );

      const createdNote = res?.data?.note;
      if (Number(createdNote?.sequence)) {
        setAllNotes((prev) => upsertProjectNote(prev, createdNote));
      } else {
        await fetchOrder({ suppressLoader: true });
      }

      toast.success("Note added!");
      return true;
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.error || err?.response?.data?.message || "Failed to add note.");
      return false;
    }
  }, [fetchOrder, orderId]);
  

// … inside your component …

const handleTogglePin = async (sequence) => {

  // 1️⃣ find the original note
  const orig = allNotes.find(n => n.sequence === sequence);
  if (!orig) return;

  // 2️⃣ compute the new value
  const newPin = !orig.pinned;

  // 3️⃣ optimistically update the UI
  setAllNotes(notes =>
    notes.map(n =>
      n.sequence === sequence ? { ...n, pinned: newPin } : n
    )
  );

  // 4️⃣ persist to the server
  try {
    const result = await axios.patch(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customerData.id}/notes/${sequence}/pin`,
      { pinned: newPin },
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    );
    console.log(JSON.stringify(result))
    // you could also setAllNotes(res.data.notes) here if you return them
  } catch (err) {
    toast.error("Could not save pin state");
    // optional rollback if the server fails:
    setAllNotes(notes =>
      notes.map(n =>
        n.sequence === sequence ? { ...n, pinned: orig.pinned } : n
      )
    );
    console.error("Pin toggle failed:", err.response?.data || err.message);
  }
};

const handleDeleteProjectNote = async (note) => {
  const sequence = Number(note?.sequence);
  if (!sequence || !customerData?.id) return;
  if (!window.confirm("Delete this comment?")) return;
  try {
    await axios.delete(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customerData.id}/notes/${sequence}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    );
    setAllNotes((prev) => prev.map((n) => Number(n?.sequence) === sequence ? { ...n, message: "Comment deleted", deletedAt: new Date().toISOString() } : n));
  } catch (err) {
    toast.error(err?.response?.data?.message || "Could not delete comment.");
  }
};

const handleReplyProjectNote = useCallback(async (note, draftFromEditor, mentionsFromEditor = [], attachment = null) => {
  const sequence = Number(note?.sequence);
  const draft = String(draftFromEditor || "").trim();
  if (!sequence || !customerData?.id || !draft) return false;
  const mentions = mentionsFromEditor.length ? mentionsFromEditor : extractMentionIdsFromText(draft);
  const parentNotePreview = String(note?.message || "")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .slice(0, 280);
  const messageHtml = buildMentionPreviewHtml(draft);
  try {
    const replyTo = {
      sequence,
      id: note?.id || note?.sequence,
      authorName: note?.userName || "",
      messagePreview: parentNotePreview,
      createdAt: note?.timestamp || null,
    };
    const basePayload = {
      orderId,
      message: draft,
      messageText: draft,
      messageHtml,
      mentions,
      parentNoteSequence: sequence,
      parentNoteId: note?.id || note?.sequence,
      parentNotePreview,
      parentNoteAuthor: note?.userName || "",
      isReply: true,
      replyTo,
    };
    const payload = attachment
      ? (() => {
          const form = new FormData();
          Object.entries(basePayload).forEach(([key, value]) => {
            form.append(key, typeof value === "object" ? JSON.stringify(value) : String(value ?? ""));
          });
          form.append("file", attachment);
          return form;
        })()
      : basePayload;

    const res = await axios.post(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/customers/${customerData.id}/notes/${sequence}/reply`,
      payload,
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    );
    const created = enrichProjectNoteAuthor(res?.data?.note, { availableUsers, assignedUsersDetailed, authState });
    if (created?.sequence) {
      setAllNotes((prev) => upsertProjectNote(prev, created));
    } else {
      await fetchOrder({ suppressLoader: true });
    }
    setNoteReplyDrafts((prev) => ({ ...prev, [sequence]: "" }));
    setActiveReplySequence(null);
    return true;
  } catch (err) {
    toast.error(err?.response?.data?.message || "Could not add reply.");
    return false;
  }
}, [assignedUsersDetailed, authState, availableUsers, customerData?.id, fetchOrder, orderId]);

const handleReplyDraftSnapshot = useCallback((sequence, draft) => {
  if (!sequence) return;
  setNoteReplyDrafts((prev) => {
    const nextValue = String(draft || "");
    if (prev[sequence] === nextValue) return prev;
    return {
      ...prev,
      [sequence]: nextValue,
    };
  });
}, []);

const handleCancelReplyEditor = useCallback((sequence, draft = "") => {
  if (sequence) {
    setNoteReplyDrafts((prev) => {
      const nextValue = String(draft || "");
      if (prev[sequence] === nextValue) return prev;
      return {
        ...prev,
        [sequence]: nextValue,
      };
    });
  }
  setActiveReplySequence(null);
}, []);

const toggleNoteThread = (sequence) => {
  setExpandedNoteThreads((prev) => ({ ...prev, [sequence]: !prev[sequence] }));
};

  


  // Handlers for Purchase Orders (POs/Proofs tab)
  const handleEmailPurchaseOrder = (po) => {
    console.log("Sending email for Purchase Order:", po.poNumber);
    // Implement email functionality here.
  };

  const handleDeletePurchaseOrder = (po) => {
    setPurchaseOrders((prevOrders) => prevOrders.filter((o) => o.id !== po.id));
    console.log("Deleted Purchase Order ID:", po.id);
  };

  const handleOpenRegeneratePopup = () => {
    setRegeneratePopup(true);
  };

  // Mapping function to transform the status code to readable text
  const parseStampedMeta = (raw) => {
    if (!raw) return {};
    if (typeof raw === 'string') {
      try { return JSON.parse(raw); } catch (_) { return {}; }
    }
    return typeof raw === 'object' ? raw : {};
  };

  const mapStatus = (status, rowIndex = -1, stampedMeta = {}) => {
    const normalizedStatus = String(status ?? '');
    const lifecycleStatus = String(stampedMeta?.lifecycleStatus || '').toLowerCase();
    const orderSoStage = canonicalizeSoDisplay(order?.OrderStatus?.SO);
    const isLatestRow = rowIndex === 0;

    if (lifecycleStatus === 'closed') {
      return 'Closed';
    }

    if (
      (normalizedStatus === '2' || normalizedStatus === '2_sent') &&
      isLatestRow &&
      orderSoStage === 'Agreement Sent'
    ) {
      return 'Agreement Sent';
    }

    switch (normalizedStatus) {
      case '':
      case 'Open':
        return 'N/A';
      case "1":
        return 'Estimate';
      case "1_sent":
        return 'Estimate Sent';
      case "2":
        return 'Agreement Pending';
      case "2_sent":
        return 'Agreement Sent';
      case "3":
        return 'Client Approved';
      case "6":
        return 'In Production';
      case "7":
        return 'Shipped';
      case "8":
        return 'Ready to be Invoiced';
      case "9":
        return 'Invoiced';
      case '4':
        return 'Client Change Requested';
      case '5':
        return 'Closed';   // <- new: should appear on both tabs
      default:
        return 'Unknown';
    }
  };


  const getDocTabTypeByStatus = (status) =>
    ['1', '1_sent'].includes(String(status)) ? 'estimation' : 'sales-order';

  // optionally format the class name from the status text
  const formatStatusClass = (statusText) => {
    return `status-${statusText.toLowerCase().replace(/\s+/g, '-')}`;
  };

  // Transformed row data with readable status + PO flag
  const mappedSalesOrderData = salesOrderData.map((order, index) => {
    const stampedMeta = parseStampedMeta(order?.stampedBookedAmount);
    const readableStatus = mapStatus(order.status, index, stampedMeta);
    const statusClass    = formatStatusClass(readableStatus);
    const revisionNumber = Number(stampedMeta?.revisionNumber || 0) || null;
    const routeType = getDocTabTypeByStatus(order.status);

    // see if any purchase-order record references this estimate
    const poGenerated = purchaseOrderData.some(
      (po) => Number(po.salesOrderId) === Number(order.estimationId)
    );

    const relatedInvoices = (orderInvoices || []).filter((inv) => {
      const relRaw = inv?.invoiceRelationships;
      let rel = {};
      if (typeof relRaw === 'string') {
        try { rel = JSON.parse(relRaw); } catch (_) { rel = {}; }
      } else if (typeof relRaw === 'object' && relRaw) {
        rel = relRaw;
      }
      return String(rel?.salesOrderRevisionId || rel?.salesOrderId || '') === String(order.estimationId);
    });

    const stripeLinks = relatedInvoices
      .map((inv) => inv?.checkoutLink || inv?.checkoutUrl || inv?.paymentLink || inv?.stripeCheckoutUrl || null)
      .filter(Boolean);

    const matchingRegenerationNote = (allNotes || []).find((note) => {
      if (!['estimate-regenerated', 'sales-order-regenerated'].includes(String(note?.action || ''))) return false;
      const msg = String(note?.message || '');
      const mArrow = msg.match(/Revision\s+(\d+)\s*[→\-]+\s*(\d+)/i);
      const mSingle = msg.match(/Revision\s+(\d+)/i);
      const toRevision = mArrow ? Number(mArrow[2]) : (mSingle ? Number(mSingle[1]) : NaN);
      if (!Number.isFinite(toRevision)) return false;
      return toRevision === Number(revisionNumber || -1);
    });

    const stampedRegeneratedByName = stampedMeta?.regeneratedByName || null;
    const stampedRegeneratedByAvatar = stampedMeta?.regeneratedByAvatar || null;

    return {
      ...order,
      readableStatus,
      statusClass,
      lifecycleStatus: stampedMeta?.lifecycleStatus || 'Active',
      revisionNumber,
      routePath: `/instance/${instanceUniqueId}/sales/orders/${orderId}/${routeType}/${order.estimationId}`,
      regeneratedBy: stampedRegeneratedByName || matchingRegenerationNote?.userName || '—',
      regeneratedByAvatar: stampedRegeneratedByAvatar || matchingRegenerationNote?.userAvatarUrl || matchingRegenerationNote?.userAvatar || null,
      stripeLinks,
      poGenerated,    // <-- new flag
    };
  });

  const getDocumentContextFromPath = () => {
    const path = window.location.pathname;

    const salesOrderMatch = path.match(/\/sales\/orders\/([^/]+)\/sales-order\/([^/]+)/);
    if (salesOrderMatch) {
      return {
        orderIdFromPath: salesOrderMatch[1],
        documentType: 'sales-order',
        documentId: salesOrderMatch[2],
      };
    }

    const estimationMatch = path.match(/\/sales\/orders\/([^/]+)\/estimation\/([^/]+)/);
    if (estimationMatch) {
      return {
        orderIdFromPath: estimationMatch[1],
        documentType: 'estimate',
        documentId: estimationMatch[2],
      };
    }

    const estimateMatch = path.match(/\/sales\/orders\/([^/]+)\/estimate\/([^/]+)/);
    if (estimateMatch) {
      return {
        orderIdFromPath: estimateMatch[1],
        documentType: 'estimate',
        documentId: estimateMatch[2],
      };
    }

    const estimatesMatch = path.match(/\/sales\/orders\/([^/]+)\/estimates\/([^/]+)/);
    if (estimatesMatch) {
      return {
        orderIdFromPath: estimatesMatch[1],
        documentType: 'estimate',
        documentId: estimatesMatch[2],
      };
    }

    return {
      orderIdFromPath: null,
      documentType: null,
      documentId: null,
    };
  };

  const mappedDocumentSnapshotHistory = documentSnapshotHistory.map((snapshot) => {
    const {
      documentType,
      documentId,
    } = getDocumentContextFromPath();

    const normalizedDocumentType = String(snapshot.documentType || documentType || '').toLowerCase();
    const resolvedDocumentId = snapshot.documentId || documentId;
    const revisionNumber = snapshot.revisionNumber || null;

    const isSalesOrder = normalizedDocumentType === 'sales-order';

    return {
      id: snapshot.id || snapshot.snapshotId || `${resolvedDocumentId}-${revisionNumber}`,
      estimationId: resolvedDocumentId,
      documentId: resolvedDocumentId,
      regeneratedBy: snapshot.createdByName || '—',
      regeneratedByAvatar: null,
      orderDate: snapshot.createdAt || snapshot.snapshotCreatedAt,
      revisionNumber,
      lifecycleStatus: snapshot.lifecycleStatus,
      readableStatus: snapshot.lifecycleStatus || 'Unknown',
      statusClass:
        String(snapshot.lifecycleStatus || '').toLowerCase() === 'active'
          ? 'status-active'
          : 'status-inactive',
      stripeLinks: [],
      itemCount: snapshot.itemCount || 0,
      snapshotId: snapshot.snapshotId,
      routePath: isSalesOrder
        ? `/generated-sales-order/${resolvedDocumentId}?snapshotRevision=${revisionNumber}`
        : `/generated-estimate/${resolvedDocumentId}?snapshotRevision=${revisionNumber}`,
    };
  });

    // Aggregate PO statuses → counts  advised overall stage (lowest present until all advance)
    const { poCounts, poTotal, poAdvisedStage } = useMemo(() => {
      const counts = Object.fromEntries(PO_RANK.map(k => [k, 0]));
      let total = 0;
  
      (purchaseOrderData || []).forEach(po => {
        const raw =
          po?.supplierStatus ??
          po?.poStatus ??
          po?.statusText ??
          po?.status; // last resort (may be numeric for SO, but included just in case)
        const canon = normalizePOStatus(raw);
        if (canon && counts.hasOwnProperty(canon)) {
          counts[canon] = 1;
          total += 1;
        }
      });
  
      let advised = null;
      if (total > 0) {
        const firstIdx = PO_RANK.findIndex(stage => counts[stage] > 0);
        advised = firstIdx >= 0 ? PO_RANK[firstIdx] : null;
      }
      return { poCounts: counts, poTotal: total, poAdvisedStage: advised };
    }, [purchaseOrderData]);
  


  // Rows filtered per tab:
  const filteredSalesRows = React.useMemo(() => {
    const s = (x) => String(x?.status);
    const isClosed = (x) => String(x?.lifecycleStatus || '').toLowerCase() === 'closed' || s(x) === '5';
    if (activeTab === "Estimates") {
      return mappedSalesOrderData.filter(r => ["1", "1_sent"].includes(s(r)) || isClosed(r));
    }
    if (activeTab === "Sales Order") {
      return mappedSalesOrderData.filter(r => ["2","2_sent","3","4","6","7","8","9"].includes(s(r)) || isClosed(r));
    }
    return mappedSalesOrderData;
  }, [activeTab, mappedSalesOrderData]);

  const mappedPurchaseOrderData = purchaseOrderData.map((po) => {
    const readableStatus   = mapStatus(po.status)
    const statusClass      = formatStatusClass(readableStatus)
  
    // see if any invoice record references this purchase order
    //const poGenerated = invoiceData.some(
    //  (inv) => Number(inv.purchaseOrderId) === Number(po.id)
    //)
  
    return {
      ...po,
      readableStatus,
      statusClass,
      //invoiceGenerated,    // <-- new flag
    }
  })

  const smartEstimateRoute = React.useMemo(() => (
    buildSmartOrderTabRoute({
      tab: TABS.ESTIMATES,
      instanceUniqueId,
      orderId,
      salesOrderRows: mappedSalesOrderData,
    })
  ), [instanceUniqueId, orderId, mappedSalesOrderData]);

  const smartSalesOrderRoute = React.useMemo(() => (
    buildSmartOrderTabRoute({
      tab: TABS.SALES_ORDER,
      instanceUniqueId,
      orderId,
      salesOrderRows: mappedSalesOrderData,
    })
  ), [instanceUniqueId, orderId, mappedSalesOrderData]);

  useEffect(() => {
    if (hasDocumentId) return;

    const normalizedPath = String(pathname || '').split('?')[0].split('#')[0];

    if (normalizedTabType === 'estimates' && smartEstimateRoute && normalizedPath !== smartEstimateRoute) {
      history.push(smartEstimateRoute);
      return;
    }

    if (normalizedTabType === 'sales-order' && smartSalesOrderRoute && normalizedPath !== smartSalesOrderRoute) {
      history.push(smartSalesOrderRoute);
    }
  }, [
    hasDocumentId,
    history,
    normalizedTabType,
    pathname,
    smartEstimateRoute,
    smartSalesOrderRoute,
  ]);

  const historyTitle = React.useMemo(() => {
    const routeKey = String(tabtype || '').toLowerCase();
    if (routeKey === 'sales-order' && tabId) return 'Sales Order history';
    if (routeKey === 'estimation' && tabId) return 'Estimation history';
    return 'Estimate / Sales Order history';
  }, [tabtype, tabId]);

  const historyTabLabel = React.useMemo(() => {
    const routeKey = String(tabtype || '').toLowerCase();
    if (routeKey === 'sales-order') return 'Sales Order History';
    if (routeKey === 'estimation') return 'Estimate History';
    return 'History';
  }, [tabtype]);

  const assignedTo = useMemo(() => parseAssignedTo(order?.AssignedTo), [order?.AssignedTo]);
  const orderRepContacts = useMemo(
    () =>
      assignedTo
        .filter((rep) => String(rep?.role || '').toLowerCase() === 'order-rep')
        .map((rep) => toContact(getAssignedEmail(rep), rep))
        .filter(Boolean),
    [assignedTo]
  );
  const clientRepContacts = useMemo(
    () =>
      assignedTo
        .filter((rep) => String(rep?.role || '').toLowerCase() === 'client-rep')
        .map((rep) => toContact(getAssignedEmail(rep), rep))
        .filter(Boolean),
    [assignedTo]
  );

  const presentationFallbackAdminContacts = useMemo(
    () => assignedTo
      .map((assignment) => {
        const user = (availableUsers || []).find((entry) =>
          String(entry?.id) === String(assignment?.id ?? assignment?.userId));
        const self = String(currentUser?.id || authState?.id || '') ===
          String(assignment?.id ?? assignment?.userId) ? currentUser : null;
        const resolved = { ...(user || {}), ...(self || {}), ...assignment };
        const roles = [assignment?.role, user?.role, self?.role, ...(Array.isArray(user?.roles) ? user.roles : [])];
        if (!roles.some((role) => normalizeInvoiceRoles({ role: role?.name || role }).has('administrator'))) return null;
        const email = getAssignedEmail(resolved) || getAssignedEmail(user) || getAssignedEmail(self);
        return toContact(email, {
          ...assignment,
          ...(user || {}),
          ...(self || {}),
          // Keep project-assignment role detection separate from profile-photo resolution.
          profilePicture: self?.profilePicture || user?.profilePicture || assignment?.profilePicture,
          profile_picture: self?.profile_picture || user?.profile_picture || assignment?.profile_picture,
        });
      })
      .filter(Boolean),
    [assignedTo, availableUsers, currentUser, authState?.id]
  );
  const presentationCcContacts = orderRepContacts.length || clientRepContacts.length
    ? [...orderRepContacts, ...clientRepContacts]
    : presentationFallbackAdminContacts;

  const composerSelfContact = useMemo(() => {
    const email = currentUser?.email || authState?.email || '';
    if (!email) return null;
    const matchingUser = (availableUsers || []).find((user) =>
      String(user?.id || '') === String(currentUser?.id || authState?.id || '') ||
      String(user?.email || '').toLowerCase() === email.toLowerCase()
    );
    const name = [currentUser?.first_name || currentUser?.firstName, currentUser?.last_name || currentUser?.lastName]
      .filter(Boolean).join(' ').trim() || currentUser?.name || authState?.name ||
      [matchingUser?.first_name, matchingUser?.last_name].filter(Boolean).join(' ') || '';
    const avatarCandidates = [currentUser, authState, authState?.user, matchingUser];
    const avatarUrl = avatarCandidates.reduce((found, user) => found ||
      resolveMentionAvatarUrl(user?.profilePicture || user?.profile_picture ||
        user?.avatarUrl || user?.avatar || user?.photoUrl || null), null);
    return {
      id: email,
      email,
      name: name && name.toLowerCase() !== email.toLowerCase() ? name : email,
      badge: 'You',
      avatarUrl,
    };
  }, [currentUser, authState, availableUsers]);

  const composerSelfContactWithAvatar = useMemo(() => {
    if (!composerSelfContact) return null;
    const assignedSelf = [...orderRepContacts, ...clientRepContacts, ...presentationFallbackAdminContacts]
      .find((contact) => String(contact?.id || '').toLowerCase() === composerSelfContact.id.toLowerCase());
    return {
      ...composerSelfContact,
      avatarUrl: composerSelfContact.avatarUrl || assignedSelf?.avatarUrl || null,
    };
  }, [composerSelfContact, orderRepContacts, clientRepContacts, presentationFallbackAdminContacts]);

  const emailContacts = useMemo(() => {
    let contacts = Array.isArray(clientContacts) ? [...clientContacts] : [];
    contacts = contacts.map((contact) => {
      const safeName = getContactDisplayName(contact);
      return {
        ...contact,
        name: safeName || contact.id,
        id: contact?.email || contact?.id,
      };
    });

    if (composerSelfContact) {
      contacts = contacts.filter((contact) =>
        String(contact.id || '').toLowerCase() !== composerSelfContact.id.toLowerCase());
      contacts.unshift(composerSelfContactWithAvatar);
    }

    const additionalContacts = [...orderRepContacts, ...clientRepContacts, ...presentationFallbackAdminContacts].filter(Boolean);
    additionalContacts.forEach((contact) => {
      if (!contacts.some((existing) => existing.id === contact.id)) {
        contacts = [...contacts, contact];
      }
    });

    return contacts;
  }, [clientContacts, composerSelfContact, composerSelfContactWithAvatar, orderRepContacts, clientRepContacts, presentationFallbackAdminContacts]);

  const normalizedClientContacts = useMemo(() => {
    const contacts = Array.isArray(clientContacts) ? clientContacts : [];
    return contacts.map((c) => {
      const id = String(c?.contactId || c?.id || "").trim();
      const email = String(c?.email || "").trim();
      const phone = String(c?.phone || "").trim();
      return {
        ...c,
        id,
        email,
        phone,
        name: getContactDisplayName(c) || email || id || "Contact",
      };
    }).filter((c) => c.id);
  }, [clientContacts]);

  const linkedClientContact = useMemo(() => {
    const linkedId = String(order?.clientContactId || '').trim();
    if (!linkedId) return null;
    return normalizedClientContacts.find((c) => c.id === linkedId) || null;
  }, [normalizedClientContacts, order?.clientContactId]);

  const linkedClientContactName = useMemo(
    () => getContactDisplayName(linkedClientContact),
    [linkedClientContact]
  );

  useEffect(() => {
    setContactSourceMode(String(order?.clientContactId || "").trim() ? "contact" : "customer");
  }, [order?.clientContactId]);

  const applyCustomerFallbackContact = () => {
    setOrder((prev) => ({
      ...prev,
      clientContactId: null,
      Email: customerData?.emailAddress || prev?.Email || "",
      Phone: customerData?.phoneNumber || prev?.Phone || "",
    }));
    setContactSourceMode("customer");
  };

  const applyLinkedContact = (contactId) => {
    const selected = normalizedClientContacts.find((c) => c.id === String(contactId || "").trim());
    if (!selected) return;
    setOrder((prev) => ({
      ...prev,
      clientContactId: selected.id,
      Email: selected.email || prev?.Email || "",
      Phone: selected.phone || prev?.Phone || "",
    }));
    setContactSourceMode("contact");
  };

  useEffect(() => {
    const fetchTemplates = async () => {
      if (!instanceUniqueId) return;
      try {
        const headers = { headers: { accessToken: localStorage.getItem('accessToken') } };
        const instanceRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
          headers
        );
        const instanceId = instanceRes.data?.id;
        if (!instanceId) return;
        const templatesRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/email-templates`,
          headers
        );
        const templates = templatesRes.data?.templates || [];
        setEmailTemplates(templates.filter((template) => template.enabled !== false));
      } catch (error) {
        console.warn('Failed to load email templates', error);
      }
    };

    fetchTemplates();
  }, [instanceUniqueId]);

  useEffect(() => {
    const fetchSubStatuses = async () => {
      const currentStatus = canonicalizeSoDisplay(order?.OrderStatus?.SO || "");
      if (!instanceUniqueId || !currentStatus) {
        setAvailableSubStatuses([]);
        return;
      }

      try {
        const headers = { headers: { accessToken: localStorage.getItem('accessToken') } };
        const instanceRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`,
          headers
        );
        const instanceId = instanceRes.data?.id;
        if (!instanceId) {
          setAvailableSubStatuses([]);
          return;
        }

        const subStatusRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/project-sub-statuses`,
          {
            ...headers,
            params: {
              parentStatusKey: currentStatus,
              activeOnly: true,
            },
          }
        );
        setAvailableSubStatuses(subStatusRes.data?.subStatuses || []);
      } catch (error) {
        console.warn("Failed to load project sub statuses", error);
        setAvailableSubStatuses([]);
      }
    };

    fetchSubStatuses();
  }, [instanceUniqueId, order?.OrderStatus?.SO]);

  useEffect(() => {
    if (!emailComposerOpen) return;
    const defaultToId =
      currentSO?.clientEmail ||
      order?.presentation?.clientContactEmail ||
      order?.clientContactEmail ||
      order?.clientContact?.email ||
      '';
    const defaultTo = emailContacts.find(
      (contact) => String(contact.id || '').toLowerCase() === String(defaultToId || '').toLowerCase()
    );
    setEmailValue((prev) => ({
      ...prev,
      to: defaultTo ? [defaultTo] : prev.to,
    }));
  }, [emailComposerOpen, emailContacts, currentSO, order]);

  useEffect(() => {
    if (!invoiceComposerOpen) return;

    const defaultToId =
      currentSO?.clientEmail ||
      order?.presentation?.clientContactEmail ||
      order?.clientContactEmail ||
      order?.clientContact?.email ||
      '';

    const defaultTo = emailContacts.find(
      (contact) => String(contact.id || '').toLowerCase() === String(defaultToId || '').toLowerCase()
    );

    const provisionalInvoice = {
      id: null,
      orderId,
      amount: Number(invoiceCreateAmount || 0),
      currency: currentSO?.currency || order?.currency || 'CAD',
      paymentStatus: 'Open',
      invoiceStatus: 'Open',
      customerName: currentSO?.billingName || order?.CustomerName || '',
      billingName: currentSO?.billingName || '',
    };

    const projectName = order?.ProjectName || order?.projectName || `Project ${orderId}`;
    const autoSubject = buildInvoiceEmailSubject({
      invoice: provisionalInvoice, orderId, order, projectName,
    });
    const autoBody = buildInvoiceEmailBody({
      invoice: provisionalInvoice, orderId, order, projectName,
      amountOverride: Number(invoiceCreateAmount || 0),
    });
    const previousAutofill = invoiceEmailLastAutofillRef.current;
    setInvoiceEmailValue((prev) => ({
      ...prev,
      to: defaultTo ? [defaultTo] : prev.to,
      subject: !prev.subject || prev.subject === previousAutofill.subject ? autoSubject : prev.subject,
      body: !prev.body || prev.body === previousAutofill.body ? autoBody : prev.body,
      layout: getPreferredInvoiceLayout(prev.layout),
    }));
    invoiceEmailLastAutofillRef.current = { subject: autoSubject, body: autoBody };
  }, [invoiceComposerOpen, emailContacts, currentSO, order, orderId, invoiceCreateAmount]);

  const handleSendEstimateEmail = async () => {
    const activeEstimationId = tabId || currentSO?.estimationId || currentSO?.id;
    if (!activeEstimationId) {
      toast.error("Missing estimate id to send email.");
      return;
    }

    const to = (emailValue.to || []).map(c => c?.id).filter(Boolean);
    const ccRaw = (emailValue.cc || []).map(c => c?.id).filter(Boolean);
    const bccRaw = (emailValue.bcc || []).map(c => c?.id).filter(Boolean);
    const cc = ccRaw.filter((e, i) => ccRaw.indexOf(e) === i && !to.includes(e));
    const bcc = bccRaw.filter((e, i) => bccRaw.indexOf(e) === i && !to.includes(e) && !cc.includes(e));

    if (!to.length) {
      toast.error("Choose at least one recipient in 'To'.");
      return;
    }

    setEmailSending(true);
    try {
      await updateEstimation(activeEstimationId, {
        sendEmail: true,
        orderId,
        email: {
          to,
          cc,
          bcc,
          subject: emailValue.subject,
          body: emailValue.body,
          templateId: emailValue.templateId || null,
          layout: emailValue.layout || 'plain',
        },
        clientEmail: to[0] || null,
        ccList: cc.join(', ')
      });

      // Refresh from backend so persisted SalesOrder.status (_sent transitions) is reflected in UI.
      await fetchOrder({ suppressLoader: true });

      toast.success("Email sent.");
      setEmailComposerOpen(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to send email.");
    } finally {
      setEmailSending(false);
    }
  };
  

  const openPresentationEmailComposer = (presentationRow) => {
    const defaultTo = emailContacts.find(
      (contact) => String(contact.id || '').toLowerCase() === String(presentationRow?.clientContactEmail || '').toLowerCase()
    );

    // Match the recipients automatically included by the presentation send endpoint.
    // Exclude the primary recipient and deduplicate reps assigned to both roles.
    const to = defaultTo ? [defaultTo] : [];
    const toAddresses = new Set(to.map((contact) => String(contact.id || '').toLowerCase()));
    const seenCc = new Set();
    const defaultCc = presentationCcContacts.filter((contact) => {
      const email = String(contact?.email || contact?.id || '').trim().toLowerCase();
      if (!email || toAddresses.has(email) || seenCc.has(email)) return false;
      seenCc.add(email);
      return true;
    });

    setEmailAttachments([]);
    setPresentationEmailTarget(presentationRow || null);
    setPresentationEmailValue({
      to,
      cc: defaultCc,
      bcc: [],
      subject: 'Your Product Presentation is Ready',
      body: [
        `<p>Hi,</p>`,
        `<p>Your presentation is ready for review.</p>`,
        `<p>Thanks!</p>`,
      ].join(''),
      templateId: '',
      layout: 'elite',
      quickActions: {
        bccMe: false,
        bccOrderRep: false,
        bccClientRep: false,
        requestReadReceipt: false,
        attachPdf: false,
        attachDashboard: false,
      },
    });
    setPresentationEmailOpen(true);
  };

  const handleSendPresentationEmail = async () => {
    if (!presentationEmailTarget?.id && !presentationEmailTarget?.presentationId) {
      toast.error('Missing presentation id.');
      return;
    }

    const to = (presentationEmailValue.to || []).map((c) => c?.id).filter(Boolean);
    const ccRaw = (presentationEmailValue.cc || []).map((c) => c?.id).filter(Boolean);
    const bccRaw = (presentationEmailValue.bcc || []).map((c) => c?.id).filter(Boolean);
    const cc = ccRaw.filter((e, i) => ccRaw.indexOf(e) === i && !to.includes(e));
    const bcc = bccRaw.filter((e, i) => bccRaw.indexOf(e) === i && !to.includes(e) && !cc.includes(e));

    if (!to.length) {
      toast.error("Choose at least one recipient in 'To'.");
      return;
    }

    setPresentationEmailSending(true);
    try {
      // Only process attachments when files were explicitly selected. Otherwise retain
      // the original JSON email request without any attachment payload.
      let encodedAttachments;
      if (emailAttachments.length) {
        const allowed = new Set([
          'image/jpeg', 'image/png', 'image/gif', 'image/webp',
          'application/pdf', 'text/plain', 'text/csv',
          'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ]);
        const maxEach = 5 * 1024 * 1024;
        const maxTotal = 12 * 1024 * 1024;
        if (emailAttachments.some((file) => !allowed.has(file.type) || !file.size || file.size > maxEach)
            || emailAttachments.reduce((total, file) => total + file.size, 0) > maxTotal) {
          throw new Error('Attachments must be JPG, PNG, GIF, WEBP, PDF, TXT, CSV, DOC, DOCX, XLS or XLSX; maximum 5 MB each and 12 MB total.');
        }
        encodedAttachments = await Promise.all(emailAttachments.map(async (file) => {
          const bytes = new Uint8Array(await file.arrayBuffer());
          let binary = '';
          for (let i = 0; i < bytes.length; i += 8192) {
            binary += String.fromCharCode(...bytes.subarray(i, i + 8192));
          }
          return { name: file.name, content: btoa(binary), type: file.type };
        }));
      }
      const presId = presentationEmailTarget?.id || presentationEmailTarget?.presentationId;
      await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/presentation/${presId}/send-mail`,
        {
          instanceUniqueId,
          email: {
            to,
            cc,
            bcc,
            subject: presentationEmailValue.subject,
            body: presentationEmailValue.body,
            templateId: presentationEmailValue.templateId || null,
            layout: presentationEmailValue.layout || 'plain',
          },
          ...(encodedAttachments ? { attachments: encodedAttachments } : {}),
        },
        { headers: { accessToken: localStorage.getItem('accessToken') } }
      );
      toast.success('Presentation email sent.');
      setPresentationEmailOpen(false);
      await fetchOrder({ suppressLoader: true });
      if (customerData?.id) await loadAttachedCustomer(customerData.id);
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to send presentation email.');
    } finally {
      setPresentationEmailSending(false);
    }
  };

  // Header title logic:
  // status "1" => Estimate
  // status "2" | "3" | "4" => Sales Order
  const docTitle = React.useMemo(() => {
    const routeType = String(tabtype || "").toLowerCase();
    if (routeType === "estimation") return "Estimate";
    if (routeType === "sales-order") return "Sales Order";
    const s = String(currentSO?.status ?? "");
    return s === "1" ? "Estimate" : "Sales Order";
  }, [currentSO, tabtype]);

  const soStatusCode   = String(currentSO?.status ?? "");
  const isSOCompleted  = soStatusCode === "3";
  const [depositCheckDialogOpen, setDepositCheckDialogOpen] = useState(false);
  const [paidDepositApproval, setPaidDepositApproval] = useState(null);
  const [paidDepositDialogOpen, setPaidDepositDialogOpen] = useState(false);
  const [paidDepositApprovalLoading, setPaidDepositApprovalLoading] = useState(false);
  const [paidDepositEligibilityLoading, setPaidDepositEligibilityLoading] = useState(false);
  const canApprovePaidDeposit = isAdministrator || isFinanceRep || isOrderRep || isClientRep;

  const loadPaidDepositApproval = useCallback(async () => {
    const estimationId = currentSO?.estimationId || currentSO?.id;
    const eligibleStatus = ['1', '1_sent', '2', '2_sent'].includes(String(currentSO?.status || '').trim().toLowerCase());
    if (!isSalesOrderRoute || !estimationId || !canApprovePaidDeposit || !eligibleStatus) {
      setPaidDepositApproval(null);
      return;
    }
    setPaidDepositEligibilityLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/sales-orders/${estimationId}/paid-deposit-approval`,
        {
          params: { instanceUniqueId },
          headers: { accessToken: localStorage.getItem('accessToken') },
        }
      );
      setPaidDepositApproval(response?.data?.paidDepositApproval || null);
    } catch (error) {
      if (error?.response?.status !== 404) {
        console.warn('Unable to load paid deposit approval:', error?.response?.data?.message || error?.message);
      }
      setPaidDepositApproval(null);
    } finally {
      setPaidDepositEligibilityLoading(false);
    }
  }, [canApprovePaidDeposit, currentSO?.estimationId, currentSO?.id, currentSO?.status, instanceUniqueId, isSalesOrderRoute, orderId]);

  useEffect(() => {
    loadPaidDepositApproval();
  }, [loadPaidDepositApproval]);

  const approveFromPaidDeposit = async () => {
    if (paidDepositApprovalLoading) return;
    const estimationId = currentSO?.estimationId || currentSO?.id;
    setPaidDepositApprovalLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/sales-orders/${estimationId}/approve-from-paid-deposit`,
        { instanceUniqueId },
        { headers: { accessToken: localStorage.getItem('accessToken') } }
      );
      const invoiceId = response?.data?.depositInvoice?.id || paidDepositApproval?.invoiceId;
      toast.success(`Sales Order approved from paid deposit invoice #${invoiceId}.`);
      setPaidDepositDialogOpen(false);
      setPaidDepositApproval(null);
      await fetchOrder();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to approve Sales Order from the paid deposit.');
    } finally {
      setPaidDepositApprovalLoading(false);
    }
  };
  const paidDepositIconState = getPaidDepositApprovalIconState({
    status: currentSO?.status,
    paidDepositApproval,
    hasPermission: canApprovePaidDeposit,
    loading: paidDepositEligibilityLoading || paidDepositApprovalLoading,
  });
  const paidDepositApprovalAction = (
    <SalesOrderDepositActions
      isSalesOrderRoute={isSalesOrderRoute}
      depositCheckDialogOpen={depositCheckDialogOpen}
      setDepositCheckDialogOpen={setDepositCheckDialogOpen}
      instanceUniqueId={instanceUniqueId}
      orderId={orderId}
      currentUser={currentUser}
      orderInvoices={orderInvoices}
      paidDepositIconState={paidDepositIconState}
      onOpenPaidDepositApproval={() => setPaidDepositDialogOpen(true)}
    />
  );

  useEffect(() => {
    if (docViewTab === 'history') {
      loadDocumentSnapshotHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [docViewTab, order?.OrderId, orderId, window.location.pathname]);

  useEffect(() => {
    const pref = localStorage.getItem("orderTabsSidebar") === "true";
    setIsSidebar(pref);
  }, []);

  const toggleSidebar = () => {
    setIsSidebar(s => {
      localStorage.setItem("orderTabsSidebar", String(!s));
      return !s;
    });
  };

   const previousValidOverviewFinancialsRef = useRef(null);
   const previousValidOverviewSourceKeyRef = useRef(null);

   // Same eligibility and ordering as commissionBookedSnapshot.findLatestApprovedSalesOrder:
   // customer agreed, approved status, latest updatedAt then createdAt.
   const approvedBookedSalesOrder = React.useMemo(() => (
     selectLatestApprovedBookedSalesOrder([
       ...asList(order?.SalesOrderData),
       ...asList(order?.salesOrderData),
       ...asList(salesOrderData),
     ], order?.OrderId || orderId)
   ), [order?.SalesOrderData, order?.salesOrderData, salesOrderData, order?.OrderId, orderId]);

   const overviewFinancials = React.useMemo(() => {
       const stamp = getLatestBookedStamp(approvedBookedSalesOrder);
       const salesOrderCartCandidates = getSalesOrderCartPayloadCandidates(approvedBookedSalesOrder);
       const identifiedSalesOrderCartCandidates = salesOrderCartCandidates.filter(isUsableSalesOrderCartCandidate);
       // Use complete cost/revenue rows from THIS approved Sales Order's frozen
       // cart before older stamp fields. This repairs legacy stamps where
       // freight was added to subtotal without refreshing bookedMargin.
       const frozenCartBookedFinancials = resolveFrozenSalesOrderBookedFinancials(approvedBookedSalesOrder);
       const stampSummaryFinancials = firstValidSnapshotSummaryFinancials([stamp], "sales-order-stamp-summary");
       const salesOrderCartSummaryFinancials = firstValidSnapshotSummaryFinancials(identifiedSalesOrderCartCandidates, "sales-order-cart-summary");
       const stampFinancials = stamp
         ? resolveBookedSummaryFinancials(mergeBookedStampSummary(stamp), "sales-order-stamp")
         : null;
       const salesOrderCartFinancials = firstValidFinancialSummary(
         identifiedSalesOrderCartCandidates,
         "sales-order-cart",
       );
       // The live cart is provisional only. After approval an incomplete
       // booked record must be visible, never silently replaced with live data.
       const orderCartFinancials = approvedBookedSalesOrder ? null : firstValidFinancialSummary(
         [cartWorkspace?.cartPayload, order],
         "order-cart",
       );

       // Never let a newly approved revision borrow the previous revision's
       // booked figures while its own snapshot is loading.
       const sourceKey = `${String(order?.id || orderId)}:${approvedBookedSalesOrder
         ? `approved:${approvedBookedSalesOrder.estimationId}:${approvedBookedSalesOrder.updatedAt || ""}`
         : "pre-approval"}`;
       const priorForSameSource = previousValidOverviewSourceKeyRef.current === sourceKey
         ? previousValidOverviewFinancialsRef.current : null;
       const resolved = selectOverviewFinancials(
         approvedBookedSalesOrder
           ? [frozenCartBookedFinancials, stampSummaryFinancials, salesOrderCartSummaryFinancials, stampFinancials, salesOrderCartFinancials, unavailableBookedFinancials]
           : [orderCartFinancials],
         approvedBookedSalesOrder ? null : priorForSameSource,
       );

       if (resolved.source !== "fallback-zero" && resolved.source !== "booked-unavailable") {
         previousValidOverviewFinancialsRef.current = resolved;
         previousValidOverviewSourceKeyRef.current = sourceKey;
       }
       return resolved;
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [order, salesOrderData, cartWorkspace?.cartPayload, approvedBookedSalesOrder, orderId]);

   const isBookedFinancialsUnavailable = overviewFinancials?.source === "booked-unavailable";
   const bookedMarginForUI = React.useMemo(() => {
       if (overviewFinancials?.source === "booked-unavailable") return null;
       const margin = toMoneyNumber(overviewFinancials?.bookedMargin, Number.NaN);
       return Number.isFinite(margin) ? margin : 0;
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [overviewFinancials]);

   useEffect(() => {
     const orderDbId = order?.id;
     const salesOrderStatus = order?.OrderStatus?.SO;
     if (!orderDbId || !isBilledMarginStatus(salesOrderStatus)) {
       setBilledMarginFinancials(null);
       return undefined;
     }

     let active = true;
     axios.get(
       `${process.env.REACT_APP_NODEJS_SERVER_URL}/commissions/${orderDbId}/financial-summary`,
       { headers: { accessToken: localStorage.getItem("accessToken") } },
     ).then(({ data }) => {
       if (active) setBilledMarginFinancials(data || null);
     }).catch((error) => {
       console.error("Failed to load Billed Margin", error);
       if (active) setBilledMarginFinancials(null);
     });

     return () => {
       active = false;
     };
   }, [
     order?.id,
     order?.OrderStatus?.SO,
     order?.updatedAt,
     billsSummary?.actual,
     orderInvoices,
   ]);

   const billedMarginView = getBilledMarginView(
     order?.OrderStatus?.SO,
     billedMarginFinancials,
   );

   const overviewFinancialDebugPayload = React.useMemo(() => {
       if (!OVERVIEW_FINANCIAL_DEBUG) return null;

       const stamp = getLatestBookedStamp(approvedBookedSalesOrder);
       const stampSummaryDerived = financialsFromSnapshotSummary(getSnapshotSummaryFromPayload(stamp), "sales-order-stamp-summary");
       const stampDerived = stampSummaryDerived || (stamp ? {
         source: "sales-order-stamp",
         bookedRevenue: toMoneyNumber(firstNonEmpty(stamp?.targetRevenue, stamp?.revenue, stamp?.subtotal)),
         costs: toMoneyNumber(firstNonEmpty(stamp?.targetCosts, stamp?.costs), 0),
         bookedMargin: toMoneyNumber(stamp?.bookedMargin, 0),
         bookedMarginPct: calculateBookedMarginPct(firstNonEmpty(stamp?.targetRevenue, stamp?.revenue, stamp?.subtotal), stamp?.bookedMargin),
         totalInclTax: toMoneyNumber(firstNonEmpty(stamp?.invoiceableTotal, stamp?.salesOrderTotal, stamp?.totalIncl, stamp?.totalInclTax), 0),
       } : null);
       const toDebugCandidate = (candidate, indexOrLabel) => ({
         index: typeof indexOrLabel === "number" ? indexOrLabel : undefined,
         label: typeof indexOrLabel === "string" ? indexOrLabel : candidate.label,
         exists: candidate.exists,
         accepted: String(candidate.reason || "").startsWith("accepted"),
         reason: candidate.reason,
         summaryFields: candidate.summaryValues,
         derivedFinancials: candidate.derived,
         topLevelKeys: candidate.topLevelKeys,
         productCount: candidate.counts?.products || 0,
         itemCount: candidate.counts?.items || 0,
         otherServiceCount: candidate.counts?.otherServices || 0,
         costRowPoolCount: candidate.counts?.costRowPools || 0,
         ...(OVERVIEW_FINANCIAL_DEBUG_RAW && candidate.rawPayload ? { rawPayload: candidate.rawPayload } : {}),
       });
       const salesOrderCandidates = getSalesOrderCartPayloadCandidates(approvedBookedSalesOrder);
       const salesOrderCandidateReports = salesOrderCandidates.map((candidate, index) => {
         const hasIdentity = hasSalesOrderCartIdentity(candidate);
         const rejectedFalseHundred = hasIdentity && isFalseHundredPercentSalesOrderCartCandidate(candidate);
         const usableSalesOrderCart = hasIdentity && !rejectedFalseHundred;
         const summaryDerived = usableSalesOrderCart ? financialsFromSnapshotSummary(getSnapshotSummaryFromPayload(candidate), "sales-order-cart-summary") : null;
         const derived = usableSalesOrderCart ? summaryDerived || deriveCartFinancialSummary({}, candidate, "sales-order-cart") : null;
         return buildOverviewFinancialDebugCandidate(
           `sales-order-cart #${index + 1}`,
           candidate,
           derived,
           !hasIdentity
             ? "rejected-missing-sales-order-cart-identity"
             : rejectedFalseHundred
               ? "rejected-generic-products-only-cart"
               : summaryDerived ? "accepted-sales-order-cart-summary" : derived ? "accepted-sales-order-cart" : null,
           { salesOrderDataCandidateCount: salesOrderCandidates.length },
         );
       });
       const orderCandidates = [cartWorkspace?.cartPayload, order].filter(Boolean);
       const orderCandidateReports = orderCandidates.map((candidate, index) => {
         const summaryDerived = financialsFromSnapshotSummary(getSnapshotSummaryFromPayload(candidate), "order-cart");
         const derived = summaryDerived || deriveCartFinancialSummary({}, candidate, "order-cart");
         return buildOverviewFinancialDebugCandidate(
           index === 0 ? "order-cart cartWorkspace.cartPayload" : "order-cart order",
           candidate,
           derived,
           summaryDerived ? "accepted-order-cart-summary" : derived ? "accepted-order-cart" : null,
         );
       });
       const stampCandidateReport = buildOverviewFinancialDebugCandidate(
         "sales-order stamp",
         stamp,
         stampDerived,
         stampSummaryDerived ? "accepted-sales-order-stamp-summary" : stampDerived ? "accepted-sales-order-stamp" : null,
         { salesOrderDataCandidateCount: asList(order?.SalesOrderData).length + asList(salesOrderData).length },
       );
       const allPayloadCandidates = [
         stamp, ...salesOrderCandidates,
         ...(!approvedBookedSalesOrder ? orderCandidates : []),
       ].filter(Boolean);
       const expectedFromSelectedSummary = getExpectedOverviewFinancialsFromCandidates(allPayloadCandidates);
       const salesOrderSnapshotSummaryFound = [stampCandidateReport, ...salesOrderCandidateReports]
         .some((candidate) => ["sales-order-stamp-summary", "sales-order-cart-summary"].includes(candidate.derived?.source));
       const effectiveOrderCandidateReports = approvedBookedSalesOrder
         ? orderCandidateReports.map((candidate) => ({ ...candidate, reason: "rejected-approved-sales-order-booked-source-only" }))
         : orderCandidateReports;
       const validSalesOrderCartExists = salesOrderCandidateReports.some((candidate) => candidate.derived);
       const liveOrderCartIgnored = salesOrderSnapshotSummaryFound && orderCandidateReports.some((candidate) => candidate.derived);
       const anyCandidateSubtotal = [stampCandidateReport, ...salesOrderCandidateReports, ...effectiveOrderCandidateReports]
         .some((candidate) => toMoneyNumber(candidate.summaryValues?.subtotal, 0) > 0);
       const hasApprovedSalesOrder = Boolean(approvedBookedSalesOrder);
       const selected = overviewFinancials || {};
       const warnings = [];
       if (selected.costsDerivedFromBookedMargin) {
         warnings.push("selected costs derived from stamped booked margin because explicit costs were missing or zero");
       }
       if (selected.source === "fallback-zero" && hasApprovedSalesOrder) warnings.push("fallback-zero selected while a sales order appears approved/completed");
       if (selected.source === "booked-unavailable") warnings.push("approved Sales Order has no verifiable booked financials; live Order Cart fallback is intentionally disabled");
       if (selected.source === "order-cart" && validSalesOrderCartExists) warnings.push("order-cart selected while a valid sales-order-cart candidate exists");
       if (toMoneyNumber(selected.costs, 0) === 0 && toMoneyNumber(selected.bookedRevenue, 0) > 0) warnings.push("selected costs are 0 while selected revenue is non-zero");
       if (toMoneyNumber(selected.bookedRevenue, 0) === 0 && anyCandidateSubtotal) warnings.push("selected revenue is 0 while a candidate orderSummary.subtotal is non-zero");
       if (expectedFromSelectedSummary?.costsFromMargin != null) {
         const selectedHasExplicitCosts = [stampCandidateReport, ...salesOrderCandidateReports, ...effectiveOrderCandidateReports]
           .find((candidate) => candidate.derived?.source === selected.source)?.summaryValues;
         const hasExplicitCosts = selectedHasExplicitCosts?.targetCosts != null || selectedHasExplicitCosts?.costs != null;
         if (!hasExplicitCosts && numbersDiffer(selected.costs, expectedFromSelectedSummary.costsFromMargin)) {
           warnings.push("selected costs differ from subtotal - bookedMarginAmount without explicit costs");
         }
       }
       if (numbersDiffer(selected.bookedMargin, expectedFromSelectedSummary?.bookedMargin)) warnings.push("selected bookedMargin differs from orderSummary.bookedMarginAmount");
       if (numbersDiffer(selected.bookedRevenue, expectedFromSelectedSummary?.revenue)) warnings.push("selected revenue differs from orderSummary.subtotal");
       if (selected.source === "fallback-zero") warnings.push("fallback-zero-used");
       if (selected.source === "previous-valid") warnings.push("previous-valid-used");

       return {
         orderId,
         selectedSource: selected.source,
         selectedFinancials: selected,
         expectedFromSelectedSummary,
         salesOrderSnapshotSummaryFound,
         liveOrderCartIgnoredBecauseBookedSummaryExists: liveOrderCartIgnored,
         candidates: {
           salesOrderStamp: toDebugCandidate(stampCandidateReport, "Sales Order Stamp"),
           salesOrderCart: salesOrderCandidateReports.map((candidate, index) => toDebugCandidate(candidate, index + 1)),
           orderCart: effectiveOrderCandidateReports.map((candidate) => toDebugCandidate(candidate, candidate.label)),
           previousValidFinancials: previousValidOverviewFinancialsRef.current,
         },
         warnings,
       };
     // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [OVERVIEW_FINANCIAL_DEBUG, order, orderId, salesOrderData, cartWorkspace?.cartPayload, overviewFinancials, approvedBookedSalesOrder]);

   useEffect(() => {
     if (!OVERVIEW_FINANCIAL_DEBUG || !overviewFinancialDebugOpen || !overviewFinancialDebugPayload) return;
     const candidates = [
       overviewFinancialDebugPayload.candidates.salesOrderStamp,
       ...overviewFinancialDebugPayload.candidates.salesOrderCart,
       ...overviewFinancialDebugPayload.candidates.orderCart,
     ].map((candidate) => ({
       label: candidate.label || `#${candidate.index}`,
       accepted: candidate.accepted,
       reason: candidate.reason,
       revenue: candidate.derivedFinancials?.bookedRevenue ?? candidate.summaryFields?.subtotal,
       costs: candidate.derivedFinancials?.costs,
       margin: candidate.derivedFinancials?.bookedMargin ?? candidate.summaryFields?.bookedMarginAmount,
       totalInclTax: candidate.derivedFinancials?.totalInclTax ?? candidate.summaryFields?.totalInclTax,
       products: candidate.productCount,
       items: candidate.itemCount,
       otherServices: candidate.otherServiceCount,
     }));
     console.groupCollapsed(`[overview-financials] Project #${orderId} selected ${overviewFinancialDebugPayload.selectedSource}`);
     console.table(candidates);
     if (overviewFinancialDebugPayload.warnings?.length) console.warn("Overview financial warnings", overviewFinancialDebugPayload.warnings);
     console.log("Overview financial debug", overviewFinancialDebugPayload);
     console.groupEnd();
   }, [OVERVIEW_FINANCIAL_DEBUG, overviewFinancialDebugOpen, overviewFinancialDebugPayload, orderId]);

   const copyOverviewFinancialDebugPayload = async () => {
     if (!overviewFinancialDebugPayload) return;
     await navigator.clipboard?.writeText(JSON.stringify(overviewFinancialDebugPayload, null, 2));
     toast.success("Overview financial debug payload copied.");
   };

  const poId = tabId ? parseInt(tabId, 10) : null;
  // Disable if still loading, or missing records, or not all approved
  const disableConvertToPO =
    shippingGate.loading ||
    (!perPoProofEvaluationEnabled && (!shippingGate.has || !shippingGate.allApproved)) ||
    (perPoProofEvaluationEnabled && !poProofValidation?.canGenerate) ||
    customerReviewGate.loading ||
    !customerReviewGate.passed ||
    !isSOCompleted ||
    loading ||
    !orderHydrated;
  const convertToPoActionState = getConvertToPoActionState({
    isConverting: creatingPO,
    hasConverted: perPoProofEvaluationEnabled
      ? (createdPO || hasGeneratedIncrementalPoCandidates)
      : hasConvertedToPO,
    isBlocked:
      disableConvertToPO ||
      isProofReadinessBlockingGeneration({
        mode: proofEnforcementMode,
        status: poProofReadiness.status,
      }),
    allowAdditionalGeneration: perPoProofEvaluationEnabled,
    hasRemainingPurchaseOrders,
  });

    const buildActionGuardTooltip = (actionLabel, opts = {}) => {
    const {
      soCompleted = false,
      gate = { loading: false, has: false, totalProducts: 0, allApproved: false, missingProductIds: [], incompleteProductIds: [], unapprovedProductIds: [], requireShippingConfirmation: false },
      soAvailable = true,
      customerGate = { loading: false, passed: true, tooltipMessage: "" },
    } = opts;

    if (gate.loading)    return "Checking shipping records…";
    if (!soAvailable)    return "No eligible Sales Order found.";
    if (customerGate.loading) return "Checking attached customer status…";
    if (!soCompleted)    return `${actionLabel} requires a Completed sales order.`;
    if (!customerGate.passed)
      return customerGate.tooltipMessage || "Customer review must pass before Purchase Orders can be generated.";
    if (!gate.has)       return `Missing shipping for ${gate.missingProductIds.length}/${gate.totalProducts} product(s).`;
    if (!gate.allApproved)
      return gate.requireShippingConfirmation
        ? `All shipping must be approved. Unapproved product(s): ${gate.unapprovedProductIds.join(", ")}`
        : `Incomplete shipping for product(s): ${(gate.incompleteProductIds?.length ? gate.incompleteProductIds : gate.missingProductIds).join(", ")}`;
    return `All checks passed. You can ${actionLabel.toLowerCase()}.`;
  };

  // Choose an SO id usable for creating POs when there's no tabId in the URL.
  const eligibleSOIdForPO = React.useMemo(() => {
    // The PO home route uses a symbolic tabId, not a Sales Order ID.
    // Prefer an explicit Sales Order revision only when it actually exists.
    const selectedSalesOrder = salesOrderData.find((so) =>
      String(so.estimationId) === String(tabId) || String(so.id) === String(tabId)
    );
    if (selectedSalesOrder) return selectedSalesOrder.estimationId || selectedSalesOrder.id;

    const sorted = [...salesOrderData].sort(
      (a, b) => new Date(b.orderDate || 0) - new Date(a.orderDate || 0)
    );

    const completed = sorted.find(so => APPROVED_OR_LATER_SO_STATUSES.has(String(so.status)));
    if (completed) return completed.estimationId || completed.id;

    const agreed = sorted.find(so => ['2', '2_sent'].includes(String(so.status)));
    if (agreed) return agreed.estimationId || agreed.id;

    return null;
  }, [tabId, salesOrderData]);

  // Standard PO generation has a single completed hand-off: revisit the already
  // generated POs/Proofs instead of showing the generation landing page again.
  // Advanced (per-purchase-order) generation must keep PO Home accessible so
  // users can generate remaining individual POs.
  useEffect(() => {
    if (normalizedTabType !== 'purchase-order-home' || !instanceUniqueId || !orderId) return;
    if (!poProofValidation || perPoProofEvaluationEnabled) return;

    const existing = (purchaseOrderData || []).filter((po) =>
      po && po.id != null && po.salesOrderId != null &&
      !po.archived && !po.isDeleted
    );
    if (!existing.length) return;

    const distinctSoIds = [...new Set(existing.map((po) => String(po.salesOrderId)))];
    const targetSoId = distinctSoIds.includes(String(eligibleSOIdForPO))
      ? String(eligibleSOIdForPO)
      : distinctSoIds.length === 1 ? distinctSoIds[0] : null;
    // Multiple historical SO revisions with no unambiguous active match:
    // retain the home page instead of guessing which proofs should open.
    if (!targetSoId) return;

    history.replace(`/instance/${instanceUniqueId}/sales/orders/${orderId}/pos-proofs/${targetSoId}`);
  }, [normalizedTabType, instanceUniqueId, orderId, poProofValidation,
    perPoProofEvaluationEnabled, purchaseOrderData, eligibleSOIdForPO, history]);

  // The deposit gate must evaluate the same Sales Order revision as the PO generator.
  // currentSO is null on /purchase-order-home because its tabId is not a document ID.
  useEffect(() => {
    if (normalizedTabType !== 'purchase-order-home' || !orderId || !eligibleSOIdForPO || !instanceUniqueId) {
      setPoDepositReadiness({ status: 'idle', message: '' });
      return;
    }
    let active = true;
    const controller = new AbortController();
    setPoDepositReadiness({ status: 'loading', message: '' });
    axios.get(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${orderId}/sales-orders/${eligibleSOIdForPO}/po-deposit-readiness`,
      {
        params: { instanceUniqueId },
        headers: { accessToken: localStorage.getItem('accessToken') },
        timeout: 5000,
        signal: controller.signal,
      }
    ).then(({ data }) => {
      if (active) setPoDepositReadiness(data?.status ? data : { status: 'unknown', message: 'Invalid payment readiness response.' });
    }).catch((error) => {
      if (!active) return;
      setPoDepositReadiness({
        status: 'unknown',
        message: error?.response?.data?.message ||
          (error?.code === 'ECONNABORTED'
            ? 'Payment verification timed out. Please retry.'
            : 'Unable to check Sales Order payment terms.'),
      });
    });
    return () => { active = false; controller.abort(); };
  }, [normalizedTabType, orderId, eligibleSOIdForPO, instanceUniqueId]);

  const isEligibleSOCompleted = React.useMemo(() => {
    const so = salesOrderData.find(so =>
      String(so.estimationId) === String(eligibleSOIdForPO) ||
      String(so.id)          === String(eligibleSOIdForPO)
    );
    return APPROVED_OR_LATER_SO_STATUSES.has(String(so?.status));
  }, [eligibleSOIdForPO, salesOrderData]);

  const refreshPoProofReadiness = React.useCallback(async () => {
    if (!eligibleSOIdForPO) {
      setPoProofValidation(null);
      setPoProofReadiness({ status: 'idle', error: null });
      return;
    }
    setPoProofReadiness(prev => prev.status === 'idle' || prev.status === 'error' ? { status: 'loading', error: null } : prev);
    try {
      const validation = await fetchPurchaseOrderProofPreflight(eligibleSOIdForPO);
      const mode = normalizeProofEnforcementMode(validation?.mode);
      setProofEnforcementMode(mode);
      setPoProofValidation(validation);
      setPoProofReadiness({
        status: normalizeProofReadinessStatus({ mode, validation }),
        error: null,
      });
    } catch (error) {
      setPoProofReadiness({
        status: 'error',
        error: error?.response?.data?.message || 'Proof readiness could not be checked.',
      });
    }
  }, [eligibleSOIdForPO]);

  const proofReadinessOrderVersion = React.useMemo(
    () => [
      order?.id,
      order?.OrderId,
      order?.updatedAt,
      order?.UpdatedAt,
      order?.OrderStatus?.PO,
    ].map((value) => value ?? '').join(':'),
    [order?.id, order?.OrderId, order?.updatedAt, order?.UpdatedAt, order?.OrderStatus?.PO]
  );

  useEffect(() => {
    refreshPoProofReadiness();
  }, [refreshPoProofReadiness, proofReadinessOrderVersion]);

  // Basic mode still uses its original first-time generation guards. The
  // outstanding-only action is offered solely when a server-side review finds
  // an eligible group not covered by any previously generated PO.
  useEffect(() => {
    if (!eligibleSOIdForPO || !hasGeneratedPurchaseOrders || perPoProofEvaluationEnabled) {
      setOutstandingSummary(null);
      return;
    }
    let active = true;
    fetchOutstandingPurchaseOrders(eligibleSOIdForPO)
      .then((result) => { if (active) setOutstandingSummary(result); })
      .catch(() => { if (active) setOutstandingSummary(null); });
    return () => { active = false; };
  }, [eligibleSOIdForPO, hasGeneratedPurchaseOrders, perPoProofEvaluationEnabled, proofReadinessOrderVersion, isPOProofDetailRoute]);



  useEffect(() => {
    const refreshOnReturn = () => {
      if (document.visibilityState === 'visible') refreshPoProofReadiness();
    };
    window.addEventListener('focus', refreshOnReturn);
    document.addEventListener('visibilitychange', refreshOnReturn);
    return () => {
      window.removeEventListener('focus', refreshOnReturn);
      document.removeEventListener('visibilitychange', refreshOnReturn);
    };
  }, [refreshPoProofReadiness]);
  

  const handleGeneratePOFromPOHome = async () => {
    if (generatePurchaseOrdersDisabled) return;
    try {
      setCreatingPO(true);
      setPoProofValidation(null);
      setPoGenStage(0);
  
      // kick off 15s stage ticker
      if (poGenTimerRef.current) clearInterval(poGenTimerRef.current);
      poGenTimerRef.current = setInterval(() => {
        setPoGenStage(prev => Math.min(prev + 1, PO_GEN_STAGES.length - 1));
      }, 15000);
  
      const response = await createPurchaseOrderApi(eligibleSOIdForPO);
      const result = response || {};
      const createdCount = Number(result?.summary?.created) || 0;

      if (createdCount > 0) {
        setCreatedPO(true);
        toast.success(result?.message || "Purchase Orders are being finalized. You can view them in POs/Proofs shortly.");
      } else {
        toast(result?.message || "No additional Purchase Orders are ready yet.");
      }
      await fetchOrder({ suppressLoader: true });
      await refreshPoProofReadiness();
      if (createdCount > 0) {
        history.push(`/instance/${instanceUniqueId}/sales/orders/${orderId}/pos-proofs/${eligibleSOIdForPO}`);
      }
    } catch (error) {
      if (error?.response?.data?.proofValidation) {
        const validation = error.response.data.proofValidation;
        const mode = normalizeProofEnforcementMode(validation.mode);
        setPoProofValidation(validation);
        setProofEnforcementMode(mode);
        setPoProofReadiness({
          status: normalizeProofReadinessStatus({ mode, validation }),
          error: null,
        });
      }
      if (error?.response?.data?.code === 'CUSTOMER_REVIEW_REQUIRED') {
        if (customerData?.id) {
          await loadAttachedCustomer(customerData.id);
        }
        toast.error(
          error?.response?.data?.message ||
          "Purchase Orders cannot be generated until this Lead has been converted to a Customer."
        );
        return;
      }
      const isCORS = error?.message === 'Network Error' && !error?.response;
      if (isCORS) {
        // Likely CORS/preflight/redirect blocked by browser
        toast.warn("Request was blocked by the browser (CORS). The server may still be generating the POs—check POs/Proofs.");
        // optional: optimistic refresh
        await fetchOrder();
      } else {
        toast.error(error?.response?.data?.message || "Failed to generate purchase order. Please complete required steps.");
      }
    } finally {
      if (poGenTimerRef.current) {
        clearInterval(poGenTimerRef.current);
        poGenTimerRef.current = null;
      }
      setCreatingPO(false);
    }
  };
  
  

  const convertTooltip = perPoProofEvaluationEnabled
    ? allIncrementalPosComplete
      ? "All Purchase Order candidates have already been generated."
      : poProofReadiness.status === "blocked"
        ? "Remaining Purchase Orders are waiting on proof approval."
        : (createdPO || hasGeneratedIncrementalPoCandidates)
          ? `${readyToCreatePoCount} PO${readyToCreatePoCount === 1 ? "" : "s"} ready to generate · ${blockedPoCandidateCount} waiting on requirements.`
          : buildActionGuardTooltip("Convert To PO", {
              soCompleted: isSOCompleted,
              gate: shippingGate,
              soAvailable: true,
              customerGate: customerReviewGate,
            })
    : hasConvertedToPO
      ? "This Sales Order has already been converted to Purchase Order(s)."
      : buildActionGuardTooltip("Convert To PO", {
          soCompleted: isSOCompleted,
          gate: shippingGate,
          soAvailable: true,
          customerGate: customerReviewGate,
        });

      const financialsOpen = React.useMemo(
      () => isFinancialsOpen({ so: soStatus, po: order?.OrderStatus?.PO }),
      [soStatus, order?.OrderStatus?.PO]
    );

    const invoiceTooltip = invoiceCreatedActionState.created
      ? `Invoice #${invoiceCreatedActionState.invoiceId} has already been created for this Sales Order. You can still review an available balance or create another eligible invoice.`
      : invoiceCreatedActionCheck.loading && invoiceCreatedCheckIsCurrent
        ? "Checking existing invoices for this Sales Order…"
        : invoiceCreatedActionCheck.error && invoiceCreatedCheckIsCurrent
          ? "Existing invoices could not be verified. Open Create Invoice to review the current balance."
          : financialsOpen
            ? "Financials are open — you can create an invoice."
            : "Requires SO = Client Approved (or later) and PO = Ready For Billing / Closed / Billed.";

    const disableCreateInvoice = !financialsOpen;


  const disableConvertToPO_POHome =
  shippingGate.loading ||
  (!perPoProofEvaluationEnabled && (!shippingGate.has || !shippingGate.allApproved)) ||
  (perPoProofEvaluationEnabled && !poProofValidation?.canGenerate) ||
  customerReviewGate.loading ||
  !customerReviewGate.passed ||
  !isEligibleSOCompleted ||
  !eligibleSOIdForPO;

  const purchaseOrdersLoading = loading || !orderHydrated;
  const basicOutstandingReady = !perPoProofEvaluationEnabled &&
    hasGeneratedPurchaseOrders &&
    isEligibleSOCompleted &&
    customerReviewGate.passed &&
    !!eligibleSOIdForPO &&
    Number(outstandingSummary?.summary?.readyToCreatePurchaseOrderCount || 0) > 0;
  const generatePurchaseOrdersDisabled =
    purchaseOrdersLoading ||
    creatingPO ||
    (!perPoProofEvaluationEnabled && (createdPO || hasGeneratedPurchaseOrders) && !basicOutstandingReady) ||
    (perPoProofEvaluationEnabled && allIncrementalPosComplete) ||
    (!basicOutstandingReady && isProofReadinessBlockingGeneration({
      mode: proofEnforcementMode,
      status: poProofReadiness.status,
    })) ||
    (!basicOutstandingReady && disableConvertToPO_POHome);

  // The /pos-proofs/:salesOrderId route is the landing page for orders that
  // already have POs. Offer the same outstanding-only review directly there;
  // do not route users back through the first-time Basic generation button.
  const outstandingPoReadyCount = Number(outstandingSummary?.summary?.readyToCreatePurchaseOrderCount) || 0;
  const outstandingPoWaitingCount = Number(outstandingSummary?.summary?.blockedPurchaseOrderCount) || 0;
  const outstandingPoCanReview = !!eligibleSOIdForPO &&
    !loading && orderHydrated && !creatingPO;
  const outstandingPoDetailButtonLabel = outstandingSummary == null
    ? 'Check Outstanding POs'
    : outstandingPoReadyCount > 0
      ? `Generate ${outstandingPoReadyCount} Outstanding PO${outstandingPoReadyCount === 1 ? '' : 's'}`
      : outstandingPoWaitingCount > 0
        ? `Review ${outstandingPoWaitingCount} Pending PO${outstandingPoWaitingCount === 1 ? '' : 's'}`
        : 'All POs Generated';

  const refreshOutstandingPoScreens = async () => {
    setOutstandingPoListRefresh((value) => value + 1);
    await fetchOrder({ suppressLoader: true });
    try {
      setOutstandingSummary(await fetchOutstandingPurchaseOrders(eligibleSOIdForPO));
    } catch (error) {
      // Keep the manual review accessible if its prefetch fails.
      setOutstandingSummary(null);
    }
  };

  const readyPoGroups = perPoProofEvaluationEnabled
    ? (poProofValidation?.groups || []).filter(group => group.shouldGenerate === true && !group.alreadyGenerated)
    : [];
  const readyPoDescription = readyPoGroups.map((group, index) => {
    const supplier = group.supplierName || group.routeSummary || `Purchase Order ${index + 1}`;
    const type = String(group.type || '');
    const decoration = type === 'Same_supplier_decoration'
      ? (group.disposition === 'supplier_proof_source'
        ? 'supplier-managed decoration; artwork / supplier proof to follow'
        : 'supplier-managed decoration')
      : type === 'Different_supplier_decoration'
        ? (group.isEliteDecoratorGroup
          ? 'internal Elite decoration; artwork approval required'
          : group.isDecorationNetworkGroup
            ? 'Decoration Network; separate decorator PO'
            : 'external decoration; separate decorator PO')
        : type === 'No_decoration'
          ? 'products only'
          : type === 'Other_service_art'
            ? 'artwork service'
            : 'PO';
    return `${supplier} (${decoration})`;
  }).join('; ');

  const convertTooltip_POHome = allIncrementalPosComplete
    ? "All Purchase Order candidates have already been generated."
    : eligibleSOIdForPO && isProofReadinessBlockingGeneration({
        mode: proofEnforcementMode,
        status: poProofReadiness.status,
      })
      ? (poProofReadiness.status === 'loading' || poProofReadiness.status === 'idle'
        ? 'Checking proof readiness…'
        : poProofReadiness.status === 'error'
          ? 'Proof readiness could not be checked. Retry the check before generating Purchase Orders.'
          : perPoProofEvaluationEnabled
            ? 'Remaining Purchase Orders are waiting on proof or shipping requirements.'
            : 'Required proofs need attention before Purchase Orders can be generated.')
      : perPoProofEvaluationEnabled && readyPoGroups.length > 0
        ? `Will generate ${readyPoGroups.length} PO${readyPoGroups.length === 1 ? '' : 's'}: ${readyPoDescription}. ${blockedPoCandidateCount} waiting on requirements.`
        : buildActionGuardTooltip("Generate Purchase Orders", {
            soCompleted: isEligibleSOCompleted,
            gate: shippingGate,
            soAvailable: !!eligibleSOIdForPO,
            customerGate: customerReviewGate,
          });

    
  // same gating for both actions:
  //const disableCreateInvoice = disableConvertToPO;

          const getDocPreviewPath = (status, estimationId) => {
            if (isEstimateRoute) return `/generated-estimate/${estimationId}`;
            if (isSalesOrderRoute) return `/generated-sales-order/${estimationId}`;
            return ['1', '1_sent'].includes(String(status))
              ? `/generated-estimate/${estimationId}`
              : `/generated-sales-order/${estimationId}`;
          };
        
   // Unique users who actually have notes on this project
   const commentersOnly = React.useMemo(() => {
     const byId = new Map();          // id -> { id, label }
     const byNameOnly = new Map();    // label -> { id:null, label } for notes missing userId
  
     const all = Array.isArray(allNotes) ? allNotes : [];
     all.forEach(n => {
       const id = (n.userId != null && String(n.userId)) || null;
       const name = `${n.userName || ""}`.trim();
  
       // Prefer mapping by id when we have one
       if (id) {
         if (!byId.has(id)) {
           // Try to enrich label from availableUsers; fallback to note userName or "User #id"
           const u = (normalizedMentionUsers || []).find(u => String(u.id) === id);
           const label = u
             ? u.display || `User #${u.id}`
             : (name || `User #${id}`);
           byId.set(id, { id, label });
         }
       } else if (name) {
         // No id on the note — keep a name-only option so we can still filter
         if (!byNameOnly.has(name.toLowerCase())) {
           byNameOnly.set(name.toLowerCase(), { id: `name:${name}`, label: name });
         }
       }
     });
  
     // Merge id-based first (preferred), then any name-only items not already represented
     const list = [...byId.values()];
     byNameOnly.forEach(v => {
       if (!list.some(x => x.label.toLowerCase() === v.label.toLowerCase())) list.push(v);
     });
     // Sort alphabetically
     return list.sort((a, b) => a.label.localeCompare(b.label));
   }, [allNotes, normalizedMentionUsers]);
  
   // When the filter changes or the notes list updates, reset to page 1 so we don't land on an empty page
   useEffect(() => { setNotesPage(1); }, [noteFilterUser, noteSortAsc, allNotes, showCartChanges, infiniteNotesEnabled]);
   useEffect(() => {
     try {
       window.localStorage.setItem(PROJECT_NOTES_CART_FILTER_KEY, String(showCartChanges));
     } catch (_error) {
       // Ignore persistence failures so notes remain usable.
     }
   }, [showCartChanges]);
   useEffect(() => {
     try {
       window.localStorage.setItem(PROJECT_NOTES_INFINITE_SCROLL_KEY, String(infiniteNotesEnabled));
     } catch (_error) {
       // Ignore persistence failures so notes remain usable.
     }
   }, [infiniteNotesEnabled]);

  const loadDocumentSnapshotHistory = async () => {
    const {
      orderIdFromPath,
      documentType,
      documentId,
    } = getDocumentContextFromPath();

    const currentOrderId = order?.OrderId || orderId || orderIdFromPath;

    if (!currentOrderId || !documentType || !documentId) {
      setDocumentSnapshotHistory([]);
      return;
    }

    try {
      setDocumentSnapshotHistoryLoading(true);

      const res = await fetchDocumentSnapshots(
        currentOrderId,
        documentType,
        documentId
      );

      setDocumentSnapshotHistory(Array.isArray(res?.snapshots) ? res.snapshots : []);
    } catch (err) {
      console.error('[document snapshot history] failed:', err);
      setDocumentSnapshotHistory([]);
    } finally {
      setDocumentSnapshotHistoryLoading(false);
    }
  };

const isGeneratedSalesOrderPage =
  /\/sales\/orders\/[^/]+\/sales-order\/[^/]+\/?$/.test(pathname);

const isSalesOrderPage =
  /\/sales\/orders\/[^/]+\/sales-order\/?$/.test(pathname);

const isGeneratedEstimationPage =
  /\/sales\/orders\/[^/]+\/estimation\/[^/]+\/?$/.test(pathname);

const isInvoicePage =
  /\/sales\/orders\/[^/]+\/invoice\/?$/.test(pathname);

const isPresentationPage =
  /\/sales\/orders\/[^/]+\/presentation(?:\/[^/]+)?\/?$/.test(pathname);

const invoiceInitialSettled = orderHydrated &&
  invoiceCartsSettledOrderId === String(orderId) &&
  invoiceDataSettledOrderId === String(orderId) &&
  !invoicingCartsLoading &&
  (selectableInvoicingCarts.length === 0 || (selectedInvoiceCartIsValid &&
    !cartWorkspace.loading && (
      cartWorkspace.loadedInvoicingCartKey === selectedInvoicingCartKey ||
      Boolean(cartWorkspace.error || cartWorkspace.missing)
    )
  ));
const invoicePageReady = invoicePageRevealedOrderId === String(orderId);
useEffect(() => {
  if (isInvoicePage && invoiceInitialSettled && !invoicePageReady) {
    setInvoicePageRevealedOrderId(String(orderId));
  }
}, [isInvoicePage, invoiceInitialSettled, invoicePageReady, orderId]);

const shouldShow =
  isSalesOrderPage ||
  isGeneratedSalesOrderPage ||
  isGeneratedEstimationPage ||
  (isInvoicePage && invoicePageReady && selectedInvoiceCartIsValid &&
    cartWorkspace.loadedInvoicingCartKey === selectedInvoicingCartKey &&
    !cartWorkspace.loading && !cartWorkspace.missing && !cartWorkspace.error) ||
  isPresentationPage

const showInitialOrderPageLoader = !orderHydrated;

  return (
    <div className={`instance-dashboard single-order-container instance-order-page${isSidebar ? ` left-sidebar-guide` : `` } `}>
      <InstanceLeftSidebar />
      <Toaster position="top-right" />
      <div className="rightSide place-items-top">
        {showInitialOrderPageLoader ? (
          <Box
            className="order-page-initial-loader"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              flex: 1,
              minHeight: 0,
            }}
          >
            <CircularProgress />
          </Box>
        ) : docRegenerationInProgress ? (
          (activeRegenerationDocType === 'estimate' || activeRegenerationDocType === 'sales-order' || activeRegenerationDocType === 'presentation') ? (
            <RegenerationLoader type={activeRegenerationDocType} />
          ) : (
            <div className="page-loading-in-progress">
              <p>Loading...</p>
            </div>
          )
        ) : loading ? (
          <div className="page-loading-in-progress">
            <p>Loading...</p>
          </div>
        ) : (
          <>
            <div className="options-container fade-in-effect-usability">
              <div className="options-inner-container no-relativity">
              <div className="order-page-header">
              <PageHeaderWithBreadcrumbs
                title={
                  <div className="order-page-title">
                    {customerData?.customUploadedBrandLogo && (
                      <img
                        src={customerData.customUploadedBrandLogo}
                        alt="Customer Logo"
                        className="order-page-title-logo"
                      />
                    )}
                    <span>
                      Project #{orderId}
                      {projectHeaderCustomerName ? (
                        <>
                          {" - "}
                          {projectHeaderCustomerHref ? (
                            <Tooltip title="Open customer" arrow>
                              <Link
                                href={projectHeaderCustomerHref}
                                target="_blank"
                                rel="noopener noreferrer"
                                underline="hover"
                                color="primary"
                                sx={{
                                  fontSize: "inherit",
                                  fontWeight: "inherit",
                                  verticalAlign: "inherit",
                                }}
                              >
                                {projectHeaderCustomerName}
                              </Link>
                            </Tooltip>
                          ) : (
                            projectHeaderCustomerName
                          )}
                        </>
                      ) : null}
                    </span>
                  </div>
                }
                breadcrumb="Sales > Projects"
                includeButton={true}
              />
              </div>

              {/* <div className="order-context-strip">
                <div className="order-context-primary">
                  <div className="order-context-item">
                    <span className="order-context-label">Project</span>
                    <span className="order-context-value">
                      {order?.ProjectName || `Project #${orderId}`}
                    </span>
                  </div>
                  <div className="order-context-item">
                    <span className="order-context-label">Customer</span>
                    <span className="order-context-value">
                      {customerData?.businessName || "Not attached"}
                    </span>
                  </div>
                  {order?.EventType ? (
                    <div className="order-context-item">
                      <span className="order-context-label">Event Type</span>
                      <span className="order-context-value">{order.EventType}</span>
                    </div>
                  ) : null}
                </div>
                <div className="order-context-status">
                  {renderStatusChips(order?.OrderStatus?.SO, order?.OrderStatus?.PO, getWorkflowLabel)}
                  {customerData?.status ? (
                    <Chip
                      size="small"
                      variant="outlined"
                      label={customerData.status}
                      className="order-context-customer-chip"
                    />
                  ) : null}
                </div>
              </div> */}
 
<div className="op-highlights">
 
  <div className="op-hl-cards">
 
    <div className="op-hl-card">
      <div className="op-hl-card-icon op-hl-icon-customer">
        <PersonIcon sx={{ fontSize: 15 }} />
      </div>
      <div className="op-hl-card-content">
        <span className="op-hl-card-label">Customer</span>
        <span className="op-hl-card-value">
          {customerData?.customUploadedBrandLogo && (
            <img src={customerData.customUploadedBrandLogo} alt="" className="op-hl-card-logo" />
          )}
          {customerData?.businessName || "Not attached"}
        </span>
        <span className="op-hl-card-sub">
          {order?.ProjectName || `Project #${orderId}`}
        </span>
      </div>
    </div>

    <div className="op-hl-card-divider" />
 
    <div className="op-hl-card">
      <div className="op-hl-card-icon op-hl-icon-stage">
        <UpdateIcon sx={{ fontSize: 15 }} />
      </div>
      <div className="op-hl-card-content">
        <span className="op-hl-card-label">Order Status</span>
 
        <div className="op-hl-status-row">
          <span className="op-hl-status-tag op-hl-status-so">SO</span>
          <span className="op-hl-card-value" style={{ fontSize: "0.82rem" }}>
            {order?.OrderStatus?.SO || "—"}
          </span>
        </div>
 
        <div className="op-hl-status-row" style={{ marginTop: 3 }}>
          <span className="op-hl-status-tag op-hl-status-po">PO</span>
          <span className="op-hl-card-sub" style={{ color: order?.OrderStatus?.PO ? "var(--order-text)" : "var(--order-text-muted)" }}>
            {order?.OrderStatus?.PO || "Not started"}
          </span>
        </div>
      </div>
 
      {(() => {
        const stages = [
          "Quote Requested","Waiting","Presentation Draft","Presentation Sent",
          "Estimate Draft","Estimate Sent","Agreement Pending","Agreement Sent",
          "Client Change Requested","Client Approved","In Production",
          "Shipped","Ready to be Invoiced","Invoiced","Paid","Closed",
        ];
        const idx = stages.findIndex(
          (s) => s.toLowerCase() === (order?.OrderStatus?.SO || "").toLowerCase()
        );
        const pct = idx >= 0 ? Math.round(((idx + 1) / stages.length) * 100) : 0;
        return (
          <div className="op-hl-card-progress">
            <div className="op-hl-card-progress-bar" style={{ width: `${pct}%` }} />
          </div>
        );
      })()}
    </div>

    {projectHeaderSettings.showBookedRevenue && (
      <>
        <div className="op-hl-card-divider" />
 
        <div className="op-hl-card">
          <div className="op-hl-card-icon op-hl-icon-revenue">
            <ReceiptLongIcon sx={{ fontSize: 15 }} />
          </div>
          <div className="op-hl-card-content">
            <span className="op-hl-card-label" style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
              {overviewFinancials.source === "order-cart" ? "Cart Revenue" : "Booked Revenue"}
              {OVERVIEW_FINANCIAL_DEBUG && overviewFinancialDebugPayload && (
                <Tooltip title="Open overview financial debug payload">
                  <IconButton
                    size="small"
                    onClick={(event) => {
                      event.stopPropagation();
                      setOverviewFinancialDebugOpen(true);
                    }}
                    sx={{ p: 0.25, color: "text.secondary", opacity: 0.75 }}
                  >
                    <InfoOutlinedIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                </Tooltip>
              )}
            </span>
            <span className="op-hl-card-value" style={{ fontVariantNumeric: "tabular-nums" }}>
              {isBookedFinancialsUnavailable ? "—" : formatOverviewCurrency(overviewFinancials.bookedRevenue)}
            </span>
            <span className="op-hl-card-sub">
              {isBookedFinancialsUnavailable
                ? "Booked financials unavailable"
                : <>Costs: {formatOverviewCurrency(overviewFinancials.costs)}</>}
            </span>
          </div>
        </div>
      </>
    )}

    {projectHeaderSettings.showBookedMargin && (
      <>
        <div className="op-hl-card-divider" />
 
        <div className="op-hl-card">
          <div className="op-hl-card-icon op-hl-icon-margin">
            <MonetizationOnIcon sx={{ fontSize: 15 }} />
          </div>
          <div className="op-hl-card-content">
            <span className="op-hl-card-label">Booked Margin</span>
            <span
              className="op-hl-card-value"
              style={{
                color: Number.isFinite(bookedMarginForUI)
                  ? bookedMarginForUI >= 0 ? "#16a34a" : "#dc2626"
                  : "inherit",
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {Number.isFinite(bookedMarginForUI)
                ? `$${bookedMarginForUI.toLocaleString("en-CA", { minimumFractionDigits: 2 })}`
                : "—"}
            </span>
            {(() => {
              const computedPct = calculateBookedMarginPct(overviewFinancials.bookedRevenue, bookedMarginForUI);
              const pct = computedPct === null ? null : computedPct.toFixed(2);
              return isBookedFinancialsUnavailable ? (
                <span className="op-hl-card-sub" style={{ color: "#b45309" }}>
                  Review approved Sales Order financials
                </span>
              ) : pct !== null ? (
                <span
                  className="op-hl-card-sub"
                  style={{
                    color: parseFloat(pct) >= 30 ? "#16a34a"
                      : parseFloat(pct) > 0 ? "#d97706" : "#64748b"
                  }}
                >
                  {parseFloat(pct) >= 0 ? "▲" : "▼"} {pct}% margin
                </span>
              ) : (
                <span className="op-hl-card-sub" style={{ opacity: 0.5 }}>No revenue yet</span>
              );
            })()}
          </div>
        </div>
      </>
    )}

    {projectHeaderSettings.showBookedMargin && billedMarginView && (
      <>
        <div className="op-hl-card-divider" />

        <div className="op-hl-card" data-testid="project-header-billed-margin">
          <div className="op-hl-card-icon op-hl-icon-margin">
            <MonetizationOnIcon sx={{ fontSize: 15 }} />
          </div>
          <div className="op-hl-card-content">
            <span className="op-hl-card-label">Billed Margin</span>
            <span
              className="op-hl-card-value"
              style={{
                color: billedMarginView.actualMargin >= 0 ? "#16a34a" : "#dc2626",
                fontVariantNumeric: "tabular-nums",
              }}
            >
              {formatOverviewCurrency(billedMarginView.actualMargin)}
            </span>
            <span
              className="op-hl-card-sub"
              style={{
                color: billedMarginView.marginPercent >= 30
                  ? "#16a34a"
                  : billedMarginView.marginPercent > 0
                    ? "#d97706"
                    : billedMarginView.marginPercent < 0 ? "#dc2626" : "#64748b",
              }}
            >
              {billedMarginView.marginPercent >= 0 ? "▲" : "▼"}{" "}
              {billedMarginView.marginPercent.toFixed(2)}% margin
            </span>
          </div>
        </div>
      </>
    )}

    {projectHeaderSettings.showInHandsDate && (
      <>
        <div className="op-hl-card-divider" />
 
        <div className="op-hl-card">
          <div className="op-hl-card-icon op-hl-icon-date">
            <AccessTimeIcon sx={{ fontSize: 15 }} />
          </div>
          <div className="op-hl-card-content">
            <span className="op-hl-card-label">In-Hands Date</span>
            {(order?.inHandsDate || order?.inhandsDate) ? (() => {
              const d = new Date(order?.inHandsDate || order?.inhandsDate);
              const daysLeft = Math.ceil((d - new Date()) / (1000 * 60 * 60 * 24));
              const isUrgent = daysLeft >= 0 && daysLeft <= 7;
              const isOverdue = daysLeft < 0;
              return (
                <>
                  <span
                    className="op-hl-card-value"
                    style={{ color: isOverdue ? "#dc2626" : isUrgent ? "#d97706" : "inherit" }}
                  >
                    {d.toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" })}
                  </span>
                  <span
                    className="op-hl-card-sub"
                    style={{
                      color: isOverdue ? "#dc2626" : isUrgent ? "#d97706" : "var(--order-text-muted)"
                    }}
                  >
                    {isOverdue
                      ? `⚠ ${Math.abs(daysLeft)}d overdue`
                      : isUrgent
                      ? `⚠ ${daysLeft}d left`
                      : `${daysLeft} days away`}
                  </span>
                </>
              );
            })() : (
              <>
                <span className="op-hl-card-value" style={{ opacity: 0.45 }}>Not set</span>
                <span className="op-hl-card-sub">No deadline assigned</span>
              </>
            )}
          </div>
        </div>
      </>
    )}

  </div>

  <div className="op-hl-chips">
 
    {order?.OrderStatus?.SO && (
      <Chip
        size="small"
        label={`SO: ${order.OrderStatus.SO}`}
        sx={{
          fontFamily: '"Nunito"', fontWeight: 700, fontSize: "0.72rem", height: 22,
          bgcolor: "#fef3c7", color: "#92400e", border: "1px solid #fde68a",
        }}
      />
    )}
 
    {order?.OrderStatus?.PO && (
      <Chip
        size="small"
        label={`PO: ${order.OrderStatus.PO}`}
        sx={{
          fontFamily: '"Nunito"', fontWeight: 700, fontSize: "0.72rem", height: 22,
          bgcolor: "#eff6ff", color: "#1d4ed8", border: "1px solid #bfdbfe",
        }}
      />
    )}
 
    {customerData?.status && (
      <Chip
        size="small"
        variant="outlined"
        label={customerData.status === "active" ? "✓ Active" : customerData.status}
        sx={{
          textTransform: "capitalize",
          fontFamily: '"Nunito"', fontWeight: 700, fontSize: "0.72rem", height: 22,
          ...(customerData.status === "active" && {
            bgcolor: "#f0fdf4", color: "#16a34a", borderColor: "#86efac",
          }),
          ...(customerData.status === "lead" && {
            bgcolor: "#fff7ed", color: "#c2410c", borderColor: "#fed7aa",
          }),
          ...(customerData.status === "in-review" && {
            bgcolor: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe",
          }),
        }}
      />
    )}
 
    {order?.EventType && (
      <Chip
        size="small"
        icon={<EventIcon sx={{ fontSize: "13px !important" }} />}
        label={order.EventType}
        sx={{
          fontFamily: '"Nunito"', fontWeight: 600, fontSize: "0.72rem", height: 22,
          bgcolor: "#f5f3ff", color: "#6d28d9", border: "1px solid #ddd6fe",
        }}
      />
    )}
 
    {customerTermsChip && (customerTermsTooltip ? (
      <Tooltip title={customerTermsTooltip} arrow>
        {customerTermsChip}
      </Tooltip>
    ) : customerTermsChip)}
 
    {linkedClientContactName && (
      <Chip
        size="small"
        icon={<PersonIcon sx={{ fontSize: "13px !important" }} />}
        label={linkedClientContactName}
        sx={{
          fontFamily: '"Nunito"', fontWeight: 600, fontSize: "0.72rem", height: 22,
          bgcolor: "#f0f9ff", color: "#0369a1", border: "1px solid #bae6fd",
        }}
      />
    )}
 
    {order?.subStatus?.label && (
      <Chip
        size="small"
        label={`↳ ${order.subStatus.label}`}
        sx={{
          fontFamily: '"Nunito"', fontWeight: 600, fontSize: "0.72rem", height: 22,
          bgcolor: "#fafaf9", color: "#57534e", border: "1px solid #d6d3d1",
        }}
      />
    )}
 
    {order?.createdAt && (
      <Chip
        size="small"
        icon={<AccessTimeIcon sx={{ fontSize: "13px !important" }} />}
        label={`Created ${new Date(order.createdAt).toLocaleDateString("en-CA", {
          month: "short", day: "numeric", year: "numeric"
        })}`}
        sx={{
          fontFamily: '"Nunito"', fontWeight: 500, fontSize: "0.72rem", height: 22,
          bgcolor: "#f8fafc", color: "#94a3b8", border: "1px solid #e2e8f0",
          marginLeft: "auto",  /* pushes to right end */
        }}
      />
    )}

  </div>

</div>

{OVERVIEW_FINANCIAL_DEBUG && overviewFinancialDebugPayload && (
  <Dialog
    open={overviewFinancialDebugOpen}
    onClose={() => setOverviewFinancialDebugOpen(false)}
    maxWidth="md"
    fullWidth
  >
    <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
      <span>Overview Financial Debug</span>
      <IconButton size="small" onClick={() => setOverviewFinancialDebugOpen(false)}>
        <CancelIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>
      {/* TEMP DEBUG: remove after Project Overview financial KPI source verification is complete. */}
      <Stack spacing={2}>
        <Box>
          <Typography variant="subtitle2" fontWeight={800}>Selected source: {overviewFinancialDebugPayload.selectedSource || "—"}</Typography>
          <Typography variant="body2">Revenue: {formatOverviewCurrency(overviewFinancialDebugPayload.selectedFinancials?.bookedRevenue)}</Typography>
          <Typography variant="body2">Costs: {formatOverviewCurrency(overviewFinancialDebugPayload.selectedFinancials?.costs)}</Typography>
          <Typography variant="body2">Booked Margin: {formatOverviewCurrency(overviewFinancialDebugPayload.selectedFinancials?.bookedMargin)}</Typography>
          <Typography variant="body2">Booked Margin %: {Number.isFinite(toMoneyNumber(overviewFinancialDebugPayload.selectedFinancials?.bookedMarginPct, Number.NaN)) ? `${toMoneyNumber(overviewFinancialDebugPayload.selectedFinancials?.bookedMarginPct).toFixed(2)}%` : "—"}</Typography>
          <Typography variant="body2">Total Incl Tax: {formatOverviewCurrency(overviewFinancialDebugPayload.selectedFinancials?.totalInclTax)}</Typography>
          <Typography variant="body2">Sales Order snapshot summary found: {overviewFinancialDebugPayload.salesOrderSnapshotSummaryFound ? "yes" : "no"}</Typography>
          <Typography variant="body2">Live order cart ignored because booked Sales Order summary exists: {overviewFinancialDebugPayload.liveOrderCartIgnoredBecauseBookedSummaryExists ? "yes" : "no"}</Typography>
        </Box>

        {overviewFinancialDebugPayload.expectedFromSelectedSummary && (
          <Box>
            <Typography variant="subtitle2" fontWeight={800}>Expected from summary</Typography>
            <Typography variant="body2">Subtotal: {formatOverviewCurrency(overviewFinancialDebugPayload.expectedFromSelectedSummary.subtotal)}</Typography>
            <Typography variant="body2">Total Incl Tax: {formatOverviewCurrency(overviewFinancialDebugPayload.expectedFromSelectedSummary.totalInclTax)}</Typography>
            <Typography variant="body2">Booked Margin Amount: {formatOverviewCurrency(overviewFinancialDebugPayload.expectedFromSelectedSummary.bookedMarginAmount)}</Typography>
            <Typography variant="body2">
              Booked Margin %: {overviewFinancialDebugPayload.expectedFromSelectedSummary.bookedMarginPct != null
                ? `${overviewFinancialDebugPayload.expectedFromSelectedSummary.bookedMarginPct.toFixed(2)}%`
                : overviewFinancialDebugPayload.expectedFromSelectedSummary.subtotal
                  ? `${(((overviewFinancialDebugPayload.expectedFromSelectedSummary.bookedMarginAmount || 0) / overviewFinancialDebugPayload.expectedFromSelectedSummary.subtotal) * 100).toFixed(2)}%`
                  : "—"}
            </Typography>
            <Typography variant="body2">Expected Costs: {formatOverviewCurrency(overviewFinancialDebugPayload.expectedFromSelectedSummary.costsFromMargin)}</Typography>
          </Box>
        )}

        <Box>
          <Typography variant="subtitle2" fontWeight={800}>Candidate status</Typography>
          <Typography variant="body2">Sales Order Stamp: {overviewFinancialDebugPayload.candidates.salesOrderStamp.reason}</Typography>
          {overviewFinancialDebugPayload.candidates.salesOrderCart.map((candidate) => (
            <Typography key={`so-cart-${candidate.index}`} variant="body2">
              Sales Order Cart Candidate #{candidate.index}: {candidate.reason}
            </Typography>
          ))}
          {overviewFinancialDebugPayload.candidates.orderCart.map((candidate) => (
            <Typography key={candidate.label} variant="body2">
              {candidate.label}: {candidate.reason}
            </Typography>
          ))}
          <Typography variant="body2">
            Previous Valid: {overviewFinancialDebugPayload.candidates.previousValidFinancials ? "present" : "none"}
          </Typography>
        </Box>

        {overviewFinancialDebugPayload.warnings?.length > 0 && (
          <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
            {overviewFinancialDebugPayload.warnings.map((warning) => (
              <Chip key={warning} size="small" color="warning" variant="outlined" label={warning} />
            ))}
          </Stack>
        )}

        <Box>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
            <Typography variant="subtitle2" fontWeight={800}>Raw JSON payload</Typography>
            <Button size="small" variant="outlined" onClick={copyOverviewFinancialDebugPayload}>Copy Debug Payload</Button>
          </Stack>
          <Box
            component="pre"
            sx={{
              m: 0,
              p: 1.5,
              maxHeight: 360,
              overflow: "auto",
              bgcolor: "#0f172a",
              color: "#e2e8f0",
              borderRadius: 1,
              fontSize: 12,
              whiteSpace: "pre-wrap",
            }}
          >
            {JSON.stringify(overviewFinancialDebugPayload, null, 2)}
          </Box>
        </Box>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => setOverviewFinancialDebugOpen(false)}>Close</Button>
    </DialogActions>
  </Dialog>
)}
           
              {!customerIsCreditHold ? (
               


<Box
  className="order-tabs-shell"
  sx={{
    borderBottom: 1,
    borderColor: "divider",
    bgcolor: "background.paper",
    position: "sticky",
    top: 0,
    zIndex: 10,
    display: "flex",
    alignItems: "center",
    pr: 1,
  }}
>
  <Tabs
    value={tabsToShow.includes(activeTab) ? activeTab : tabsToShow[0]}
    onChange={(_, val) => handleTabChange(val)}
    variant="scrollable"
    scrollButtons="auto"
    sx={{
      flex: 1,
      minHeight: 44,
      "& .MuiTab-root": {
        minHeight: 44,
        fontSize: "0.8125rem",
        fontWeight: 600,
        textTransform: "none",
        letterSpacing: 0,
        color: "text.secondary",
        opacity: 1,
        py: 0,
        px: 1.75,
        gap: 0.625,
      },
      "& .Mui-selected": {
        color: "primary.main",
        fontWeight: 700,
      },
      "& .MuiTabs-indicator": {
        height: 2.5,
        borderRadius: "2px 2px 0 0",
        backgroundColor: "primary.main",
      },
      "& .Mui-disabled": {
        opacity: "0.38 !important",
        cursor: "not-allowed",
      },
    }}
  >
    {ALL_TABS_WITH_ICONS
      .filter(({ key }) => tabsToShow.includes(key))
      .map(({ key, label, icon }) => {
        const isDisabled = disabledTabs.has(key);
        const tip = tabTips[key];

        const tabEl = (
          <Tab
            key={key}
            value={key}
            disabled={isDisabled}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                {icon}
                {label}
              </Box>
            }
          />
        );
 
        return isDisabled && tip ? (
          <Tooltip key={key} title={tip} placement="bottom" arrow>
            <span style={{ display: "inline-flex" }}>{tabEl}</span>
          </Tooltip>
        ) : tabEl;
      })}
  </Tabs>
 
  {/*<Tooltip title={isSidebar ? "Switch to top tabs" : "Switch to sidebar"} placement="bottom">
    <IconButton size="small" onClick={toggleSidebar} sx={{ ml: 0.5, flexShrink: 0 }}>
      <ViewSidebarIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </Tooltip>*/}
</Box>
              ) : "" }


  
                <div className="order-container">
                    {isInvoicePage && !invoicePageReady && (
                      <Box role="status" aria-live="polite" sx={{ minHeight: 260, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1.5, bgcolor: 'background.paper', borderRadius: 2 }}>
                        <CircularProgress size={28} />
                        <Typography variant="body2" color="text.secondary">Preparing invoice workspace…</Typography>
                      </Box>
                    )}
                    {shouldShow && (
                      <div className="order-progress-shell" style={{ width: "100%" }}>
                      <OrderProgressBar
                        orderStatus={order.OrderStatus}
                        assignedUsers={assignedUsers}
                        allUsers={availableUsers}  // Pass the complete list from your API
                        getWorkflowLabel={getWorkflowLabel}
                        getWorkflowTooltip={getWorkflowTooltip}
                        docsData={{
                          orderId,                    // ensures links route for this order
                          orderEmail: order?.Email || "",
                          presentations: presentationData,
                          salesOrders:   salesOrderData,
                          purchaseOrders: purchaseOrderData,
                          // invoices:   invoiceData || [],     // if/when you have it
                          // bills:      billsData || [],       // optional
                        }}
                        notesForChat={notesForChat}
                        renderCart={
                          <CartPresentationBoundary
                            resetKey={`${order?.updatedAt || ""}-${order?.Items?.length || 0}`}
                            onRetry={fetchOrder}
                          >
                            <PresentationTabs
                              fetchOrder={fetchOrder}
                              order={orderForCartView}
                              selectedProducts={selectedProducts}
                              handleShowProductsPopup={handleShowProductsPopup}
                              onOpenCartHistory={() => setCartHistoryOpen(true)}
                              cartWorkspace={cartWorkspaceForPresentation}
                              onWorkspaceMutationCommitted={handleWorkspaceMutationCommitted}
                              salesOrderCartUnlocked={effectiveSalesOrderCartUnlocked}
                              onUnlockSalesOrderCart={() => setSalesOrderCartUnlocked(true)}
                              onReorderProducts={handleReorderProducts}
                              onReorderLayout={handleReorderLayout}
                              canSeeManualPricingToggle={isSuperAdministrator}
                            />
                          </CartPresentationBoundary>
                        }
                      />
                      </div>
                  )}








                  {activeTab === "Overview" && (
  <Box sx={{ p: 0 }}>
 
    {customerData?.status === "lead" && !customerIsCreditHold && (
      <div className="ov2-banner warning">
        <WarningAmberIcon sx={{ fontSize: 18, flexShrink: 0, mt: "1px" }} />
        <span>
          This customer is currently a <strong>lead</strong> and must be approved before the Sales
          Order process.{" "}
          <Button
            type="button"
            variant="text"
            size="small"
            onClick={handleRequestCustomerConversion}
            disabled={requestingCustomerConversion}
            sx={{
              minWidth: 0,
              p: 0,
              ml: 0.5,
              textTransform: "none",
              fontWeight: 700,
              lineHeight: "inherit",
              verticalAlign: "baseline",
            }}
          >
            {requestingCustomerConversion ? "Requesting conversion..." : "Request conversion ->"}
          </Button>
        </span>
      </div>
    )}
    {customerData?.status === "in-review" && (
      <div className="ov2-banner info">
        <InfoOutlinedIcon sx={{ fontSize: 18, flexShrink: 0, mt: "1px" }} />
        <span>
          This project is currently <strong>under review</strong>. Please wait before proceeding.
        </span>
      </div>
    )}
    {customerIsCreditHold && (
      <div className="ov2-banner error">
        <WarningAmberIcon sx={{ fontSize: 18, flexShrink: 0, mt: "1px" }} />
        <span>
          This customer is on <strong>Credit Hold</strong> — contact financing to restore order
          processing.
        </span>
      </div>
    )}
 

 
    <div className="ov2-body">
 
      <div className="ov2-panel ov2-notes-panel">

      
        <div className="ov2-panel-header">
          <ForumIcon className="ov2-panel-header-icon" sx={{ fontSize: 15 }} />
          <span className="ov2-panel-title">Project Notes</span>
          {totalNotes > 0 && (
            <span className="ov2-panel-badge">{totalNotes}</span>
          )}
        </div>

        <div className="ov2-notes-body">

           
          <div className="ov2-notes-toolbar">
            <Tooltip title="Filter note visibility" arrow>
              <IconButton
                size="small"
                aria-label="Filter note visibility"
                onClick={(event) => setProjectNotesFilterAnchorEl(event.currentTarget)}
              >
                <FilterAltIcon sx={{ fontSize: 16, color: "text.secondary", opacity: 0.8 }} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={projectNotesFilterAnchorEl}
              open={Boolean(projectNotesFilterAnchorEl)}
              onClose={() => setProjectNotesFilterAnchorEl(null)}
              PaperProps={{ sx: { width: 280, p: 1 } }}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              transformOrigin={{ vertical: "top", horizontal: "left" }}
            >
              <Box sx={{ px: 1, py: 0.75 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 700, fontFamily: "Nunito" }}>
                  Filter notes
                </Typography>
                <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 0.25 }}>
                  Hide routine cart edits unless you want to review every cart change.
                </Typography>
              </Box>
              <Box sx={{ px: 1, py: 0.5 }}>
                <FormControlLabel
                  sx={{ alignItems: "flex-start", m: 0 }}
                  control={(
                    <Checkbox
                      size="small"
                      checked={showCartChanges}
                      onChange={(event) => setShowCartChanges(event.target.checked)}
                    />
                  )}
                  label={(
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        Show cart changes
                      </Typography>
                      <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        Include cart edit events like item updates, removals, and other service changes.
                      </Typography>
                    </Box>
                  )}
                />
              </Box>
              <Box sx={{ px: 1, py: 0.5 }}>
                <FormControlLabel
                  sx={{ alignItems: "flex-start", m: 0 }}
                  control={(
                    <Switch
                      size="small"
                      checked={infiniteNotesEnabled}
                      onChange={(event) => setInfiniteNotesEnabled(event.target.checked)}
                    />
                  )}
                  label={(
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 600 }}>
                        Infinite scroll
                      </Typography>
                      <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        Load more notes automatically while scrolling inside the Project Notes box.
                      </Typography>
                    </Box>
                  )}
                />
              </Box>
              <Box sx={{ px: 1, pt: 0.5, display: "flex", justifyContent: "flex-end" }}>
                <Button size="small" onClick={() => setProjectNotesFilterAnchorEl(null)}>
                  Close
                </Button>
              </Box>
            </Menu>
            <FormControl size="small" sx={{ minWidth: 160 }}>
              <InputLabel id="ov2-note-filter-label" sx={{ fontSize: "0.8rem" }}>
                Filter by user
              </InputLabel>
              <Select
                labelId="ov2-note-filter-label"
                label="Filter by user"
                value={noteFilterUser}
                onChange={(e) => setNoteFilterUser(e.target.value)}
                sx={{ fontSize: "0.8rem", height: 34 }}
              >
                <MenuItem value="all">All users</MenuItem>
                {commentersOnly.map((u) => (
                  <MenuItem key={u.id} value={u.id} sx={{ fontSize: "0.8rem" }}>
                    {u.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="ov2-notes-toolbar-spacer" />

            <Tooltip title={noteSortAsc ? "Showing oldest first" : "Showing newest first"} arrow>
              <IconButton size="small" onClick={() => setNoteSortAsc((s) => !s)}>
                <SwapVertIcon sx={{ fontSize: 17 }} />
              </IconButton>
            </Tooltip>

            <Tooltip
              arrow
              placement="bottom-end"
              title={
                <Box sx={{ maxWidth: 280, lineHeight: 1.5, fontSize: "0.82rem" }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mb: 0.5, fontWeight: 700 }}>
                    <AlternateEmailIcon sx={{ fontSize: 15 }} /> Tag teammates
                  </Box>
                  Type <strong>@name</strong> in the composer to notify a teammate by email and
                  in-app.
                </Box>
              }
            >
              <IconButton size="small">
                <InfoOutlinedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Tooltip>
          </div>

        
          {(() => {
            if (!chatLastAt) return null;
            const ageMs = chatNowTick - new Date(chatLastAt).getTime();
            if (ageMs > VISIBLE_WINDOW_MS) return null;
            const isLive = ageMs < LIVE_WINDOW_MS;
            const mins = minutesAgo(chatLastAt);
            const by = chatLastBy ? ` · ${chatLastBy}` : "";
            return (
              <div className="ov2-live-banner" data-live={String(isLive)}>
                <span className="ov2-live-dot" />
                <span className="ov2-live-title">
                  {isLive ? "Live chat in progress" : "Recent chat activity"}
                </span>
                <span className="ov2-live-meta">
                  — Last activity{by} {mins === 0 ? "just now" : `${mins}m ago`}
                </span>
              </div>
            );
          })()}
 
          <ProjectOverviewNoteComposer
            mentionUsers={normalizedMentionUsers}
            onSubmit={handleAddNote}
          />
 
          {totalNotes === 0 ? (
            <div className="ov2-notes-empty">
              <ForumIcon sx={{ fontSize: 38, opacity: 0.25 }} />
              <span>No notes yet — post the first one above</span>
            </div>
          ) : (
            <div
              className="ov2-notes-list"
              onScroll={(event) => {
                if (!infiniteNotesEnabled || !hasMoreProjectNotes) return;
                const node = event.currentTarget;
                if (node.scrollHeight - node.scrollTop - node.clientHeight <= 96) {
                  setNotesPage((current) => current + 1);
                }
              }}
              style={infiniteNotesEnabled ? { overflowY: "auto", paddingRight: 4 } : undefined}
            >
              {(() => {
                const renderProjectNote = (note, depth = 0) => {
                  const meta = ACTION_META[note.action] || {};
                  const isChatDigest = note.action === "chat-digest";
                  const avatarSrc = isChatDigest
                    ? "/elite-core-placeholder-live-chat-conversation.png"
                    : resolveProjectNoteAvatarSrc(note, {
                        availableUsers,
                        assignedUsersDetailed,
                        authState,
                        defaultAvatarUrl,
                      });
                  const isReply = depth > 0;
                  const businessLogoSrc = note.businessLogo
                    ? note.businessLogo.startsWith("uploads")
                      ? `${process.env.REACT_APP_NODEJS_SERVER_URL}/${note.businessLogo}`
                      : note.businessLogo
                    : "/elite-core-brand-logo.png";
                  const canDeleteNote =
                    isManualProjectNote(note) &&
                    Number(note?.userId) === Number(authState?.id) &&
                    !note?.deletedAt;
                  const emailPreview = buildEmailNotePreview(note);
                  const hasChildren = Array.isArray(note.children) && note.children.length > 0;
                  const isExpanded = Boolean(expandedNoteThreads[note.sequence]);

                  return (
                    <div
                      key={note.sequence}
                      className={`ov2-note-post${isReply ? " is-reply" : ""}`}
                    >
                     
                      <div className="ov2-note-actions">
                        <Tooltip title="Reply" arrow>
                          <IconButton
                            size="small"
                            disabled={!Number(note?.sequence)}
                            onClick={() => {
                              const sequence = Number(note?.sequence);
                              if (!sequence) {
                                fetchOrder({ suppressLoader: true });
                                toast("Refreshing note before replying...");
                                return;
                              }
                              setActiveReplySequence((prev) =>
                                Number(prev) === sequence ? null : sequence
                              );
                            }}
                            sx={{ p: 0.5 }}
                          >
                            <ReplyIcon sx={{ fontSize: 15 }} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={note.pinned ? "Unpin" : "Pin"} arrow>
                          <IconButton
                            size="small"
                            onClick={() => handleTogglePin(note.sequence)}
                            sx={{ p: 0.5, color: note.pinned ? "#EAB308" : "inherit" }}
                          >
                            {note.pinned
                              ? <StarIcon sx={{ fontSize: 15 }} />
                              : <StarBorderIcon sx={{ fontSize: 15 }} />}
                          </IconButton>
                        </Tooltip>
                        {canDeleteNote && (
                          <Tooltip title="Delete" arrow>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteProjectNote(note)}
                              sx={{ p: 0.5, color: "#dc2626" }}
                            >
                              <DeleteForeverIcon sx={{ fontSize: 15 }} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </div>

                     
                      <div className="ov2-note-header">
                        <Tooltip title={note.userName || ""} arrow>
                          <img src={avatarSrc} alt="avatar" className="ov2-note-avatar" />
                        </Tooltip>
                        {!isChatDigest && !isReply && (
                          <>
                            <ArrowForwardIcon className="ov2-note-arrow" sx={{ fontSize: 13 }} />
                            <Tooltip title={note.businessName || ""} arrow>
                              <img src={businessLogoSrc} alt="biz" className="ov2-note-biz-logo" />
                            </Tooltip>
                          </>
                        )}
                        <div className="ov2-note-meta">
                          <span className="ov2-note-type">
                            {meta.icon && <span style={{ display: "flex", alignItems: "center" }}>{meta.icon}</span>}
                            {meta.label || "Customer Note"}
                            {note.pinned && (
                              <Chip
                                size="small"
                                label="Pinned"
                                sx={{
                                  height: 16, fontSize: "0.62rem", fontWeight: 700,
                                  ml: 0.5, bgcolor: "#fef9c3", color: "#854d0e",
                                  border: "1px solid #fde047",
                                }}
                              />
                            )}
                          </span>
                          <span className="ov2-note-time">
                            {formatDistanceToNow(new Date(note.timestamp), { addSuffix: true })}
                            {formatProjectNoteDateTime(note.timestamp) && ` · ${formatProjectNoteDateTime(note.timestamp)}`}
                            {!isChatDigest && note.businessName && ` · ${note.businessName}`}
                          </span>
                        </div>
                      </div>

                      
                      {emailPreview ? (
                        <div className="ov2-email-preview">
                          <div className="ov2-email-preview-heading">
                            {emailPreview.directionLabel}{emailPreview.party ? ` · ${emailPreview.party}` : ""}
                          </div>
                          <div className="ov2-email-preview-subject">{emailPreview.subject}</div>
                          {emailPreview.bodyPreview && (
                            <div className="ov2-email-preview-body">{emailPreview.bodyPreview}</div>
                          )}
                          <div className="ov2-email-preview-actions">
                            {emailPreview.attachmentCount > 0 && (
                              <span>{emailPreview.attachmentCount} {emailPreview.attachmentCount === 1 ? "attachment" : "attachments"}</span>
                            )}
                            <Button
                              size="small"
                              startIcon={<VisibilityIcon sx={{ fontSize: 16 }} />}
                              onClick={() => setActiveProjectEmailNote(note)}
                              sx={{ p: 0, minWidth: 0, textTransform: "none", fontWeight: 700 }}
                            >
                              View email
                            </Button>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="ov2-note-body"
                          dangerouslySetInnerHTML={{ __html: note.message }}
                        />
                      )}
                      {!emailPreview && <ProjectNoteAttachments attachments={note.attachments || []} />}

                      
                      {activeReplySequence === note.sequence && (
                        <ProjectNoteReplyEditor
                          note={note}
                          initialValue={noteReplyDrafts[note.sequence] || ""}
                          projectMentionUsers={projectMentionUsers}
                          isAssignedMentionUser={isAssignedMentionUser}
                          onSubmit={handleReplyProjectNote}
                          onCancel={handleCancelReplyEditor}
                          onDraftSnapshot={handleReplyDraftSnapshot}
                        />
                      )}
 
                      {hasChildren && (
                        <div className="ov2-note-thread-toggle">
                          <Button
                            size="small"
                            onClick={() => toggleNoteThread(note.sequence)}
                            startIcon={
                              isExpanded
                                ? <ExpandMoreIcon sx={{ fontSize: 15 }} />
                                : <ChevronRightIcon sx={{ fontSize: 15 }} />
                            }
                            sx={{
                              textTransform: "none", fontWeight: 600,
                              fontSize: "0.78rem", color: "text.secondary",
                              fontFamily: '"Nunito", sans-serif',
                              p: "2px 6px",
                            }}
                          >
                            {isExpanded
                              ? "Hide replies"
                              : `Show ${note.children.length} repl${note.children.length === 1 ? "y" : "ies"}`}
                          </Button>
                          {isExpanded && (
                            <div className="ov2-note-children">
                              {note.children.map((child) => renderProjectNote(child, depth + 1))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                };
                return threadedPaginatedNotes.map((note) => renderProjectNote(note, 0));
              })()}
            </div>
          )}
 
          {totalNotes > 0 && !infiniteNotesEnabled && (
            <div className="ov2-notes-pagination">
              <span className="ov2-notes-pagination-label">
                {pageStartIdx + 1}–{pageEndIdx} of {totalNotes}
              </span>
              <Pagination
                size="small"
                page={notesPage}
                count={notesTotalPages}
                onChange={(_e, p) => setNotesPage(p)}
                siblingCount={0}
                boundaryCount={1}
              />
            </div>
          )}
          {totalNotes > 0 && infiniteNotesEnabled && (
            <div className="ov2-notes-pagination">
              <span className="ov2-notes-pagination-label">
                Showing {pageEndIdx} of {totalNotes}{hasMoreProjectNotes ? " · scroll for more" : ""}
              </span>
            </div>
          )}

          <EmailViewerDialog
            open={Boolean(activeProjectEmailNote && activeProjectEmailView)}
            email={activeProjectEmailView}
            onClose={() => setActiveProjectEmailNote(null)}
          />

        </div> 
      </div> 
 
      <div className="ov2-panel ov2-details-panel">

        <div className="ov2-panel-header">
          <DescriptionIcon className="ov2-panel-header-icon" sx={{ fontSize: 15 }} />
          <span className="ov2-panel-title">Project Details</span>
        </div>

        <div className="ov2-details-body">
 
          <div className="ov2-section">
            <div className="ov2-section-header">
              <NoteAltIcon sx={{ fontSize: 13, color: "text.secondary" }} />
              <span className="ov2-section-title">Project Info</span>
            </div>
            <div className="ov2-section-body">

              <div className="ov2-field">
                <label className="ov2-field-label">Project Name</label>
                <input
                  type="text"
                  value={order?.ProjectName || ""}
                  onChange={(e) => handleChange("ProjectName", e.target.value)}
                  placeholder="e.g. Fall Campaign"
                />
              </div>

              <div className="ov2-field">
                <label className="ov2-field-label">Event Type</label>
                <select
                  value={order?.EventType || ""}
                  onChange={(e) => handleChange("EventType", e.target.value)}
                >
                  <option value="">Select type</option>
                  {EVENT_TYPES.map((t) => (
                    <option key={t} value={t}>{t}</option>
                  ))}
                </select>
              </div>

              <div className="ov2-field full">
                <label className="ov2-field-label">Customer Account</label>
                <CustomerSearchSelectAsync
                  showLabel={false}
                  inputId="ov2-customerAccount"
                  instanceUniqueId={instanceUniqueId}
                  value={order?.attachedCustomers?.[0] ?? ""}
                  disableClearable={!isAdministrator}
                  borderlessInput
                  onChange={(custId) => {
                    handleChange("attachedCustomers", custId ? [custId] : []);
                    if (custId) fetchClientContacts(custId);
                  }}
                />
              </div>

              <div className="ov2-field">
                <label className="ov2-field-label">Currency</label>
                <select
                  value={normalizeCurrencyCode(order?.CurrencyCode || order?.currency, "CAD")}
                  onChange={(e) => handleChange("CurrencyCode", normalizeCurrencyCode(e.target.value, "CAD"))}
                  disabled={orderCurrencyOptionsLoading}
                  title={orderCurrencyOptionsLoading ? "Loading enabled currencies…" : "Order customer-facing currency"}
                >
                  {Array.from(new Set([
                    normalizeCurrencyCode(order?.CurrencyCode || order?.currency, "CAD"),
                    ...orderCurrencyOptions,
                  ])).map((code) => (
                    <option key={code} value={code}>{code}</option>
                  ))}
                </select>
              </div>

              <div className="ov2-field">
                <label className="ov2-field-label">In-Hands Date</label>
                <input
                  type="date"
                  value={toDateInput(order?.inHandsDate || order?.inhandsDate) || ""}
                  onChange={(e) => handleChange("inHandsDate", e.target.value)}
                />
              </div>

            </div>
          </div>
 
          <div className="ov2-section">
            <div className="ov2-section-header">
              <PersonIcon sx={{ fontSize: 13, color: "text.secondary" }} />
              <span className="ov2-section-title">Contact Info</span>
            </div>
            <div className="ov2-section-body">

          
              <div className="ov2-field full">
                <div className="ov2-contact-source">
                  <span className="ov2-contact-source-label">Source:</span>
                  <button
                    className={`ov2-source-btn${contactSourceMode === "customer" ? " active" : ""}`}
                    onClick={(e) => { e.preventDefault(); applyCustomerFallbackContact(); }}
                  >
                    <BuildIcon sx={{ fontSize: 13 }} /> Customer fallback
                  </button>
                  <button
                    className={`ov2-source-btn${contactSourceMode === "contact" ? " active" : ""}`}
                    disabled={!normalizedClientContacts.length}
                    onClick={(e) => {
                      e.preventDefault();
                      if (!normalizedClientContacts.length) return;
                      applyLinkedContact(linkedClientContact?.id || normalizedClientContacts[0]?.id);
                    }}
                  >
                    <PersonIcon sx={{ fontSize: 13 }} /> Linked contact
                  </button>
                </div>

                {contactSourceMode === "contact" && normalizedClientContacts.length > 0 && (
                  <FormControl fullWidth size="small" sx={{ mt: 0.5 }}>
                    <Select
                      value={linkedClientContact?.id || normalizedClientContacts[0]?.id || ""}
                      onChange={(e) => applyLinkedContact(e.target.value)}
                      sx={{ fontSize: "0.85rem" }}
                    >
                      {normalizedClientContacts.map((c) => (
                        <MenuItem key={c.id} value={c.id} sx={{ fontSize: "0.85rem" }}>
                          {c.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
                {contactSourceMode !== "contact" && (
                  <div style={{
                    marginTop: 6, padding: "7px 10px", fontSize: "0.8rem",
                    color: "var(--order-text-muted)", background: "var(--order-panel-muted)",
                    border: "1px solid var(--order-border)", borderRadius: 8,
                  }}>
                    Using customer-level email/phone fallback.
                  </div>
                )}
              </div>

              <div className="ov2-field">
                <label className="ov2-field-label">Contact Email</label>
                <input
                  type="email"
                  value={order?.Email || ""}
                  onChange={(e) => handleChange("Email", e.target.value)}
                  placeholder="name@company.com"
                />
              </div>

              <div className="ov2-field">
                <label className="ov2-field-label">Contact Phone</label>
                <input
                  type="tel"
                  value={order?.Phone || ""}
                  onChange={(e) => handleChange("Phone", e.target.value)}
                  placeholder="+1 555 000 0000"
                />
              </div>

            </div>
          </div>
 
          {!customerIsCreditHold && (
            <div className="ov2-section">
              <div className="ov2-section-header">
                <UpdateIcon sx={{ fontSize: 13, color: "text.secondary" }} />
                <span className="ov2-section-title">Project Stage</span>
              </div>
              <div className="ov2-section-body single-col">

                <FormControl fullWidth size="small">
                  <InputLabel
                    id="ov2-unified-label"
                    shrink
                    sx={{ fontFamily: '"Nunito", sans-serif', fontWeight: 700, fontSize: "0.75rem" }}
                  >
                    SO / PO Status
                  </InputLabel>
                  <Select
                    disabled={!canManuallyManageProjectStage}
                    labelId="ov2-unified-label"
                    value="summary"
                    displayEmpty
                    onChange={handleUnifiedStatusChange}
                    renderValue={() => unifiedCurrentLabel}
                    label="SO / PO Status"
                    sx={{
                      fontFamily: '"Nunito", sans-serif',
                      fontWeight: 700,
                      "& .MuiSelect-select": {
                        backgroundColor: alpha(soTint || "#c3171d", 0.06),
                        borderRadius: "8px",
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          maxHeight: 360,
                          "& .MuiMenu-list": { p: 0 },
                          "& .MuiListSubheader-root": {
                            bgcolor: "var(--ec-color-primary-soft)",
                            fontFamily: '"Nunito", sans-serif',
                            fontSize: 13, fontWeight: 800,
                            px: 2, py: 1, mb: 0.5,
                          },
                        },
                      },
                    }}
                  >
                    <MenuItem value="summary" disabled sx={{ display: "none" }} />
                    <ListSubheader>Sales Order</ListSubheader>
                    {(isAdministrator
                      ? UNIFIED_STATUS_OPTIONS.filter((o) => o.group === "Sales Order")
                      : manualSalesOrderStatusOptions).map((o) => {
                      const isSel = valEq(order?.OrderStatus?.SO, o.value);
                      return (
                        <MenuItem key={o.key} value={o.key} selected={isSel} sx={itemSx("SO", o.value)}>
                          <ListItemIcon sx={{ minWidth: 26 }}>
                            {isSel && <CheckIcon sx={{ fontSize: 15 }} />}
                          </ListItemIcon>
                          <Box className="status-swatch" />
                          <ListItemText
                            primary={getWorkflowLabel("SO", o.value)}
                            secondary={getWorkflowTooltip("SO", o.value)}
                            primaryTypographyProps={{ sx: { fontFamily: '"Nunito"', fontSize: "0.85rem", fontWeight: 600 } }}
                            secondaryTypographyProps={{ sx: { fontSize: "0.72rem" } }}
                          />
                        </MenuItem>
                      );
                    })}
                    {isAdministrator && <>
                    <ListSubheader>
                      Purchase Order{" "}
                      {!poUnlocked && (
                        <LockOutlinedIcon sx={{ fontSize: 12, ml: 0.5, verticalAlign: "middle", opacity: 0.5 }} />
                      )}
                    </ListSubheader>
                    {UNIFIED_STATUS_OPTIONS.filter((o) => o.group === "Purchase Order").map((o) => {
                      const isSel = valEq(order?.OrderStatus?.PO, o.value);
                      return (
                        <MenuItem
                          key={o.key}
                          value={o.key}
                          disabled={isPOOptionDisabled(o)}
                          selected={isSel}
                          sx={itemSx("PO", o.value)}
                        >
                          <ListItemIcon sx={{ minWidth: 26 }}>
                            {isSel && <CheckIcon sx={{ fontSize: 15 }} />}
                          </ListItemIcon>
                          <Box className="status-swatch" />
                          <ListItemText
                            primary={getWorkflowLabel("PO", o.value)}
                            secondary={getWorkflowTooltip("PO", o.value)}
                            primaryTypographyProps={{ sx: { fontFamily: '"Nunito"', fontSize: "0.85rem", fontWeight: 600 } }}
                            secondaryTypographyProps={{ sx: { fontSize: "0.72rem" } }}
                          />
                        </MenuItem>
                      );
                    })}
                    <ListSubheader>Global</ListSubheader>
                    {UNIFIED_STATUS_OPTIONS.filter((o) => o.group === "Global").map((o) => (
                      <MenuItem key={o.key} value={o.key}>
                        <ListItemText
                          primary={getWorkflowLabel("GLOBAL", o.value)}
                          primaryTypographyProps={{ sx: { fontFamily: '"Nunito"', fontSize: "0.85rem" } }}
                        />
                      </MenuItem>
                    ))}
                    </>}
                  </Select>
                </FormControl>

                {availableSubStatuses.length > 0 && (
                  <FormControl fullWidth size="small">
                    <InputLabel
                      id="ov2-substatus-label"
                      shrink
                      sx={{ fontFamily: '"Nunito"', fontWeight: 700, fontSize: "0.75rem" }}
                    >
                      Sub Status
                    </InputLabel>
                    <Select
                      disabled={!isAdministrator}
                      labelId="ov2-substatus-label"
                      value={order?.subStatusId ?? ""}
                      label="Sub Status"
                      onChange={(e) =>
                        setOrder((prev) => ({
                          ...prev,
                          subStatusId: e.target.value ? Number(e.target.value) : null,
                        }))
                      }
                      sx={{ fontFamily: '"Nunito"' }}
                    >
                      <MenuItem value=""><em>None</em></MenuItem>
                      {availableSubStatuses.map((s) => (
                        <MenuItem key={s.id} value={s.id} sx={{ fontFamily: '"Nunito"', fontSize: "0.85rem" }}>
                          {s.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}

                {isAdministrator && (
                  <Box sx={{ mt: 1 }}>
                    {order?.isArchived ? (
                      <Chip icon={<ArchiveOutlinedIcon />} label="Archived project" variant="outlined" size="small" />
                    ) : (
                      <Button
                        variant="outlined"
                        color="inherit"
                        size="small"
                        startIcon={<ArchiveOutlinedIcon />}
                        disabled={archivingProject}
                        onClick={() => { setArchiveProjectNameConfirmation(""); setArchiveConfirmOpen(true); }}
                        sx={{ fontFamily: '"Nunito", sans-serif', fontWeight: 700, textTransform: "none", borderColor: "var(--order-border)", borderRadius: 2 }}
                      >
                        Archive Project
                      </Button>
                    )}
                  </Box>
                )}

                <div className="ov2-status-chips">
                  {renderStatusChips(order?.OrderStatus?.SO, order?.OrderStatus?.PO, getWorkflowLabel)}
                  {!!order?.subStatus?.label && (
                    <Chip size="small" variant="outlined" label={`Sub: ${order.subStatus.label}`}
                      sx={{ fontFamily: '"Nunito"', fontSize: "0.72rem", fontWeight: 700 }} />
                  )}
                  {unlockedMessages.length > 0 && (
                    <Tooltip arrow placement="top" title={
                      <Box sx={{ display: "grid", gap: 0.5, fontSize: "0.8rem" }}>
                        {unlockedMessages.map((msg) => (
                          <Box key={msg} sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                            <CheckCircleIcon sx={{ fontSize: 13 }} /> {msg}
                          </Box>
                        ))}
                      </Box>
                    }>
                      <IconButton size="small" sx={{ color: "success.main", p: 0.25 }}>
                        <CheckCircleIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>




              </div>
            </div>
          )}


          <Dialog open={archiveConfirmOpen} onClose={() => { if (!archivingProject) { setArchiveConfirmOpen(false); setArchiveProjectNameConfirmation(""); } }} maxWidth="xs" fullWidth>
            <DialogTitle>Archive Project #{order?.OrderId || orderId}?</DialogTitle>
            <DialogContent>
              <Typography variant="body2">
                This project and its associated documents will be hidden from normal operational lists. Nothing is deleted.
                You can open it later under Operations Management → Archived Projects.
              </Typography>
              <Typography sx={{ mt: 2, mb: 0.5, fontWeight: 700 }} variant="body2">
                Project name (copy this to confirm):
              </Typography>
              <Typography variant="body2" sx={{ mb: 1, userSelect: "text", fontWeight: 700 }}>
                {order?.ProjectName}
              </Typography>
              <TextField
                fullWidth
                size="small"
                autoComplete="off"
                label="Type the exact project name"
                value={archiveProjectNameConfirmation}
                onChange={(event) => setArchiveProjectNameConfirmation(event.target.value)}
                disabled={archivingProject}
              />
            </DialogContent>
            <DialogActions>
              <Button disabled={archivingProject} onClick={() => { setArchiveConfirmOpen(false); setArchiveProjectNameConfirmation(""); }}>Cancel</Button>
              <Button
                variant="contained"
                color="error"
                disabled={archivingProject || !order?.ProjectName || archiveProjectNameConfirmation !== order.ProjectName}
                onClick={async () => {
                  if (!isAdministrator || archivingProject || !order?.ProjectName || archiveProjectNameConfirmation !== order.ProjectName) return;
                  setArchivingProject(true);
                  try {
                    await axios.patch(
                      `${process.env.REACT_APP_NODEJS_SERVER_URL}/orders/${order.id}/archive`,
                      { instanceUniqueId },
                      { headers: { accessToken: localStorage.getItem("accessToken") } }
                    );
                    setOrder((previous) => ({ ...previous, isArchived: true }));
                    setArchiveConfirmOpen(false);
                    setArchiveProjectNameConfirmation("");
                    toast.success("Project archived. Available under Operations Management.");
                  } catch (error) {
                    toast.error(error?.response?.data?.message || "Failed to archive project.");
                  } finally {
                    setArchivingProject(false);
                  }
                }}
              >
                {archivingProject ? "Archiving…" : "Archive Project"}
              </Button>
            </DialogActions>
          </Dialog>
 
<div className="ov2-section">
  <div className="ov2-section-header">
    <AlternateEmailIcon sx={{ fontSize: 13, color: "text.secondary" }} />
    <span className="ov2-section-title">Project Email</span>
  </div>
  <div className="ov2-section-body single-col">
    <div className="ov2-field full">
      <label className="ov2-field-label">
        Smart Inbox Address&nbsp;
        <Tooltip
          arrow
          title={
            projectEmailAddress
              ? "Email this address to auto-post into the project timeline."
              : "Project email not available yet."
          }
        >
          <InfoOutlinedIcon sx={{ fontSize: 13, verticalAlign: "middle", opacity: 0.6 }} />
        </Tooltip>
      </label>
      <Stack direction="row" spacing={1} alignItems="center">
        <input
          type="text"
          readOnly
          disabled
          value={projectEmailAddress || ""}
          placeholder="Loading..."
          style={{
            flex: 1,
            fontSize: "0.82rem",
            fontFamily: "Nunito, sans-serif",
            padding: "5px 8px",
            borderRadius: 6,
            border: "1px solid #e2e8f0",
            background: "#f8fafc",
            color: "#475569",
          }}
        />
        <Tooltip arrow title={projectEmailAddress ? "Copy to clipboard" : "Not available yet"}>
          <span>
            <Button
              size="small"
              variant="outlined"
              disabled={!projectEmailAddress}
              onClick={async () => {
                if (!projectEmailAddress) {
                  toast("Project email not available yet.");
                  return;
                }
                try {
                  await navigator.clipboard.writeText(projectEmailAddress);
                  toast.success("Project email copied!");
                } catch {
                  toast(`Copy manually: ${projectEmailAddress}`);
                }
              }}
              sx={{
                textTransform: "none",
                fontFamily: "Nunito, sans-serif",
                fontWeight: 700,
                fontSize: "0.78rem",
                height: 32,
                whiteSpace: "nowrap",
              }}
            >
              Copy
            </Button>
          </span>
        </Tooltip>
      </Stack>
    </div>
  </div>
</div>
 
{showAssignedUsersSection && (
  <div className="ov2-section">
    <div className="ov2-section-header">
      <PersonIcon sx={{ fontSize: 13, color: "text.secondary" }} />
      <span className="ov2-section-title">Assignment</span>
    </div>
    <div className="ov2-section-body single-col" style={{ padding: "10px 14px" }}>
      <OrderUserAssignment
        orderId={order?.OrderId}
        initialAssignedUsers={order?.AssignedTo}
        onChangeAssignedUsers={(updatedUsers) => {
          setAssignedUsers(updatedUsers);
        }}
      />
    </div>
  </div>
)}
 
          {/*<div className="ov2-section">
            <div className="ov2-section-header">
              <MonetizationOnIcon sx={{ fontSize: 13, color: "text.secondary" }} />
              <span className="ov2-section-title">Financial Snapshot</span>
            </div>
            <div className="ov2-section-body single-col" style={{ padding: "10px 14px" }}>
              <div className="ov2-fin-row">
                <span className="ov2-fin-label">Booked Revenue</span>
                <span className="ov2-fin-value">
                  ${(order?.cart?.bookedRevenue ?? order?.Total ?? 0).toLocaleString("en-CA", { minimumFractionDigits: 2 })}
                </span>
              </div>
              <div className="ov2-fin-row">
                <span className="ov2-fin-label">Target Costs</span>
                <span className="ov2-fin-value">
                  ${(billsSummary?.target ?? 0).toLocaleString("en-CA", { minimumFractionDigits: 2 })}
                </span>
              </div>
              <div className="ov2-fin-row">
                <span className="ov2-fin-label">Booked Margin</span>
                <span className={`ov2-fin-value ${bookedMarginForUI >= 0 ? "positive" : "negative"}`}>
                  ${bookedMarginForUI.toLocaleString("en-CA", { minimumFractionDigits: 2 })}
                </span>
              </div>
              {(() => {
                const rev = order?.cart?.bookedRevenue ?? order?.Total ?? 0;
                const pct = rev > 0 ? (bookedMarginForUI / rev) * 100 : 0;
                return (
                  <div className="ov2-fin-row">
                    <span className="ov2-fin-label">Margin %</span>
                    <Chip
                      size="small"
                      label={`${pct.toFixed(1)}%`}
                      sx={{
                        fontWeight: 700, fontSize: "0.72rem", fontFamily: '"Nunito"',
                        height: 20,
                        bgcolor: pct >= 30 ? "#dcfce7" : pct > 0 ? "#fef9c3" : "#f1f5f9",
                        color: pct >= 30 ? "#16a34a" : pct > 0 ? "#854d0e" : "#64748b",
                        border: pct >= 30 ? "1px solid #86efac" : pct > 0 ? "1px solid #fde047" : "1px solid #cbd5e1",
                      }}
                    />
                  </div>
                );
              })()}
            </div>
          </div>*/}

        </div> 
 
        <div className="ov2-save-row">
          <button className="ov2-save-btn" onClick={handleSaveChanges} disabled={orderSaving}>
            {orderSaving ? "Saving…" : "Save Changes"}
          </button>
        </div>

      </div> 
    </div> 
  </Box>
)}
                  




      {activeTab === "Presentation" && (
  <>
    {showPresentationDetails && !presentationData.length ? (
      <Box sx={{ mb: 2 }}>
        <Box className="order-header-action" sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <h2>
              Presentation
            </h2>
        </Box>

        <PresentationScreen
          clientContacts={clientContacts}
          activeTab={activeTab}
          createDocsLocked={blockCreateDocs}
          createDocsLockTip={blockTip}
          label="Presentation Date"
          fetchOrder={fetchOrder}
          conversionStatus={conversionStatus}
          selectedProducts={selectedProducts}
          handleShowProductsPopup={handleShowProductsPopup}
          order={order}
          handleChange={handleChange}
          setOrder={setOrder}
        />
      </Box>
    ) : null}
 
    {showPresentationHistory ? (
      <Box sx={{ pt: 2, pb: 3 }}>
        {!tabId && presentationData.length > 1 ? (
          <UITableShell
            customLayout
            paperSx={{
              borderRadius: '10px', border: '1px solid', borderColor: 'divider',
              borderTop: '3px solid', borderTopColor: 'primary.main',
              minHeight: 0, mt: 0,
              boxShadow: '0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)',
              display: 'flex', flexDirection: 'column',
            }}
          >
            <UITableToolbar sx={{ backgroundColor: 'background.paper', p: 0 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ px: 2, py: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="h6" fontWeight={700} sx={{ color: 'text.primary', lineHeight: 1 }}>Presentations</Typography>
                  <Chip label={`${presentationData.length} presentations`} size="small" sx={{ fontWeight: 600, fontSize: '0.72rem', height: 22, bgcolor: '#f1f5f9', color: 'text.secondary', border: '1px solid', borderColor: 'divider' }} />
                </Stack>
                <Tooltip title="Refresh" arrow>
                  <span><IconButton size="small" onClick={() => fetchOrder(true)} disabled={loading} sx={{ color: 'text.secondary' }}><RefreshIcon sx={{ fontSize: 18 }} /></IconButton></span>
                </Tooltip>
              </Stack>
            </UITableToolbar>
            <TableContainer sx={{ flex: 1, overflow: 'auto', minHeight: 280, maxHeight: 480, '&::-webkit-scrollbar': { width: 6, height: 6 }, '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(148,163,184,0.8)', borderRadius: 99 } }}>
              <Table stickyHeader size="small" sx={{ minWidth: 680 }}>
                <TableHead><TableRow>
                  {['Presentation ID', 'Presentation Date', 'Created At', 'Client Contact', 'Actions'].map((heading, i) => (
                    <TableCell key={heading} align={i === 4 ? 'right' : 'left'} sx={{ px: 2, py: 1.25, backgroundColor: '#1e293b !important', color: '#f8fafc !important', fontWeight: 700, fontSize: '0.72rem', letterSpacing: '0.06em', textTransform: 'uppercase', borderBottom: 'none', whiteSpace: 'nowrap', position: 'sticky', top: 0, zIndex: 2 }}>{heading}</TableCell>
                  ))}
                </TableRow></TableHead>
                <TableBody sx={{ '& .MuiTableCell-root': { borderBottom: '1px solid', borderColor: 'divider' }, '& .MuiTableRow-root:last-child .MuiTableCell-root': { borderBottom: 'none' } }}>
                  {presentationData.map((p, index) => {
                    const presentationId = p.id ?? p.presentationId;
                    const destination = `/instance/${instanceUniqueId}/sales/orders/${orderId}/presentation/${presentationId}`;
                    return (
                      <TableRow key={presentationId} hover onClick={() => history.push(destination)} sx={{ cursor: 'pointer', bgcolor: index % 2 === 0 ? 'background.paper' : '#f8fafc', borderLeft: '3px solid transparent', transition: 'background-color 0.12s' }}>
                        <TableCell sx={{ px: 2, py: 1.5 }}><Typography variant="caption" sx={{ fontFamily: 'monospace', fontWeight: 700, color: 'text.secondary' }}>{presentationId}</Typography></TableCell>
                        <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.8rem' }}>{p.presentationDate ? String(p.presentationDate).slice(0, 10) : '—'}</TableCell>
                        <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.8rem', whiteSpace: 'nowrap' }}>{p.createdAt && !Number.isNaN(new Date(p.createdAt).getTime()) ? `${new Date(p.createdAt).toISOString().slice(0, 10)} (${getRelativeTime(p.createdAt)})` : '—'}</TableCell>
                        <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.8rem' }}>{p.clientContactEmail || '—'}</TableCell>
                        <TableCell align="right" sx={{ px: 2, py: 1.5 }}><Button size="small" onClick={(e) => { e.stopPropagation(); history.push(destination); }}>Open</Button></TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </UITableShell>
        ) : (
        <>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }} spacing={2}>
            <Box className="order-header-action" sx={{ flex: 1, mb: 0 }}><h2 style={{ margin: 0 }}>Presentation{editPresForm.id ? ` #${editPresForm.id}` : ""}</h2></Box>
            {editPresForm.id && (
              <div className="dropdown-container">
                <Button variant="contained" onClick={(e) => setPresentationActionsAnchor(presentationActionsAnchor ? null : e.currentTarget)}
                  sx={{ textTransform: 'none', borderRadius: '10px', color: 'white', backgroundColor: '#c3171d',
                    '&:hover': { backgroundColor: 'white', color: '#c3171d', border: '1px solid #c3171d' },
                    width: '200px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <SettingsIcon /> Actions
                </Button>
                {!!presentationActionsAnchor && (
                  <Box className="dropdown-menu">
                    <Button sx={{ width: '100%', mb: '10px', fontWeight: 700 }}
                      onClick={() => { setPresentationActionsAnchor(null); window.open(`/instance/${instanceUniqueId}/presentations/${editPresForm.id}`, '_blank'); }}>
                      Presentation Preview
                    </Button>
                    <Button sx={{ width: '100%', mb: '10px', fontWeight: 700 }}
                      disabled={presentationEmailSending}
                      onClick={() => {
                        setPresentationActionsAnchor(null);
                        const selected = presentationData.find((p) => String(p.id ?? p.presentationId) === String(editPresForm.id));
                        if (selected) openPresentationEmailComposer(selected);
                      }}>
                      {selectedPresentationSend ? 'Resend Presentation' : 'Send Presentation'}
                    </Button>
                    <Button sx={{ width: '100%', mb: '10px', fontWeight: 700 }}
                      disabled={editPresRegenerating || !hasCartItems}
                      onClick={() => { setPresentationActionsAnchor(null); regenerateEditedPresentation(); }}>
                      Regenerate Presentation
                    </Button>
                  </Box>
                )}
              </div>
            )}
          </Stack>
        {tabId && !presentationData.some((p) => String(p.id ?? p.presentationId) === String(tabId)) ? (
          <Alert severity="warning">This presentation was not found in this project.</Alert>
        ) : editPresForm.id && (!tabId || String(editPresForm.id) === String(tabId)) ? (
          <Box sx={{ mt: 1 }}>
    {selectedPresentationSend && (
      <Alert severity="success" icon={<EmailIcon />} sx={{ mb: 2, borderRadius: '10px' }}>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>Presentation Sent</Typography>
        <Typography variant="caption">
          This presentation has been emailed to the customer.
          {selectedPresentationSend.at && !Number.isNaN(new Date(selectedPresentationSend.at).getTime())
            ? ` Last sent: ${new Date(selectedPresentationSend.at).toLocaleString()}.` : ''}
          {selectedPresentationSend.recipients.length
            ? ` To: ${selectedPresentationSend.recipients.join(', ')}.` : ''}
        </Typography>
      </Alert>
    )}
    <Tabs value={editPresTab} onChange={(_, value) => setEditPresTab(value)} sx={{ mb: 2, borderBottom: 1, borderColor: "divider", "& .MuiTabs-indicator": { bgcolor: "primary.main" } }}>
      <Tab value="details" label="Details" />
      <Tab value="history" label="Presentation History" disabled={!editPresForm.id} />
    </Tabs>
    {editPresTab === 'details' ? (
    <>
    <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '10px', overflow: 'hidden', bgcolor: 'background.paper', boxShadow: '0 1px 3px 0 rgba(0,0,0,0.05), 0 1px 2px -1px rgba(0,0,0,0.05)' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.4, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'rgba(199,9,9,0.02)', gap: 1, flexWrap: 'wrap' }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box sx={{ width: 28, height: 28, borderRadius: '7px', bgcolor: 'rgba(199,9,9,0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <SettingsIcon sx={{ fontSize: 15, color: 'primary.main' }} />
          </Box>
          <Box>
            <Typography variant="body2" fontWeight={700} sx={{ lineHeight: 1.2, color: 'text.primary', fontSize: '0.875rem' }}>Presentation Settings</Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.72rem', lineHeight: 1.3 }}>Dates, contact, currency, pricing visibility and display preferences</Typography>
          </Box>
        </Stack>
      </Box>
      <Box sx={{ p: 2 }}>
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2, mb: 2 }}>
      <Box>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.65, color: 'text.secondary', fontWeight: 600, fontSize: '0.74rem', lineHeight: 1 }}>Presentation Date</Typography>
        <TextField size="small" type="date" value={editPresForm.presentationDate || ''} onChange={(e) => handleEditPresChange('presentationDate', e.target.value)} fullWidth sx={presentationEditInputSx} />
      </Box>
      <Box>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.65, color: 'text.secondary', fontWeight: 600, fontSize: '0.74rem', lineHeight: 1 }}>Requested In Hands Date</Typography>
        <TextField size="small" type="date" value={editPresForm.inhandsDate || ''} onChange={(e) => handleEditPresChange('inhandsDate', e.target.value)} fullWidth sx={presentationEditInputSx} />
      </Box>
      <Box>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.65, color: 'text.secondary', fontWeight: 600, fontSize: '0.74rem', lineHeight: 1 }}>Client Contact</Typography>
        <TextField size="small" select value={editPresForm.clientContactEmail || ''} onChange={(e) => handleEditPresChange('clientContactEmail', e.target.value)} fullWidth sx={presentationEditInputSx}>
          {!!editPresForm.clientContactEmail && !normalizedClientContacts.some((contact) => contact.email === editPresForm.clientContactEmail) && (<MenuItem value={editPresForm.clientContactEmail}>{editPresForm.clientContactEmail}</MenuItem>)}
          {normalizedClientContacts.filter((contact) => contact.email).map((contact) => (<MenuItem key={contact.id} value={contact.email}>{contact.name} ({contact.email})</MenuItem>))}
        </TextField>
      </Box>
      <Box>
        <Typography variant="caption" sx={{ display: 'block', mb: 0.65, color: 'text.secondary', fontWeight: 600, fontSize: '0.74rem', lineHeight: 1 }}>Currency</Typography>
        <TextField size="small" select value={editPresForm.currency || 'CAD'} onChange={(e) => handleEditPresChange('currency', e.target.value)} fullWidth sx={presentationEditInputSx}>
          {[...new Set([editPresForm.currency || 'CAD', ...orderCurrencyOptions])].map((code) => (<MenuItem key={code} value={code}>{code}</MenuItem>))}
        </TextField>
      </Box>
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 2 }}>
      <Box
        onClick={() => handleEditPresChange('showCatalogueDetails', !editPresForm.showCatalogueDetails)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          px: 2, py: 1.25, border: '1px solid', borderColor: 'divider',
          borderRadius: '8px', bgcolor: 'action.hover', cursor: 'pointer', userSelect: 'none' }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Tooltip title={editPresForm.showCatalogueDetails ? 'Size / colour source: Supplier catalogue' : 'Size / colour source: Order Cart'}>
            <PaletteOutlinedIcon sx={{ fontSize: 17, color: 'text.secondary' }} />
          </Tooltip>
          <Typography variant="body2" fontWeight={600}>Show Supplier Catalogue Details (Next Revision)</Typography>
          <Tooltip title="Choose supplier sizes and colours for the next regeneration instead of the selected Order Cart variations. Earlier revisions retain their original choice.">
            <InfoOutlinedIcon onClick={(e) => e.stopPropagation()} sx={{ fontSize: 17, color: 'text.secondary' }} />
          </Tooltip>
        </Stack>
        <Checkbox size="small" sx={{ p: 0 }} checked={!!editPresForm.showCatalogueDetails}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => handleEditPresChange('showCatalogueDetails', e.target.checked)} />
      </Box>

      <Box
        onClick={() => handleEditPresChange('hideProductTotals', !editPresForm.hideProductTotals)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          px: 2, py: 1.25, border: '1px solid', borderColor: 'divider',
          borderRadius: '8px', bgcolor: 'action.hover', cursor: 'pointer', userSelect: 'none' }}
      >
        <Stack direction="row" alignItems="center" spacing={1.25}>
          <VisibilityOffIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
          <Box>
            <Typography variant="body2" fontWeight={600}>Hide Product Totals</Typography>
            <Typography variant="caption" color="text.secondary">
              Hide each product's subtotal, tax and total. Unit pricing and overall presentation totals remain visible. Save to apply without regeneration.
            </Typography>
          </Box>
        </Stack>
        <Checkbox checked={!!editPresForm.hideProductTotals} size="small" color="primary" sx={{ p: 0 }}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => handleEditPresChange('hideProductTotals', e.target.checked)} />
      </Box>
       <Box
        onClick={() => handleEditPresChange('hidePrice', !editPresForm.hidePrice)}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          px: 2, py: 1.25, border: '1px solid',
          borderColor: editPresForm.hidePrice ? 'rgba(199,9,9,0.3)' : 'divider',
          borderRadius: '8px', bgcolor: editPresForm.hidePrice ? 'rgba(199,9,9,0.03)' : 'action.hover',
          cursor: 'pointer', userSelect: 'none', transition: 'border-color 0.15s, background-color 0.15s' }}
      >
        <Stack direction="row" alignItems="center" spacing={1.25}>
          <VisibilityOffIcon sx={{ fontSize: 18, color: editPresForm.hidePrice ? 'primary.main' : 'text.disabled' }} />
          <Box>
            <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.2 }}>Hide Pricing</Typography>
            <Typography variant="caption" color="text.secondary">
              Hide pricing from the customer-facing presentation. Changes apply to all versions of this presentation, including previous revisions. Regeneration is not required.
            </Typography>
          </Box>
        </Stack>
        <Checkbox checked={!!editPresForm.hidePrice} size="small" color="primary" sx={{ p: 0 }}
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => handleEditPresChange('hidePrice', e.target.checked)} />
      </Box>
    </Box>

    {/* Introduction */}
    <Box sx={{ mb: 2 }}>
      <Typography variant="caption" sx={{ display: 'block', mb: 0.65, color: 'text.secondary', fontWeight: 600, fontSize: '0.74rem', lineHeight: 1 }}>Presentation Title</Typography>
    <TextField
      size="small"
      value={editPresForm.introduction}
      onChange={(e) => handleEditPresChange('introduction', e.target.value)}
      fullWidth
      multiline
      minRows={4}
      sx={{ ...presentationEditInputSx, '& .MuiOutlinedInput-root': { ...presentationEditInputSx['& .MuiOutlinedInput-root'], minHeight: 'auto' } }}
    />
    </Box>

</Box>
    </Paper>
    {/* Presentation comments - separate card matching Presentation Settings */}
<Paper elevation={0} sx={{ mt: 2, border: '1px solid', borderColor: 'divider', borderRadius: '10px', overflow: 'hidden', bgcolor: 'background.paper', boxShadow: '0 1px 3px 0 rgba(0,0,0,0.05), 0 1px 2px -1px rgba(0,0,0,0.05)' }}>
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.4, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', gap: 1, flexWrap: 'wrap' }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Box sx={{ width: 28, height: 28, borderRadius: '7px', bgcolor: 'action.hover', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <ChatBubbleOutlineIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
          </Box>
          <Box>
            <Typography variant="body2" fontWeight={700} sx={{ lineHeight: 1.2, color: 'text.primary', fontSize: '0.875rem' }}>Presentation Comments {editPresComments.length ? `(${editPresComments.length})` : ''}</Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: '0.72rem', lineHeight: 1.3 }}>Customer feedback and product discussions</Typography>
          </Box>
        </Stack>
    <Button
      size="small"
      onClick={async () => {
        setEditPresLoadingComments(true);
        try {
          const comments = await loadPresentationComments(editPresForm.id);
          setEditPresComments(comments);
        } finally {
          setEditPresLoadingComments(false);
        }
      }}
      disabled={editPresLoadingComments}
    >
      {editPresLoadingComments ? 'Refreshing…' : 'Refresh'}
    </Button>
  </Box>
  <Box sx={{ p: 2 }}>
  {editPresLoadingComments ? (
    <Typography variant="body2" sx={{ opacity: 0.7 }}>Loading comments…</Typography>
  ) : editPresComments.length === 0 ? (
    <Typography variant="body2" sx={{ opacity: 0.7 }}>No comments yet.</Typography>
  ) : (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {editPresComments.map((c) => (
        <div key={c.id} style={{ border: '1px solid #eee', borderRadius: 8, padding: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {c.authorName}
            </Typography>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              {c.productName || (c.productId ? `Product #${c.productId}` : '')}
              {c.timestamp ? ` • ${new Date(c.timestamp).toLocaleString()}` : ''}
            </Typography>
          </div>
          <Typography variant="body2" dangerouslySetInnerHTML={{ __html: c.message }} />
        </div>
      ))}
    </div>
  )}
  </Box>
</Paper>
    </>
    ) : (
      <Box sx={{ minHeight: 170 }}>
        {editPresRevisionsLoading ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>Loading revisions…</Typography>
        ) : editPresRevisionsError ? (
          <Alert severity="error" sx={{ m: 2 }}>Unable to load revision history. Reopen this tab to retry.</Alert>
        ) : (
          <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 3px 0 rgba(0,0,0,0.05)' }}>
            <TableContainer sx={{ overflow: 'auto', maxHeight: 480, '&::-webkit-scrollbar': { width: 6, height: 6 }, '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(148,163,184,0.8)', borderRadius: 99 } }}>
              <Table stickyHeader size="small" sx={{ minWidth: 730 }}>
                <TableHead>
                  <TableRow>
                    {['Revision', 'Generated By', 'Date', 'Products', 'Status', 'Snapshot'].map((heading) => (
                      <TableCell key={heading} sx={{ px: 2, py: 1.25, backgroundColor: '#1e293b !important', color: '#f8fafc !important', fontWeight: 700, fontSize: '0.72rem', letterSpacing: '0.06em', textTransform: 'uppercase', whiteSpace: 'nowrap', borderBottom: 'none' }}>
                        {heading}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody sx={{ '& .MuiTableCell-root': { borderBottom: '1px solid', borderColor: 'divider' }, '& .MuiTableRow-root:last-child .MuiTableCell-root': { borderBottom: 'none' } }}>
                  {editPresRevisions.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ py: 7, color: 'text.secondary' }}>
                        No saved presentation revisions found.
                      </TableCell>
                    </TableRow>
                  ) : editPresRevisions.map((revision, index) => {
                    const highestRevision = Math.max(...editPresRevisions.map((item) => Number(item.revisionNumber) || 0));
                    const isCurrent = Number(revision.revisionNumber) === highestRevision;
                    const createdDate = revision.createdAt ? new Date(revision.createdAt) : null;
                    return (
                      <TableRow key={revision.id || revision.snapshotId || revision.revisionNumber} hover sx={{ bgcolor: isCurrent ? 'rgba(199,9,9,0.04)' : index % 2 === 0 ? 'background.paper' : '#f8fafc', borderLeft: isCurrent ? '3px solid' : '3px solid transparent', borderLeftColor: isCurrent ? 'primary.main' : 'transparent' }}>
                        <TableCell sx={{ px: 2, py: 1.5 }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Typography variant="caption" sx={{ fontFamily: 'monospace', fontWeight: 700, color: isCurrent ? 'primary.main' : 'text.secondary' }}>#{revision.revisionNumber || '—'}</Typography>
                            {isCurrent && <Chip label="Current" size="small" sx={{ height: 18, fontSize: '0.6rem', fontWeight: 700, bgcolor: 'rgba(199,9,9,0.1)', color: 'primary.main', border: '1px solid rgba(199,9,9,0.2)', '& .MuiChip-label': { px: '6px' } }} />}
                          </Stack>
                        </TableCell>
                        <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.8rem' }}>
                          <Stack direction="row" alignItems="center" spacing={1}>
                            <Box component="img" src={resolveAvatarSrc(revision.createdByAvatar)} alt="" onError={(e) => { e.currentTarget.src = defaultAvatarUrl; }}
                              sx={{ width: 26, height: 26, borderRadius: '50%', objectFit: 'cover', flexShrink: 0, border: '1px solid', borderColor: 'divider' }} />
                            <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>{revision.createdByName || 'System'}</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.8rem', whiteSpace: 'nowrap' }}>{createdDate && !Number.isNaN(createdDate.getTime()) ? createdDate.toLocaleString() : '—'}</TableCell>
                        <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.8rem' }}>{revision.itemCount ?? 0}</TableCell>
                        <TableCell sx={{ px: 2, py: 1.5, fontSize: '0.8rem' }}>{revision.lifecycleStatus || 'Saved'}</TableCell>
                        <TableCell sx={{ px: 2, py: 1.5 }}><Typography variant="caption" sx={{ color: 'text.secondary', fontFamily: 'monospace', overflowWrap: 'anywhere' }}>{revision.snapshotId || '—'}</Typography></TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        )}
      </Box>
    )}
  
{editPresTab === 'details' && (
<Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ mt: 2 }}>
  <Button onClick={() => { const row = presentationData.find((p) => String(p.id ?? p.presentationId) === String(editPresForm.id)); if (row) openEditPresentation(row); }} disabled={editPresSaving}>Reset</Button>
  <Button variant="contained" onClick={savePresentationEdits} disabled={editPresSaving || editPresTab !== 'details'}>
    {editPresSaving ? 'Saving…' : 'Save'}
  </Button>
</Stack>
)}
</Box>

        ) : (
          <Typography color="text.secondary">Loading presentation details…</Typography>
        )}
        </>
        )}
      </Box>
    ) : null}
  </>
)}

                  {activeTab === "shipping" && (
                    <>
                      <div className="order-details-section">
                        <div className="order-header-action">
                          <h2>Order #{orderId} - Presentation</h2>
                          <div className="dropdown-container">
                            <Box className='introduction-field' sx={{
                              display: 'flex',
                              justifyContent: 'center'
                            }}>
                              <Button
                                variant="contained"
                                onClick={handleActionsClick}
                                sx={{
                                  textTransform: 'none',
                                  justifySelf: 'center',
                                  color: 'white',
                                  backgroundColor: '#c3171d',
                                  '&:hover': {
                                    backgroundColor: 'white',
                                    color: '#c3171d',
                                  },
                                  width: '200px',
                                  fontWeight: 600,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.5rem'
                                }}
                              >
                                {loading ? <ButtonLoader /> : <>
                                  <SettingsIcon /> Actions
                                </>}
                              </Button>
                            </Box>
                            {showActions && (
                              <Box
                                className="dropdown-menu"
                              >
                                <Button
                                  disabled={documentCreationGuards.blockCreateEstimate}
                                  onClick={() => openEstimationPopup(1)}
                                  sx={{
                                    width: '100%', marginBottom: '10px',
                                    fontWeight: 700

                                  }}>
                                  Create Estimate
                                </Button>
                              </Box>
                            )}
                          </div>
                        </div>

                        <Shipping />
                      </div>

                      <h2>Presentation history</h2>


                    </>
                  )}

{isDocumentDetailRoute && (
                    <>
                      <div className="order-details-section">
                        <div className="order-header-action">
                          <h2>{ docTitle }</h2>
                          <div className="dropdown-container">
                            <Box className='introduction-field' sx={{
                              display: 'flex',
                              justifyContent: 'center'
                            }}>
                              <Button
                                variant="contained"
                                onClick={handleActionsClick}
                                sx={{
                                  textTransform: 'none',
                                  borderRadius: '10px',
                                  justifySelf: 'center',
                                  color: 'white',
                                  backgroundColor: '#c3171d',
                                  '&:hover': {
                                    backgroundColor: 'white',
                                    color: '#c3171d',
                                    border: '1px solid #c3171d',
                                  },
                                  width: '200px',
                                  fontWeight: 600,
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '0.5rem'
                                }}
                              >
                                {loading ? <ButtonLoader /> : <>
                                  <SettingsIcon /> Actions
                                </>}
                              </Button>
                            </Box>
                            {showActions && (
                              <Box className="dropdown-menu"
                              >
                                <Button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const previewId =
                                      tabId || currentSO?.estimationId || currentSO?.id;  
                                    const href = getDocPreviewPath(soStatusCode, previewId);
                                    window.open(href, "_blank");
                                  }}
                                  sx={{ width: '100%', mb: '10px', fontWeight: 700 }}
                                >
                                  {isEstimateRoute || soStatusCode === "1" ? "Estimate Preview" : "Sales Order Preview"}
                                </Button>
                                <Button
                                  onClick={() => {
                                    setShowActions(false);

                                    if (isSalesOrderRoute && enforceAddressBeforeSalesOrderSend) {
                                      const missing = getMissingSalesOrderSendAddresses(currentSO);

                                      if (missing.length) {
                                        toast.error(
                                          `Please add ${missing.join(" and ")} before sending this Sales Order.`
                                        );
                                        return;
                                      }
                                    }

                                    setEmailComposerOpen(true);
                                  }}
                                  disabled={isChangeRequestedActiveDoc}
                                  sx={{ width: '100%', mb: '10px', fontWeight: 700, opacity: isChangeRequestedActiveDoc ? 0.5 : 1 }}
                                >
                                  Send Email
                                </Button>
                                <Button
                                  onClick={openRequestArtDialog}
                                  sx={{ width: '100%', mb: '10px', fontWeight: 700 }}
                                >
                                  Artwork & Proofing
                                </Button>
                                <Button
                                  onClick={() => openPromoStoreCopy(docTitle, activeDocumentPromoStoreProducts)}
                                  disabled={!activeDocumentPromoStoreProducts.length}
                                  sx={{
                                    width: '100%',
                                    mb: '10px',
                                    fontWeight: 700,
                                    opacity: activeDocumentPromoStoreProducts.length ? 1 : 0.5,
                                  }}
                                >
                                  Convert to PromoStore
                                </Button>
                                <Tooltip title={regenerateTooltip} arrow>
                                  <span>
                                    <Button
                                      disabled={!canRegenerateActiveDoc}
                                      onClick={handleRegenerateActiveDoc}
                                      sx={{ width: '100%', mb: '10px', fontWeight: 700, opacity: canRegenerateActiveDoc ? 1 : 0.5 }}
                                    >
                                      {regenerateActionLabel}
                                    </Button>
                                  </span>
                                </Tooltip>
                                <Tooltip title={convertTooltip} arrow>
                                  <span>
                                    <Button
                                      disabled={convertToPoActionState.disabled}
                                      aria-busy={convertToPoActionState.status === "converting"}
                                      
                                      onClick={(e) => {
                                        // e.stopPropagation(); // Prevents triggering row click events
                                        // window.open(
                                        //   `/generated-sales-order/${tabId}`,
                                        //   "_blank"
                                        // );
                                        handleGeneratePO()
                                      }
                                      }
                                      sx={{
                                        width: '100%', marginBottom: '10px',
                                        fontWeight: 700,
                                        opacity: convertToPoActionState.disabled ? 0.55 : 1,
                                        cursor: convertToPoActionState.disabled ? "not-allowed" : "pointer",

                                      }}
                                      startIcon={
                                        convertToPoActionState.status === "converting"
                                          ? <AutorenewIcon sx={{ animation: 'spin 1.25s linear infinite', fontSize: 16 }} />
                                          : convertToPoActionState.status === "converted"
                                            ? <CheckCircleIcon sx={{ fontSize: 16 }} />
                                            : null
                                      }
                                    >
                                      {convertToPoActionState.label}
                                    </Button>
                                  </span>
                                </Tooltip>
                                <Tooltip title={invoiceTooltip} arrow>
                                  <span>
                                    <Button
                                      disabled={disableCreateInvoice || invoiceOpenLoading}
                                      data-testid="so-action-create-invoice"
                                      // Don't pass the React click event as skipDiffConfirm.
                                      // A truthy event would bypass the existing cart-diff confirmation.
                                      onClick={() => handleCreateInvoice()}
                                      sx={{
                                        width: '100%',
                                        marginBottom: '10px',
                                        fontWeight: 700,
                                        opacity: (disableCreateInvoice || invoiceOpenLoading) ? 0.4 : 1,
                                        cursor: (disableCreateInvoice || invoiceOpenLoading) ? 'not-allowed' : 'normal',
                                      }}
                                      startIcon={invoiceOpenLoading
                                        ? <CircularProgress size={16} color="inherit" />
                                        : invoiceCreatedActionCheck.loading && invoiceCreatedCheckIsCurrent
                                          ? <CircularProgress size={16} color="inherit" />
                                          : invoiceCreatedActionState.created
                                            ? <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
                                            : null}
                                    >
                                      {invoiceOpenLoading ? 'Preparing Invoice…'
                                        : invoiceCreatedActionState.created ? 'Invoice Created' : 'Create Invoice'}
                                    </Button>
                                  </span>
                                </Tooltip>
                       
                              </Box>
                            )}
                          </div>
                        </div>

                        <Dialog
                          open={paidDepositDialogOpen}
                          onClose={paidDepositApprovalLoading ? undefined : () => setPaidDepositDialogOpen(false)}
                          maxWidth="xs"
                          fullWidth
                        >
                          <DialogTitle>Approve This Sales Order?</DialogTitle>
                          <DialogContent dividers>
                            <Typography>
                              A paid deposit invoice has been confirmed. Approve this Sales Order as Client Approved?
                            </Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button disabled={paidDepositApprovalLoading} onClick={() => setPaidDepositDialogOpen(false)}>Cancel</Button>
                            <Button
                              variant="contained"
                              color="success"
                              disabled={paidDepositApprovalLoading}
                              onClick={approveFromPaidDeposit}
                            >
                              {paidDepositApprovalLoading ? <ButtonLoader /> : 'Approve Sales Order'}
                            </Button>
                          </DialogActions>
                        </Dialog>

                        <Tabs
                          value={docViewTab}
                          onChange={(_, nextValue) => setDocViewTab(nextValue)}
                          sx={{ mt: 0, mb: 2 }}
                        >
                          <Tab value="details" label="Details" />
                          <Tab value="history" label={historyTabLabel} />
                        </Tabs>

                        {docViewTab === 'details' && (
                          <PresentationScreen
                            clientContacts={clientContacts}
                            activeTab={activeTab}
                            label="Presentation Date"
                            fetchOrder={fetchOrder}
                            conversionStatus={conversionStatus}
                            paidDepositApprovalAction={paidDepositApprovalAction}
                            selectedProducts={selectedProducts}
                            handleShowProductsPopup={handleShowProductsPopup}
                            order={order} handleChange={handleChange} setOrder={setOrder} />
                        )}

{docViewTab === "history" && (() => {
  const SNAPSHOT_HISTORY_COLUMNS = [
    {
      id: "estimationId",
      label: "Document ID",
      minWidth: 150,
      align: "left",
      locked: true,
    },
    {
      id: "regeneratedBy",
      label: "User",
      minWidth: 220,
      align: "left",
    },
    {
      id: "orderDate",
      label: "Created",
      minWidth: 190,
      align: "left",
    },
    {
      id: "revisionNumber",
      label: "Revision",
      minWidth: 120,
      align: "left",
    },
    {
      id: "itemCount",
      label: "Lines",
      minWidth: 90,
      align: "left",
    },
    {
      id: "snapshotId",
      label: "Snapshot",
      minWidth: 260,
      align: "left",
    },
    {
      id: "status",
      label: "Status",
      minWidth: 150,
      align: "left",
    },
    {
      id: "action",
      label: "Action",
      minWidth: 120,
      align: "center",
      locked: true,
    },
  ];

  const sortedHistory = [...mappedDocumentSnapshotHistory].sort((a, b) => {
    const revA = Number(a.revisionNumber || 0);
    const revB = Number(b.revisionNumber || 0);
    if (revA !== revB) return revB - revA;

    const dateA = new Date(a.orderDate || a.createdAt || 0).getTime();
    const dateB = new Date(b.orderDate || b.createdAt || 0).getTime();
    return dateB - dateA;
  });

  const pagedHistory = sortedHistory.slice(
    historyPage * historyRowsPerPage,
    historyPage * historyRowsPerPage + historyRowsPerPage
  );

  const snapshotColumnIds = new Set(SNAPSHOT_HISTORY_COLUMNS.map((c) => c.id));

  const visibleHistoryCols = (() => {
    if (!(historyVisibleCols instanceof Set)) {
      return new Set(SNAPSHOT_HISTORY_COLUMNS.map((c) => c.id));
    }

    const next = new Set(
      [...historyVisibleCols].filter((id) => snapshotColumnIds.has(id))
    );

    // Force the new main columns visible even if old 179 state only had stripeLinks.
    next.add("estimationId");
    next.add("itemCount");
    next.add("snapshotId");
    next.add("action");

    // Do not carry over the old PR179 Stripe Links column.
    next.delete("stripeLinks");

    return next;
  })();

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <UITableShell
        customLayout
        paperSx={{
          borderRadius: "10px",
          border: "1px solid",
          borderColor: "divider",
          borderTop: "3px solid",
          borderTopColor: "primary.main",
          mt: 0,
          boxShadow:
            "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <UITableToolbar sx={{ backgroundColor: "background.paper", p: 0 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
            sx={{
              px: 2,
              py: 1,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography
                variant="h6"
                fontWeight={700}
                sx={{ color: "text.primary", lineHeight: 1 }}
              >
                {historyTitle}
              </Typography>

              {sortedHistory.length > 0 && (
                <Chip
                  label={`${sortedHistory.length} revision${
                    sortedHistory.length !== 1 ? "s" : ""
                  }`}
                  size="small"
                  sx={{
                    fontWeight: 600,
                    fontSize: "0.72rem",
                    height: 22,
                    bgcolor: "#f1f5f9",
                    color: "text.secondary",
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                />
              )}
            </Stack>

            <Stack direction="row" spacing={0.75} alignItems="center">
              <Tooltip title="Show / hide columns" arrow>
                <IconButton
                  size="small"
                  onClick={(e) => setHistoryColumnMenuAnchor(e.currentTarget)}
                  sx={{ color: "text.secondary" }}
                >
                  <ViewColumnIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>

              <Tooltip title="Row density" arrow>
                <IconButton
                  size="small"
                  onClick={(e) => setHistoryDensityAnchor(e.currentTarget)}
                  sx={{ color: "text.secondary" }}
                >
                  <FormatLineSpacingIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>

              <Tooltip title="Refresh" arrow>
                <span>
                  <IconButton
                    size="small"
                    onClick={() => fetchOrder(true)}
                    disabled={loading}
                    sx={{ color: "text.secondary" }}
                  >
                    <RefreshIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title="Export" arrow>
                <span>
                  <IconButton
                    size="small"
                    disabled={!sortedHistory.length}
                    onClick={(e) => setHistoryExportMenuAnchor(e.currentTarget)}
                    sx={{ color: "text.secondary" }}
                  >
                    <FileDownloadIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Stack>
        </UITableToolbar>

        <TableContainer
          sx={{
            flex: 1,
            overflow: "auto",
            minHeight: 280,
            maxHeight: 480,
            "&::-webkit-scrollbar": { width: 6, height: 6 },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(148,163,184,0.8)",
              borderRadius: 99,
            },
            "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
          }}
        >
          <Table stickyHeader size="small" sx={{ minWidth: 1180 }}>
            <TableHead>
              <TableRow>
                {SNAPSHOT_HISTORY_COLUMNS.filter((c) =>
                  visibleHistoryCols.has(c.id)
                ).map((col) => (
                  <TableCell
                    key={col.id}
                    align={col.align || "left"}
                    sx={{
                      minWidth: col.minWidth,
                      px: 2,
                      py: 1.25,
                      backgroundColor: "#1e293b !important",
                      color: "#f8fafc !important",
                      fontWeight: 700,
                      fontSize: "0.72rem",
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                      borderBottom: "none",
                      whiteSpace: "nowrap",
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    {col.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody
              sx={{
                "& .MuiTableCell-root": {
                  borderBottom: "1px solid",
                  borderColor: "divider",
                },
                "& .MuiTableRow-root:last-child .MuiTableCell-root": {
                  borderBottom: "none",
                },
              }}
            >
              {sortedHistory.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={SNAPSHOT_HISTORY_COLUMNS.length}
                    sx={{ border: "none", p: 0 }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        py: 8,
                      }}
                    >
                      <HistoryIcon
                        sx={{
                          fontSize: 52,
                          mb: 1.5,
                          opacity: 0.2,
                          color: "text.disabled",
                        }}
                      />
                      <Typography
                        variant="body1"
                        fontWeight={600}
                        sx={{ mb: 0.5, color: "text.secondary" }}
                      >
                        No snapshot revisions yet
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "text.disabled" }}
                      >
                        Revisions will appear here after the document is created
                        or regenerated.
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                pagedHistory.map((row, idx) => {
                  const isCurrentDoc =
                    String(row.estimationId || row.id) === String(tabId);

                  const createdDate = row.orderDate
                    ? new Date(row.orderDate)
                    : row.createdAt
                    ? new Date(row.createdAt)
                    : null;

                  const statusColor = getEstSoStatusColor(row.statusClass);
                  const avatarSrc = resolveAvatarSrc(row.regeneratedByAvatar);

                  return (
                    <TableRow
                      key={`${row.estimationId || row.id || "doc"}-${
                        row.revisionNumber || idx
                      }-${row.snapshotId || "snapshot"}`}
                      hover
                      onClick={() => {
                        if (row.routePath) history.push(row.routePath);
                      }}
                      sx={{
                        cursor: row.routePath ? "pointer" : "default",
                        bgcolor: isCurrentDoc
                          ? "rgba(199,9,9,0.04)"
                          : idx % 2 === 0
                          ? "background.paper"
                          : "#f8fafc",
                        borderLeft: isCurrentDoc
                          ? "3px solid"
                          : "3px solid transparent",
                        borderLeftColor: isCurrentDoc
                          ? "primary.main"
                          : "transparent",
                        transition: "background-color 0.12s",
                      }}
                    >
                      {visibleHistoryCols.has("estimationId") && (
                        <TableCell sx={{ px: 2, py: historyDensity.py }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.75,
                            }}
                          >
                            <Typography
                              variant="caption"
                              sx={{
                                fontFamily: "monospace",
                                fontWeight: isCurrentDoc ? 700 : 600,
                                color: isCurrentDoc
                                  ? "primary.main"
                                  : "text.secondary",
                                fontSize: historyDensity.fontSize,
                              }}
                            >
                              {row.estimationId || row.id || "—"}
                            </Typography>

                            {isCurrentDoc && (
                              <Chip
                                label="Current"
                                size="small"
                                sx={{
                                  height: 18,
                                  fontSize: "0.6rem",
                                  fontWeight: 700,
                                  bgcolor: "rgba(199,9,9,0.1)",
                                  color: "primary.main",
                                  border: "1px solid rgba(199,9,9,0.2)",
                                  "& .MuiChip-label": { px: "6px" },
                                }}
                              />
                            )}
                          </Box>
                        </TableCell>
                      )}

                      {visibleHistoryCols.has("regeneratedBy") && (
                        <TableCell sx={{ px: 2, py: historyDensity.py }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Box
                              component="img"
                              src={avatarSrc}
                              alt="avatar"
                              onError={(e) => {
                                e.currentTarget.src = defaultAvatarUrl;
                              }}
                              sx={{
                                width: 26,
                                height: 26,
                                borderRadius: "50%",
                                objectFit: "cover",
                                flexShrink: 0,
                                border: "1px solid",
                                borderColor: "divider",
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: historyDensity.fontSize,
                                color: "text.primary",
                              }}
                            >
                              {row.regeneratedBy || "—"}
                            </Typography>
                          </Box>
                        </TableCell>
                      )}

                      {visibleHistoryCols.has("orderDate") && (
                        <TableCell sx={{ px: 2, py: historyDensity.py }}>
                          <Typography
                            variant="body2"
                            fontWeight={500}
                            sx={{ fontSize: historyDensity.fontSize }}
                          >
                            {createdDate && !Number.isNaN(createdDate.getTime())
                              ? createdDate.toLocaleDateString(undefined, {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                })
                              : "—"}
                          </Typography>

                          {createdDate && !Number.isNaN(createdDate.getTime()) && (
                            <Typography
                              variant="caption"
                              sx={{
                                color: "text.secondary",
                                fontSize: "0.7rem",
                              }}
                            >
                              {getRelativeTime(createdDate)}
                            </Typography>
                          )}
                        </TableCell>
                      )}

                      {visibleHistoryCols.has("revisionNumber") && (
                        <TableCell sx={{ px: 2, py: historyDensity.py }}>
                          {row.revisionNumber ? (
                            <Chip
                              label={`Rev ${row.revisionNumber}`}
                              size="small"
                              sx={{
                                height: 20,
                                fontSize: "0.68rem",
                                fontWeight: 700,
                                bgcolor: "#f1f5f9",
                                color: "text.secondary",
                                border: "1px solid",
                                borderColor: "divider",
                                "& .MuiChip-label": { px: "8px" },
                              }}
                            />
                          ) : (
                            <Typography
                              variant="caption"
                              sx={{ color: "text.disabled" }}
                            >
                              —
                            </Typography>
                          )}
                        </TableCell>
                      )}

                      {visibleHistoryCols.has("itemCount") && (
                        <TableCell sx={{ px: 2, py: historyDensity.py }}>
                          <Chip
                            label={Number(row.itemCount || 0)}
                            size="small"
                            sx={{
                              height: 22,
                              minWidth: 34,
                              fontSize: "0.68rem",
                              fontWeight: 700,
                              bgcolor: "rgba(14,165,233,0.08)",
                              color: "#0369a1",
                              border: "1px solid rgba(14,165,233,0.22)",
                              "& .MuiChip-label": { px: "8px" },
                            }}
                          />
                        </TableCell>
                      )}

                      {visibleHistoryCols.has("snapshotId") && (
                        <TableCell sx={{ px: 2, py: historyDensity.py }}>
                          <Tooltip title={row.snapshotId || "No snapshot id"} arrow>
                            <Typography
                              variant="caption"
                              sx={{
                                display: "inline-block",
                                maxWidth: 240,
                                fontFamily: "monospace",
                                fontSize: "0.7rem",
                                color: row.snapshotId
                                  ? "text.secondary"
                                  : "text.disabled",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                verticalAlign: "middle",
                              }}
                            >
                              {row.snapshotId || "—"}
                            </Typography>
                          </Tooltip>
                        </TableCell>
                      )}

                      {visibleHistoryCols.has("status") && (
                        <TableCell sx={{ px: 2, py: historyDensity.py }}>
                          <Chip
                            label={row.readableStatus || row.status || "—"}
                            size="small"
                            sx={{
                              height: 22,
                              fontSize: "0.68rem",
                              fontWeight: 700,
                              backgroundColor: statusColor.bg,
                              color: statusColor.text,
                              border: `1px solid ${statusColor.border}`,
                              "& .MuiChip-label": { px: "8px" },
                            }}
                          />
                        </TableCell>
                      )}

                      {visibleHistoryCols.has("action") && (
                        <TableCell
                          align="center"
                          sx={{ px: 2, py: historyDensity.py }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Tooltip title="Open document" arrow>
                            <span>
                              <IconButton
                                size="small"
                                disabled={!row.routePath}
                                onClick={() => {
                                  if (row.routePath) {
                                    window.open(row.routePath, "_blank", "noopener,noreferrer");
                                  }
                                }}
                                sx={{
                                  color: "text.secondary",
                                  "&:hover": { color: "primary.main" },
                                }}
                              >
                                <ArrowForwardIcon sx={{ fontSize: 16 }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {!loading && sortedHistory.length > 0 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 2,
              py: 0.5,
              borderTop: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              flexShrink: 0,
            }}
          >
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              Showing{" "}
              {Math.min(
                historyPage * historyRowsPerPage + 1,
                sortedHistory.length
              )}
              –
              {Math.min(
                historyPage * historyRowsPerPage + historyRowsPerPage,
                sortedHistory.length
              )}{" "}
              of {sortedHistory.length} revision
              {sortedHistory.length !== 1 ? "s" : ""}
            </Typography>

            <TablePagination
              component="div"
              count={sortedHistory.length}
              page={historyPage}
              onPageChange={(_, newPage) => setHistoryPage(newPage)}
              rowsPerPage={historyRowsPerPage}
              onRowsPerPageChange={(e) => {
                setHistoryRowsPerPage(parseInt(e.target.value, 10));
                setHistoryPage(0);
              }}
              rowsPerPageOptions={[10, 25, 50]}
              sx={{
                "& .MuiTablePagination-toolbar": {
                  minHeight: 40,
                  pl: 0,
                },
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                  {
                    fontSize: "0.78rem",
                    color: "text.secondary",
                  },
              }}
            />
          </Box>
        )}
      </UITableShell>

      <Menu
        anchorEl={historyColumnMenuAnchor}
        open={Boolean(historyColumnMenuAnchor)}
        onClose={() => setHistoryColumnMenuAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 210, borderRadius: 2 } } }}
      >
        <Typography
          variant="overline"
          sx={{
            px: 2,
            pt: 1.25,
            pb: 0.5,
            display: "block",
            color: "text.disabled",
          }}
        >
          Columns
        </Typography>

        <Divider sx={{ mb: 0.5 }} />

        {SNAPSHOT_HISTORY_COLUMNS.filter((c) => !c.locked).map((col) => (
          <MenuItem
            key={col.id}
            onClick={() =>
              setHistoryVisibleCols((prev) => {
                const next = new Set(
                  prev instanceof Set
                    ? [...prev].filter((id) => snapshotColumnIds.has(id))
                    : SNAPSHOT_HISTORY_COLUMNS.map((c) => c.id)
                );

                next.has(col.id) ? next.delete(col.id) : next.add(col.id);

                next.add("estimationId");
                next.add("action");
                next.delete("stripeLinks");

                return next;
              })
            }
            sx={{ py: 0.4 }}
          >
            <Checkbox
              size="small"
              checked={visibleHistoryCols.has(col.id)}
              sx={{ p: 0.5, mr: 0.5 }}
            />
            <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>
              {col.label}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>

      <Menu
        anchorEl={historyDensityAnchor}
        open={Boolean(historyDensityAnchor)}
        onClose={() => setHistoryDensityAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 180, borderRadius: 2 } } }}
      >
        <Typography
          variant="overline"
          sx={{
            px: 2,
            pt: 1.25,
            pb: 0.5,
            display: "block",
            color: "text.disabled",
          }}
        >
          Row Density
        </Typography>

        {["compact", "comfortable", "spacious"].map((d) => (
          <MenuItem
            key={d}
            onClick={() => {
              setHistoryDensityMode(d);
              setHistoryDensityAnchor(null);
            }}
            sx={{ py: 0.75 }}
          >
            <Checkbox
              size="small"
              checked={historyDensityMode === d}
              sx={{ p: 0.5, mr: 0.5 }}
            />
            <ListItemText
              primaryTypographyProps={{
                fontSize: "0.875rem",
                textTransform: "capitalize",
              }}
            >
              {d}
            </ListItemText>
          </MenuItem>
        ))}
      </Menu>

      <Menu
        anchorEl={historyExportMenuAnchor}
        open={Boolean(historyExportMenuAnchor)}
        onClose={() => setHistoryExportMenuAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 180, borderRadius: 2 } } }}
      >
        <Typography
          variant="overline"
          sx={{
            px: 2,
            pt: 1.25,
            pb: 0.5,
            display: "block",
            color: "text.disabled",
          }}
        >
          Export As
        </Typography>

        <Divider sx={{ mb: 0.5 }} />

        <MenuItem
          onClick={() => {
            handleHistoryExportCSV();
            setHistoryExportMenuAnchor(null);
          }}
          sx={{ py: 0.75, gap: 1.5 }}
        >
          <TableChartIcon sx={{ fontSize: 17, color: "text.secondary" }} />
          <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>
            Export CSV
          </ListItemText>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleHistoryExportExcel();
            setHistoryExportMenuAnchor(null);
          }}
          sx={{ py: 0.75, gap: 1.5 }}
        >
          <GridOnIcon sx={{ fontSize: 17, color: "#217346" }} />
          <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>
            Export Excel
          </ListItemText>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleHistoryExportPDF();
            setHistoryExportMenuAnchor(null);
          }}
          sx={{ py: 0.75, gap: 1.5 }}
        >
          <PictureAsPdfIcon sx={{ fontSize: 17, color: "#c3171d" }} />
          <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>
            Export PDF
          </ListItemText>
        </MenuItem>
      </Menu>
    </Box>
  );
})()}





                      </div>
                    </>
                  )}

       {((activeTab === "Sales Order" && !isSalesOrderDocumentRoute) || (activeTab === "Estimates" && !isEstimateDocumentRoute)) && (
  <>
    
    {(() => {
      const C = {
        headerBg: "#1e293b",
        headerText: "#f8fafc",
        border: "divider",
      };

      const sortedRows = [...filteredSalesRows].sort(
        (a, b) => new Date(b.orderDate || 0) - new Date(a.orderDate || 0)
      );

      return (
        <Box sx={{ width: "100%", mt: 1 }}>
          <UITableShell
            customLayout
            paperSx={{
              borderRadius: "10px",
              border: "1px solid",
              borderColor: "divider",
              borderTop: "3px solid",
              borderTopColor: "primary.main",
              minHeight: 0,
              mt: 0,
              boxShadow: "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
              display: "flex",
              flexDirection: "column",
            }}
          >
             
            <UITableToolbar sx={{ backgroundColor: "background.paper", p: 0 }}>
               
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                gap={1}
                sx={{ px: 2, py: 1, borderBottom: "1px solid", borderColor: "divider" }}
              >
                
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="h6" fontWeight={700} sx={{ color: "text.primary", lineHeight: 1 }}>
                    {activeTab === "Estimates" ? "Estimates" : "Sales Orders"}
                  </Typography>
                  {filteredSalesRows.length > 0 && (
                    <Chip
                      label={`${filteredSalesRows.length} ${activeTab === "Estimates" ? "estimate" : "order"}${filteredSalesRows.length !== 1 ? "s" : ""}`}
                      size="small"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.72rem",
                        height: 22,
                        bgcolor: "#f1f5f9",
                        color: "text.secondary",
                        border: "1px solid",
                        borderColor: "divider",
                      }}
                    />
                  )}
                </Stack>
 
                <Stack direction="row" spacing={0.75} alignItems="center">
                  
                  <Tooltip title="Show / hide columns" arrow>
                    <IconButton
                      size="small"
                      onClick={(e) => setEstSoColumnMenuAnchor(e.currentTarget)}
                      sx={{ color: "text.secondary" }}
                    >
                      <ViewColumnIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>

                  
                  <Tooltip title="Row density" arrow>
                    <IconButton
                      size="small"
                      onClick={(e) => setEstSoDensityAnchor(e.currentTarget)}
                      sx={{ color: "text.secondary" }}
                    >
                      <FormatLineSpacingIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>

                 
                  <Tooltip title="Refresh" arrow>
                    <span>
                      <IconButton
                        size="small"
                        onClick={() => fetchOrder(true)}
                        disabled={loading}
                        sx={{ color: "text.secondary" }}
                      >
                        <RefreshIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </span>
                  </Tooltip>

                 
                
                  <Tooltip title="Export" arrow>
  <span>
    <IconButton
      size="small"
      disabled={filteredSalesRows.length === 0}
      onClick={(e) => setEstSoExportMenuAnchor(e.currentTarget)}
      sx={{ color: "text.secondary" }}
    >
      <FileDownloadIcon sx={{ fontSize: 18 }} />
    </IconButton>
  </span>
</Tooltip>
 
<Menu
  anchorEl={estSoExportMenuAnchor}
  open={Boolean(estSoExportMenuAnchor)}
  onClose={() => setEstSoExportMenuAnchor(null)}
  slotProps={{ paper: { sx: { minWidth: 180, borderRadius: 2 } } }}
>
  <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>
    Export As
  </Typography>
  <Divider sx={{ mb: 0.5 }} />
  <MenuItem
    onClick={() => { handleEstSoExportCSV(); setEstSoExportMenuAnchor(null); }}
    sx={{ py: 0.75, gap: 1.5 }}
  >
    <TableChartIcon sx={{ fontSize: 17, color: "text.secondary" }} />
    <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>Export CSV</ListItemText>
  </MenuItem>
  <MenuItem
    onClick={() => { handleEstSoExportExcel(); setEstSoExportMenuAnchor(null); }}
    sx={{ py: 0.75, gap: 1.5 }}
  >
    <GridOnIcon sx={{ fontSize: 17, color: "#217346" }} />
    <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>Export Excel</ListItemText>
  </MenuItem>
  <MenuItem
    onClick={() => { handleEstSoExportPDF(); setEstSoExportMenuAnchor(null); }}
    sx={{ py: 0.75, gap: 1.5 }}
  >
    <PictureAsPdfIcon sx={{ fontSize: 17, color: "#c3171d" }} />
    <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>Export PDF</ListItemText>
  </MenuItem>
</Menu>

                  <Divider orientation="vertical" flexItem sx={{ height: 28, alignSelf: "center" }} />

              
                  <Tooltip title={activeTab === "Estimates" ? estimateCreationTip : salesOrderCreationTip} arrow>
                    <span>
                      <Button
                        variant="contained"
                        size="small"
                        disabled={activeTab === "Estimates"
                          ? documentCreationGuards.blockCreateEstimate
                          : documentCreationGuards.blockCreateSalesOrder}
                        onClick={() => {
                          openEstimationPopup(activeTab === "Estimates" ? 1 : 2);
                        }}
                        sx={{
                          height: 32,
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.8rem",
                          borderRadius: "8px",
                          boxShadow: "none",
                          opacity: (activeTab === "Estimates"
                            ? documentCreationGuards.blockCreateEstimate
                            : documentCreationGuards.blockCreateSalesOrder) ? 0.5 : 1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {activeTab === "Estimates" ? "New Estimate" : "New Sales Order"}
                      </Button>
                    </span>
                  </Tooltip>
                </Stack>
              </Stack>
            </UITableToolbar>

        
            <TableContainer
              sx={{
                flex: 1,
                overflow: "auto",
                minHeight: 320,
                maxHeight: 480,
                "&::-webkit-scrollbar": { width: 6, height: 6 },
                "&::-webkit-scrollbar-thumb": { backgroundColor: "rgba(148,163,184,0.8)", borderRadius: 99 },
                "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
              }}
            >
              <Table stickyHeader size="small" sx={{ minWidth: 680 }}>
              
                <TableHead>
                  <TableRow>
                    {EST_SO_COLUMNS.filter((c) => estSoVisibleCols.has(c.id)).map((col) => (
                      <TableCell
                        key={col.id}
                        align={col.align || "left"}
                        sx={{
                          minWidth: col.minWidth,
                          px: 2,
                          py: 1.25,
                          backgroundColor: `${C.headerBg} !important`,
                          color: `${C.headerText} !important`,
                          fontWeight: 700,
                          fontSize: "0.72rem",
                          letterSpacing: "0.06em",
                          textTransform: "uppercase",
                          borderBottom: "none",
                          whiteSpace: "nowrap",
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        {col.id === "estimationId"
                          ? activeTab === "Sales Order" ? "Sales Order ID" : "Estimation ID"
                          : col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
 
                <TableBody
                  sx={{
                    "& .MuiTableCell-root": { borderBottom: "1px solid", borderColor: "divider" },
                    "& .MuiTableRow-root:last-child .MuiTableCell-root": { borderBottom: "none" },
                  }}
                >
                  {sortedRows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={EST_SO_COLUMNS.length} sx={{ border: "none", p: 0 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            py: 8,
                            color: "text.disabled",
                          }}
                        >
                          {activeTab === "Estimates"
                            ? <RequestQuoteIcon sx={{ fontSize: 52, mb: 1.5, opacity: 0.25 }} />
                            : <ReceiptLongIcon sx={{ fontSize: 52, mb: 1.5, opacity: 0.25 }} />
                          }
                          <Typography variant="body1" fontWeight={600} sx={{ mb: 0.5, color: "text.secondary" }}>
                            {activeTab === "Estimates" ? "No estimates yet" : "No sales orders yet"}
                          </Typography>
                          <Typography variant="body2" sx={{ color: "text.disabled" }}>
                            {activeTab === "Estimates"
                              ? "Add products to the cart and click New Estimate."
                              : "Add products to the cart and click New Sales Order."}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    sortedRows
                      .slice(estSoPage * estSoRowsPerPage, estSoPage * estSoRowsPerPage + estSoRowsPerPage)
                      .map((row, idx) => {
                        const orderDate = row.orderDate ? new Date(row.orderDate) : null;
                        const relText = orderDate ? getRelativeTime(orderDate) : "—";
                        const statusColor = getEstSoStatusColor(row.statusClass);
                        const isCurrentDoc = String(row.id) === String(tabId);

                        return (
                          <TableRow
                            key={row.id || row.estimationId || idx}
                            hover
                            onClick={() => {
                              const tabType = getDocTabTypeByStatus(row.status);
                              history.push(
                                `/instance/elite-promo-marketing/sales/orders/${orderId}/${tabType}/${row.id}`
                              );
                            }}
                            sx={{
                              cursor: "pointer",
                              bgcolor: isCurrentDoc
                                ? "rgba(199,9,9,0.04)"
                                : idx % 2 === 0 ? "background.paper" : "#f8fafc",
                              borderLeft: isCurrentDoc ? "3px solid" : "3px solid transparent",
                              borderLeftColor: isCurrentDoc ? "primary.main" : "transparent",
                              transition: "background-color 0.12s",
                            }}
                          >
                            
                            {estSoVisibleCols.has("estimationId") && (
                              <TableCell sx={{ px: 2, py: estSoDensity.py }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontFamily: "monospace",
                                      color: isCurrentDoc ? "primary.main" : "text.secondary",
                                      fontWeight: isCurrentDoc ? 700 : 600,
                                      fontSize: estSoDensity.fontSize,
                                    }}
                                  >
                                    {row.estimationId || "—"}
                                  </Typography>
                                  {isCurrentDoc && (
                                    <Chip
                                      label="Current"
                                      size="small"
                                      sx={{
                                        height: 18,
                                        fontSize: "0.6rem",
                                        fontWeight: 700,
                                        bgcolor: "rgba(199,9,9,0.1)",
                                        color: "primary.main",
                                        border: "1px solid rgba(199,9,9,0.2)",
                                        "& .MuiChip-label": { px: "6px" },
                                      }}
                                    />
                                  )}
                                </Box>
                              </TableCell>
                            )}

                          
                            {estSoVisibleCols.has("orderDate") && (
                              <TableCell sx={{ px: 2, py: estSoDensity.py }}>
                                <Typography variant="body2" fontWeight={500} sx={{ fontSize: estSoDensity.fontSize }}>
                                  {orderDate
                                    ? orderDate.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })
                                    : "—"}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "text.secondary", fontSize: "0.7rem" }}>
                                  {relText}
                                </Typography>
                              </TableCell>
                            )}
 
                            {estSoVisibleCols.has("status") && (
                              <TableCell sx={{ px: 2, py: estSoDensity.py }}>
                                <Chip
                                  label={row.readableStatus || row.status || "—"}
                                  size="small"
                                  sx={{
                                    height: 22,
                                    fontSize: "0.68rem",
                                    fontWeight: 700,
                                    backgroundColor: statusColor.bg,
                                    color: statusColor.text,
                                    border: `1px solid ${statusColor.border}`,
                                    "& .MuiChip-label": { px: "8px" },
                                  }}
                                />
                              </TableCell>
                            )}

                           
                            {estSoVisibleCols.has("clientEmail") && (
                              <TableCell sx={{ px: 2, py: estSoDensity.py }}>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                  <MailOutlineIcon sx={{ fontSize: 13, color: "text.disabled", flexShrink: 0 }} />
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "text.secondary",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      maxWidth: 200,
                                      fontSize: estSoDensity.fontSize,
                                    }}
                                  >
                                    {row.clientEmail || "—"}
                                  </Typography>
                                </Box>
                              </TableCell>
                            )}
 
                            {estSoVisibleCols.has("action") && (
                              <TableCell
                                align="center"
                                sx={{ px: 2, py: estSoDensity.py }}
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                                  <Tooltip title="Open document" arrow>
                                    <IconButton
                                      size="small"
                                      onClick={() => {
                                        setDocViewTab("details");
                                        const tabType = getDocTabTypeByStatus(row.status);
                                        history.push(
                                          `/instance/elite-promo-marketing/sales/orders/${orderId}/${tabType}/${row.id}`
                                        );
                                      }}
                                      sx={{ color: "text.secondary", "&:hover": { color: "primary.main" } }}
                                    >
                                      <ArrowForwardIcon sx={{ fontSize: 16 }} />
                                    </IconButton>
                                  </Tooltip>

                                  {row.status === "3" && row.poGenerated && (
                                    <Tooltip title="View Purchase Order" arrow>
                                      <Chip
                                        label="PO"
                                        size="small"
                                        onClick={() =>
                                          window.open(
                                            `/instance/elite-promo-marketing/sales/orders/${orderId}/pos-proofs/${row.id}`,
                                            "_blank"
                                          )
                                        }
                                        sx={{
                                          height: 22,
                                          fontSize: "0.68rem",
                                          fontWeight: 700,
                                          cursor: "pointer",
                                          bgcolor: "var(--ec-status-success-bg)",
                                          color: "var(--ec-status-success-text)",
                                          border: "1px solid var(--ec-status-success-border)",
                                          "& .MuiChip-label": { px: "8px" },
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                </Stack>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })
                  )}
                </TableBody>
              </Table>
            </TableContainer>
 
            {!loading && sortedRows.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2,
                  py: 0.5,
                  borderTop: "1px solid",
                  borderColor: "divider",
                  bgcolor: "background.paper",
                  flexShrink: 0,
                }}
              >
                <Typography variant="caption" sx={{ color: "text.secondary" }}>
                  Showing{" "}
                  {Math.min(estSoPage * estSoRowsPerPage + 1, sortedRows.length)}–
                  {Math.min(estSoPage * estSoRowsPerPage + estSoRowsPerPage, sortedRows.length)}{" "}
                  of {sortedRows.length}{" "}
                  {activeTab === "Estimates" ? "estimate" : "order"}
                  {sortedRows.length !== 1 ? "s" : ""}
                </Typography>
                <TablePagination
                  component="div"
                  count={sortedRows.length}
                  page={estSoPage}
                  onPageChange={(_, newPage) => setEstSoPage(newPage)}
                  rowsPerPage={estSoRowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setEstSoRowsPerPage(parseInt(e.target.value, 10));
                    setEstSoPage(0);
                  }}
                  rowsPerPageOptions={[10, 25, 50]}
                  sx={{
                    "& .MuiTablePagination-toolbar": { minHeight: 40, pl: 0 },
                    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
                      fontSize: "0.78rem",
                      color: "text.secondary",
                    },
                  }}
                />
              </Box>
            )}
          </UITableShell>
 
          <Menu
            anchorEl={estSoColumnMenuAnchor}
            open={Boolean(estSoColumnMenuAnchor)}
            onClose={() => setEstSoColumnMenuAnchor(null)}
            slotProps={{ paper: { sx: { minWidth: 210, borderRadius: 2 } } }}
          >
            <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>
              Columns
            </Typography>
            <Divider sx={{ mb: 0.5 }} />
            {EST_SO_COLUMNS.filter((c) => !c.locked).map((col) => (
              <MenuItem
                key={col.id}
                onClick={() => {
                  setEstSoVisibleCols((prev) => {
                    const next = new Set(prev);
                    next.has(col.id) ? next.delete(col.id) : next.add(col.id);
                    return next;
                  });
                }}
                sx={{ py: 0.4 }}
              >
                <Checkbox
                  size="small"
                  checked={estSoVisibleCols.has(col.id)}
                  sx={{ p: 0.5, mr: 0.5 }}
                />
                <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>
                  {col.id === "estimationId"
                    ? activeTab === "Sales Order" ? "Sales Order ID" : "Estimation ID"
                    : col.label}
                </ListItemText>
              </MenuItem>
            ))}
          </Menu>
 
          <Menu
            anchorEl={estSoDensityAnchor}
            open={Boolean(estSoDensityAnchor)}
            onClose={() => setEstSoDensityAnchor(null)}
            slotProps={{ paper: { sx: { minWidth: 180, borderRadius: 2 } } }}
          >
            <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>
              Row Density
            </Typography>
            {["compact", "comfortable", "spacious"].map((d) => (
              <MenuItem
                key={d}
                onClick={() => { setEstSoDensityMode(d); setEstSoDensityAnchor(null); }}
                sx={{ py: 0.75 }}
              >
                <Checkbox size="small" checked={estSoDensityMode === d} sx={{ p: 0.5, mr: 0.5 }} />
                <ListItemText primaryTypographyProps={{ fontSize: "0.875rem", textTransform: "capitalize" }}>
                  {d}
                </ListItemText>
              </MenuItem>
            ))}
          </Menu>
        </Box>
      );
    })()}
  </>
)}
                  {activeTab === "Files" && (
                    <div className="order-details-section">
                      <h2>Files</h2>
                      <OrderFiles order={order} />
                    </div>
                  )}

                  {activeTab === "Invoice" && (
                    <Box sx={{ display: isInvoicePage && !invoicePageReady ? "none" : "block" }}>
                      {/*<Box sx={{ mb: 2, p: 1.5, borderRadius: 1.5, border: "1px solid #cbd5e1", background: "#f8fafc" }}>
                        <Typography sx={{ fontWeight: 700 }}>Invoice Source Check</Typography>
                        <Typography variant="body2">Approved Sales Order is frozen. Invoice generation uses Invoicing Cart values when present.</Typography>
                        {invoiceDiffState.loading && <Typography variant="caption">Loading cart diff…</Typography>}
                        {invoiceDiffState.error && <Typography variant="caption" sx={{ color: "#b91c1c" }}>{invoiceDiffState.error}</Typography>}
                        {!invoiceDiffState.loading && invoiceDiffState.data?.diff && (
                          <Box sx={{ mt: 1 }}>
                            <Typography variant="caption" display="block">Approved Sales Order lines: {invoiceDiffState.data?.diff?.totals?.sourceLineCount ?? 0}</Typography>
                            <Typography variant="caption" display="block">Invoicing Cart lines: {invoiceDiffState.data?.diff?.totals?.currentLineCount ?? 0}</Typography>
                            <Typography variant="caption" display="block">Qty changes: {(invoiceDiffState.data?.diff?.quantityChanges || []).length}</Typography>
                            <Typography variant="caption" display="block">Added items: {(invoiceDiffState.data?.diff?.addedItems || []).length}</Typography>
                            <Typography variant="caption" display="block">Removed items: {(invoiceDiffState.data?.diff?.removedItems || []).length}</Typography>
                            <Typography variant="caption" display="block">Service delta: {invoiceDiffState.data?.diff?.otherServices?.delta ?? 0}</Typography>
                            <Typography variant="caption" display="block">Line delta: {invoiceDiffState.data?.diff?.totals?.delta ?? 0}</Typography>
                          </Box>
                        )
                      </Box>*/}
                      {isInvoiceEditRoute && (invoiceCartResolution.loading || invoiceCartResolution.error) && (
                        <Box sx={{ mb: 1.5, p: 1, border: invoiceCartResolution.error ? '1px solid #fde68a' : '1px solid #c7d2fe', background: invoiceCartResolution.error ? '#fffbeb' : '#eef2ff', borderRadius: 1.5 }}>
                          <Typography variant="caption" sx={{ display: 'block', color: invoiceCartResolution.error ? '#92400e' : 'inherit' }}>
                            {invoiceCartResolution.error
                              ? 'No invoice-specific invoicing cart was found. The invoice popup is open, but cart-backed invoice generation is disabled until a cart is linked.'
                              : 'Resolving invoice-specific invoicing cart…'}
                          </Typography>
                        </Box>
                      )}
                      <Invoices
                        clientContacts={clientContacts}
                        authState={authState}
                        canViewInvoices={canViewInvoices}
                        canManageInvoices={canManageInvoices}
                        readOnlyInvoiceAccess={readOnlyInvoiceAccess}
                        invoiceCount={invoiceCount}
                        onInvoicesChanged={setOrderInvoices}
                        salesOrderTotal={order?.Total}
                        order={order}
                        invoicingCartKey={selectedInvoicingCartKey}
                        activeInvoicingCartSummary={selectedInvoicingCartSummary}
                        invoiceCartSelector={isInvoicePage && selectableInvoicingCarts.length > 0 ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75, minWidth: 0 }}>
                        <FormControl size="small" sx={{ minWidth: { xs: 200, sm: 240 }, maxWidth: 330 }}>
                          <Select
                            displayEmpty
                            aria-label="Select invoice-owned invoicing cart"
                            value={selectedInvoiceCartIsValid && selectedInvoicingCartKey
                              ? `invoicing-cart:${selectedInvoicingCartKey}` : ""}
                            disabled={invoicingCartsLoading || selectableInvoicingCarts.length === 0}
                            onChange={handleCartViewChange}
                            renderValue={(value) => {
                              const match = selectableInvoicingCarts.find((cart) =>
                                value === `invoicing-cart:${cart.invoicingCartKey}`);
                              return match ? formatInvoiceCartChoice(match, selectableInvoicingCarts)
                                : invoicingCartsLoading ? "Checking invoice carts…"
                                  : invoicingCartsError ? "Unable to load invoice carts" : "No linked invoicing cart";
                            }}
                          >
                            {selectableInvoicingCarts.map((cart) => (
                              <MenuItem key={cart.invoicingCartKey}
                                value={`invoicing-cart:${cart.invoicingCartKey}`}>
                                {formatInvoiceCartChoice(cart, selectableInvoicingCarts)}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                            {invoicingCartsError && (
                              <Button size="small" onClick={loadInvoicingCarts}>Retry</Button>
                            )}
                            {selectedInvoiceCartIsValid && !invoicingCartsLoading &&
                              !cartWorkspace.loading && (cartWorkspace.error || cartWorkspace.missing) && (
                                <Button size="small" onClick={() => cartWorkspace.reload()}>Retry cart</Button>
                              )}
                          </Box>
                        ) : null}
                        invoiceCartResolution={invoiceCartResolution}
                        onCreateInvoicePathA={handleCreateInvoiceWithEmail}
                        sourceSalesOrderId={currentSO?.estimationId || currentSO?.id || null}
                        onInitialInvoiceDataReady={handleInitialInvoiceDataReady}
                      />
                    </Box>
                  )}

                  
                   {/* need to add a check here if all checks are done (Reference convert to po and convert to invoice buttons, when this is good to go, we need to hook into same function as convert to po which essentially takes the project's complete status (3) sales order and converts it to the PO in the backend - already done) */}

                  {/* {(activeTab === "Purchase Order Home" || activeTab === "Purchase Orders / Proofs") && (
                  <>
                   
                    {mappedPurchaseOrderData.length === 0 ? (
                    <>
                      <h2>Purchase Order & Proofs</h2>

                      {!creatingPO && (
                        <>
                           
                            <Box className="status-message">
                              <Tooltip title={convertTooltip_POHome} arrow>
                                <span>
                                  <Button
                                    variant="contained"
                                    onClick={handleGeneratePOFromPOHome}
                                    disabled={disableConvertToPO_POHome || creatingPO || createdPO}
                                    aria-busy={creatingPO}
                                    sx={{
                                      textTransform: 'none',
                                      fontWeight: 700,
                                      opacity: (disableConvertToPO_POHome || creatingPO || createdPO) ? 0.4 : 1,
                                      cursor: (disableConvertToPO_POHome || creatingPO || createdPO) ? 'not-allowed' : 'pointer',
                                      minWidth: 240
                                    }}
                                    startIcon={creatingPO ? <AutorenewIcon sx={{ animation: 'spin 1.25s linear infinite' }} /> : null}
                                  >
                                    {creatingPO ? 'Creating Purchase Orders…' : (createdPO ? 'Created' : 'Create Purchase Orders')}
                                  </Button>
                                </span>
                              </Tooltip>
                            </Box>

                            
                            <Typography variant="caption" sx={{ display: 'block', width: "100%", mt: 1, fontSize: "16px"}}>
                              <p>Converts your <b>customer-signed</b> sales order into purchase orders.</p>
                            </Typography>

                            
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                              <AccessTimeIcon fontSize="small" sx={{ opacity: 0.7 }} />
                              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                <p style={{fontSize: "16px"}}>Heads up: PDF generation can take ~15s per PO. You can leave this page - this will keep running in background.</p>
                              </Typography>
                            </Box>

                          
                            {!shippingGate.loading && !shippingGate.has && shippingGate.totalProducts > 0 && (
                              <Typography variant="caption" sx={{ display: 'block', mt: .5 }}>
                                Missing shipping for {shippingSourceLabel}: {formatShippingGateRefs(shippingGate.missingProductIds)}
                              </Typography>
                            )}
                            {!shippingGate.loading && shippingGate.requireShippingConfirmation && !shippingGate.allApproved && shippingGate.unapprovedProductIds.length > 0 && (
                              <Typography variant="caption" sx={{ display: 'block', mt: .5 }}>
                                Unapproved product(s): {formatShippingGateRefs(shippingGate.unapprovedProductIds)}
                              </Typography>
                            )}
                            {!shippingGate.loading && (!shippingGate.has || !shippingGate.allApproved) && (
                              <Box sx={{ mt: 1 }}>
                                <Button
                                  variant="text"
                                  size="small"
                                  onClick={retryShipping}
                                  sx={{ textTransform: 'none' }}
                                >
                                  Retry Shipping
                                </Button>
                              </Box>
                            )}
                          </>
                        )}
                        {creatingPO && (
                          <Box
                            sx={{
                              mt: 2,
                              p: 2,
                              border: '1px solid #e5e7eb',
                              borderRadius: 2,
                              bgcolor: '#fafafa',
                              display: 'grid',
                              gap: 1,
                            }}
                            role="status"
                            aria-live="polite"
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              <AutorenewIcon sx={{ animation: 'spin 1.25s linear infinite' }} />
                              <Typography variant="subtitle2">{PO_GEN_STAGES[poGenStage]}</Typography>
                            </Box>

                            <LinearProgress />

                            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                              This runs in the background — you can keep working on this page. Your POs
                              will show up under <b>POs/Proofs</b> when they’re ready.
                            </Typography>
                          </Box>
                        )}

                    </>
                  ) : (
                    <>
                    <h2>Purchase Order & Proofs</h2>
                    {
                      //JSON.stringify(mappedPurchaseOrderData)
                    }
                    <DataTable
                      columns={[
                        { field: "salesOrderId", headerName: "Sales Order ID", width: 150 },
                        {
                          field: "supplierInfo",
                          headerName: "Supplier",
                          width: 240,
                          renderCell: (params) => {
                            const info = params.row.supplierInfo || {};
                            const { supplierName, supplierEmail, supplierPhone } = info;

                            return (
                              <Box>
                                
                                {supplierName && (
                                  <Typography variant="body2">{supplierName}</Typography>
                                )}

                              
                                {supplierEmail && (
                                  <Tooltip title={supplierEmail}>
                                    <Link
                                      href={`mailto:${supplierEmail}`}
                                      sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        textDecoration: "none",
                                        color: "inherit",
                                      }}
                                    >
                                      <EmailIcon fontSize="small" sx={{ mr: 0.5 }} />
                                    </Link>
                                  </Tooltip>
                                )}

                            
                                {supplierPhone && (
                                  <Box sx={{ display: "inline-flex", alignItems: "center", ml: 1 }}>
                                    {supplierPhone.Work && (
                                      <Tooltip title={`Work: ${supplierPhone.Work}`}>
                                        <PhoneIcon fontSize="small" sx={{ mr: 0.5 }} />
                                      </Tooltip>
                                    )}
                                    {supplierPhone.TollFree && (
                                      <Tooltip title={`Toll-Free: ${supplierPhone.TollFree}`}>
                                        <PhoneIcon fontSize="small" sx={{ transform: "rotate(90deg)" }} />
                                      </Tooltip>
                                    )}
                                  </Box>
                                )}
                              </Box>
                            );
                          },
                        },         
                        { field: "poNumber", headerName: "PO Number", width: 200 },
                        {
                          field: "projectDetails",
                          headerName: "Project Details",
                          width: 200,
                          sortable: false,
                          renderCell: (params) => {
                            const trackingDisplay = getTrackingDisplay(params?.row || {});
                            return (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                width: "200px",
                                gap: 0.5,
                              }}
                            >
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<DescriptionIcon fontSize="small" />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(
                                    `/instance/${instanceUniqueId}/purchase-orders/${params.row.id}/print/packing-slip`,
                                    "_blank"
                                  );
                                }}
                                sx={{
                                  width: "200px",
                                  minWidth: "200px",
                                  lineHeight: "1em",
                                  height: 36,
                                  whiteSpace: "normal",
                                  justifyContent: "flex-start",
                                }}
                              >
                                Packing Slip
                              </Button>
                              {trackingDisplay ? (
                                <Box sx={{ px: 1, mt: -0.25 }}>
                                  <Typography variant="caption" sx={{ color: "text.secondary", display: "block", lineHeight: 1.1 }}>
                                    Tracking
                                  </Typography>
                                  <Typography variant="caption" sx={{ display: "block", fontWeight: 600, lineHeight: 1.2 }}>
                                    {trackingDisplay}
                                  </Typography>
                                </Box>
                              ) : null}
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<LocalShippingIcon fontSize="small" />}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  window.open(
                                    `/instance/${instanceUniqueId}/purchase-orders/${params.row.id}/print/shipping-label`,
                                    "_blank"
                                  );
                                }}
                                sx={{
                                  width: "200px",
                                  minWidth: "200px",
                                  lineHeight: "1em",
                                  height: 36,
                                  whiteSpace: "normal",
                                  justifyContent: "flex-start",
                                }}
                              >
                                Shipping Label
                              </Button>
                            </Box>
                            );
                          },
                        },
                        {
                          field: "supplierStatus",
                          headerName: "Status",
                          width: 150,
                          renderCell: (params) => (
                            <span className={params.row.statusClass}>
                              {params.row.supplierStatus}
                            </span>
                          ),
                        },
                        {
                          field: "nextActionDate",
                          headerName: "Next Action",
                          width: 160,
                          renderCell: (params) => {
                            const raw = params.value;
                            if (!raw) return null;
                        
                            const actionDate = new Date(raw);
                            const now = new Date();
                            const diffMs = actionDate.getTime() - now.getTime();
                            const absMs = Math.abs(diffMs);
                        
                            // breakdown
                            const days    = Math.floor(absMs / (1000 * 60 * 60 * 24));
                            const hours   = Math.floor((absMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                            const minutes = Math.floor((absMs % (1000 * 60 * 60))     / (1000 * 60));
                            const seconds = Math.floor((absMs % (1000 * 60))          / 1000);
                        
                            let relText;
                            if      (days   > 0) relText = `${days} day${days   > 1 ? 's' : ''}`;
                            else if (hours  > 0) relText = `${hours} hour${hours > 1 ? 's' : ''}`;
                            else if (minutes> 0) relText = `${minutes} minute${minutes > 1 ? 's' : ''}`;
                            else                 relText = `${seconds} second${seconds > 1 ? 's' : ''}`;
                        
                            relText += diffMs >= 0 ? ' away' : ' ago';
                        
                            return (
                              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        
                                <Typography variant="body2">
                                  {actionDate.toLocaleDateString()}
                                </Typography>
                           
                                <Typography
                                  variant="caption"
                                  sx={{ color: diffMs < 0 ? 'error.main' : 'text.secondary' }}
                                >
                                  {relText}
                                </Typography>
                              </Box>
                            );
                          }
                        },
                        
                            {
                              field: 'proof',
                              headerName: 'Proof',
                              width: 320,
                              renderCell: (params) => {
                                const {
                                  proofRequired,
                                  requestChange,
                                  proofStatus,
                                  proofFilePath
                                } = params.row
                            
                                return (
                                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                      <Tooltip title={proofRequired ? 'Proof required' : 'Proof not required'}>
                                        {proofRequired
                                          ? <CheckCircleIcon fontSize="small" sx={{ color: 'green' }} />
                                          : <CancelIcon      fontSize="small" sx={{ color: 'gray' }} />
                                        }
                                      </Tooltip>
                            
                                      <Tooltip title={requestChange ? 'Change requested' : 'No change requested'}>
                                        {requestChange
                                          ? <WarningAmberIcon        fontSize="small" sx={{ color: 'orange' }} />
                                          : <RemoveCircleOutlineIcon fontSize="small" sx={{ color: 'gray' }} />
                                        }
                                      </Tooltip>
                                    </Box>
                            
                                     
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Typography variant="body2">
                                        {proofStatus}
                                      </Typography>
                            
                                      {proofStatus === 'Uploaded' && proofFilePath && (
                                        <Link
                                          href={proofFilePath}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          underline="hover"
                                          sx={{ fontStyle: 'italic' }}
                                        >
                                          View
                                        </Link>
                                      )}
                                    </Box>
                                  </Box>
                                )
                              }
                            },
                            
                        {
                          field: "action",
                          headerName: "Action",
                          width: 200,
                          renderCell: (params) => {
                            const isCompleted = params.row.status === "3";
                            const poGenerated = params.row.poGenerated;

                            return (
                              <Box sx={{ display: "flex", gap: 1 }}>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    history.push(`/instance/elite-promo-marketing/sales/orders/${orderId}/pos-proofs/${params.row.salesOrderId}`);
                                  }}
                                >
                                  View
                                </Button>

                                {isCompleted && (
                                  <Button
                                    variant="contained"
                                    size="small"
                                    sx={{
                                      backgroundColor: poGenerated ? "green" : "red",
                                      "&:hover": {
                                        backgroundColor: poGenerated ? "darkgreen" : "darkred"
                                      }
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (poGenerated) {
                                        window.open(
                                          `/instance/elite-promo-marketing/sales/orders/${orderId}/pos-proofs/${params.row.id}`,
                                          "_blank"
                                        );
                                      } else {
                                        // Maybe open a "Generate PO" flow
                                        //generatePO(params.row.id);
                                      }
                                    }}
                                  >
                                    {poGenerated ? "PO" : "No PO"}
                                  </Button>
                                )}
                              </Box>
                            );
                          }
                        }
                        
                      ]}
                      rows={mappedPurchaseOrderData}
                      onRowClick={(row) => console.log("SalesOrder row clicked", row)}
                      onRowDoubleClick={(params) => {
                        history.push(`/instance/elite-promo-marketing/sales/orders/${orderId}/pos-proofs/${params.row.salesOrderId}`);
                      }}
                      onViewDetails={(row) => console.log("View sales order details", row)}
                    />
                    </>
                    )}
                  </>
                  )} */}


{(activeTab === "Purchase Order Home" || activeTab === "Purchase Orders / Proofs") && !isPOProofDetailRoute && (() => {
  const poDensitySettings = {
    compact:     { py: 0.75, fontSize: '0.8125rem' },
    comfortable: { py: 1.5,  fontSize: '0.875rem'  },
    spacious:    { py: 2.25, fontSize: '0.9375rem' },
  };
  const poDensity = poDensitySettings[poDensityMode];

  const poPagedRows = mappedPurchaseOrderData.slice(
    poPage * poRowsPerPage,
    poPage * poRowsPerPage + poRowsPerPage
  );
  const proofReadinessCardCopy = getProofReadinessCardCopy({
    status: poProofReadiness.status,
    validation: poProofValidation,
    error: poProofReadiness.error,
  });

 
  const renderCreatePOButton = (
    <Tooltip
      title={
        hasGeneratedPurchaseOrders && !perPoProofEvaluationEnabled
          ? "Purchase orders have already been generated for this order."
          : convertTooltip_POHome
      }
      arrow
    >
      <span>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={basicOutstandingReady ? () => setOutstandingReviewOpen(true) : handleGeneratePOFromPOHome}
          disabled={generatePurchaseOrdersDisabled}
          aria-busy={creatingPO}
          startIcon={
            creatingPO
              ? <AutorenewIcon sx={{ animation: 'spin 1.25s linear infinite', fontSize: 16 }} />
              : <ShoppingCartIcon sx={{ fontSize: 16 }} />
          }
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            fontSize: '0.8rem',
            height: 32,
            borderRadius: '8px',
            boxShadow: 'none',
            opacity: generatePurchaseOrdersDisabled ? 0.5 : 1,
            whiteSpace: 'nowrap',
            minWidth: 180,
          }}
        >
          {creatingPO
            ? 'Generating Purchase Orders...'
            : basicOutstandingReady
              ? `Generate ${Number(outstandingSummary.summary.readyToCreatePurchaseOrderCount)} Outstanding PO${Number(outstandingSummary.summary.readyToCreatePurchaseOrderCount) === 1 ? '' : 's'}`
              : allIncrementalPosComplete
              ? 'All POs Generated'
              : perPoProofEvaluationEnabled && (createdPO || hasGeneratedIncrementalPoCandidates)
                ? 'Generate Remaining POs'
                : createdPO && !perPoProofEvaluationEnabled
                  ? 'Generated'
                  : perPoProofEvaluationEnabled && readyToCreatePoCount > 0
                    ? `Generate ${readyToCreatePoCount} PO${readyToCreatePoCount === 1 ? '' : 's'}`
                    : 'Generate Purchase Orders'}
        </Button>
      </span>
    </Tooltip>
  );

  return (
    <Box sx={{ width: '100%', mt: 1 }}>
      <OutstandingPOsDialog
        open={outstandingReviewOpen}
        onClose={() => setOutstandingReviewOpen(false)}
        salesOrderId={eligibleSOIdForPO}
        onGenerated={refreshOutstandingPoScreens}
      />
      <UITableShell
        customLayout
        paperSx={{
          borderRadius: '10px',
          border: '1px solid',
          borderColor: 'divider',
          borderTop: '3px solid',
          borderTopColor: 'primary.main',
          minHeight: 0,
          mt: 0,
          boxShadow: '0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
  
        <UITableToolbar sx={{ backgroundColor: 'background.paper', p: 0 }}>
 
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            flexWrap="wrap"
            gap={1}
            sx={{ px: 2, py: 1, borderBottom: '1px solid', borderColor: 'divider' }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="h6" fontWeight={700} sx={{ color: 'text.primary', lineHeight: 1 }}>
                Purchase Orders &amp; Proofs
              </Typography>
              {mappedPurchaseOrderData.length > 0 && (
                <Chip
                  label={`${mappedPurchaseOrderData.length} PO${mappedPurchaseOrderData.length !== 1 ? 's' : ''}`}
                  size="small"
                  sx={{
                    fontWeight: 700,
                    fontSize: '0.72rem',
                    height: 22,
                    bgcolor: 'var(--ec-status-info-bg)',
                    color: 'var(--ec-status-info-text)',
                    border: '1px solid var(--ec-status-info-border)',
                    '& .MuiChip-label': { px: '8px' },
                  }}
                />
              )}
            </Stack>

 
            <Stack direction="row" alignItems="center" spacing={0.75}>
            

              {mappedPurchaseOrderData.length > 0 && (
                <>
                  <Tooltip title="Show/hide columns" arrow>
                    <IconButton size="small" onClick={e => setPoColumnMenuAnchor(e.currentTarget)} sx={{ color: 'text.secondary' }}>
                      <ViewColumnIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Row density" arrow>
                    <IconButton size="small" onClick={e => setPoDensityAnchor(e.currentTarget)} sx={{ color: 'text.secondary' }}>
                      <FormatLineSpacingIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Export" arrow>
                    <IconButton size="small" onClick={e => setPoExportMenuAnchor(e.currentTarget)} sx={{ color: 'text.secondary' }}>
                      <FileDownloadIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Refresh" arrow>
                    <span>
                      <IconButton size="small" onClick={() => fetchOrder(true)} disabled={loading} sx={{ color: 'text.secondary' }}>
                        <RefreshIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </span>
                  </Tooltip>
                </>
              )}


   <Divider orientation="vertical" flexItem sx={{ mx: 0.5, height: 24, alignSelf: "center" }} />


                {renderCreatePOButton}

            </Stack>
          </Stack>
        </UITableToolbar>

        {creatingPO && (
          <Box
            sx={{
              mx: 2,
              mt: 1.5,
              mb: 0.5,
              p: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
              bgcolor: 'background.default',
            }}
            role="status"
            aria-live="polite"
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <AutorenewIcon sx={{ animation: 'spin 1.25s linear infinite', fontSize: 18, color: 'primary.main' }} />
              <Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
                {PO_GEN_STAGES[poGenStage]}
              </Typography>
            </Box>
            <LinearProgress sx={{ borderRadius: 99, mb: 1 }} />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              This runs in the background — you can keep working. Your POs will appear here when ready.
            </Typography>
          </Box>
        )}

        
        {!creatingPO && mappedPurchaseOrderData.length === 0 && (
          <Box sx={{ px: 2, pt: 1.5, pb: 2 }}>
 
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 0.75 }}>
              Converts your <strong>customer-signed</strong> sales order into purchase orders.
            </Typography>

        
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 1 }}>
              <AccessTimeIcon sx={{ fontSize: 15, color: 'text.disabled' }} />
              <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                PDF generation takes ~15s per PO. You can leave this page — it will keep running in the background.
              </Typography>
            </Box>

 
            <Box
              sx={{
                display: 'grid',
                gap: 1,
                p: 1.5,
                mb: 1.25,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                bgcolor: 'background.paper',
              }}
            >
              {[
                {
                  key: 'sales-order',
                  title: 'Sales Order Approved',
                  passed: isEligibleSOCompleted,
                  loading: false,
                  status: isEligibleSOCompleted ? 'active' : 'blocked',
                  actionLabel: isEligibleSOCompleted ? 'Passed' : 'Not Ready',
                  message: isEligibleSOCompleted
                    ? 'A completed Sales Order is available for PO generation.'
                    : 'A completed Sales Order is required before Purchase Orders can be generated.',
                },
                {
                  key: 'shipping',
                  title: perPoProofEvaluationEnabled ? 'Shipping Readiness' : (shippingGate.requireShippingConfirmation ? 'Shipping Approved' : 'Shipping Complete'),
                  passed: perPoProofEvaluationEnabled ? Boolean(poProofValidation?.canGenerate) : (shippingGate.has && shippingGate.allApproved),
                  loading: shippingGate.loading && !perPoProofEvaluationEnabled,
                  status: perPoProofEvaluationEnabled ? poProofReadiness.status : (shippingGate.loading ? 'loading' : (shippingGate.has && shippingGate.allApproved ? 'active' : 'blocked')), 
                  actionLabel: shippingGate.loading
                    ? 'Checking'
                    : perPoProofEvaluationEnabled
                      ? (poProofValidation?.canGenerate ? 'Partially Ready' : 'Not Ready')
                    : shippingGate.has && shippingGate.allApproved
                      ? 'Passed'
                      : 'Not Ready',
                  message: shippingGate.loading
                    ? 'Checking shipping configuration.'
                    : perPoProofEvaluationEnabled
                      ? `${Number(poProofValidation?.summary?.readyToCreatePurchaseOrderCount) || 0} PO(s) ready with shipping and proof requirements satisfied; ${Number(poProofValidation?.summary?.shippingBlockedPurchaseOrderCount) || 0} waiting on shipping.`
                    : !shippingGate.has
                      ? 'Shipping configuration is missing for one or more products.'
                      : !shippingGate.allApproved
                        ? shippingGate.requireShippingConfirmation
                          ? 'All shipping records must be approved before Purchase Orders can be generated.'
                          : 'Shipping records must be complete before Purchase Orders can be generated.'
                        : shippingGate.requireShippingConfirmation
                          ? 'Shipping records are complete and approved.'
                          : 'Shipping records are complete.',
                },
                customerReviewGate,
                ...(poDepositReadiness.status === 'not_required' ? [] : [{
                  key: 'deposit', title: 'Deposit / Upfront Payment',
                  passed: poDepositReadiness.status === 'paid' || poDepositReadiness.status === 'not_required',
                  loading: poDepositReadiness.status === 'loading',
                  status: poDepositReadiness.status === 'not_required' ? 'not_required'
                    : poDepositReadiness.status === 'paid' ? 'active' : poDepositReadiness.status,
                  actionLabel: poDepositReadiness.status === 'not_required' ? 'Not Required'
                    : poDepositReadiness.status === 'paid' ? 'Passed'
                    : poDepositReadiness.status === 'loading' ? 'Checking'
                    : poDepositReadiness.status === 'unknown' ? 'Unable to Verify' : 'Needs Attention',
                  message: [poDepositReadiness.message || (
                    poDepositReadiness.status === 'loading' ? 'Checking the required upfront payment.'
                      : poDepositReadiness.status === 'pending' ? 'The upfront invoice did not pass payment verification. See details below.'
                      : poDepositReadiness.status === 'unknown' ? 'Unable to verify the upfront payment. See details below.'
                      : ''
                  ),
                    poDepositReadiness.overridden ? 'Sales Order terms override the customer default.' : ''
                  ].filter(Boolean).join(' '),
                }]),
                ...(proofEnforcementMode === PROOF_ENFORCEMENT_MODES.NONE && poProofReadiness.status === 'ready' ? [] : [{
                  key: 'proofs',
                  title: 'Proofs',
                  passed:
                    poProofReadiness.status === 'ready' ||
                    poProofReadiness.status === 'partial' ||
                    poProofReadiness.status === 'complete' ||
                    poProofReadiness.status === 'not_required',
                  loading: poProofReadiness.status === 'loading' || poProofReadiness.status === 'idle',
                  status: poProofReadiness.status,
                  actionLabel: proofReadinessCardCopy.actionLabel,
                  message: proofReadinessCardCopy.message,
                }]),
              ].map((item) => {
                const icon = item.loading
                  ? <AutorenewIcon sx={{ fontSize: 16, color: 'info.main', animation: 'spin 1.25s linear infinite' }} />
                  : item.status === 'not_required'
                    ? <InfoOutlinedIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
                  : item.passed
                    ? <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
                    : item.status === 'in-review'
                      ? <InfoOutlinedIcon sx={{ fontSize: 16, color: 'info.main' }} />
                      : <CancelIcon sx={{ fontSize: 16, color: 'error.main' }} />;

                return (
                  <Box
                    key={item.key || item.title}
                    sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.25 }}
                  >
                    <Box sx={{ display: 'flex', gap: 1, minWidth: 0 }}>
                      <Box sx={{ pt: 0.15 }}>{icon}</Box>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: 'text.primary' }}>
                          {item.title}
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
                          {item.message || (item.key === 'deposit' && !item.passed && !item.loading
                            ? 'Payment verification did not provide a reason. See deposit diagnostics below.'
                            : '')}
                        </Typography>
                        {item.title === 'Customer Review' && customerReviewGate.canRequestConversion && !customerIsCreditHold && (
                          <Button
                            variant="text"
                            size="small"
                            onClick={handleRequestCustomerConversion}
                            disabled={requestingCustomerConversion}
                            sx={{ textTransform: 'none', mt: 0.5, px: 0, minWidth: 0, fontWeight: 700 }}
                          >
                            {requestingCustomerConversion ? 'Requesting conversion...' : 'Request conversion'}
                          </Button>
                        )}
                      </Box>
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{
                        flexShrink: 0,
                        fontWeight: 700,
                        color: item.passed ? 'success.main' : item.loading || item.status === 'in-review' ? 'info.main' : 'error.main',
                      }}
                    >
                      {item.actionLabel}
                    </Typography>
                  </Box>
                );
              })}
            </Box>

            {poDepositReadiness.status !== 'paid' &&
              poDepositReadiness.status !== 'not_required' &&
              poDepositReadiness.status !== 'loading' && (
                <Box sx={{
                  border: '1px solid', borderColor: 'warning.light',
                  borderLeft: '4px solid', borderLeftColor: 'warning.main',
                  borderRadius: 2.5, px: { xs: 2, sm: 2.5 }, py: 2, mb: 1.5,
                  bgcolor: 'background.paper',
                  boxShadow: '0 2px 12px rgba(20, 30, 55, 0.04)',
                }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.75, fontSize: '0.95rem', letterSpacing: '-0.01em', color: 'text.primary' }}>
                    Deposit / Upfront Payment — {poDepositReadiness.status === 'unknown' ? 'Unable to verify' : 'Needs attention'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.55, mb: 1.5 }}>
                    {poDepositReadiness.message || 'The payment readiness service did not provide a reason. Refresh the check; if this persists, the server may be running an older version.'}
                  </Typography>
                  {poDepositReadiness.termsLabel && (
                    <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary', lineHeight: 1.65 }}>
                      Payment terms: {poDepositReadiness.termsLabel}
                      {poDepositReadiness.overridden ? ' (Sales Order override)' : ''}
                    </Typography>
                  )}
                  {poDepositReadiness.requiredAmount != null && (
                    <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.65 }}>
                      Required upfront: ${Number(poDepositReadiness.requiredAmount).toFixed(2)}
                      {poDepositReadiness.receivedAmount != null
                        ? ` · Recorded payment: $${Number(poDepositReadiness.receivedAmount).toFixed(2)}`
                        : ''}
                    </Typography>
                  )}
                  {poDepositReadiness.invoiceId != null && (
                    <Typography variant="caption" sx={{ display: 'block' }}>
                      Invoice ID: {poDepositReadiness.invoiceId}
                    </Typography>
                  )}
                  {Array.isArray(poDepositReadiness.diagnostics) && poDepositReadiness.diagnostics.length > 0 && (
                    <Box sx={{ mt: 1.5, pt: 1.25, borderTop: '1px solid', borderColor: 'divider' }}>
                      {poDepositReadiness.diagnostics.map((diagnostic, index) => (
                        <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.7, py: 0.25 }} key={`${diagnostic.invoiceId || 'invoice'}-${index}`}>
                          Invoice {diagnostic.invoiceId ?? 'unknown'}: {diagnostic.message || diagnostic.reason || 'Did not qualify.'}
                        </Typography>
                      ))}
                    </Box>
                  )}
                </Box>
              )}

            <PurchaseOrderProofEnforcementNotice
              mode={proofEnforcementMode}
              validation={poProofValidation}
              status={poProofReadiness.status}
              error={poProofReadiness.error}
              onRetry={refreshPoProofReadiness}
              hideReady
            />

            {!perPoProofEvaluationEnabled && !shippingGate.loading && !shippingGate.has && shippingGate.totalProducts > 0 && (
              <Typography variant="caption" sx={{ display: 'block', color: 'warning.main', mb: 0.5 }}>
                ⚠ Missing shipping for {shippingSourceLabel}: {shippingGate.missingProductIds.join(', ')}
              </Typography>
            )}
            {!perPoProofEvaluationEnabled && !shippingGate.loading && shippingGate.requireShippingConfirmation && !shippingGate.allApproved && shippingGate.unapprovedProductIds.length > 0 && (
              <Typography variant="caption" sx={{ display: 'block', color: 'warning.main', mb: 0.5 }}>
                ⚠ Unapproved product(s): {shippingGate.unapprovedProductIds.join(', ')}
              </Typography>
            )}
            {!shippingGate.loading && (!shippingGate.has || !shippingGate.allApproved) && (
              <Button
                variant="text"
                size="small"
                onClick={retryShipping}
                sx={{ textTransform: 'none', mt: 0.5, px: 0 }}
              >
                Retry Shipping
              </Button>
            )}
          </Box>
        )}

         
        {mappedPurchaseOrderData.length > 0 && (
          <>
            <TableContainer
              sx={{
                flex: 1,
                overflow: 'auto',
                minHeight: 280,
                maxHeight: 520,
                '&::-webkit-scrollbar': { width: 6, height: 6 },
                '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(148,163,184,0.8)', borderRadius: 99 },
                '&::-webkit-scrollbar-track': { backgroundColor: 'transparent' },
              }}
            >
              <Table stickyHeader size="small" sx={{ minWidth: 960 }}>
                <TableHead>
                  <TableRow>
                    {POCOLUMNS.filter(c => poVisibleCols.has(c.id)).map(col => (
                      <TableCell
                        key={col.id}
                        align={col.align || 'left'}
                        sx={{
                          minWidth: col.minWidth,
                          px: 2,
                          py: 1.25,
                          backgroundColor: '#1e293b !important',
                          color: '#f8fafc !important',
                          fontWeight: 700,
                          fontSize: '0.72rem',
                          letterSpacing: '0.06em',
                          textTransform: 'uppercase',
                          borderBottom: 'none',
                          whiteSpace: 'nowrap',
                          position: 'sticky',
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        {col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody
                  sx={{
                    '& .MuiTableCell-root': { borderBottom: '1px solid', borderColor: 'divider' },
                    '& .MuiTableRow-root:last-child .MuiTableCell-root': { borderBottom: 'none' },
                  }}
                >
                  {poPagedRows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={POCOLUMNS.length} sx={{ border: 'none', p: 0 }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8, color: 'text.disabled' }}>
                          <ShoppingCartIcon sx={{ fontSize: 48, mb: 1.5, opacity: 0.25 }} />
                          <Typography variant="body1" fontWeight={600} sx={{ mb: 0.5, color: 'text.secondary' }}>
                            No purchase orders found
                          </Typography>
                          <Typography variant="body2" sx={{ color: 'text.disabled' }}>
                            Create purchase orders to see them here.
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    poPagedRows.map((row, idx) => (
                      <TableRow
                        key={row.id || row.salesOrderId || idx}
                        hover
                        onDoubleClick={() => {
                          history.push(`/instance/${instanceUniqueId}/sales/orders/${orderId}/pos-proofs/${row.salesOrderId}`);
                        }}
                        sx={{
                          cursor: 'default',
                          bgcolor: idx % 2 === 0 ? 'background.paper' : '#f8fafc',
                          transition: 'background-color 0.12s',
                        }}
                      >
                      
                        {poVisibleCols.has('salesOrderId') && (
                          <TableCell sx={{ px: 2, py: poDensity.py }}>
                            <Typography
                              variant="caption"
                              sx={{ fontFamily: 'monospace', fontWeight: 600, fontSize: poDensity.fontSize, color: 'text.secondary' }}
                            >
                              {row.salesOrderId}
                            </Typography>
                          </TableCell>
                        )}

                        
                        {poVisibleCols.has('supplierInfo') && (
                          <TableCell sx={{ px: 2, py: poDensity.py }}>
                            {(() => {
                              const info = row.supplierInfo || {};
                              const { supplierName, supplierEmail, supplierPhone } = info;
                              return (
                                <Box>
                                  {supplierName && (
                                    <Typography variant="body2" sx={{ fontWeight: 600, fontSize: poDensity.fontSize, lineHeight: 1.3 }}>
                                      {supplierName}
                                    </Typography>
                                  )}
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.25 }}>
                                    {supplierEmail && (
                                      <Tooltip title={supplierEmail} arrow>
                                        <Link
                                          href={`mailto:${supplierEmail}`}
                                          sx={{ display: 'inline-flex', alignItems: 'center', color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
                                          onClick={e => e.stopPropagation()}
                                        >
                                          <EmailIcon sx={{ fontSize: 14 }} />
                                        </Link>
                                      </Tooltip>
                                    )}
                                    {supplierPhone?.Work && (
                                      <Tooltip title={`Work: ${supplierPhone.Work}`} arrow>
                                        <PhoneIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                                      </Tooltip>
                                    )}
                                    {supplierPhone?.TollFree && (
                                      <Tooltip title={`Toll-Free: ${supplierPhone.TollFree}`} arrow>
                                        <PhoneIcon sx={{ fontSize: 14, color: 'text.secondary', transform: 'rotate(90deg)' }} />
                                      </Tooltip>
                                    )}
                                  </Box>
                                </Box>
                              );
                            })()}
                          </TableCell>
                        )}

                        
                        {poVisibleCols.has('poNumber') && (
                          <TableCell sx={{ px: 2, py: poDensity.py }}>
                            <Typography variant="body2" sx={{ fontFamily: 'monospace', fontWeight: 600, fontSize: poDensity.fontSize, color: 'text.primary' }}>
                              {row.poNumber || '—'}
                            </Typography>
                          </TableCell>
                        )}

                        
                        {poVisibleCols.has('projectDetails') && (
                          <TableCell sx={{ px: 2, py: poDensity.py }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<DescriptionIcon sx={{ fontSize: 13 }} />}
                                onClick={e => {
                                  e.stopPropagation();
                                  window.open(`/instance/${instanceUniqueId}/purchase-orders/${row.id}/print/packing-slip`, '_blank');
                                }}
                                sx={{
                                  justifyContent: 'flex-start',
                                  textTransform: 'none',
                                  fontSize: '0.78rem',
                                  fontWeight: 600,
                                  height: 28,
                                  px: 0.75,
                                  py: 0,
                                  color: 'text.secondary',
                                  '&:hover': { color: 'primary.main', bgcolor: 'transparent' },
                                }}
                              >
                                Packing Slip
                              </Button>
                              <Button
                                size="small"
                                variant="text"
                                startIcon={<LocalShippingIcon sx={{ fontSize: 13 }} />}
                                onClick={e => {
                                  e.stopPropagation();
                                  window.open(`/instance/${instanceUniqueId}/purchase-orders/${row.id}/print/shipping-label`, '_blank');
                                }}
                                sx={{
                                  justifyContent: 'flex-start',
                                  textTransform: 'none',
                                  fontSize: '0.78rem',
                                  fontWeight: 600,
                                  height: 28,
                                  px: 0.75,
                                  py: 0,
                                  color: 'text.secondary',
                                  '&:hover': { color: 'primary.main', bgcolor: 'transparent' },
                                }}
                              >
                                Shipping Label
                              </Button>
                            </Box>
                          </TableCell>
                        )}

                     
                        {poVisibleCols.has('supplierStatus') && (
                          <TableCell sx={{ px: 2, py: poDensity.py }}>
                            {(() => {
                              const sc = getEstSoStatusColor(row.statusClass || row.supplierStatus || '');
                              return (
                                <Box
                                  component="span"
                                  sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    px: 1,
                                    py: 0.25,
                                    borderRadius: '999px',
                                    fontSize: '0.72rem',
                                    fontWeight: 700,
                                    whiteSpace: 'nowrap',
                                    bgcolor: sc.bg,
                                    color: sc.text,
                                    border: `1px solid ${sc.border}`,
                                  }}
                                >
                                  {row.supplierStatus || '—'}
                                </Box>
                              );
                            })()}
                          </TableCell>
                        )}

                        
                        {poVisibleCols.has('nextActionDate') && (
                          <TableCell sx={{ px: 2, py: poDensity.py }}>
                            {(() => {
                              const raw = row.nextActionDate;
                              if (!raw) return <Typography variant="caption" sx={{ color: 'text.disabled' }}>—</Typography>;
                              const actionDate = new Date(raw);
                              const now = new Date();
                              const diffMs = actionDate.getTime() - now.getTime();
                              const absMs = Math.abs(diffMs);
                              const days    = Math.floor(absMs / (1000 * 60 * 60 * 24));
                              const hours   = Math.floor((absMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                              const minutes = Math.floor((absMs % (1000 * 60 * 60)) / (1000 * 60));
                              const seconds = Math.floor((absMs % (1000 * 60)) / 1000);
                              let relText;
                              if      (days    > 0) relText = `${days} day${days > 1 ? 's' : ''}`;
                              else if (hours   > 0) relText = `${hours} hr${hours > 1 ? 's' : ''}`;
                              else if (minutes > 0) relText = `${minutes} min`;
                              else                  relText = `${seconds}s`;
                              relText += diffMs >= 0 ? ' away' : ' ago';
                              return (
                                <Box>
                                  <Typography variant="body2" sx={{ fontSize: poDensity.fontSize, lineHeight: 1.3 }}>
                                    {actionDate.toLocaleDateString()}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    sx={{ color: diffMs < 0 ? 'error.main' : 'text.disabled', fontSize: '0.7rem' }}
                                  >
                                    {relText}
                                  </Typography>
                                </Box>
                              );
                            })()}
                          </TableCell>
                        )}
 
                        {poVisibleCols.has('proof') && (
                          <TableCell sx={{ px: 2, py: poDensity.py }}>
                            {(() => {
                              const { proofRequired, requestChange, proofStatus, proofFilePath } = row;
                              return (
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                  <Box sx={{ display: 'flex', gap: 1 }}>
                                    <Tooltip title={proofRequired ? 'Proof required' : 'Proof not required'} arrow>
                                      {proofRequired
                                        ? <CheckCircleIcon sx={{ fontSize: 16, color: 'success.main' }} />
                                        : <CancelIcon      sx={{ fontSize: 16, color: 'text.disabled' }} />
                                      }
                                    </Tooltip>
                                    <Tooltip title={requestChange ? 'Change requested' : 'No change requested'} arrow>
                                      {requestChange
                                        ? <WarningAmberIcon        sx={{ fontSize: 16, color: 'warning.main' }} />
                                        : <RemoveCircleOutlineIcon sx={{ fontSize: 16, color: 'text.disabled' }} />
                                      }
                                    </Tooltip>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                                    <Typography variant="caption" sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                      {proofStatus || '—'}
                                    </Typography>
                                    {proofStatus === 'Uploaded' && proofFilePath && (
                                      <Link
                                        href={proofFilePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        underline="hover"
                                        sx={{ fontSize: '0.72rem', fontStyle: 'italic', color: 'primary.main' }}
                                        onClick={e => e.stopPropagation()}
                                      >
                                        View
                                      </Link>
                                    )}
                                  </Box>
                                </Box>
                              );
                            })()}
                          </TableCell>
                        )}

                        
                        {poVisibleCols.has('action') && (
                          <TableCell align="center" sx={{ px: 2, py: poDensity.py }}>
                            <Box sx={{ display: 'flex', gap: 0.75, justifyContent: 'center' }}>
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<VisibilityIcon sx={{ fontSize: 14 }} />}
                                onClick={e => {
                                  e.stopPropagation();
                                  history.push(`/instance/${instanceUniqueId}/sales/orders/${orderId}/pos-proofs/${row.salesOrderId}`);
                                }}
                                sx={{
                                  textTransform: 'none',
                                  fontWeight: 600,
                                  fontSize: '0.78rem',
                                  height: 28,
                                  borderRadius: '8px',
                                  px: 1.25,
                                }}
                              >
                                View
                              </Button>

                              {row.status === '3' && (
                                <Tooltip title={row.poGenerated ? 'View Purchase Order PDF' : 'No PO generated yet'} arrow>
                                  <span>
                                    <Button
                                      variant="contained"
                                      size="small"
                                      disabled={!row.poGenerated}
                                      onClick={e => {
                                        e.stopPropagation();
                                        if (row.poGenerated) {
                                          window.open(
                                            `/instance/${instanceUniqueId}/sales/orders/${orderId}/pos-proofs/${row.id}`,
                                            '_blank'
                                          );
                                        }
                                      }}
                                      sx={{
                                        textTransform: 'none',
                                        fontWeight: 700,
                                        fontSize: '0.78rem',
                                        height: 28,
                                        borderRadius: '8px',
                                        boxShadow: 'none',
                                        px: 1.25,
                                        ...(row.poGenerated
                                          ? {
                                              bgcolor: 'var(--ec-status-success-bg)',
                                              color: 'var(--ec-status-success-text)',
                                              border: '1px solid var(--ec-status-success-border)',
                                              '&:hover': { bgcolor: 'success.main', color: '#fff' },
                                            }
                                          : {
                                              bgcolor: 'var(--ec-status-neutral-bg)',
                                              color: 'var(--ec-status-neutral-text)',
                                              border: '1px solid var(--ec-status-neutral-border)',
                                            }
                                        ),
                                      }}
                                    >
                                      {row.poGenerated ? 'PO ↗' : 'No PO'}
                                    </Button>
                                  </span>
                                </Tooltip>
                              )}
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 2,
                py: 0.5,
                borderTop: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                flexShrink: 0,
              }}
            >
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Showing{' '}
                {mappedPurchaseOrderData.length > 0
                  ? `${poPage * poRowsPerPage + 1}–${Math.min(mappedPurchaseOrderData.length, poPage * poRowsPerPage + poRowsPerPage)}`
                  : '0'}{' '}
                of {mappedPurchaseOrderData.length} PO{mappedPurchaseOrderData.length !== 1 ? 's' : ''}
              </Typography>
              <TablePagination
                component="div"
                count={mappedPurchaseOrderData.length}
                page={poPage}
                onPageChange={(_, newPage) => setPoPage(newPage)}
                rowsPerPage={poRowsPerPage}
                onRowsPerPageChange={e => { setPoRowsPerPage(parseInt(e.target.value, 10)); setPoPage(0); }}
                rowsPerPageOptions={[10, 25, 50]}
                sx={{
                  border: 0,
                  '& .MuiTablePagination-toolbar': { minHeight: 40, px: 0, alignItems: 'center' },
                  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                    fontSize: '0.78rem',
                    color: 'text.secondary',
                    mb: 0,
                    lineHeight: 1,
                  },
                  '& .MuiTablePagination-select': { fontSize: '0.78rem' },
                }}
              />
            </Box>
          </>
        )}
      </UITableShell>

      {perPoProofEvaluationEnabled && hasRemainingPurchaseOrders && mappedPurchaseOrderData.length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.75 }}>
            Remaining Purchase Order Readiness
          </Typography>
          <PurchaseOrderProofEnforcementNotice
            mode={proofEnforcementMode}
            validation={poProofValidation}
            status={poProofReadiness.status}
            error={poProofReadiness.error}
            onRetry={refreshPoProofReadiness}
          />
          {readyToCreatePoCount > 0 && (
            <Box sx={{ mt: 1.5 }}>
              {renderCreatePOButton}
            </Box>
          )}
        </Box>
      )}

     
      <Menu
        anchorEl={poColumnMenuAnchor}
        open={Boolean(poColumnMenuAnchor)}
        onClose={() => setPoColumnMenuAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 210, borderRadius: 2 } } }}
      >
        <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: 'block', color: 'text.disabled' }}>
          Columns
        </Typography>
        <Divider sx={{ mb: 0.5 }} />
        {POCOLUMNS.filter(c => !c.locked).map(col => (
          <MenuItem key={col.id} onClick={() => togglePOCol(col.id)} sx={{ py: 0.4 }}>
            <Checkbox size="small" checked={poVisibleCols.has(col.id)} sx={{ mr: 1, p: 0.25 }} />
            {col.label}
          </MenuItem>
        ))}
      </Menu>
 
      <Menu
        anchorEl={poDensityAnchor}
        open={Boolean(poDensityAnchor)}
        onClose={() => setPoDensityAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 160, borderRadius: 2 } } }}
      >
        <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: 'block', color: 'text.disabled' }}>
          Row Density
        </Typography>
        <Divider sx={{ mb: 0.5 }} />
        {[
          { key: 'compact',     label: 'Compact' },
          { key: 'comfortable', label: 'Comfortable' },
          { key: 'spacious',    label: 'Spacious' },
        ].map(opt => (
          <MenuItem
            key={opt.key}
            selected={poDensityMode === opt.key}
            onClick={() => { setPoDensityMode(opt.key); setPoDensityAnchor(null); }}
            sx={{ py: 0.75, fontSize: '0.875rem' }}
          >
            {poDensityMode === opt.key && (
              <CheckIcon sx={{ fontSize: 15, mr: 1, color: 'primary.main' }} />
            )}
            {poDensityMode !== opt.key && <Box sx={{ width: 15, mr: 1 }} />}
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
 
      <Menu
        anchorEl={poExportMenuAnchor}
        open={Boolean(poExportMenuAnchor)}
        onClose={() => setPoExportMenuAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 180, borderRadius: 2 } } }}
      >
        <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: 'block', color: 'text.disabled' }}>
          Export As
        </Typography>
        <Divider sx={{ mb: 0.5 }} />
        <MenuItem
          onClick={() => { handlePOExportCSV(); setPoExportMenuAnchor(null); }}
          sx={{ py: 0.75, fontSize: '0.875rem', gap: 1 }}
        >
          <TableChartIcon sx={{ fontSize: 16, color: 'text.secondary' }} />
          CSV
        </MenuItem>
        <MenuItem
          onClick={() => { handlePOExportExcel(); setPoExportMenuAnchor(null); }}
          sx={{ py: 0.75, fontSize: '0.875rem', gap: 1 }}
        >
          <GridOnIcon sx={{ fontSize: 16, color: 'success.main' }} />
          Excel
        </MenuItem>
        <MenuItem
          onClick={() => { handlePOExportPDF(); setPoExportMenuAnchor(null); }}
          sx={{ py: 0.75, fontSize: '0.875rem', gap: 1 }}
        >
          <PictureAsPdfIcon sx={{ fontSize: 16, color: 'error.main' }} />
          PDF
        </MenuItem>
      </Menu>
 
      <PurchaseOrderList
        regeneratePopup={regeneratePopup}
        setRegeneratePopup={setRegeneratePopup}
        order={order}
        requestProofs={requestProofs}
      />
    </Box>
  );
})()}

                  {(activeTab === "POs/Proofs" || isPOProofDetailRoute) && (
                    <div className="order-details-section">

                      {purchaseOrderData.length === 0 ? (
                        // 1) No POs at all
                        (<div className="status-po-warning">
                          <Typography>
                            ⚠️ There are no purchase orders generated yet.
                          </Typography>
                        </div>)

                      ) : !poId ? (
                        // 2) Some POs exist, but no poId in the URL
                        (<div className="status-po-warning">
                          <Typography>
                            ⚠️ Please select a purchase order to view its proofs.
                          </Typography>
                        </div>)

                      ) : purchaseOrderData.some(p => p.salesOrderId === Number(poId)) ? (
                        // 4) Matching PO found
                        (<>
                          <OutstandingPOsDialog
                            open={outstandingReviewOpen}
                            onClose={() => setOutstandingReviewOpen(false)}
                            salesOrderId={eligibleSOIdForPO}
                            onGenerated={refreshOutstandingPoScreens}
                          />
                          <div className="order-header-action">
                            <h2>POs/Proofs</h2>
                            {!perPoProofEvaluationEnabled && hasGeneratedPurchaseOrders && (
                              <Tooltip title={
                                outstandingSummary == null
                                  ? 'Check existing PO coverage against the approved Sales Order.'
                                  : outstandingPoReadyCount > 0
                                    ? 'Review existing POs and select only the outstanding ones to create.'
                                    : outstandingPoWaitingCount > 0
                                      ? 'Review outstanding POs that still need shipping, routing, or proof attention.'
                                      : 'There are no ungenerated POs for this approved Sales Order.'
                              } arrow>
                                <span>
                                  <Button
                                    variant={outstandingPoReadyCount > 0 ? 'contained' : 'outlined'}
                                    color={outstandingPoReadyCount > 0 ? 'success' : 'primary'}
                                    size="small"
                                    disabled={!outstandingPoCanReview || (
                                      outstandingSummary != null &&
                                      outstandingPoReadyCount === 0 &&
                                      outstandingPoWaitingCount === 0
                                    )}
                                    onClick={() => setOutstandingReviewOpen(true)}
                                    startIcon={<ShoppingCartIcon />}
                                    sx={{ textTransform: 'none', fontWeight: 700, mr: 1 }}
                                  >
                                    {outstandingPoDetailButtonLabel}
                                  </Button>
                                </span>
                              </Tooltip>
                            )}
                            <div className="dropdown-container">
                              <Box
                                className="introduction-field"
                                sx={{ display: 'flex', justifyContent: 'center' }}
                              >
                                <Button
                                  variant="contained"
                                  onClick={handleActionsClick}
                                  sx={{
                                    textTransform: 'none',
                                    color: 'white',
                                    backgroundColor: '#c3171d',
                                    '&:hover': { backgroundColor: 'white', color: '#c3171d' },
                                    width: '200px',
                                    fontWeight: 600,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                  }}
                                >
                                  {loading ? <ButtonLoader /> : <><SettingsIcon /> Actions</>}
                                </Button>
                              </Box>
                              {showActions && (
                                <Box className="dropdown-menu">
                                  <Button
                                    onClick={requestProofsApi}
                                    sx={{ width: '100%', mb: 1, fontWeight: 700 }}
                                  >
                                    Request Proof
                                  </Button>
                                  <Button
                                    onClick={handleOpenRegeneratePopup}
                                    sx={{ width: '100%', fontWeight: 700 }}
                                  >
                                    Regenerate All POs
                                  </Button>
                                </Box>
                              )}
                            </div>
                          </div>
                          <PurchaseOrderList
                            regeneratePopup={regeneratePopup}
                            setRegeneratePopup={setRegeneratePopup}
                            order={orderForCartView}
                            requestProofs={requestProofs}
                            setSelectedPOList={setSelectedPOList}
                            refreshKey={outstandingPoListRefresh}
                          />
                          {hasGeneratedIncrementalPoCandidates && hasRemainingPurchaseOrders && (
                            <Box sx={{ mt: 2, px: 2, py: 1.5, border: '1px solid', borderColor: 'info.main', borderRadius: 2, bgcolor: 'background.paper' }}>
                              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                More purchase orders remain
                              </Typography>
                              <Typography variant="body2" sx={{ mt: 0.5, mb: 1, color: 'text.secondary' }}>
                                {readyToCreatePoCount > 0
                                  ? `${readyToCreatePoCount} additional PO${readyToCreatePoCount === 1 ? '' : 's'} ready to generate.`
                                  : `${blockedPoCandidateCount} remaining PO${blockedPoCandidateCount === 1 ? '' : 's'} waiting on shipping, artwork, or routing requirements.`}
                                {' '}Review the live checks on Purchase Order Home to generate the next eligible POs.
                              </Typography>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => history.push(`/instance/${instanceUniqueId}/sales/orders/${orderId}/purchase-order-home`)}
                                sx={{ textTransform: 'none', fontWeight: 700 }}
                              >
                                Check &amp; Generate Remaining POs
                              </Button>
                            </Box>
                          )}
                        </>)

                      ) : (
                        // 3) poId exists but no matching PO
                        (<div className="status-po-warning">
                          <Typography>
                            ⚠️ Note: Sales order #{poId} has not been converted to a purchase order.
                          </Typography>
                        </div>)
                      )}
                    </div>
                  )}


                  {activeTab === "Shipping" && (
                    <ShippingDetails orderDetails={order} />
                  )}


                  {activeTab === "Bills" && (
                    <Billing 
                      onComputed={(s) => setBillsSummary(s)}
                      bookedMargin={bookedMarginForUI}
                    />
                  )}

                  {activeTab === "Commissions" && (
                      <Commissions
                      orderId={order?.id}
                      instanceUniqueId={instanceUniqueId}
                      canFinance={isAdministrator || isFinanceRep}
                      isAdministrator={isAdministrator}
                      bookedMargin={Number(billsSummary?.stamped?.bookedMargin ?? bookedMarginForUI ?? 0)}
                      bookedRevenue={Number(billsSummary?.stamped?.targetRevenue ?? order?.cart?.bookedRevenue ?? order?.Total ?? 0)}
                      billedActual={billsSummary?.actual || 0}     // ✅ what Finance has entered
                      invoicedTotal={billsSummary?.invoicedTotal || 0}
                      targetBooked={billsSummary?.target || 0}     // (optional) lets you show % progress
                      assignedUsers={assignedUsers}
                      userDirectory={availableUsers}
                    />
                  )}

                </div>
              </div>
            </div>

            {/* Let's edit current products */}
            {showProductManagerPopup === true ? (
              <InstanceProductManager
                popupMode={popupInitialView}
                onRequestClose={togglePopupMode}
                productId={currentProduct || ""}
                orderData={order}
                instanceUniqueId={instanceUniqueId}
                handleSaveProduct={handleSaveProduct}
              />
            ) : (
              ""
            )}

            {showAddNewProductManager === true ? (
              <>
                <ProductPopup
                  isOpen={popupInitialView}
                  onRequestClose={setShowAddNewProductManager}
                  productId={null}
                  instanceUniqueId={instanceUniqueId}

                />
              </>
            ) : (
              ""
            )}


          </>
        )}

        {showProductPopup &&

          <InstanceProducts updateItemsToOrder={updateItemsToOrder} selectedProducts={selectedProducts}
            setSelectedProducts={setSelectedProducts} fetchOrder={fetchOrder} isPresentation={true}
            popupMode={showProductPopup} closeProductListPopup={closeProductListPopup} order={orderForCartView} />}
          <SelectedProductsPopup
            open={estimationPopup}
            setEstimationPopup={setEstimationPopup}
            order={orderForCartView}
            clientContacts={clientContacts}
            conversionStatus={conversionStatus}
            fetchOrder={fetchOrder}
            enforceAddressBeforeSalesOrderSend={enforceAddressBeforeSalesOrderSend}
          />
          <CopyProductsToPromoStoreDialog
            open={promoStoreCopyOpen}
            onClose={() => setPromoStoreCopyOpen(false)}
            order={order}
            products={promoStoreCopySource.products}
            instanceUniqueId={instanceUniqueId}
            sourceLabel={promoStoreCopySource.label}
            onComplete={({ promoStoreId, productCount }) => {
              toast.success(
                `${productCount} product${productCount === 1 ? "" : "s"} copied to PromoStore.`,
              );
              history.push(
                `/instance/${instanceUniqueId}/sales/promostores/${promoStoreId}/products`,
              );
            }}
          />

          <Dialog
            open={requestArtOpen}
            onClose={() => setRequestArtOpen(false)}
            maxWidth={requestArtTab === "binated" && binatedArtView === "status" ? "xl" : "md"}
            fullWidth
          >
            <DialogTitle>
              Request Art
            </DialogTitle>
            <DialogContent dividers>
              <Tabs
                value={requestArtTab}
                onChange={(_, next) => setRequestArtTab(next)}
                sx={{ mb: 2 }}
              >
                <Tab value="designer" label="Design Rep" />
                <Tab value="binated" label="Fulfillment" />
                <Tab value="proofing" label="Proofing" />
              </Tabs>

              {requestArtTab === "designer" && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Typography variant="body2">
                    Notify a design rep that this estimate/sales-order needs artwork assistance.
                  </Typography>
                  <TextField
                    fullWidth
                    label="Document Link"
                    value={`${window.location.origin}${history.location.pathname}`}
                    InputProps={{ readOnly: true }}
                  />
                  <FormControl fullWidth>
                    <InputLabel id="request-art-design-rep-label">Design Rep</InputLabel>
                    <Select
                      labelId="request-art-design-rep-label"
                      label="Design Rep"
                      value={selectedDesignRepId}
                      onChange={(e) => setSelectedDesignRepId(String(e.target.value))}
                    >
                      <MenuItem value="">All Design Reps</MenuItem>
                      {designRepOptions.map((rep) => (
                        <MenuItem key={rep.id} value={rep.id}>{rep.name}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Request Note"
                    multiline
                    minRows={4}
                    fullWidth
                    value={requestArtNote}
                    onChange={(e) => setRequestArtNote(e.target.value)}
                    helperText="Add request details for this specific estimate/sales-order."
                  />
                  <Button
                    variant="outlined"
                    component="label"
                    sx={{ width: "fit-content" }}
                  >
                    Attach File(s)
                    <input
                      hidden
                      multiple
                      type="file"
                      onChange={(e) => {
                        const files = Array.from(e.target.files || []);
                        setRequestArtFiles(files);
                      }}
                    />
                  </Button>
                  {requestArtFiles.length > 0 && (
                    <Typography variant="caption" sx={{ color: "text.secondary" }}>
                      Attached: {requestArtFiles.map((f) => f.name).join(", ")}
                    </Typography>
                  )}
                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                    The selected design rep will receive this document link, your note, and any attachments. You will be CC’d.
                  </Typography>
                </Box>
              )}

              {requestArtTab === "proofing" && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>
                    Sales Order Proofing
                  </Typography>
                  <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 760 }}>
                    Review mapped proof files from {proofingSourceLabel} against the artwork targets for this document.
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      Proof Source
                    </Typography>
                    <Tooltip
                      arrow
                      title="Choose where the proof files available for mapping come from. Each source keeps its current sync and mapping behavior."
                    >
                      <IconButton size="small" aria-label="Proof source help" sx={{ p: 0.25 }}>
                        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <FormControl size="small" sx={{ maxWidth: 420 }}>
                    <InputLabel id="proofing-source-label">Proof Source</InputLabel>
                    <Select
                      labelId="proofing-source-label"
                      value={proofMappingSourceType || ""}
                      label="Proof Source"
                      displayEmpty
                      onChange={(event) => {
                        proofSourceManualOverrideRef.current = true;
                        setProofSourceLinkageBanner(null);
                        setProofSourceStatusMeta(null);
                        setProofMappingSourceType(event.target.value);
                      }}
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                              No proof source available
                            </Typography>
                          );
                        }
                        const option = PROOF_SOURCE_OPTIONS[selected] || PROOF_SOURCE_OPTIONS.design_rep;
                        const SourceIcon = option.icon;
                        return (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                            <SourceIcon sx={{ fontSize: 18, color: "text.secondary", flexShrink: 0 }} />
                            <Box sx={{ minWidth: 0 }}>
                              <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                {option.selectedLabel}
                              </Typography>
                              <Typography variant="caption" sx={{ color: "text.secondary", lineHeight: 1.2 }}>
                                {option.shortDescription}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      }}
                    >
                      {Object.values(PROOF_SOURCE_OPTIONS).map((option) => {
                        const SourceIcon = option.icon;
                        const availability = proofSourceAvailability[option.value] || {};
                        const disabledReason = availability.disabledReason || "";
                        const secondaryText = disabledReason
                          ? `${option.shortDescription} ${disabledReason}`
                          : option.shortDescription;
                        return (
                          <MenuItem
                            key={option.value}
                            value={option.value}
                            disabled={!availability.isApplicable}
                            aria-label={`${option.label}: ${secondaryText}`}
                          >
                            <Tooltip title={disabledReason || option.tooltip} placement="right" arrow>
                              <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                                <ListItemIcon sx={{ minWidth: 34 }}>
                                  <SourceIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={option.label} secondary={secondaryText} />
                              </Box>
                            </Tooltip>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <Typography variant="caption" sx={{ color: "text.secondary" }}>
                    {selectedProofSourceStatus.summary}
                    {selectedProofSourceStatus.approvalStatus ? (
                      <Box component="span" sx={{ fontWeight: 700, ml: 0.5 }}>
                        {selectedProofSourceStatus.approvalStatus}
                      </Box>
                    ) : null}
                  </Typography>
                  {proofSourceLinkageBanner && proofMappingSourceType === "core-network" ? (
                    <Box
                      role="status"
                      sx={(theme) => ({
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 1,
                        p: 1.25,
                        borderRadius: 1.5,
                        border: `1px solid ${alpha(theme.palette.success.main, 0.22)}`,
                        backgroundColor: alpha(theme.palette.success.main, 0.08),
                      })}
                    >
                      <LinkOutlinedIcon sx={{ fontSize: 18, color: "success.main", mt: 0.15 }} />
                      <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700, color: "success.dark", lineHeight: 1.2 }}>
                          {proofSourceLinkageBanner.heading}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "text.secondary", lineHeight: 1.35 }}>
                          {proofSourceLinkageBanner.message}
                        </Typography>
                      </Box>
                    </Box>
                  ) : null}
                  {latestProofWorkRequestId && proofMappingSourceType !== "design_rep" && !(proofSourceLinkageBanner && proofMappingSourceType === "core-network") && (
                    <Alert severity="success">
                      {proofingSourceLabel} request #{latestProofWorkRequestId} created. Approved submission files will appear here automatically and can be remapped if needed.
                    </Alert>
                  )}
                  {proofMappingSourceType ? (
                    <DesignRepArtworkProofMapper
                      active={requestArtOpen && requestArtTab === "proofing"}
                      orderId={orderId}
                      documentType={lifecycleDocumentType}
                      documentId={resolvedBinatedDocumentId}
                      customerId={
                        customerData?.id ||
                        (Array.isArray(order?.attachedCustomers)
                          ? (typeof order.attachedCustomers[0] === "object"
                              ? order.attachedCustomers[0]?.id
                              : order.attachedCustomers[0])
                          : null)
                      }
                      disabled={requestArtLoading}
                      sourceType={proofMappingSourceType}
                      sourceProvider={proofMappingSourceType}
                      sourceLabel={proofingSourceLabel}
                      salesOrderWorkflowStatus={order?.OrderStatus?.SO || ""}
                      resetBlockedReason={proofingResetBlockedReason}
                      onResetComplete={handleProofingResetComplete}
                      onSourceSummaryChange={handleProofSourceSummaryChange}
                    />
                  ) : (
                    <Alert severity="info">
                      No artwork proof request exists for this Sales Order yet.
                    </Alert>
                  )}
                </Box>
              )}

              {requestArtTab === "binated" && (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      Fulfillment Method
                    </Typography>
                    <Box
                      role="radiogroup"
                      aria-label="Fulfillment Method"
                      sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" }, gap: 1.25 }}
                    >
                      {FULFILLMENT_METHOD_OPTIONS.map((option) => {
                        const OptionIcon = option.icon;
                        const selected = proofFulfillmentProvider === option.value;
                        return (
                          <Box
                            key={option.value}
                            component="button"
                            type="button"
                            role="radio"
                            aria-checked={selected}
                            aria-label={`${option.label}: ${option.description}`}
                            onClick={() => setProofFulfillmentProvider(option.value)}
                            sx={(theme) => ({
                              width: "100%",
                              textAlign: "left",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: 1.25,
                              p: 1.5,
                              borderRadius: 2,
                              border: "1px solid",
                              borderColor: selected ? "primary.main" : "divider",
                              backgroundColor: selected ? alpha(theme.palette.primary.main, 0.08) : "background.paper",
                              boxShadow: selected ? `0 0 0 1px ${alpha(theme.palette.primary.main, 0.18)}` : "none",
                              cursor: "pointer",
                            })}
                          >
                            <Box
                              sx={(theme) => ({
                                width: 40,
                                height: 40,
                                borderRadius: 1.5,
                                display: "grid",
                                placeItems: "center",
                                backgroundColor: selected ? alpha(theme.palette.primary.main, 0.14) : "var(--ec-color-surface-muted)",
                                color: selected ? "primary.main" : "text.secondary",
                                flexShrink: 0,
                              })}
                            >
                              <OptionIcon fontSize="small" />
                            </Box>
                            <Box sx={{ minWidth: 0 }}>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 700, lineHeight: 1.25, display: "flex", alignItems: "center", gap: 0.75 }}
                              >
                                {option.label}
                                {option.value === "binated" && currentUserBinatedConnected && (
                                  <Box
                                    component="span"
                                    title="Binated connected"
                                    aria-label="Binated connected"
                                    sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: "success.main", flexShrink: 0 }}
                                  />
                                )}
                              </Typography>
                              <Typography variant="caption" sx={{ color: "text.secondary", lineHeight: 1.35 }}>
                                {option.description}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                  {resolvedProofWorkProvider !== "binated" && activeDuplicateRequestArtStatus && (
                    <Alert severity="warning">
                      An active {activeDuplicateRequestArtStatus.mode === "marketplace" ? "marketplace design" : activeDuplicateRequestArtStatus.mode === "direct" ? "designer" : activeDuplicateRequestArtStatus.mode} request already exists for this artwork scope. Reuse it unless this is a different product, decoration, placement, or replacement request.
                    </Alert>
                  )}
                  {proofFulfillmentProvider === "binated" && !binatedSettings.ready && (
                    <Typography variant="body2" sx={{ color: "#b45309", fontWeight: 600 }}>
                      Binated is not fully configured for this instance (API key/secret/base URL).
                    </Typography>
                  )}
                  {process.env.NODE_ENV !== "production" && isBinatedFulfillment && sendToBinatedDisabledReason && (
                    <Alert severity="info" data-testid="send-to-binated-disabled-reason">
                      Send to Binated disabled: {sendToBinatedDisabledReason}
                    </Alert>
                  )}
                  <Tabs
                    value={binatedArtView}
                    onChange={(_, next) => {
                      userSelectedBinatedArtViewRef.current = true;
                      setBinatedArtView(next);
                    }}
                  >
                    <Tab
                      value="status"
                      label={resolvedProofWorkProvider === "binated" ? "Status" : "Design requests"}
                    />
                    <Tab
                      value="form"
                      label={resolvedProofWorkProvider === "binated" ? "Form" : "New design request"}
                    />
                    <Tab value="payload" label="Payload Preview" />
                  </Tabs>

                  {binatedArtView === "status" && (
                    resolvedProofWorkProvider === "binated" ? (
                      binatedLifecycle.lifecycle ? (
                      <BinatedLifecycleStatusPanel
                        lifecycle={binatedLifecycle.lifecycle}
                        onRefresh={binatedLifecycle.refreshLifecycle}
                        refreshing={requestArtLoading || binatedLifecycle.lifecycleLoading}
                        timeline={<BinatedLifecycleTimeline normalizedStatus={binatedLifecycle.normalizedStatus} />}
                        onSubmitStatusItemUpdate={submitStatusItemDecorationUpdate}
                        onUploadReplacementFiles={uploadBinatedReplacementFiles}
                        customerId={binatedCustomerId}
                        statusItemUpdating={binatedLifecycle.statusItemUpdateSubmitting}
                      >
                        {binatedLifecycle.canShowFiles && (
                          <BinatedLifecycleFilesTable
                            files={binatedLifecycle.files}
                            statusItems={binatedLifecycle.lifecycle?.statusItems}
                            revisionAllowed={!!binatedLifecycle.lifecycle?.revisionAllowed}
                            onRequestRevision={
                              hasBinatedPlacementStatusItems ? undefined : binatedLifecycle.openRevisionModalForFile
                            }
                            disabled={requestArtLoading || binatedLifecycle.lifecycleLoading}
                          />
                        )}
                        <BinatedArtworkProofMapper
                          active={requestArtOpen && requestArtTab === "binated" && binatedArtView === "status"}
                          orderId={orderId}
                          documentType={lifecycleDocumentType}
                          documentId={resolvedBinatedDocumentId}
                          lifecycle={binatedLifecycle.lifecycle}
                          disabled={requestArtLoading || binatedLifecycle.lifecycleLoading}
                          onLifecycleRefresh={binatedLifecycle.refreshLifecycle}
                        />
                      </BinatedLifecycleStatusPanel>
                      ) : (
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          Please submit a request.
                        </Typography>
                      )
                    ) : (
                      <Stack spacing={2}>
                        {requestArtStatusesLoading ? (
                          <Typography variant="body2" sx={{ color: "text.secondary" }}>
                            Loading existing requests…
                          </Typography>
                        ) : requestArtStatusesForProvider.length ? (
                          requestArtStatusesForProvider.map((statusRow) => {
                            const designer = statusRow.assignedTalent || statusRow.selectedTalent || null;
                            const designerName = designer?.displayName || "Designer not assigned";
                            const lifecycleStatusLabel = String(statusRow.lifecycleStatus || "active").replace(/[_-]+/g, " ");
                            const progressLabel = getDesignerRequestProgressLabel(statusRow);
                            const isOverdue = statusRow.isActive && statusRow.dueDate && dayjs(statusRow.dueDate).isBefore(dayjs(), "day");
                            const createdAgo = formatDesignerRequestAgo(statusRow.createdAt, requestArtClockNow);
                            const elapsed = formatDesignerRequestElapsed(statusRow.createdAt, requestArtClockNow);
                            const lastActivityAgo = formatDesignerRequestAgo(statusRow.lastActivityAt, requestArtClockNow);
                            const hasSubmission = Boolean(statusRow.latestSubmission);
                            return (
                              <Box
                                key={statusRow.requestId}
                                sx={(theme) => ({
                                  overflow: "hidden",
                                  borderRadius: 2.5,
                                  border: "1px solid",
                                  borderColor: isOverdue ? alpha(theme.palette.error.main, 0.35) : statusRow.isActive ? alpha(theme.palette.primary.main, 0.28) : "divider",
                                  backgroundColor: "background.paper",
                                  boxShadow: statusRow.isActive ? `0 10px 30px ${alpha(theme.palette.primary.main, 0.07)}` : "none",
                                })}
                              >
                                <Box sx={{ p: { xs: 2, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2 }}>
                                  <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "stretch", sm: "flex-start" }} spacing={1.5}>
                                    <Stack direction="row" spacing={1.5} alignItems="center">
                                      <Box sx={(theme) => ({ width: 42, height: 42, borderRadius: 2, display: "grid", placeItems: "center", backgroundColor: alpha(theme.palette.primary.main, 0.1), color: "primary.main", flexShrink: 0 })}>
                                        <DesignServicesOutlinedIcon fontSize="small" />
                                      </Box>
                                      <Box sx={{ minWidth: 0 }}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 800, lineHeight: 1.25 }}>
                                          Design Request #{statusRow.requestId}
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                          {statusRow.mode === "marketplace" ? "Designer marketplace" : "Assigned designer"}
                                          {createdAgo ? ` · Created ${createdAgo}` : ""}
                                        </Typography>
                                      </Box>
                                    </Stack>
                                    <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap alignItems="center">
                                      <Chip size="small" color={statusRow.isActive ? "primary" : "default"} label={statusRow.isActive ? "Active" : "History"} />
                                      <Chip size="small" variant="outlined" label={lifecycleStatusLabel} />
                                      {isOverdue ? <Chip size="small" color="error" label="Overdue" /> : null}
                                    </Stack>
                                  </Stack>
                                  <Box sx={(theme) => ({
                                    display: "flex", alignItems: "center", gap: 1.25,
                                    p: 1.5, borderRadius: 2, backgroundColor: alpha(theme.palette.primary.main, 0.045),
                                  })}>
                                    <Avatar src={designer?.profileImageUrl || undefined} sx={{ width: 39, height: 39, bgcolor: "primary.light", color: "primary.dark", fontSize: 14 }}>
                                      {designer?.displayName ? designer.displayName.slice(0, 1).toUpperCase() : <PersonIcon fontSize="small" />}
                                    </Avatar>
                                    <Box sx={{ minWidth: 0, flex: 1 }}>
                                      <Typography variant="body2" sx={{ fontWeight: 700 }}>{designerName}</Typography>
                                      <Typography variant="caption" color="text.secondary">
                                        {designer?.companyName || (designer ? "Design talent" : "No designer assigned yet")}
                                      </Typography>
                                    </Box>
                                    {designer?.id ? (
                                      <Button
                                        size="small" variant="text" sx={{ flexShrink: 0 }}
                                        onClick={() => window.open(`/instance/${instanceUniqueId}/core-network/talent/${designer.id}`, "_blank", "noopener,noreferrer")}
                                      >
                                        Profile
                                      </Button>
                                    ) : null}
                                  </Box>
                                  <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
                                    <FactCheckOutlinedIcon sx={{ fontSize: 18, color: hasSubmission ? "success.main" : "text.secondary" }} />
                                    <Typography variant="body2" sx={{ fontWeight: 700 }}>{progressLabel}</Typography>
                                    {hasSubmission ? (
                                      <Chip size="small" variant="outlined" label={`Submission v${statusRow.latestSubmission.version || 1}`} />
                                    ) : String(statusRow.lifecycleStatus || "").toLowerCase() === "completed" ? (
                                      <Chip size="small" color="warning" label="Artwork missing" />
                                    ) : null}
                                    {statusRow.revisionCount > 0 ? <Chip size="small" variant="outlined" label={`${statusRow.revisionCount} revisions`} /> : null}
                                  </Box>
                                  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))" }, gap: 1.5, pt: 1.5, borderTop: "1px solid", borderColor: "divider" }}>
                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                      <AccessTimeIcon sx={{ fontSize: 18, color: "text.secondary", mt: 0.15 }} />
                                      <Box>
                                        <Typography variant="caption" color="text.secondary">{statusRow.isActive ? "Time elapsed" : "Request age"}</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 650 }}>
                                          {elapsed ? elapsed : "Not recorded"}
                                        </Typography>
                                      </Box>
                                    </Stack>
                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                      <EventIcon sx={{ fontSize: 18, color: isOverdue ? "error.main" : "text.secondary", mt: 0.15 }} />
                                      <Box>
                                        <Typography variant="caption" color="text.secondary">Due date</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 650, color: isOverdue ? "error.main" : "text.primary" }}>
                                          {statusRow.dueDate ? dayjs(statusRow.dueDate).format("MMM D, YYYY") : "Not set"}
                                        </Typography>
                                      </Box>
                                    </Stack>
                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                      <UpdateIcon sx={{ fontSize: 18, color: "text.secondary", mt: 0.15 }} />
                                      <Box>
                                        <Typography variant="caption" color="text.secondary">Last activity</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 650 }}>{lastActivityAgo || "Not recorded"}</Typography>
                                        {statusRow.lastActivityAt ? <Typography variant="caption" color="text.secondary">{dayjs(statusRow.lastActivityAt).format("MMM D, YYYY h:mm A")}</Typography> : null}
                                      </Box>
                                    </Stack>
                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                      <ForumIcon sx={{ fontSize: 18, color: "text.secondary", mt: 0.15 }} />
                                      <Box>
                                        <Typography variant="caption" color="text.secondary">Conversation</Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 650 }}>
                                          {statusRow.unreadMessageCount ? `${statusRow.unreadMessageCount} unread messages` : "No unread messages"}
                                        </Typography>
                                      </Box>
                                    </Stack>
                                  </Box>
                                  <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
                                    {statusRow.priority && String(statusRow.priority).toLowerCase() !== "normal" ? (
                                      <Chip size="small" variant="outlined" label={`Priority: ${statusRow.priority}`} />
                                    ) : null}
                                    {statusRow.assignment?.status ? (
                                      <Chip size="small" variant="outlined" label={`Assignment: ${String(statusRow.assignment.status).replace(/[_-]+/g, " ")}`} />
                                    ) : null}
                                  </Stack>
                                </Box>
                                <Box sx={{ px: { xs: 2, md: 2.5 }, py: 1.5, display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, borderTop: "1px solid", borderColor: "divider", backgroundColor: "action.hover" }}>
                                  <Button size="small" variant="contained" endIcon={<OpenInNewIcon fontSize="small" />} onClick={() => openRequestArtWorkRequest(statusRow)}>
                                    Open Design Request
                                  </Button>
                                  <Button size="small" variant="outlined" onClick={() => openRequestArtWorkRequest(statusRow, "messages")}>
                                    Conversation
                                  </Button>
                                  {hasSubmission ? (
                                    <>
                                      <Button size="small" variant="outlined" onClick={() => openRequestArtWorkRequest(statusRow, "submissions")}>
                                        Submission history
                                      </Button>
                                      <Button size="small" variant="outlined" onClick={() => reviewRequestArtSubmission(statusRow)}>
                                        View in Proofing
                                      </Button>
                                    </>
                                  ) : null}
                                  <Box sx={{ flex: 1 }} />
                                  {statusRow.isActive ? (
                                    <Button size="small" color="error" variant="text" disabled={requestArtLoading} onClick={() => cancelRequestArtWorkRequest(statusRow)}>
                                      Cancel request
                                    </Button>
                                  ) : null}
                                  <Button size="small" variant="text" onClick={() => {
                                    userSelectedBinatedArtViewRef.current = true;
                                    setBinatedArtView(DESIGNER_REQUEST_TAB_OPTIONS.create);
                                  }}>
                                    New design request
                                  </Button>
                                </Box>
                              </Box>
                            );
                          })
                        ) : (
                          <Box
                            sx={{
                              borderRadius: 2,
                              border: "1px dashed",
                              borderColor: "divider",
                              p: 2,
                              backgroundColor: "background.paper",
                            }}
                          >
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
                              No design requests yet
                            </Typography>
                            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                              Choose a designer and create a design request to get artwork underway.
                            </Typography>
                          </Box>
                        )}
                      </Stack>
                    )
                  )}

                  {binatedArtView === "form" && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        opacity: resolvedProofWorkProvider === "binated" && isSubmittedRequestLocked ? 0.78 : 1,
                        pointerEvents: resolvedProofWorkProvider === "binated" && isSubmittedRequestLocked ? "none" : "auto",
                      }}
                    >
                      {resolvedProofWorkProvider === "binated" && isSubmittedRequestLocked && (
                        <Typography variant="body2" sx={{ color: "text.secondary" }}>
                          This request has been submitted. Fields are read-only.
                        </Typography>
                      )}
                      {resolvedProofWorkProvider !== "binated" && (
                        <Stack spacing={2}>
                          <Alert severity={resolvedProofWorkProvider === "internal" ? "info" : "success"}>
                            {resolvedProofWorkProvider === "internal"
                              ? "Create an internal proof work request. Approved files will flow back into the Proofing tab."
                              : isDirectTalentAssignment
                                ? "Create a designer request and assign it directly to another available designer."
                                : "Create a Core Network marketplace request so eligible Core Network artwork talent can respond and Elite can choose the winning provider."}
                          </Alert>
                          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                            <TextField
                              fullWidth
                              type="date"
                              label="Due Date"
                              value={requestArtDueDate}
                              onChange={(event) => setRequestArtDueDate(event.target.value)}
                              InputLabelProps={{ shrink: true }}
                            />
                            <FormControl fullWidth>
                              <InputLabel id="proof-priority-level-label">Priority</InputLabel>
                              <Select
                                labelId="proof-priority-level-label"
                                label="Priority"
                                value={requestArtPriorityLevel}
                                onChange={(event) => setRequestArtPriorityLevel(String(event.target.value))}
                              >
                                <MenuItem value="low">Low</MenuItem>
                                <MenuItem value="normal">Normal</MenuItem>
                                <MenuItem value="high">High</MenuItem>
                                <MenuItem value="rush">Rush</MenuItem>
                              </Select>
                            </FormControl>
                          </Box>
                          {resolvedProofWorkProvider === "core-network" && (
                            <>
                              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                                <FormControl fullWidth>
                                  <InputLabel id="core-network-capability-filter-label">Design Capability</InputLabel>
                                  <Select
                                    labelId="core-network-capability-filter-label"
                                    label="Design Capability"
                                    value={coreNetworkCapabilityFilter}
                                    onChange={(event) => setCoreNetworkCapabilityFilter(String(event.target.value))}
                                  >
                                    <MenuItem value="artwork-proof">Artwork Proof</MenuItem>
                                    <MenuItem value="vector_art">Vector Art</MenuItem>
                                    <MenuItem value="digitizing">Digitizing</MenuItem>
                                    <MenuItem value="proof_mockup">Proof Mockup</MenuItem>
                                  </Select>
                                </FormControl>
                                <TextField
                                  fullWidth
                                  label="Fixed Cost (CAD)"
                                  value="0"
                                  InputProps={{ readOnly: true }}
                                />
                              </Box>
                              {isDirectTalentAssignment ? (
                                <>
                                  <FormControl fullWidth disabled={coreNetworkTalentLoading || !coreNetworkTalentOptions.length}>
                                    <InputLabel id="core-network-member-label">Designer</InputLabel>
                                    <Select
                                      labelId="core-network-member-label"
                                      label="Designer"
                                      value={selectedCoreNetworkMemberId}
                                      onChange={(event) => setSelectedCoreNetworkMemberId(String(event.target.value))}
                                    >
                                      {coreNetworkTalentOptions.map((member) => (
                                        <MenuItem key={member.id} value={member.id}>
                                          {member.displayName}{member.companyName ? ` - ${member.companyName}` : ""}
                                        </MenuItem>
                                      ))}
                                    </Select>
                                  </FormControl>
                                  {!coreNetworkTalentLoading && !coreNetworkTalentOptions.length && (
                                    <Alert severity="warning">
                                      No eligible designers found for the selected capability.
                                    </Alert>
                                  )}
                                </>
                              ) : (
                                <Stack spacing={2}>
                                  <Alert severity="info">
                                    Marketplace posting creates one work request without a pre-created assignment. Offers are sent based on the audience you choose below.
                                  </Alert>
                                  <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                                    <FormControl fullWidth>
                                      <InputLabel id="core-network-marketplace-audience-label">Audience</InputLabel>
                                      <Select
                                        labelId="core-network-marketplace-audience-label"
                                        label="Audience"
                                        value={marketplaceAudienceMode}
                                        onChange={(event) => setMarketplaceAudienceMode(String(event.target.value))}
                                      >
                                        <MenuItem value="all_eligible">All eligible talent</MenuItem>
                                        <MenuItem value="top_matches">Top matches</MenuItem>
                                        <MenuItem value="selected_talent">Selected talent</MenuItem>
                                      </Select>
                                    </FormControl>
                                    <TextField
                                      fullWidth
                                      label="Offer Expiry (hours)"
                                      value={marketplaceOfferExpiryHours}
                                      onChange={(event) => setMarketplaceOfferExpiryHours(event.target.value)}
                                    />
                                  </Box>
                                  <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3,minmax(0,1fr))", gap: 2 }}>
                                    <FormControl fullWidth>
                                      <InputLabel id="core-network-marketplace-budget-mode-label">Fee Strategy</InputLabel>
                                      <Select
                                        labelId="core-network-marketplace-budget-mode-label"
                                        label="Fee Strategy"
                                        value={marketplaceBudgetMode}
                                        onChange={(event) => setMarketplaceBudgetMode(String(event.target.value))}
                                      >
                                        <MenuItem value="fixed">Fixed budget</MenuItem>
                                        <MenuItem value="range">Budget range</MenuItem>
                                        <MenuItem value="talent_proposes_fee">Talent proposes fee</MenuItem>
                                      </Select>
                                    </FormControl>
                                    <TextField
                                      fullWidth
                                      label="Currency"
                                      value={marketplaceCurrency}
                                      onChange={(event) => setMarketplaceCurrency(String(event.target.value || "").toUpperCase())}
                                    />
                                    <TextField
                                      fullWidth
                                      label="Maximum Offers"
                                      value={marketplaceMaxOffers}
                                      onChange={(event) => setMarketplaceMaxOffers(event.target.value)}
                                    />
                                  </Box>
                                  {marketplaceBudgetMode === "fixed" ? (
                                    <TextField
                                      fullWidth
                                      label="Fixed Budget"
                                      value={requestArtFeeEstimate}
                                      onChange={(event) => setRequestArtFeeEstimate(event.target.value)}
                                    />
                                  ) : null}
                                  {marketplaceBudgetMode === "range" ? (
                                    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                                      <TextField
                                        fullWidth
                                        label="Budget Range Min"
                                        value={marketplaceBudgetRangeMin}
                                        onChange={(event) => setMarketplaceBudgetRangeMin(event.target.value)}
                                      />
                                      <TextField
                                        fullWidth
                                        label="Budget Range Max"
                                        value={marketplaceBudgetRangeMax}
                                        onChange={(event) => setMarketplaceBudgetRangeMax(event.target.value)}
                                      />
                                    </Box>
                                  ) : null}
                                  {marketplaceAudienceMode === "top_matches" ? (
                                    <FormControl fullWidth>
                                      <InputLabel id="core-network-marketplace-top-match-limit-label">Top Match Count</InputLabel>
                                      <Select
                                        labelId="core-network-marketplace-top-match-limit-label"
                                        label="Top Match Count"
                                        value={marketplaceTopMatchLimit}
                                        onChange={(event) => setMarketplaceTopMatchLimit(String(event.target.value))}
                                      >
                                        <MenuItem value="3">Top 3</MenuItem>
                                        <MenuItem value="5">Top 5</MenuItem>
                                        <MenuItem value="10">Top 10</MenuItem>
                                      </Select>
                                    </FormControl>
                                  ) : null}
                                  {marketplaceAudienceMode === "selected_talent" ? (
                                    <FormControl fullWidth disabled={coreNetworkTalentLoading || !coreNetworkTalentOptions.length}>
                                      <InputLabel id="core-network-marketplace-selected-talent-label">Selected Talent</InputLabel>
                                      <Select
                                        multiple
                                        labelId="core-network-marketplace-selected-talent-label"
                                        label="Selected Talent"
                                        value={selectedMarketplaceMemberIds}
                                        onChange={(event) => setSelectedMarketplaceMemberIds(Array.isArray(event.target.value) ? event.target.value : [])}
                                        renderValue={(selected) =>
                                          selected
                                            .map((memberId) => coreNetworkTalentOptions.find((member) => String(member.id) === String(memberId))?.displayName)
                                            .filter(Boolean)
                                            .join(", ")
                                        }
                                      >
                                        {coreNetworkTalentOptions.map((member) => {
                                          const checked = selectedMarketplaceMemberIds.includes(String(member.id)) || selectedMarketplaceMemberIds.includes(member.id);
                                          return (
                                            <MenuItem key={member.id} value={String(member.id)}>
                                              <Checkbox checked={checked} />
                                              <ListItemText
                                                primary={member.displayName}
                                                secondary={member.companyName || member.profileJson?.typicalTurnaround || ""}
                                              />
                                            </MenuItem>
                                          );
                                        })}
                                      </Select>
                                    </FormControl>
                                  ) : null}
                                  {(marketplaceAudienceMode === "all_eligible" || marketplaceAudienceMode === "selected_talent") && !coreNetworkTalentLoading && !coreNetworkTalentOptions.length ? (
                                    <Alert severity="warning">
                                      No eligible network members found for the selected capability.
                                    </Alert>
                                  ) : null}
                                </Stack>
                              )}
                            </>
                          )}
                          <TextField
                            label="Instructions"
                            multiline
                            minRows={4}
                            fullWidth
                            value={requestArtNote}
                            onChange={(event) => setRequestArtNote(event.target.value)}
                            helperText="These instructions are stored on the WorkRequest alongside the proof payload."
                          />
                        </Stack>
                      )}
                      <Box sx={{ p: 1.5, border: "1px solid #e5e7eb", borderRadius: 1, background: "#fafafa" }}>
                        <FormControl component="fieldset">
                          <RadioGroup
                            row
                            value={requestArtSmartSend ? "smart-sales-order-send" : "build-from-scratch"}
                            onChange={(event) => {
                              const useSmartSend = event.target.value === "smart-sales-order-send";
                              setRequestArtSmartSend(useSmartSend);
                              if (useSmartSend) {
                                setSmartSendView("preview");
                                applySmartSendFileUrl();
                              }
                            }}
                          >
                            <FormControlLabel value="smart-sales-order-send" control={<Radio />} label="Quick Proof" />
                            <FormControlLabel value="build-from-scratch" control={<Radio />} label="Artwork Services" />
                          </RadioGroup>
                        </FormControl>
                        {!requestArtSmartSend && (
                          <Typography variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                            Manually build a Binated artwork request.
                          </Typography>
                        )}
                      </Box>

                      {!requestArtSmartSend && binatedStandardsChecking ? (
                        <Alert severity="info">Checking Binated-specific mappings...</Alert>
                      ) : null}
                      {!requestArtSmartSend && binatedStandardsPreflight?.hasBlockingIssues ? (
                        <Alert severity="warning">
                          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                            Review Binated mappings before sending
                          </Typography>
                          {(binatedStandardsPreflight?.issues || []).slice(0, 4).map((issue, issueIndex) => (
                            <Typography key={`binated-standard-issue-${issueIndex}`} variant="body2">
                              {issue.message}
                            </Typography>
                          ))}
                        </Alert>
                      ) : null}

                      {requestArtSmartSend ? (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                          <Alert severity="info">
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Quick Proof</Typography>
                            <Typography variant="body2">
                              Elite Core will build the Binated sales_order payload from this Sales Order’s decorated products and attached artwork. Review the generated payload below, optionally exclude SKUs, or switch to Fields to override values.
                            </Typography>
                          </Alert>
                          {!smartSendDisplayHasActionableArtwork && (
                            <Alert severity="warning">
                              No decorated products with artwork files were found for this sales order.
                            </Alert>
                          )}
                          {smartSendDisplayHasActionableArtwork && !includedSmartSendDisplaySkuEntries.length && (
                            <Alert severity="warning">
                              Select at least one decorated product to send to Binated.
                            </Alert>
                          )}

                          {binatedStandardsChecking ? (
                            <Alert severity="info">Checking Binated-specific mappings...</Alert>
                          ) : null}

                          {binatedStandardsPreflight?.items?.length ? (
                            <Box
                              sx={{
                                p: 2,
                                border: "1px solid",
                                borderColor: binatedStandardsPreflight.hasBlockingIssues ? "#f59e0b" : "#bbf7d0",
                                borderRadius: 2,
                                background: binatedStandardsPreflight.hasBlockingIssues ? "#fffbeb" : "#f0fdf4",
                              }}
                            >
                              <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.5 }}>
                                Binated mappings
                              </Typography>
                              <Typography variant="body2" sx={{ color: "text.secondary", mb: 1.5 }}>
                                Edit Item stays free-typed. These values are only the standardized values sent to Binated. Known values are matched automatically; ambiguous values must be selected here.
                              </Typography>
                              <Stack spacing={1.5}>
                                {binatedStandardsPreflight.items.map((mappingItem) => {
                                  const itemIssues = Array.isArray(mappingItem?.issues) ? mappingItem.issues : [];
                                  return (
                                    <Box
                                      key={mappingItem.itemKey}
                                      sx={{
                                        p: 1.5,
                                        border: "1px solid #e5e7eb",
                                        borderRadius: 1.5,
                                        background: "#fff",
                                      }}
                                    >
                                      <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                        {mappingItem.productSku || "Item"}{mappingItem.productName ? ` — ${mappingItem.productName}` : ""}
                                      </Typography>
                                      {mappingItem.source?.placementName ? (
                                        <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 1 }}>
                                          Elite Core cart location: {mappingItem.source.placementName}
                                        </Typography>
                                      ) : null}

                                      {itemIssues.length ? (
                                        <Alert severity="warning" sx={{ mb: 1 }}>
                                          {itemIssues.map((issue) => issue.message).join(" ")}
                                        </Alert>
                                      ) : null}

                                      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3,minmax(0,1fr))", gap: 1 }}>
                                        <FormControl size="small" fullWidth>
                                          <InputLabel>Binated service</InputLabel>
                                          <Select
                                            label="Binated service"
                                            value={mappingItem.resolved?.serviceType || ""}
                                            onChange={(event) =>
                                              updateSmartSendOverride(mappingItem.paths.serviceType, event.target.value)
                                            }
                                          >
                                            {(binatedStandardsPreflight?.standards?.serviceTypes || []).map((value) => (
                                              <MenuItem key={value} value={value}>{value}</MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>

                                        <FormControl size="small" fullWidth error={!mappingItem.resolved?.placementCode}>
                                          <InputLabel>Binated placement</InputLabel>
                                          <Select
                                            label="Binated placement"
                                            value={mappingItem.resolved?.placementCode || ""}
                                            onChange={(event) => {
                                              const selected = (binatedStandardsPreflight?.standards?.placements || [])
                                                .find((entry) => entry.code === event.target.value);
                                              if (!selected) return;
                                              updateSmartSendOverride(mappingItem.paths.placementCode, selected.code);
                                              updateSmartSendOverride(mappingItem.paths.placementName, selected.name);
                                            }}
                                          >
                                            {(binatedStandardsPreflight?.standards?.placements || []).map((entry) => (
                                              <MenuItem key={entry.code} value={entry.code}>
                                                {entry.name} ({entry.code})
                                              </MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>

                                        <FormControl size="small" fullWidth error={!mappingItem.resolved?.processType}>
                                          <InputLabel>Binated process</InputLabel>
                                          <Select
                                            label="Binated process"
                                            value={mappingItem.resolved?.processType || ""}
                                            onChange={(event) =>
                                              updateSmartSendOverride(mappingItem.paths.processType, event.target.value)
                                            }
                                          >
                                            {(binatedStandardsPreflight?.standards?.processTypes || []).map((value) => (
                                              <MenuItem key={value} value={value}>{value}</MenuItem>
                                            ))}
                                          </Select>
                                        </FormControl>
                                      </Box>
                                    </Box>
                                  );
                                })}
                              </Stack>
                            </Box>
                          ) : null}

                          <Tabs value={smartSendView} onChange={(_, next) => setSmartSendView(next)}>
                            <Tab value="preview" label="Preview" />
                            <Tab value="fields" label="Fields" />
                          </Tabs>

                          {smartSendView === "preview" && (
                            <Stack spacing={2}>
                              {smartSendDisplaySkuEntries.map((skuEntry, skuIndex) => {
                                const baseSku = isSmartSendSubmittedDisplay ? skuEntry : (baseSmartSendSkuEntries[skuIndex] || skuEntry);
                                const skuKey = getSmartSendSkuKey(baseSku);
                                const included = isSmartSendSubmittedDisplay || smartSendSkuSelection[skuKey] !== false;
                                const decorations = Array.isArray(skuEntry?.decoration) ? skuEntry.decoration : [];
                                const firstDecoration = decorations[0] || {};
                                const firstPlacement = (Array.isArray(firstDecoration?.placements) ? firstDecoration.placements : [])[0] || {};
                                const placementUrls = decorations.flatMap((decorationItem) => (
                                  Array.isArray(decorationItem?.placements) ? decorationItem.placements : []
                                )).flatMap((placement) => (Array.isArray(placement?.url) ? placement.url : [])).filter(Boolean);
                                const colors = Array.isArray(firstPlacement?.colors) ? firstPlacement.colors.join(", ") : "";
                                return (
                                  <Box
                                    key={skuKey}
                                    sx={{
                                      border: "1px solid",
                                      borderColor: included ? "#dfe1f1" : "#e8e8ef",
                                      borderRadius: 1.5,
                                      background: included ? "#fff" : "#fafbfc",
                                      boxShadow: included ? "0 7px 24px rgba(32, 38, 80, 0.06)" : "none",
                                      overflow: "hidden",
                                      opacity: included ? 1 : 0.64,
                                    }}
                                  >
                                    <Box sx={{
                                      px: { xs: 1.75, sm: 2.5 }, py: 1.75,
                                      display: "flex", alignItems: "center", gap: 1.5,
                                      borderBottom: "1px solid #e9e8f4",
                                      background: "linear-gradient(115deg, #fff 0%, #fff 57%, #f5f3ff 100%)",
                                    }}>
                                      <Checkbox checked={included} onChange={(event) => setSmartSendSkuIncluded(skuKey, event.target.checked)}
                                        size="small" sx={{ p: 0.25, color: "#a49acb", "&.Mui-checked": { color: "#5535c9" } }} />
                                      <Box sx={{ width: "1px", height: 35, bgcolor: "#d9d7eb", flexShrink: 0 }} />
                                      <Box sx={{ minWidth: 0, flex: 1 }}>
                                        <Typography variant="subtitle2" sx={{
                                          fontWeight: 800, fontSize: 15, letterSpacing: "-0.15px",
                                          color: "#182547", lineHeight: 1.4,
                                        }}>
                                          {skuEntry?.product_sku || "SKU"} — {skuEntry?.product || "Sales Order Product"}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: "#6c7897", display: "block", mt: 0.25, fontSize: 11.5 }}>
                                          {skuEntry?.garment || "No garment"} • {skuEntry?.priority || "Next Day"}
                                        </Typography>
                                      </Box>
                                      <Chip size="small"
                                        icon={included ? <CheckCircleIcon sx={{ fontSize: "16px !important" }} /> : undefined}
                                        label={included ? "Included" : "Excluded"}
                                        sx={{
                                          height: 27, fontSize: 11, fontWeight: 750,
                                          bgcolor: included ? "#dcf7e7" : "#eff0f4",
                                          color: included ? "#117741" : "#647084",
                                          borderRadius: 10, flexShrink: 0,
                                          "& .MuiChip-icon": { color: included ? "#12a05c" : "#647084", ml: 0.75 },
                                          "& .MuiChip-label": { pl: included ? 0.5 : 1.25, pr: 1.35 },
                                        }} />
                                    </Box>

                                    <Box sx={{
                                      px: { xs: 1.75, sm: 2.5 }, py: { xs: 2, sm: 2.75 },
                                      display: "grid",
                                      gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "minmax(0, 1.07fr) minmax(0, 1fr)" },
                                      columnGap: 3, rowGap: 3,
                                    }}>
                                      <Box sx={{ minWidth: 0 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.9, mb: 1.5 }}>
                                          <LayersOutlinedIcon sx={{ color: "#634ddd", fontSize: 18 }} />
                                          <Typography variant="overline" sx={{ fontWeight: 800, color: "#5c6196", fontSize: 11, lineHeight: "20px", letterSpacing: 0.9 }}>
                                            Assets
                                          </Typography>
                                        </Box>
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", gap: 1.75, alignItems: "start", width: "100%" }}>
                                          <QuickProofFileSlots
                                            sku={skuEntry}
                                            baseSku={baseSku}
                                            skuIndex={skuIndex}
                                            customerId={binatedCustomerId}
                                            orderId={orderId}
                                            instanceUniqueId={instanceUniqueId}
                                            disabled={isSubmittedRequestLocked || isSmartSendSubmittedDisplay}
                                            onOverride={updateSmartSendOverride}
                                            onClearOverride={clearSmartSendOverride}
                                          />
                                        </Box>
                                      </Box>

                                      <Box sx={{ minWidth: 0, borderLeft: { xs: "none", md: "1px solid #dedff0" }, pl: { xs: 0, md: 2.75 } }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.9, mb: 1.5 }}>
                                          <SettingsOutlinedIcon sx={{ color: "#634ddd", fontSize: 18 }} />
                                          <Typography variant="overline" sx={{ fontWeight: 800, color: "#5c6196", fontSize: 11, lineHeight: "20px", letterSpacing: 0.9 }}>
                                            Production details
                                          </Typography>
                                        </Box>
                                        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, minmax(0, 1fr))", columnGap: 1.25, rowGap: 2.25 }}>
                                          {[
                                            ["Category", skuEntry?.product_category || "—", LocalOfferOutlinedIcon],
                                            ["Decoration", decorations.map((decorationItem) => decorationItem?.decoration_type).filter(Boolean).join(", ") || "—", AutoAwesomeOutlinedIcon],
                                            ["Placement", (firstPlacement?.placement_name || "—") + (firstPlacement?.placement_code ? " (" + firstPlacement.placement_code + ")" : ""), LayersOutlinedIcon],
                                            ["Colors", colors || "—", PaletteOutlinedIcon],
                                            ["Dimensions", (String(firstPlacement?.width || "") + " × " + String(firstPlacement?.height || "") + " " + String(firstPlacement?.measurement_unit || "")).trim() || "—", AspectRatioOutlinedIcon],
                                            ["Process", firstPlacement?.process_type || "—", TuneOutlinedIcon],
                                            ["Output", firstPlacement?.output_file_format || "—", ImageOutlinedIcon],
                                            ["Artwork files", placementUrls.length, InsertDriveFileOutlinedIcon],
                                          ].map(([label, value, DetailIcon]) => (
                                            <Box key={label} sx={{ minWidth: 0, display: "flex", alignItems: "flex-start", gap: 0.75 }}>
                                              <DetailIcon sx={{ color: "#838eb4", fontSize: 18, mt: 0.125, flexShrink: 0 }} />
                                              <Box sx={{ minWidth: 0 }}>
                                                <Typography variant="caption" sx={{ color: "#707d9c", display: "block", fontSize: 10.5, fontWeight: 550, lineHeight: 1.3, mb: 0.25 }}>{label}</Typography>
                                                <Typography variant="body2" sx={{ color: "#1e2b4b", fontSize: 12.25, fontWeight: 600, overflowWrap: "anywhere", lineHeight: 1.5 }}>{value}</Typography>
                                              </Box>
                                            </Box>
                                          ))}
                                        </Box>
                                      </Box>
                                    </Box>

                                    <Box sx={{
                                      px: { xs: 1.75, sm: 2.5 }, py: 1.4,
                                      borderTop: "1px solid #ebe9f6",
                                      background: "linear-gradient(95deg, #f7f5ff 0%, #fbfaff 100%)",
                                      display: "flex", justifyContent: "space-between", alignItems: "center",
                                      gap: 1.25, flexWrap: "wrap",
                                    }}>
                                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.85, flexWrap: "wrap" }}>
                                        {decorations.map((decorationItem, decorationIndex) => (
                                          <Chip key={skuKey + "-decoration-" + decorationIndex} size="small"
                                            icon={<AutoAwesomeOutlinedIcon sx={{ fontSize: "15px !important" }} />}
                                            label={decorationItem?.decoration_type || "Decoration"}
                                            sx={{ height: 25, bgcolor: "#ede9ff", color: "#593cba", fontWeight: 650, fontSize: 10.5, "& .MuiChip-icon": { color: "#6445cf", ml: 0.65 } }} />
                                        ))}
                                        {(Array.isArray(firstPlacement?.colors) ? firstPlacement.colors : []).map((color) => (
                                          <Chip key={skuKey + "-color-" + color} size="small" variant="outlined"
                                            icon={<PaletteOutlinedIcon sx={{ fontSize: "15px !important" }} />}
                                            label={color}
                                            sx={{ height: 25, borderColor: "#dfdcf1", bgcolor: "#fff", color: "#3d4972", fontSize: 10.5, "& .MuiChip-icon": { color: "#7c7db3", ml: 0.65 } }} />
                                        ))}
                                        {firstPlacement?.output_file_format && (
                                          <Chip size="small" variant="outlined"
                                            icon={<InsertDriveFileOutlinedIcon sx={{ fontSize: "15px !important" }} />}
                                            label={firstPlacement.output_file_format}
                                            sx={{ height: 25, borderColor: "#dfdcf1", bgcolor: "#fff", color: "#3d4972", fontSize: 10.5, "& .MuiChip-icon": { color: "#7c7db3", ml: 0.65 } }} />
                                        )}
                                      </Box>
                                      <Box sx={{ display: "flex", gap: 0.5, alignItems: "center", borderLeft: placementUrls.length ? "1px solid #d9d3ee" : "none", pl: placementUrls.length ? 1.75 : 0 }}>
                                        {placementUrls.map((url, urlIndex) => (
                                          <Button key={skuKey + "-url-" + urlIndex} size="small" variant="text"
                                            startIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
                                            href={url} target="_blank" rel="noopener noreferrer"
                                            sx={{ color: "#5034bb", fontSize: 11.5, fontWeight: 750, textTransform: "none", whiteSpace: "nowrap", minWidth: 0, px: 0.6 }}>
                                            View artwork {urlIndex + 1}
                                          </Button>
                                        ))}
                                      </Box>
                                    </Box>
                                  </Box>
                                );
                              })}
                            </Stack>
                          )}

                          {smartSendView === "fields" && (
                            <Stack spacing={2}>
                              {smartSendDisplaySalesOrders.map((salesOrder, salesOrderIndex) => {
                                const purchaseOrder = (Array.isArray(salesOrder?.purchase_order) ? salesOrder.purchase_order : [])[0] || {};
                                const displaySkuEntries = Array.isArray(purchaseOrder?.sku) ? purchaseOrder.sku : smartSendDisplaySkuEntries;
                                return (
                                  <Box key={`${salesOrder?.so_id || "sales-order"}-${salesOrderIndex}`} sx={{ p: 2, border: "1px solid #e5e7eb", borderRadius: 1.5, background: "#fff" }}>
                                    <Stack spacing={1.5}>
                                      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Smart sales order send fields</Typography>
                                      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4,minmax(0,1fr))", gap: 1.5 }}>
                                        <SmartSendDraftTextField label="Sales Order ID" value={salesOrder?.so_id || ""} onDraftValue={(value) => updateSmartSendDraftOverride(["data", "sales_order", salesOrderIndex, "so_id"], value)} onCommit={(value) => updateSmartSendOverride(["data", "sales_order", salesOrderIndex, "so_id"], value)} size="small" />
                                        <SmartSendDraftTextField label="Project number" value={salesOrder?.project_number || ""} onDraftValue={(value) => updateSmartSendDraftOverride(["data", "sales_order", salesOrderIndex, "project_number"], value)} onCommit={(value) => updateSmartSendOverride(["data", "sales_order", salesOrderIndex, "project_number"], value)} size="small" />
                                        <SmartSendDraftTextField label="In-hands date" value={salesOrder?.so_inhands_date || ""} onDraftValue={(value) => updateSmartSendDraftOverride(["data", "sales_order", salesOrderIndex, "so_inhands_date"], value)} onCommit={(value) => updateSmartSendOverride(["data", "sales_order", salesOrderIndex, "so_inhands_date"], value)} size="small" />
                                        <FormControlLabel control={<Switch checked={!!smartSendDisplayPayload?.data?.is_proofing} onChange={(e) => updateSmartSendOverride(["data", "is_proofing"], e.target.checked)} />} label="Proofing" />
                                        <SmartSendDraftTextField label="PO ID" value={purchaseOrder?.po_id || ""} onDraftValue={(value) => updateSmartSendDraftOverride(["data", "sales_order", salesOrderIndex, "purchase_order", 0, "po_id"], value)} onCommit={(value) => updateSmartSendOverride(["data", "sales_order", salesOrderIndex, "purchase_order", 0, "po_id"], value)} size="small" />
                                        <SmartSendDraftTextField label="PO in-hands date" value={purchaseOrder?.po_inhands_date || ""} onDraftValue={(value) => updateSmartSendDraftOverride(["data", "sales_order", salesOrderIndex, "purchase_order", 0, "po_inhands_date"], value)} onCommit={(value) => updateSmartSendOverride(["data", "sales_order", salesOrderIndex, "purchase_order", 0, "po_inhands_date"], value)} size="small" />
                                      </Box>
                                      {displaySkuEntries.map((skuEntry, skuIndex) => {
                                        const baseSku = isSmartSendSubmittedDisplay ? skuEntry : (baseSmartSendSkuEntries[skuIndex] || skuEntry);
                                        const skuKey = getSmartSendSkuKey(baseSku);
                                        const included = isSmartSendSubmittedDisplay || smartSendSkuSelection[skuKey] !== false;
                                        const skuPath = ["data", "sales_order", salesOrderIndex, "purchase_order", 0, "sku", skuIndex];
                                        return (
                                          <Box key={`${skuKey}-fields`} sx={{ p: 1.5, border: "1px solid #edf2f7", borderRadius: 1, background: included ? "#fafafa" : "#f3f4f6", opacity: included ? 1 : 0.68 }}>
                                            <Stack spacing={1.25}>
                                              <FormControlLabel control={<Checkbox checked={included} onChange={(e) => setSmartSendSkuIncluded(skuKey, e.target.checked)} />} label={included ? "Include SKU" : "Excluded SKU"} />
                                              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(4,minmax(0,1fr))", gap: 1 }}>
                                                <SmartSendDraftTextField label="SKU" value={skuEntry?.product_sku || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...skuPath, "product_sku"], value)} onCommit={(value) => updateSmartSendOverride([...skuPath, "product_sku"], value)} size="small" />
                                                <SmartSendDraftTextField label="Product" value={skuEntry?.product || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...skuPath, "product"], value)} onCommit={(value) => updateSmartSendOverride([...skuPath, "product"], value)} size="small" />
                                                <SmartSendDraftTextField label="Product category" value={skuEntry?.product_category || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...skuPath, "product_category"], value)} onCommit={(value) => updateSmartSendOverride([...skuPath, "product_category"], value)} size="small" />
                                                <SmartSendDraftTextField label="Product URL" value={skuEntry?.product_url || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...skuPath, "product_url"], value)} onCommit={(value) => updateSmartSendOverride([...skuPath, "product_url"], value)} size="small" />
                                                <SmartSendDraftTextField label="Garment" value={skuEntry?.garment || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...skuPath, "garment"], value)} onCommit={(value) => updateSmartSendOverride([...skuPath, "garment"], value)} size="small" />
                                                <SmartSendDraftTextField label="Priority" value={skuEntry?.priority || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...skuPath, "priority"], value)} onCommit={(value) => updateSmartSendOverride([...skuPath, "priority"], value)} size="small" />
                                                {skuEntry?.priority === "Custom" && (
                                                  <SmartSendDraftTextField label="Due hours" value={skuEntry?.due_hours || ""} valueKind="number" onDraftValue={(value) => updateSmartSendDraftOverride([...skuPath, "due_hours"], value)} onCommit={(value) => updateSmartSendOverride([...skuPath, "due_hours"], value)} size="small" />
                                                )}
                                              </Box>
                                              {(Array.isArray(skuEntry?.decoration) ? skuEntry.decoration : []).map((decorationItem, decorationIndex) => {
                                                const decorationPath = [...skuPath, "decoration", decorationIndex];
                                                return (
                                                  <Box key={`${skuKey}-decoration-fields-${decorationIndex}`} sx={{ p: 1.25, border: "1px solid #e5e7eb", borderRadius: 1, background: "#fff" }}>
                                                    <Stack spacing={1}>
                                                      <SmartSendDraftTextField label="Decoration type" value={decorationItem?.decoration_type || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...decorationPath, "decoration_type"], value)} onCommit={(value) => updateSmartSendOverride([...decorationPath, "decoration_type"], value)} size="small" />
                                                      {(Array.isArray(decorationItem?.placements) ? decorationItem.placements : []).map((placement, placementIndex) => {
                                                        const placementPath = [...decorationPath, "placements", placementIndex];
                                                        return (
                                                          <Box key={`${skuKey}-placement-fields-${placementIndex}`} sx={{ display: "grid", gridTemplateColumns: "repeat(3,minmax(0,1fr))", gap: 1 }}>
                                                            <SmartSendDraftTextField label="Placement code" value={placement?.placement_code || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "placement_code"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "placement_code"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Placement name" value={placement?.placement_name || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "placement_name"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "placement_name"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Description" value={placement?.description || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "description"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "description"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Reference" value={placement?.reference || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "reference"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "reference"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Instructions" value={placement?.instructions || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "instructions"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "instructions"], value)} size="small" multiline minRows={2} />
                                                            <SmartSendDraftTextField label="Process type" value={placement?.process_type || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "process_type"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "process_type"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Height" type="number" value={placement?.height ?? ""} valueKind="number" emptyNumberValue={0} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "height"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "height"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Width" type="number" value={placement?.width ?? ""} valueKind="number" emptyNumberValue={0} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "width"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "width"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Measurement unit" value={placement?.measurement_unit || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "measurement_unit"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "measurement_unit"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Background color" value={placement?.background_color || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "background_color"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "background_color"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Colors" value={placement?.colors || []} valueKind="csv" onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "colors"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "colors"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Text" value={placement?.text || []} valueKind="csv" onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "text"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "text"], value)} size="small" />
                                                            <SmartSendDraftTextField label="Artwork/reference URL(s)" value={placement?.url || []} valueKind="csv" onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "url"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "url"], value)} size="small" multiline minRows={2} />
                                                            <SmartSendDraftTextField label="Output file format" value={placement?.output_file_format || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "output_file_format"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "output_file_format"], value)} size="small" />
                                                            <FormControlLabel control={<Switch checked={!!placement?.sewout_logo_recreation} onChange={(e) => updateSmartSendOverride([...placementPath, "sewout_logo_recreation"], e.target.checked)} />} label="Sewout/logo recreation" />
                                                            <FormControlLabel control={<Switch checked={!!placement?.change_request} onChange={(e) => updateSmartSendOverride([...placementPath, "change_request"], e.target.checked)} />} label="Change request" />
                                                            {placement?.change_request && (
                                                              <>
                                                                <SmartSendDraftTextField label="Change comments" value={placement?.change_comments || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "change_comments"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "change_comments"], value)} size="small" />
                                                                <SmartSendDraftTextField label="Previous order reference" value={placement?.previous_order_reference || ""} onDraftValue={(value) => updateSmartSendDraftOverride([...placementPath, "previous_order_reference"], value)} onCommit={(value) => updateSmartSendOverride([...placementPath, "previous_order_reference"], value)} size="small" />
                                                              </>
                                                            )}
                                                          </Box>
                                                        );
                                                      })}
                                                    </Stack>
                                                  </Box>
                                                );
                                              })}
                                            </Stack>
                                          </Box>
                                        );
                                      })}
                                    </Stack>
                                  </Box>
                                );
                              })}
                            </Stack>
                          )}
                        </Box>
                      ) : (
                        <>
                          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                            <FormControl fullWidth>
                              <InputLabel id="art-priority-label">Order Priority</InputLabel>
                              <Select
                                labelId="art-priority-label"
                                label="Order Priority"
                                value={currentMedia?.priority || "5 Days"}
                                onChange={(e) => {
                                  const priority = String(e.target.value);
                                  updateMediaField("priority", priority);
                                  updateMediaField("due_hours", PRIORITY_TO_HOURS[priority] || 24);
                                }}
                              >
                                {Object.keys(PRIORITY_TO_HOURS).map((priority) => (
                                  <MenuItem key={priority} value={priority}>{priority}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <TextField
                              key={`${artFieldKey}-sku`}
                              label="SKU"
                              defaultValue={currentMedia?.product_sku || ""}
                              onBlur={(e) => updateMediaField("product_sku", e.target.value)}
                            />
                          </Box>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={!!currentPlacement?.is_proofing}
                                onChange={(e) => updatePlacementField("is_proofing", e.target.checked)}
                              />
                            }
                            label="Is Proofing?"
                          />
                        </>
                      )}

                      {showManualRequestArtFields && (
                        <>
                          <Typography variant="subtitle2">Order Information</Typography>
                          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                            <FormControl size="small" sx={{ minWidth: 180 }}>
                              <InputLabel id="media-index-label">Media Item</InputLabel>
                              <Select
                                labelId="media-index-label"
                                label="Media Item"
                                value={String(selectedMediaIndex)}
                                onChange={(e) => {
                                  setSelectedMediaIndex(Number(e.target.value));
                                  setSelectedPlacementIndex(0);
                                }}
                              >
                                {(artForm?.media || []).map((_, idx) => (
                                  <MenuItem key={idx} value={String(idx)}>
                                    Media #{idx + 1}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <Button variant="outlined" onClick={addMediaItem} disabled={(artForm?.media || []).length >= 99}>
                              Add Media
                            </Button>
                            <Button variant="outlined" color="error" onClick={removeCurrentMediaItem} disabled={(artForm?.media || []).length <= 1}>
                              Remove Media
                            </Button>
                          </Box>
                          <Box sx={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 1 }}>
                            <FormControl fullWidth>
                              <InputLabel id="cart-import-label">Import from Cart</InputLabel>
                              <Select
                                labelId="cart-import-label"
                                label="Import from Cart"
                                value={selectedCartImportKey}
                                onChange={(e) => setSelectedCartImportKey(String(e.target.value))}
                              >
                                {cartItemOptions.map((item) => (
                                  <MenuItem key={item.key} value={item.key}>{item.label}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <Button variant="outlined" onClick={importCurrentMediaFromCart} disabled={!selectedCartImportKey}>
                              Import
                            </Button>
                          </Box>
                          {selectedCartImportPreview && (
                            <Box sx={{ p: 1.5, border: "1px solid #e5e7eb", borderRadius: 1, background: "#fafafa", display: "flex", gap: 1.5 }}>
                              {selectedCartImportPreview.image ? (
                                <Box
                                  component="img"
                                  src={selectedCartImportPreview.image}
                                  alt="Cart import preview"
                                  sx={{ width: 56, height: 56, objectFit: "cover", borderRadius: 1, border: "1px solid #ddd" }}
                                />
                              ) : null}
                              <Box>
                              <Typography variant="caption" sx={{ display: "block" }}><b>SKU:</b> {selectedCartImportPreview.sku}</Typography>
                              <Typography variant="caption" sx={{ display: "block" }}><b>Product:</b> {selectedCartImportPreview.product}</Typography>
                              <Typography variant="caption" sx={{ display: "block" }}><b>Design Colors:</b> {selectedCartImportPreview.colors}</Typography>
                              <Typography variant="caption" sx={{ display: "block" }}><b>Logo Size:</b> {selectedCartImportPreview.logoSize}</Typography>
                              </Box>
                            </Box>
                          )}

                          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                            <TextField
                              label={isEstimateRoute ? "Estimate" : "Sales Order"}
                              value={String(tabId || "")}
                              InputProps={{ readOnly: true }}
                              fullWidth
                            />
                          </Box>

                          <Typography variant="body2" sx={{ fontWeight: 600 }}>Art Type</Typography>
                          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                            {ART_TYPE_OPTIONS.map((type) => {
                              const selected = currentDecoration?.decoration === type;
                              return (
                                <Button
                                  key={type}
                                  size="small"
                                  variant={selected ? "contained" : "outlined"}
                                  onClick={() => {
                                    updateDecorationField("decoration", type);
                                    updatePlacementField("process_type", ART_TYPE_TO_PROCESS[type] || "VECTOR");
                                    updatePlacementField("art_type", type);
                                  }}
                                >
                                  <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                                    {ART_TYPE_ICONS[type] || <AutoAwesomeIcon fontSize="small" />}
                                  </Box>
                                  {type}
                                </Button>
                              );
                            })}
                          </Box>

                          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                            <TextField
                              key={`${artFieldKey}-reference`}
                              label="Reference ID"
                              value={displayBinatedReference}
                              InputProps={{ readOnly: true }}
                              helperText="Binated receives this as {instance-slug}-{project-id}={sales-order-id}."
                            />
                            <TextField
                              key={`${artFieldKey}-description`}
                              label="Description"
                              defaultValue={currentMedia?.description || ""}
                              onBlur={(e) => updateMediaField("description", e.target.value)}
                            />
                            <TextField
                              key={`${artFieldKey}-product-name`}
                              label="Product Name"
                              defaultValue={currentMedia?.product_name || currentMedia?.product || ""}
                              onBlur={(e) => updateMediaField("product_name", e.target.value)}
                            />
                            <TextField
                              key={`${artFieldKey}-product-material`}
                              label="Product Material"
                              defaultValue={currentMedia?.garment || ""}
                              onBlur={(e) => updateMediaField("garment", e.target.value)}
                            />
                          </Box>

                          <TextField
                            key={`${artFieldKey}-instructions`}
                            label="Instructions"
                            multiline
                            minRows={3}
                            fullWidth
                            value={instructionDrafts[artFieldKey] ?? (currentMedia?.instructions || "")}
                            onChange={(e) => setInstructionDrafts((prev) => ({ ...prev, [artFieldKey]: e.target.value }))}
                            onBlur={(e) => {
                              const value = e.target.value;
                              updateMediaField("instructions", value);
                              setInstructionDrafts((prev) => ({ ...prev, [artFieldKey]: value }));
                            }}
                          />
                          <Box sx={{ mt: 1, mb: 1 }}>
                            <Button
                              size="small"
                              variant="outlined"
                              onClick={() => {
                                const previewId = tabId || currentSO?.estimationId || currentSO?.id;
                                if (!previewId) return;
                                const docPath = getDocPreviewPath(soStatusCode, previewId);
                                const fullLink = `${window.location.origin}${docPath}`;
                                const existing = instructionDrafts[artFieldKey] ?? (currentMedia?.instructions || "");
                                const appended = existing ? `${existing}\n${fullLink}` : fullLink;
                                setInstructionDrafts((prev) => ({ ...prev, [artFieldKey]: appended }));
                                updateMediaField("instructions", appended);
                              }}
                            >
                              Insert Sales Order Link
                            </Button>
                          </Box>
                          <FormControlLabel
                            control={<Switch checked={isChangeRequest} disabled />}
                            label="Change Request (initial requests are read-only and always off)"
                          />
                        </>
                      )}

                      {showManualRequestArtFields && (
                        <>
                          <Typography variant="subtitle2">Placements</Typography>
                          <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                            <FormControl size="small" sx={{ minWidth: 180 }}>
                              <InputLabel id="placement-index-label">Placement</InputLabel>
                              <Select
                                labelId="placement-index-label"
                                label="Placement"
                                value={String(selectedPlacementIndex)}
                                onChange={(e) => setSelectedPlacementIndex(Number(e.target.value))}
                              >
                                {currentPlacements.map((placement, idx) => (
                                  <MenuItem key={idx} value={String(idx)}>
                                    {placement?.placement_name
                                      ? `${idx + 1}. ${placement.placement_name}`
                                      : `Placement #${idx + 1}`}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <Button variant="outlined" onClick={addPlacementItem} disabled={currentPlacements.length >= 25}>
                              Add Placement
                            </Button>
                            <Button
                              variant="outlined"
                              color="error"
                              onClick={removeCurrentPlacementItem}
                              disabled={currentPlacements.length <= 1}
                            >
                              Remove Placement
                            </Button>
                          </Box>
                        </>
                      )}

                      {showManualRequestArtFields && (
                        <>
                          <Typography variant="subtitle2">Additional Information</Typography>
                          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                            <TextField
                              key={`${artFieldKey}-colors`}
                              label="Design Colors (comma separated)"
                              defaultValue={(currentPlacement?.colors || []).join(", ")}
                              onBlur={(e) => updatePlacementField("colors", splitCsv(e.target.value))}
                            />
                            <TextField
                              key={`${artFieldKey}-background-color`}
                              label="Background Color"
                              defaultValue={currentPlacement?.background_color || ""}
                              onBlur={(e) => updatePlacementField("background_color", e.target.value)}
                            />
                            <TextField
                              key={`${artFieldKey}-product-color`}
                              label="Product Color"
                              defaultValue={currentPlacement?.product_color || ""}
                              onBlur={(e) => updatePlacementField("product_color", e.target.value)}
                            />
                            <TextField
                              key={`${artFieldKey}-text`}
                              label="Text (comma separated)"
                              defaultValue={(currentPlacement?.text || []).join(", ")}
                              onBlur={(e) => updatePlacementField("text", splitCsv(e.target.value))}
                            />
                            <TextField
                              label="Height"
                              type="number"
                              value={currentPlacement?.height ?? 100}
                              onChange={(e) => updatePlacementField("height", Number(e.target.value || 0))}
                            />
                            <TextField
                              label="Width"
                              type="number"
                              value={currentPlacement?.width ?? 100}
                              onChange={(e) => updatePlacementField("width", Number(e.target.value || 0))}
                            />
                            <TextField
                              key={`${artFieldKey}-placement-name`}
                              label="Placement"
                              defaultValue={currentPlacement?.placement_name || PLACEMENT_OPTIONS[0].name}
                              onBlur={(e) => {
                                const name = String(e.target.value || "").trim();
                                updatePlacementField("placement_name", name);
                                updatePlacementField("placement_code", placementCodeFromName(name));
                              }}
                              helperText="Free text; code auto-generated as slug."
                            />
                            <TextField
                              key={`${artFieldKey}-placement-code`}
                              label="Placement Code"
                              defaultValue={currentPlacement?.placement_code || placementCodeFromName(currentPlacement?.placement_name || "")}
                              onBlur={(e) => updatePlacementField("placement_code", placementCodeFromName(e.target.value))}
                            />
                            <TextField
                              key={`${artFieldKey}-measurement-unit`}
                              label="Measurement Unit"
                              defaultValue={currentPlacement?.measurement_unit || "px"}
                              onBlur={(e) => updatePlacementField("measurement_unit", e.target.value)}
                            />
                          </Box>
                        </>
                      )}

                      {showManualRequestArtFields && (
                        <>
                          <Typography variant="subtitle2">Files and File Formats</Typography>
                          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2,minmax(0,1fr))", gap: 2 }}>
                            <TextField
                              key={`${artFieldKey}-output-format`}
                              label="Output File Format(s)"
                              defaultValue={currentPlacement?.output_file_format || "png"}
                              onBlur={(e) => updatePlacementField("output_file_format", normalizeOutputFormat(e.target.value))}
                            />
                            <FormControl fullWidth>
                              <InputLabel id="sewout-label">Sewout/Logo Recreation</InputLabel>
                              <Select
                                labelId="sewout-label"
                                label="Sewout/Logo Recreation"
                                value={String(currentPlacement?.sewout_logo_recreation || "No")}
                                onChange={(e) => updatePlacementField("sewout_logo_recreation", String(e.target.value))}
                              >
                                <MenuItem value="No">No</MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>
                              </Select>
                            </FormControl>
                            <TextField
                              key={`${artFieldKey}-file-urls`}
                              label="File URL(s) (comma separated)"
                              value={Array.isArray(currentPlacement?.url) ? currentPlacement.url.join(", ") : String(currentPlacement?.url || "")}
                              onChange={(e) => updatePlacementField("url", splitCsv(e.target.value))}
                              helperText="Required. Add one or more image URLs separated by commas."
                            />
                          </Box>
                        </>
                      )}
                      {showManualRequestArtFields && isChangeRequest && (
                        <TextField
                          key={`${artFieldKey}-reference-decoration-id`}
                          label="Reference Decoration ID"
                          defaultValue={currentPlacement?.reference_decoration_id || ""}
                          onBlur={(e) => updatePlacementField("reference_decoration_id", e.target.value)}
                          helperText="Required only for change requests."
                        />
                      )}
                    </Box>
                  )}

                  {binatedArtView === "payload" && (
                    <TextField
                      label="Generated Payload"
                      multiline
                      minRows={18}
                      fullWidth
                      value={payloadPreviewText}
                      InputProps={{ readOnly: true }}
                    />
                  )}
                </Box>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setRequestArtOpen(false)} disabled={requestArtLoading}>Cancel</Button>
              {showDesignRepNotifyFooterAction ? (
                <Button variant="contained" onClick={submitDesignRepRequest} disabled={requestArtLoading}>
                  {requestArtLoading ? "Sending..." : "Send Request"}
                </Button>
              ) : requestArtTab === "binated" ? (
                proofFulfillmentProvider === "binated" && isSubmittedRequestLocked ? (
                  <Button
                    variant="contained"
                    onClick={openCurrentBinatedOrderDialog}
                    disabled={currentBinatedOrderLoading}
                  >
                    {currentBinatedOrderLoading ? "Loading..." : "View current order"}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    onClick={submitBinatedArtRequest}
                    disabled={sendProofRequestDisabled}
                    title={isBinatedFulfillment && sendToBinatedDisabledReason ? sendToBinatedDisabledReason : undefined}
                  >
                    {(requestArtLoading || (isBinatedFulfillment && binatedLifecycle.submitting))
                      ? "Sending..."
                      : resolvedProofWorkProvider === "internal"
                        ? "Create Internal Request"
                        : isDirectTalentAssignment
                          ? "Create Design Request + Assignment"
                          : isCoreNetworkMarketplaceRequest
                            ? "Post to Marketplace"
                            : resolvedProofWorkProvider === "core-network"
                              ? "Create Design Request"
                          : "Send to Binated"}
                  </Button>
                )
              ) : null}
            </DialogActions>
          </Dialog>

          <Dialog
            open={currentBinatedOrderOpen}
            onClose={() => !currentBinatedOrderDeleting && setCurrentBinatedOrderOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>Current Binated Order</DialogTitle>
            <DialogContent dividers>
              {currentBinatedOrderData?.providerLookup?.success === false && (
                <Typography variant="body2" sx={{ mb: 1, color: "#b45309" }}>
                  {currentBinatedOrderData?.providerLookup?.message || "Provider order could not be loaded."}
                </Typography>
              )}
              <Typography variant="subtitle2" sx={{ mb: 1 }}>Local Elite Core Snapshot</Typography>
              <TextField
                multiline
                minRows={8}
                fullWidth
                value={JSON.stringify(currentBinatedOrderData?.localLifecycle || {}, null, 2)}
                InputProps={{ readOnly: true }}
              />
              <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>Live Provider Response</Typography>
              <TextField
                multiline
                minRows={12}
                fullWidth
                value={JSON.stringify(currentBinatedOrderData?.providerOrder || {}, null, 2)}
                InputProps={{ readOnly: true }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setCurrentBinatedOrderOpen(false)} disabled={currentBinatedOrderDeleting}>Close</Button>
              <Button
                color="error"
                variant="outlined"
                onClick={deleteCurrentBinatedOrder}
                disabled
                title="Delete order is temporarily read-only."
              >
                Delete order (read-only)
              </Button>
            </DialogActions>
          </Dialog>

          <BinatedLifecycleRevisionModal
            open={binatedLifecycle.revisionModalOpen}
            file={binatedLifecycle.revisionTargetFile}
            note={binatedLifecycle.revisionNote}
            context={binatedLifecycle.revisionContext}
            contextLoading={binatedLifecycle.revisionContextLoading}
            onNoteChange={binatedLifecycle.setRevisionNote}
            onClose={binatedLifecycle.closeRevisionModal}
            onSubmit={submitLifecycleRevision}
            submitting={binatedLifecycle.revisionSubmitting}
          />
      

<Drawer
  anchor="right"
  open={cartHistoryOpen}
  onClose={() => setCartHistoryOpen(false)}
  PaperProps={{ sx: { width: { xs: "100%", sm: 460 } } }}
>
  <Box sx={{ p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
    <Typography variant="h6">Project cart history</Typography>
    <IconButton onClick={() => setCartHistoryOpen(false)} size="large">✕</IconButton>
  </Box>
  <Box sx={{ p: 2 }}>
    <Typography variant="body2" sx={{ fontWeight: 700, mb: 1 }}>Cart View</Typography>
    <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
      <InputLabel id="cart-view-source-label">Source</InputLabel>
      <Select
        labelId="cart-view-source-label"
        label="Source"
        value={cartViewSelectValue}
        disabled={isInvoiceEditRoute}
        onChange={async (e) => {
          if (isInvoiceEditRoute) {
            setCartView('invoicing-cart');
            return;
          }
          await handleCartViewChange(e);
        }}
        displayEmpty
      >
        {effectiveCartView === "invoicing-cart" && (!selectedInvoicingCartKey || !selectedInvoicingCartIsSelectable) && (
          <MenuItem value="" disabled>Select an invoicing cart</MenuItem>
        )}
        {!isInvoiceRoute && (
          <>
            <MenuItem value="order-cart">Order Cart</MenuItem>
            <MenuItem value="sales-order-cart" disabled={!canOpenSalesOrderCart}>Sales Order Cart</MenuItem>
          </>
        )}
        {isInvoiceRoute && (
          <>
            <MenuItem disabled>Invoice-owned carts</MenuItem>
            {selectableInvoicingCarts.length === 0 ? (
              <MenuItem disabled>No invoice-owned carts yet</MenuItem>
            ) : selectableInvoicingCarts.map((cart) => (
              <MenuItem
                key={cart.invoicingCartKey}
                value={`invoicing-cart:${cart.invoicingCartKey}`}
              >
                {formatInvoicingCartOptionLabel(cart)}
              </MenuItem>
            ))}
          </>
        )}
      </Select>
    </FormControl>

    {effectiveCartView === "invoicing-cart" && (
      <Box sx={{ mb: 1.5, p: 1.5, borderRadius: 1.5, background: "#eef2ff", border: "1px solid #c7d2fe" }}>
        <Typography sx={{ fontWeight: 700 }}>Invoicing Cart</Typography>
        <Typography variant="body2">Used for invoice generation only; approved SO unchanged.</Typography>
        {isInvoiceEditRoute && (
          <Typography variant="caption" sx={{ display: "block", fontWeight: 700, mt: 0.5 }}>
            Active invoicing cart: {selectedInvoicingCartKey || "—"}
            {selectedInvoicingCartSummary?.revisionNumber ? ` · Revision ${selectedInvoicingCartSummary.revisionNumber}` : ""}
            {selectedInvoicingCartSummary?.itemCount != null ? ` · ${selectedInvoicingCartSummary.itemCount} item${Number(selectedInvoicingCartSummary.itemCount) === 1 ? "" : "s"}` : ""}
            {selectedInvoicingCartSummary?.lifecycleStatus ? ` · ${selectedInvoicingCartSummary.lifecycleStatus}` : ""}
          </Typography>
        )}
        {isInvoiceEditRoute && selectedInvoicingCartSummary?.linkedInvoiceId && (
          <Typography variant="caption" sx={{ display: "block" }}>Linked invoice: {selectedInvoicingCartSummary.linkedInvoiceNumber || selectedInvoicingCartSummary.linkedInvoiceId}</Typography>
        )}
        {isInvoiceEditRoute && (selectedInvoicingCartSummary?.sourceSalesOrderDocumentId || selectedInvoicingCartSummary?.sourceSalesOrderId || selectedInvoicingCartSummary?.sourceSalesOrderSnapshotId) && (
          <Typography variant="caption" sx={{ display: "block" }}>
            Source SO: {selectedInvoicingCartSummary.sourceSalesOrderDocumentId || selectedInvoicingCartSummary.sourceSalesOrderId || "—"}
            {selectedInvoicingCartSummary.sourceSalesOrderSnapshotId ? ` · Snapshot: ${selectedInvoicingCartSummary.sourceSalesOrderSnapshotId}` : ""}
          </Typography>
        )}
        {invoicingCartState?.data?.source?.salesOrderRevisionNumber && (
          <Typography variant="caption" sx={{ display: "block" }}>Source Sales Order Revision {invoicingCartState.data.source.salesOrderRevisionNumber}</Typography>
        )}
        {invoicingCartState.loading && <Typography variant="caption" sx={{ display: "block" }}>Loading Invoicing Cart…</Typography>}
        {invoicingCartState.error && <Typography variant="caption" sx={{ display: "block", color: "#b91c1c" }}>{invoicingCartState.error}</Typography>}
        {invoicingCartState.missing && !invoicingCartState.loading && <Typography variant="caption" sx={{ display: "block" }}>No Invoicing Cart exists yet.</Typography>}
      </Box>
    )}

    {cartView === "sales-order-cart" && (
      <Box sx={{ mb: 1.5, p: 1.5, borderRadius: 1.5, background: "#f8fafc", border: "1px solid #cbd5e1" }}>
        <Typography sx={{ fontWeight: 700 }}>Sales Order Cart</Typography>
        <Typography variant="body2">Frozen approved Sales Order snapshot (read-only).</Typography>
      </Box>
    )}
  </Box>
  <Divider />
  <Divider />
  <Tabs
    value={cartHistoryTab}
    onChange={(_, val) => setCartHistoryTab(val)}
    sx={{ px: 2, pt: 1 }}
  >
    <Tab value="activity" label="Activity" />
    <Tab value="snapshots" label="Snapshots" />
  </Tabs>
  <Box sx={{ p: 2 }}>
    {cartHistoryLoading ? (
      <Typography variant="body2" sx={{ opacity: 0.7 }}>Loading…</Typography>
    ) : cartHistoryTab === "activity" ? (
      <List dense>
        {cartActivity.length === 0 ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>No cart activity yet.</Typography>
        ) : cartActivity.map((h, idx) => (
          <React.Fragment key={`${h?.timestamp || idx}-${idx}`}>
            <ListItemButton disabled>
              <ListItemText
                primary={h?.message || h?.action || "Cart update"}
                secondary={h?.timestamp ? new Date(h.timestamp).toLocaleString() : "—"}
              />
            </ListItemButton>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    ) : (
      <List dense>
        {cartSnapshots.length === 0 ? (
          <Typography variant="body2" sx={{ opacity: 0.7 }}>No snapshots yet.</Typography>
        ) : cartSnapshots.map((s) => (
          <React.Fragment key={`${s?.estimationId}-${s?.cartSnapshotId}`}>
            <ListItemButton disabled>
              <ListItemText
                primary={`Rev ${s?.revisionNumber || "?"} • Snapshot ${s?.cartSnapshotId || "—"}`}
                secondary={`${s?.lifecycleStatus || "Active"} • ${s?.cartSnapshotCreatedAt ? new Date(s.cartSnapshotCreatedAt).toLocaleString() : "—"}${s?.itemCount != null ? ` • ${s.itemCount} item(s)` : ""}`}
              />
            </ListItemButton>
            <Divider />
          </React.Fragment>
        ))}
      </List>
    )}
  </Box>
</Drawer>

<Dialog
  open={emailComposerOpen}
  onClose={() => setEmailComposerOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>Send document via email</DialogTitle>
  <DialogContent dividers>
    <EmailComposer
      contacts={emailContacts}
      templates={emailTemplates}
      value={emailValue}
      onChange={setEmailValue}
      attachments={emailAttachments}
      onAttachmentsChange={setEmailAttachments}
      quickActionRecipients={{
        me: composerSelfContactWithAvatar ? [composerSelfContactWithAvatar] : [],
        orderReps: orderRepContacts,
        clientReps: clientRepContacts,
      }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setEmailComposerOpen(false)}>Cancel</Button>
    <Button variant="contained" onClick={handleSendEstimateEmail} disabled={emailSending}>
      {emailSending ? "Sending…" : "Send Email"}
    </Button>
  </DialogActions>
</Dialog>

<Dialog
  open={presentationEmailOpen}
  onClose={() => setPresentationEmailOpen(false)}
  maxWidth="md"
  fullWidth
>
  <DialogTitle>{presentationEmailHistory.some((entry) => entry.id === String(presentationEmailTarget?.id ?? presentationEmailTarget?.presentationId)) ? 'Resend Presentation' : 'Send Presentation'}</DialogTitle>
  <DialogContent dividers>
    <EmailComposer
      contacts={emailContacts}
      templates={emailTemplates}
      value={presentationEmailValue}
      onChange={setPresentationEmailValue}
      docId={presentationEmailTarget?.id ?? presentationEmailTarget?.presentationId ?? ''}
      fromName={[currentUser?.first_name || currentUser?.firstName, currentUser?.last_name || currentUser?.lastName].filter(Boolean).join(' ') || currentUser?.name || authState?.name || currentUser?.email || authState?.email || 'Elite Core'}
      fromEmail={currentUser?.email || authState?.email || ''}
      previewBodyHtml={(() => {
        const presentationId = presentationEmailTarget?.id ?? presentationEmailTarget?.presentationId;
        const url = presentationId ? `${window.location.origin}/instance/${instanceUniqueId}/presentations/${presentationId}` : '';
        const body = presentationEmailValue.body || '';
        return url && !body.includes(url)
          ? `${body}<p><a href="${url}">View Presentation</a></p>`
          : body;
      })()}
      attachments={emailAttachments}
      onAttachmentsChange={setEmailAttachments}
      quickActionRecipients={{
        me: composerSelfContactWithAvatar ? [composerSelfContactWithAvatar] : [],
        orderReps: orderRepContacts,
        clientReps: clientRepContacts,
      }}
    />
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setPresentationEmailOpen(false)}>Cancel</Button>
    <Button variant="contained" onClick={handleSendPresentationEmail} disabled={presentationEmailSending}>
      {presentationEmailSending ? "Sending…" : "Send Email"}
    </Button>
  </DialogActions>
</Dialog>


<Dialog
  open={invoiceComposerOpen}
  onClose={closeSalesOrderInvoiceComposer}
  maxWidth="md"
  fullWidth
  aria-labelledby="so-create-invoice-dialog-title"
  PaperProps={{
    sx: {
      borderRadius: { xs: 2, sm: 3 },
      maxHeight: 'calc(100dvh - 40px)',
      boxShadow: '0 24px 70px rgba(15, 23, 42, 0.18)',
    },
  }}
>
  <DialogTitle sx={{
    px: { xs: 2, sm: 3 }, py: 2,
    display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2,
  }}>
    <Typography id="so-create-invoice-dialog-title" component="span" sx={{
      fontSize: { xs: 21, sm: 24 }, fontWeight: 800, letterSpacing: -0.5,
    }}>
      Create Invoice
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center">
      {isAdministrator && salesOrderResetAccessAllowed &&
          salesOrderInvoiceHistorySummary.canSeeResetCandidate ? (
        <Tooltip title="Undo only the newest eligible non-deposit invoice; paid/exported invoices are protected" arrow>
          <span>
            <Button
              data-testid="sales-order-reset-invoiced-action"
              variant="outlined"
              color="warning"
              size="small"
              startIcon={<RestartAltIcon sx={{ fontSize: 16 }} />}
              onClick={handleOpenSalesOrderReset}
              disabled={invoiceEmailSending || invoiceComposerPreparing || salesOrderResetSubmitting}
              sx={{ textTransform: 'none', borderRadius: 2, fontWeight: 700, whiteSpace: 'nowrap' }}
            >
              Reset Invoiced
            </Button>
          </span>
        </Tooltip>
      ) : null}
      <IconButton
        aria-label="Close Create Invoice"
        size="small"
        disabled={invoiceEmailSending}
        onClick={closeSalesOrderInvoiceComposer}
        sx={{ color: 'text.secondary' }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Stack>
  </DialogTitle>
  <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, py: 2.5 }}>
    {invoiceComposerPreparing ? (
      <Box
        role="status"
        aria-live="polite"
        data-testid="sales-order-create-invoice-loading"
        sx={{
          minHeight: { xs: 310, sm: 390 },
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', textAlign: 'center', gap: 1.75, px: 2,
        }}
      >
        <CircularProgress size={58} thickness={4.1} sx={{ color: '#D71920' }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 800, mt: 1.25 }}>
          Preparing invoice details
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 370, lineHeight: 1.6 }}>
          Checking the Sales Order, billing and shipping details, and project team…
        </Typography>
      </Box>
    ) : null}
    {/* Mount the optional read-only preview while hiding layout changes behind
        the one-time spinner. This does not create an Invoicing Cart. */}
    <Box sx={{ display: invoiceComposerPreparing ? 'none' : 'block' }}>
      <SalesOrderExistingInvoices
        invoices={salesOrderInvoiceHistoryReview.invoices}
        instanceUniqueId={instanceUniqueId}
        salesOrderId={invoiceCreationSalesOrderId}
        depositInvoiceId={invoiceCreationSourceSO?.depositInvoiceId || null}
        currency={String(currentSO?.currency || order?.currency || 'CAD').toUpperCase()}
        balanceStatus={salesOrderInvoiceHistoryReview.balanceStatus}
        historyError={salesOrderInvoiceHistoryReview.historyError}
        balanceError={salesOrderInvoiceHistoryReview.balanceError}
        onViewInvoices={() => {
          closeSalesOrderInvoiceComposer();
          history.push(`/instance/${instanceUniqueId}/sales/orders/${orderId}/invoice`);
        }}
        onOpenInvoice={(id) => window.open(
          `${process.env.REACT_APP_NODEJS_CLI_URL}/generated-invoice/${id}`,
          '_blank', 'noopener,noreferrer'
        )}
      />
      <SalesOrderInvoiceEmailHistory
        events={invoiceEmailSendHistory.events}
        loading={invoiceEmailSendHistory.loading}
        error={invoiceEmailSendHistory.error}
        showWhenEmpty={salesOrderInvoiceHistorySummary.activeCount > 0 ||
          salesOrderInvoiceHistorySummary.inactiveCount > 0}
        onRefresh={() => setInvoiceEmailSendHistoryRefresh((value) => value + 1)}
        onOpenInvoice={(invoiceId) => window.open(
          `${process.env.REACT_APP_NODEJS_CLI_URL}/generated-invoice/${invoiceId}`,
          '_blank', 'noopener,noreferrer'
        )}
      />
      {salesOrderInvoiceHistorySummary.activeCount === 0 ? (
        <Alert severity="info" variant="outlined" sx={{ borderRadius: 2, mb: 1.25 }}>
          New invoices use the approved Sales Order
          {invoiceCreationSalesOrderId ? ` #${invoiceCreationSalesOrderId}` : ''}.
          You can review the new invoice before emailing it; existing carts stay unchanged.
        </Alert>
      ) : null}
      {(() => {
        const diff = invoiceDiffState?.data?.diff;
        const hasChanges = Boolean(diff && (
          (diff.quantityChanges || []).length ||
          (diff.addedItems || []).length ||
          (diff.removedItems || []).length ||
          Number(diff.otherServices?.delta || 0) !== 0
        ));
        return hasChanges ? (
          <Alert severity="warning" variant="outlined" sx={{ mb: 2, borderRadius: 2 }}>
            An existing invoicing cart differs from the approved Sales Order.
            This new invoice will use the approved Sales Order; those existing cart changes are not included.
          </Alert>
        ) : null;
      })()}
      <SalesOrderInvoiceAddressPrecheck
        precheck={invoiceAddressPrecheck}
        loading={invoiceAddressPrecheckLoading}
        error={invoiceAddressPrecheckError}
        sending={invoiceAddressReminderSending}
        sent={invoiceAddressReminderSent}
        disabled={invoiceEmailSending}
        sendInvoiceEmailNow={sendInvoiceEmailNow}
        onNotify={handleNotifySalesOrderInvoiceAddressReps}
        onRefresh={() => setInvoiceAddressPrecheckRefresh((value) => value + 1)}
      />

      {canOfferManualAdditionalInvoice ? (
        <Box sx={{ mt: 1.5 }} data-testid="so-manual-additional-invoice">
          {!manualAdditionalInvoice ? (
            <Button
              variant="outlined" size="small" color="warning"
              onClick={() => {
                setManualAdditionalInvoice(true);
                setManualAdditionalReason('');
                setConfirmAdditionalInvoice(false);
                setInvoiceCreateAmount('');
                setPreparedInvoiceReview(null);
                setSendInvoiceEmailNow(false);
                setQueueInvoiceForQuickBooks(false);
              }}
              sx={{ textTransform: 'none', borderRadius: 2, fontWeight: 750 }}
            >
              Create additional invoice manually
            </Button>
          ) : (
            <Box sx={{ p: 1.5, border: '1px solid', borderColor: 'warning.light', borderRadius: 2 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>Additional manual invoice</Typography>
                <Button size="small" color="inherit" onClick={() => {
                  setManualAdditionalInvoice(false);
                  setManualAdditionalReason('');
                  setConfirmAdditionalInvoice(false);
                  setInvoiceCreateAmount('');
                  setPreparedInvoiceReview(null);
                }} sx={{ textTransform: 'none' }}>Cancel override</Button>
              </Stack>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.7, lineHeight: 1.5 }}>
                This Sales Order is already covered. An extra manual invoice will start with
                the approved Sales Order lines; update its cart to reflect the additional charge
                before sharing it. Creation will not email anyone, queue QuickBooks, or launch Stripe.
              </Typography>
              <TextField
                size="small" fullWidth multiline minRows={2}
                label="Reason for additional invoice"
                placeholder="Explain the additional customer charge"
                value={manualAdditionalReason}
                onChange={(event) => { setManualAdditionalReason(event.target.value); setPreparedInvoiceReview(null); }}
                inputProps={{ maxLength: 500 }}
                helperText="Required for the invoice audit history (12–500 characters)."
                sx={{ mt: 1.5 }}
              />
              <FormControlLabel
                sx={{ mt: 1 }}
                control={<Checkbox checked={confirmAdditionalInvoice}
                  onChange={(event) => { setConfirmAdditionalInvoice(event.target.checked); setPreparedInvoiceReview(null); }} />}
                label="I understand this creates an additional invoice beyond the approved Sales Order amount."
              />
            </Box>
          )}
        </Box>
      ) : null}

      {visibleCreateInvoiceModeOptions.length > 1 && !manualAdditionalInvoice &&
         Number(invoiceSuggestedAmount) > 0 ? (
        <Box sx={{ mt: 2.5 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1 }}>
            Invoice creation method
          </Typography>
          <RadioGroup
            value={visibleCreateInvoiceModeOptions.some((option) => option.id === invoiceCreateMode)
              ? invoiceCreateMode : visibleCreateInvoiceModeOptions[0]?.id || ''}
            onChange={(e) => {
              setPreparedInvoiceReview(null);
              setInvoiceCreateMode(e.target.value);
            }}
            sx={{ gap: 1 }}
          >
            {visibleCreateInvoiceModeOptions.map((option) => (
              <Box key={option.id} sx={{
                borderRadius: 2,
                border: invoiceCreateMode === option.id ? '1px solid #A9C9B7' : '1px solid #DEE5ED',
                bgcolor: invoiceCreateMode === option.id ? '#F7FCF9' : 'background.paper',
                px: 1.5, py: 0.9,
              }}>
                <FormControlLabel
                  value={option.id}
                  control={<Radio color="success" disabled={invoiceEmailSending} />}
                  sx={{ width: '100%', m: 0, alignItems: 'center' }}
                  label={(
                    <Box sx={{ py: 0.35 }}>
                      <Typography sx={{ fontSize: 13.5, fontWeight: 750 }}>{option.title}</Typography>
                      <Typography variant="caption" color="text.secondary">{option.description}</Typography>
                    </Box>
                  )}
                />
              </Box>
            ))}
          </RadioGroup>
        </Box>
      ) : null}

      {!invoiceCreateAmount && salesOrderInvoiceHistorySummary.activeCount === 0 ? (
        <Alert severity="info" sx={{ mt: 2, borderRadius: 2 }} data-testid="so-invoice-covered-balance">
          No additional uninvoiced balance was found. Check the approved Sales Order and invoice history before creating another invoice.
        </Alert>
      ) : null}

      {(Number(invoiceSuggestedAmount) > 0 || manualAdditionalInvoice) ? (
      <Box sx={{ mt: 1.5 }}>
        <Typography variant="subtitle2" component="label" htmlFor="so-create-invoice-amount" sx={{
          display: 'block', fontWeight: 750, mb: 0.9,
        }}>
          {manualAdditionalInvoice ? 'Additional invoice amount' : 'Invoice amount'}
        </Typography>
        <TextField
          id="so-create-invoice-amount"
          fullWidth
          size="medium"
          type="number"
          value={invoiceCreateAmount}
          onChange={(event) => {
            setInvoiceCreateAmount(event.target.value);
            // A token belongs to one exact amount. Never submit a prepared
            // review for an earlier value after Finance edits the field.
            setPreparedInvoiceReview(null);
          }}
          disabled={invoiceEmailSending || !canManageInvoices}
          inputProps={{
            min: 0.01,
            step: '0.01',
            'aria-describedby': 'so-create-invoice-amount-feedback',
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Box sx={{ px: 1.1, py: 0.65, borderRadius: 1, bgcolor: '#F2F5F8',
                  color: 'text.secondary', fontWeight: 750, fontSize: 12 }}>
                  {String(currentSO?.currency || order?.currency || 'CAD').toUpperCase()}
                </Box>
              </InputAdornment>
            ),
            sx: {
              borderRadius: 2,
              '& input': { py: 1.4, fontSize: 20, fontWeight: 700, fontVariantNumeric: 'tabular-nums' },
            },
          }}
          error={Boolean(invoiceCreateAmount) && !invoiceCreateAssessment.valid}
        />
        {Boolean(invoiceCreateAmount) && !invoiceCreateAssessment.valid ? (
          <Alert
            id="so-create-invoice-amount-feedback"
            data-testid="so-invoice-amount-feedback-error"
            severity="error"
            variant="outlined"
            sx={{
              mt: 1.25, borderRadius: 2, bgcolor: '#FFF8F7',
              borderColor: '#F0CAC6', alignItems: 'center',
              '& .MuiAlert-message': { fontSize: 13, lineHeight: 1.55 },
            }}
          >
            {invoiceCreateAssessment.message}
          </Alert>
        ) : !manualAdditionalInvoice && Number(invoiceSuggestedAmount) > 0 ? (
          <Box
            id="so-create-invoice-amount-feedback"
            data-testid="so-invoice-amount-feedback-info"
            sx={{
              display: 'flex', alignItems: 'flex-start', gap: 1.15,
              mt: 1.25, px: 1.5, py: 1.3, borderRadius: 2,
              border: '1px solid #DDE6F0', bgcolor: '#F8FAFD',
            }}
          >
            <InfoOutlinedIcon sx={{ color: '#56718D', fontSize: 19, flexShrink: 0, mt: 0.1 }} />
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.5, color: 'text.primary' }}>
                <Box component="span" sx={{ fontWeight: 750 }}>Available to invoice: </Box>
                {(Number(invoiceSuggestedAmount) || 0).toFixed(2)}{' '}
                {String(currentSO?.currency || order?.currency || 'CAD').toUpperCase()}
              </Typography>
              <Typography variant="caption" sx={{ display: 'block', mt: 0.3, lineHeight: 1.6, color: 'text.secondary' }}>
                You can invoice a smaller amount now. The remaining balance stays available for a later invoice.
              </Typography>
            </Box>
          </Box>
        ) : null}
      </Box>
      ) : null}
      {invoiceCreateAssessment.valid && !manualAdditionalInvoice &&
        invoiceCreateAssessment.role === 'partial' ? (
        <Alert severity="info" variant="outlined" sx={{ mt: 1.5, borderRadius: 2 }}>
          This will create a partial invoice for {invoiceCreateAssessment.amount.toFixed(2)}.
          The remaining {((invoiceCreateAssessment.remainingCents - invoiceCreateAssessment.requestedCents) / 100).toFixed(2)}
          will stay available for later invoicing.
        </Alert>
      ) : null}

      {enableInvoiceCreationReview &&
        (!manualAdditionalInvoice || (
          invoiceCreateAssessment.valid && confirmAdditionalInvoice &&
          manualAdditionalReason.trim().length >= 12
        )) ? (
        <InvoiceCreationReview
          open={invoiceComposerOpen}
          orderId={orderId}
          order={order}
          fetchOrder={fetchOrder}
          currency={currentSO?.currency || order?.currency || 'CAD'}
          request={{
            instanceUniqueId,
            salesOrderId: invoiceCreationSalesOrderId,
            invoiceRole: invoiceCreateAssessment.role || 'full',
            invoiceMode: manualAdditionalInvoice ? 'manual' : invoiceCreateMode,
            invoiceAmount: Number(invoiceCreateAmount || 0),
            ...(manualAdditionalInvoice && canOfferManualAdditionalInvoice ? {
              manualAdditionalInvoice: true,
              manualAdditionalReason: manualAdditionalReason.trim(),
              confirmAdditionalInvoice,
              sendEmailNow: false, qboQueueOnCreate: false,
            } : {}),
            deriveTermsTaxesFrom: 'customer',
          }}
          onPrepared={setPreparedInvoiceReview}
          onInitialReviewSettled={setInvoiceInitialReviewSettled}
        />
      ) : null}

      {Number(invoiceSuggestedAmount) > 0 && !manualAdditionalInvoice ? (
      <>
      <Box sx={{
        mt: 1.25, p: { xs: 1.25, sm: 1.5 }, borderRadius: 2,
        border: '1px solid #E6EAF0', bgcolor: '#FAFBFD',
      }}>
        <FormControlLabel
          sx={{ display: 'flex', alignItems: 'center', m: 0,
            '& .MuiFormControlLabel-label': { fontSize: 14, fontWeight: 700 } }}
          control={<Switch checked={sendInvoiceEmailNow}
            disabled={invoiceEmailSending}
            onChange={(e) => setSendInvoiceEmailNow(e.target.checked)} />}
          label="Send invoice email now"
        />
        <Typography variant="caption" color="text.secondary" sx={{
          display: 'block', mt: 0.35, ml: { xs: 0, sm: 5.8 }, lineHeight: 1.5,
        }}>
          {sendInvoiceEmailNow
            ? 'The invoice will be created and sent to your selected recipients. Review any manually edited amount in the email body before sending.'
            : 'Create the invoice without emailing the customer. You can review the invoice and send it later.'}
        </Typography>
        {sendInvoiceEmailNow ? (
          <Box sx={{ mt: 1.75, pt: 1.75, borderTop: '1px solid #E3E9F1' }}>
            <Box sx={{ mb: 1.25 }}>
              <Typography variant="caption" sx={{ display: 'block', mb: 0.4, fontWeight: 700, color: 'text.secondary' }}>
                From
              </Typography>
              <Box sx={{ px: 1.5, py: 1.25, border: '1px solid #DDE4EE', borderRadius: 1.5, bgcolor: '#F8FAFC' }}>
                <Typography variant="body2" sx={{ fontWeight: 600, overflowWrap: 'anywhere' }}>
                  {invoiceSenderPreview.loading ? 'Checking sender settings…'
                    : invoiceSenderPreview.label || 'Sender unavailable — verify Financial Configuration'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {invoiceSenderPreview.mode === 'user_selectable'
                    ? 'Default sender for this Sales Order. The server determines the actual delivery identity.'
                    : 'Configured in Financial Settings. This sender is enforced when the invoice is emailed.'}
                </Typography>
              </Box>
            </Box>
            <EmailComposer
              contacts={emailContacts}
              templates={emailTemplates}
              value={invoiceEmailValue}
              onChange={setInvoiceEmailValue}
              attachments={emailAttachments}
              onAttachmentsChange={setEmailAttachments}
              quickActionRecipients={{
                me: composerSelfContactWithAvatar ? [composerSelfContactWithAvatar] : [],
                orderReps: orderRepContacts,
                clientReps: clientRepContacts,
              }}
            />
          </Box>
        ) : null}
      </Box>

      <Box sx={{
        mt: 1.25, p: { xs: 1.25, sm: 1.5 }, borderRadius: 2,
        border: '1px solid #E6EAF0', bgcolor: '#FAFBFD',
      }}>
        <FormControlLabel
          sx={{ display: 'flex', alignItems: 'center', m: 0,
            '& .MuiFormControlLabel-label': { fontSize: 14, fontWeight: 700 } }}
          control={<Switch checked={queueInvoiceForQuickBooks}
            disabled={invoiceEmailSending}
            onChange={(e) => setQueueInvoiceForQuickBooks(e.target.checked)} />}
          label="Queue for QuickBooks export"
        />
        <Typography variant="caption" color="text.secondary" sx={{
          display: 'block', mt: 0.35, ml: { xs: 0, sm: 5.8 }, lineHeight: 1.5,
        }}>
          Mark this invoice as pending for QuickBooks export after creation.
          If left off, it can still be exported manually later.
        </Typography>
      </Box>
      </>
      ) : null}
    </Box>
  </DialogContent>
  {!invoiceComposerPreparing ? (
    <DialogActions sx={{
      px: { xs: 2, sm: 3 }, py: 2,
      display: 'flex', justifyContent: 'space-between',
      alignItems: 'center', flexWrap: 'wrap', gap: 1.25,
    }}>
      <Button
        variant="outlined"
        color="inherit"
        onClick={closeSalesOrderInvoiceComposer}
        disabled={invoiceEmailSending}
        sx={{
          borderRadius: 2, minHeight: 42, px: 2.5, fontWeight: 650,
          borderColor: '#CBD3DE', color: 'text.primary', textTransform: 'none',
        }}
      >
        Cancel
      </Button>
      <Button
        color="error"
        variant="contained"
        startIcon={invoiceEmailSending
          ? <CircularProgress size={17} sx={{ color: 'inherit' }} />
          : <CheckCircleOutlineIcon />}
        onClick={() => handleCreateInvoiceWithEmail()}
        disabled={invoiceEmailSending ||
          (enableInvoiceCreationReview && !preparedInvoiceReview) ||
          !canManageInvoices || !invoiceCreateAssessment.valid ||
          (manualAdditionalInvoice
            ? !canOfferManualAdditionalInvoice || !confirmAdditionalInvoice ||
              manualAdditionalReason.trim().length < 12
            : !visibleCreateInvoiceModeOptions.length)}
        sx={{
          borderRadius: 2, minHeight: 42, px: 2.5, ml: 'auto',
          bgcolor: '#C8101E', '&:hover': { bgcolor: '#A70D19' },
          boxShadow: 'none', fontWeight: 750, textTransform: 'none',
        }}
      >
        {invoiceEmailSending ? 'Creating…' : manualAdditionalInvoice
          ? 'Create additional draft'
          : (sendInvoiceEmailNow ? 'Create & Send' : 'Create Invoice')}
      </Button>
    </DialogActions>
  ) : null}
</Dialog>

<Dialog
  open={salesOrderResetOpen}
  onClose={() => { if (!salesOrderResetSubmitting) setSalesOrderResetOpen(false); }}
  aria-labelledby="so-reset-invoiced-title"
  maxWidth="sm"
  fullWidth
  PaperProps={{ sx: { borderRadius: 3 } }}
>
  <DialogTitle id="so-reset-invoiced-title" sx={{ fontWeight: 800, display: 'flex', alignItems: 'center', gap: 1 }}>
    <RestartAltIcon color="warning" fontSize="small" />
    Reset Invoiced
  </DialogTitle>
  <DialogContent dividers sx={{ py: 2.5 }}>
    {salesOrderResetLoading ? (
      <Stack direction="row" spacing={1.5} alignItems="center" role="status">
        <CircularProgress size={22} />
        <Typography variant="body2" color="text.secondary">
          Checking the latest invoice, payment activity, and linked Sales Order…
        </Typography>
      </Stack>
    ) : null}
    {salesOrderResetError ? (
      <Alert severity="error" sx={{ mb: 2 }}>{salesOrderResetError}</Alert>
    ) : null}
    {salesOrderResetPreview ? (
      <>
        <Typography variant="body2" sx={{ mb: 2, lineHeight: 1.6 }}>
          Undo only the newest non-deposit invoice created for this project.
          The original invoice remains in history, and your approved Sales Order is not recalculated.
        </Typography>
        <Box sx={{ borderRadius: 2, border: '1px solid', borderColor: 'divider', p: 2, mb: 2 }}>
          {salesOrderResetPreview.invoice ? (
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
              <Box>
                <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
                  Invoice #{salesOrderResetPreview.invoice.id}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {salesOrderResetPreview.invoice.invoiceStatus || 'Open'} · non-deposit invoice
                </Typography>
              </Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 750, whiteSpace: 'nowrap' }}>
                {salesOrderResetPreview.invoice.currency || 'CAD'} {Number(salesOrderResetPreview.invoice.amount || 0).toFixed(2)}
              </Typography>
            </Stack>
          ) : <Typography variant="body2">No non-deposit invoice found.</Typography>}
          <Divider sx={{ my: 1.5 }} />
          <Typography variant="body2">
            Project: <strong>{salesOrderResetPreview.currentProjectStatus || '—'}</strong>
            {' → '}<strong>Ready to be Invoiced</strong>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            Sales Order #{salesOrderResetPreview.salesOrderId || '—'}:
            {' '}<strong>{String(salesOrderResetPreview.currentSalesOrderStatus || '—') === '9' ? 'Invoiced' : 'Ready to be Invoiced'}</strong>
            {' → '}<strong>Ready to be Invoiced</strong>
          </Typography>
          <Typography variant="body2" sx={{ mt: 1.25, fontWeight: 700 }}>
            {salesOrderResetPreview.depositInvoiceIds?.length
              ? `${salesOrderResetPreview.depositInvoiceIds.length} deposit invoice(s) preserved, including payments.`
              : 'No deposit invoices will be changed.'}
          </Typography>
        </Box>
        {salesOrderResetPreview.blockers?.length ? (
          <Alert severity="warning" sx={{ mb: 1 }}>
            <Typography variant="subtitle2" fontWeight={750}>Reset is not available</Typography>
            {salesOrderResetPreview.blockers.map((reason, index) => (
              <Typography variant="body2" key={index} sx={{ mt: 0.5 }}>• {reason}</Typography>
            ))}
          </Alert>
        ) : (
          <>
            <Alert severity="warning" sx={{ mb: 2 }}>
              This voids the selected invoice and its own invoicing-cart revision.
              It cannot be used for paid invoices, live Stripe checkouts, or QuickBooks-linked invoices.
              Emails already sent to a customer cannot be recalled.
            </Alert>
            <TextField
              fullWidth
              multiline
              minRows={2}
              maxRows={4}
              label="Reason for reset"
              placeholder="Example: Invoice generation test, no customer payment"
              value={salesOrderResetReason}
              onChange={(event) => setSalesOrderResetReason(event.target.value)}
              inputProps={{ maxLength: 500 }}
              helperText="Required for the project and invoice audit history (8–500 characters)."
            />
            <FormControlLabel
              sx={{ mt: 1.5, alignItems: 'flex-start' }}
              control={
                <Checkbox
                  checked={salesOrderResetAcknowledged}
                  onChange={(event) => setSalesOrderResetAcknowledged(event.target.checked)}
                />
              }
              label="I checked whether this invoice was sent to a customer and will notify them if necessary."
            />
          </>
        )}
      </>
    ) : null}
  </DialogContent>
  <DialogActions sx={{ px: 3, py: 2 }}>
    <Button
      color="inherit" variant="outlined"
      disabled={salesOrderResetSubmitting}
      onClick={() => setSalesOrderResetOpen(false)}
      sx={{ textTransform: 'none', borderRadius: 2 }}
    >
      Cancel
    </Button>
    <Button
      color="warning" variant="contained"
      data-testid="so-reset-invoiced-confirm"
      onClick={handleConfirmSalesOrderReset}
      disabled={salesOrderResetSubmitting || !salesOrderResetPreview?.canReset ||
        !salesOrderResetAcknowledged || salesOrderResetReason.trim().length < 8}
      sx={{ textTransform: 'none', borderRadius: 2 }}
    >
      {salesOrderResetSubmitting ? 'Resetting…' : 'Confirm Reset Invoiced'}
    </Button>
  </DialogActions>
</Dialog>


      <ApprovalRegenerationDialog
        open={approvalRegeneration.open}
        value={approvalRegeneration.mode}
        submitting={docRegenerationInProgress}
        onChange={(mode) => setApprovalRegeneration((state) => ({ ...state, mode }))}
        onCancel={() => setApprovalRegeneration({ open: false, mode: "reset", docType: null, targetId: null })}
        onConfirm={async () => {
          if (docRegenerationInProgress) return;
          const pending = approvalRegeneration;
          const succeeded = await handleRegenerateDocFromCart(pending.docType, pending.targetId, pending.mode);
          if (succeeded) setApprovalRegeneration({ open: false, mode: "reset", docType: null, targetId: null });
        }}
      />
      <DecorationRoutingErrorDialog
        open={decorationRoutingError.open}
        issues={decorationRoutingError.issues}
        onClose={() => setDecorationRoutingError({ open: false, issues: [] })}
        onOpenCart={() => {
          setCartView('sales-order-cart');
          setDecorationRoutingError({ open: false, issues: [] });
        }}
      />

{/* Temporarily disabled floating chat launcher.
{order && (
  <div
    className="op-float-chat-btn"
    onClick={() => {
      handleTabChange("Overview");
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent("ec:open-chat"));
      }, 100);
    }}
  >
    <ChatIcon sx={{ fontSize: 22 }} />
    {notesForChat?.length > 0 && (
      <span className="op-float-chat-badge">{notesForChat.length}</span>
    )}
  </div>
)}
*/}
      </div>
    </div>
  );
}
export default InstanceSingleOrderManager;
